import _assertThisInitialized from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _get from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/get";
import _toConsumableArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createClass from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/laurie/myuPreview-SendgridAttilaFixes/myu_web/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var _Qr, _categories, _items, _items2, _categories2, _items3, _items4, _so$IMAGE_CONTAINER_I;

function _templateObject126() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  height: 28px;\n  width: 28px;\n  border-radius: 50%;\n"]);

  _templateObject126 = function _templateObject126() {
    return data;
  };

  return data;
}

function _templateObject125() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject125 = function _templateObject125() {
    return data;
  };

  return data;
}

function _templateObject124() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 10px;\n"]);

  _templateObject124 = function _templateObject124() {
    return data;
  };

  return data;
}

function _templateObject123() {
  var data = _taggedTemplateLiteral(["\n          border-top-color: ", ";\n        "]);

  _templateObject123 = function _templateObject123() {
    return data;
  };

  return data;
}

function _templateObject122() {
  var data = _taggedTemplateLiteral(["\n          border-top-color: ", ";\n        "]);

  _templateObject122 = function _templateObject122() {
    return data;
  };

  return data;
}

function _templateObject121() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  ", "\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n"]);

  _templateObject121 = function _templateObject121() {
    return data;
  };

  return data;
}

function _templateObject120() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          height: 32px;\n        "]);

  _templateObject120 = function _templateObject120() {
    return data;
  };

  return data;
}

function _templateObject119() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n          height: 40px;\n          background: ", ";\n        "]);

  _templateObject119 = function _templateObject119() {
    return data;
  };

  return data;
}

function _templateObject118() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  bottom: 0px;\n  border-radius: ", "px;\n  left: 0;\n  ", "\n  width: 100%;\n  cursor: pointer;\n"]);

  _templateObject118 = function _templateObject118() {
    return data;
  };

  return data;
}

function _templateObject117() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n"]);

  _templateObject117 = function _templateObject117() {
    return data;
  };

  return data;
}

function _templateObject116() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    box-sizing: border-box;\n  }\n\n  /* basic ui text items use position absolute */\n  position: relative;\n\n  padding: 0;\n  cursor: pointer;\n  /* Safari will change the height of the toolbar and position the category cards at the bottom for some reason */\n  vertical-align: top;\n  border: none;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  ", ";\n  animation-fill-mode: both;\n  overflow: hidden;\n\n  ", "\n\n  /* Active */\n\n  /* No :active styles on purpose. */\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject116 = function _templateObject116() {
    return data;
  };

  return data;
}

function _templateObject115() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  ", " {\n    background-color: ", ";\n  }\n"]);

  _templateObject115 = function _templateObject115() {
    return data;
  };

  return data;
}

function _templateObject114() {
  var data = _taggedTemplateLiteral(["\n    animation: ", " 0.2s linear;\n  "]);

  _templateObject114 = function _templateObject114() {
    return data;
  };

  return data;
}

function _templateObject113() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n\n  &:active {\n    color: ", ";\n  }\n"]);

  _templateObject113 = function _templateObject113() {
    return data;
  };

  return data;
}

function _templateObject112() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject112 = function _templateObject112() {
    return data;
  };

  return data;
}

function _templateObject111() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"]);

  _templateObject111 = function _templateObject111() {
    return data;
  };

  return data;
}

function _templateObject110() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n"]);

  _templateObject110 = function _templateObject110() {
    return data;
  };

  return data;
}

function _templateObject109() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  min-width: 32px;\n"]);

  _templateObject109 = function _templateObject109() {
    return data;
  };

  return data;
}

function _templateObject108() {
  var data = _taggedTemplateLiteral(["\n      @media all and (min-width: 0) and (max-width: 599px) {\n        display: none;\n      }\n    "]);

  _templateObject108 = function _templateObject108() {
    return data;
  };

  return data;
}

function _templateObject107() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n"]);

  _templateObject107 = function _templateObject107() {
    return data;
  };

  return data;
}

function _templateObject106() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    outline: none;\n  }\n\n  > img {\n    height: 18px;\n    width: 18px;\n  }\n\n  > svg {\n    height: 18px;\n    width: 18px;\n  }\n  display: none;\n\n  @media all and (min-width: 0) and (max-width: 599px) {\n    display: flex;\n  }\n"]);

  _templateObject106 = function _templateObject106() {
    return data;
  };

  return data;
}

function _templateObject105() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject105 = function _templateObject105() {
    return data;
  };

  return data;
}

function _templateObject104() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject104 = function _templateObject104() {
    return data;
  };

  return data;
}

function _templateObject103() {
  var data = _taggedTemplateLiteral(["\n      visibility: visible;\n      animation: ", " 0.5s, fadeout 0.5s 2.5s;\n    "]);

  _templateObject103 = function _templateObject103() {
    return data;
  };

  return data;
}

function _templateObject102() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  transform: translate(-50%, 50%);\n  background: black;\n  color: white;\n  border-radius: ", "px;\n  padding: 10px 16px;\n  text-align: center;\n  z-index: ", ";\n  visibility: hidden;\n\n  ", "\n"]);

  _templateObject102 = function _templateObject102() {
    return data;
  };

  return data;
}

function _templateObject101() {
  var data = _taggedTemplateLiteral(["\n  from { transform: translate(-50%, 0%); }\n  to { transform: translate(-50%, 50%); }\n"]);

  _templateObject101 = function _templateObject101() {
    return data;
  };

  return data;
}

function _templateObject100() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: ", "px;\n"]);

  _templateObject100 = function _templateObject100() {
    return data;
  };

  return data;
}

function _templateObject99() {
  var data = _taggedTemplateLiteral(["\n  border-top: none;\n"]);

  _templateObject99 = function _templateObject99() {
    return data;
  };

  return data;
}

function _templateObject98() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject98 = function _templateObject98() {
    return data;
  };

  return data;
}

function _templateObject97() {
  var data = _taggedTemplateLiteral(["\n  padding: 11px 20px 8px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n"]);

  _templateObject97 = function _templateObject97() {
    return data;
  };

  return data;
}

function _templateObject96() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  caret-color: ", ";\n  ", "\n  min-height: 100%;\n  padding: 0px;\n  outline-offset: -8px;\n  color: ", ";\n  resize: none;\n  font-family: '", "', sans-serif;\n\n  &:selection,\n  &:-moz-selection {\n    background-color: ", ";\n    color: ", ";\n  }\n"]);

  _templateObject96 = function _templateObject96() {
    return data;
  };

  return data;
}

function _templateObject95() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject95 = function _templateObject95() {
    return data;
  };

  return data;
}

function _templateObject94() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject94 = function _templateObject94() {
    return data;
  };

  return data;
}

function _templateObject93() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n  @media all and (min-width: 640px) {\n    margin-left: 30px;\n  }\n"]);

  _templateObject93 = function _templateObject93() {
    return data;
  };

  return data;
}

function _templateObject92() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n"]);

  _templateObject92 = function _templateObject92() {
    return data;
  };

  return data;
}

function _templateObject91() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject91 = function _templateObject91() {
    return data;
  };

  return data;
}

function _templateObject90() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"]);

  _templateObject90 = function _templateObject90() {
    return data;
  };

  return data;
}

function _templateObject89() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n\n  /* Repeat active styles so they are not overwritten */\n  ", "\n\n  ", " {\n    display: none;\n  }\n\n  &:disabled {\n    opacity: ", ";\n  }\n"]);

  _templateObject89 = function _templateObject89() {
    return data;
  };

  return data;
}

function _templateObject88() {
  var data = _taggedTemplateLiteral(["\n  max-width: 50px;\n  padding-left: 16px;\n  > div > input {\n    text-align: center;\n  }\n"]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 26px;\n  margin-right: ", "px;\n"]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteral(["\n        height: 2px;\n        background: ", ";\n      "]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteral(["\n        margin-top: 10px;\n        height: 20px;\n        /* remove once we have a better concept for focus in all browser */\n        &:focus {\n          box-shadow: none;\n        }\n      "]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 0 auto;\n  appearance: none;\n  max-width: calc(100% - 50px);\n  outline: none;\n  border-radius: 0; /* iOS */\n\n  ", "\n\n  ", "\n  &::-moz-focus-outer {\n    /** This is to remove the dotted focus lines in firefox */\n    border: 0;\n  }\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n  &:hover {\n    opacity: ", ";\n  }\n  &::-webkit-slider-runnable-track {\n    cursor: pointer;\n    appearance: none;\n  }\n  &::-moz-range-track {\n    appearance: none;\n    cursor: pointer;\n  }\n  &::-ms-track {\n    cursor: pointer;\n    height: 2px;\n    appearance: none;\n    background: transparent;\n    color: transparent;\n    border-color: transparent;\n    border-width: 6px 0;\n  }\n  &::-webkit-slider-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-moz-range-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-thumb {\n    appearance: none;\n    ", "\n  }\n  &::-ms-fill-lower {\n    background: ", ";\n  }\n  &::-ms-fill-upper {\n    background: ", ";\n  }\n  &::-ms-tooltip {\n    display: none;\n  }\n  @media all and (min-width: 0) and (max-width: 599px) {\n    width: 200px;\n  }\n"]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteral(["\n        width: 20px;\n        height: 20px;\n      "]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteral(["\n        width: 16px;\n        height: 16px;\n      "]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n"]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: 2px;\n"]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  /* needed for IE11 to properly calculate the width */\n  min-width: 1px;\n"]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteral(["\n        flex-wrap: wrap;\n      "]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  ", "\n"]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        flex: 0 1 auto;\n        flex-direction: column;\n      "]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  &:first-child {\n    margin-right: 15px;\n  }\n"]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  /* override user agent style */\n  padding: 0;\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n    pointer-events: none;\n  }\n"]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid ", ";\n  transform: rotate(", "deg);\n  display: inline-block;\n  transition-duration: 0.3s;\n  transition-timing-function: ease-in;\n  right: 0;\n  top: 13px;\n"]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: none;\n  border-bottom: 1px solid ", ";\n  padding: 5px 0;\n  cursor: ", ";\n  transition: border-color 0.4s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteral(["\n        > ul {\n          height: 160px;\n          margin-bottom: 0px;\n          margin-top: 0px;\n          padding-bottom: 0px;\n          padding-top: 0px;\n        }\n      "]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteral(["\n        visibility: visible;\n        opacity: 1;\n        display: flex;\n      "]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n\n  background: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  box-shadow: ", ";\n\n  visibility: hidden;\n  opacity: 0;\n  ", "\n\n  transition: all 0.5s ease;\n\n  width: 100%;\n  max-height: 160px;\n  margin: 5px 0;\n\n  /* had to add these changes to get the dropdown working in IE11 */\n  ", "\n\n  border-radius: 0 0 ", "px\n    ", "px;\n  z-index: ", ";\n"]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteral(["\n            overflow-y: hidden;\n            overflow-x: auto;\n\n            margin-right: -10px;\n            margin-left: -10px;\n            padding-right: 10px;\n            padding-left: 10px;\n\n            padding-bottom: 10px;\n            margin-bottom: -10px;\n          "]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteral(["\n              overflow-y: auto;\n              overflow-x: hidden;\n\n              /* hidde the arrows */\n              margin-top: -10px;\n              margin-bottom: -10px;\n              padding-top: 10px;\n              padding-bottom: 10px;\n\n              /* hide the scrollbar */\n              padding-right: 10px;\n              margin-right: -10px;\n            "]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 100%;\n\n        ", "\n\n        scrollbar-face-color: #454545;\n        scrollbar-track-color: ", ";\n        scrollbar-base-color: ", ";\n        scrollbar-3dlight-color: #454545;\n        scrollbar-highlight-color: #454545;\n        scrollbar-arrow-color: ", ";\n        scrollbar-shadow-color: #454545;\n        scrollbar-dark-shadow-color: #454545;\n      "]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n\n  list-style: none;\n  padding: 0;\n  margin: 0;\n\n  ", "\n"]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n      overflow-y: hidden;\n      overflow-x: auto;\n    "]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n        flex-direction: column;\n        flex: 1 1 auto;\n        overflow-y: auto;\n        overflow-x: hidden;\n      "]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n        overflow: hidden;\n      "]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n"]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n      border-left: 2px solid ", ";\n    "]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 16px;\n  text-overflow: ellipsis;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  white-space: nowrap;\n  color: ", ";\n\n  &:hover {\n    cursor: pointer;\n    background: ", ";\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  width: 100%;\n  white-space: nowrap;\n  transition-duration: 0.5s;\n\n  &:disabled {\n    ", "\n  }\n\n  ", "\n"]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n  opacity: ", ";\n  pointer-events: none;\n"]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  width: 100%;\n  min-height: 26px;\n  color: ", ";\n  padding-bottom: 7px;\n  border: none;\n  appearance: none;\n  border-bottom: 1px solid ", ";\n  background: ", ";\n  font-family: '", "', sans-serif;\n  transition: border-color 0.4s ease-in-out;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:-moz-focusring {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &:disabled {\n    opacity: ", ";\n    pointer-events: none;\n  }\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &::-ms-clear,\n  &::-ms-reveal {\n    display: none;\n  }\n\n  &::-webkit-search-decoration,\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-results-button,\n  &::-webkit-search-results-decoration {\n    -webkit-appearance: none;\n  }\n\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n"]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  margin: 0;\n  padding: 0;\n  ", "\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: default;\n      pointer-events: none;\n    "]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      &::after {\n        color: ", ";\n        border-color: ", ";\n      }\n      &:hover {\n        background-color: ", ";\n        opacity: 0.8;\n      }\n    "]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 16px;\n  width: 16px;\n  cursor: pointer;\n  background-color: ", ";\n  border-radius: ", "px;\n  transition-timing-function: ease-in;\n  transition-duration: 0.3s;\n  &::after {\n    content: '';\n    position: absolute;\n    display: inline-block;\n    left: 5px;\n    width: 5px;\n    height: 10px;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    border-color: transparent;\n    transform: rotate(45deg) scale(0.8);\n  }\n\n  &:first-child {\n    margin-right: 8px;\n  }\n\n  &:last-child {\n    margin-left: 8px;\n  }\n\n  ", "\n\n  &:hover {\n    opacity: ", ";\n  }\n  ", "\n  ", "\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  margin-bottom: 12px;\n  max-width: ", "px;\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n          margin-right: 2px;\n          transform: rotate(-45deg);\n        "]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n          margin-left: 2px;\n          transform: rotate(135deg);\n        "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n  border: solid ", ";\n  border-width: 0 2px 2px 0;\n  padding: 3px;\n  height: 0;\n  width: 0;\n\n  ", "\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  margin-left: -", "px;\n  position: relative;\n  display: inline-block;\n  transform: translateZ(0);\n  transition: all 600ms cubic-bezier(0.77, 0, 0.175, 1);\n  font-family: '", "', sans-serif;\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  transform: translateZ(0);\n  overflow: hidden;\n  transition: all 500ms ease-out;\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n  /* 0.6 of width here refers to the width of the container without padding */\n  width: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  text-align: center;\n  margin-top: 7px;\n  display: inline-block;\n  color: ", ";\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: ", "px;\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: 1px 7px 2px;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  align-self: flex-start;\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n      opacity: ", ";\n      cursor: default;\n      pointer-events: none;\n    "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n  margin: 0;\n  padding-bottom: 8px;\n\n  ", "\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    box-sizing: border-box;\n  }\n  text-align: center;\n  position: relative;\n  padding: 4px 8px;\n  min-height: 32px;\n  border-radius: ", "px;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  font-family: ", ", sans-serif;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  overflow: hidden;\n  ", "\n\n  /* Active */\n\n  &:active {\n    ", "\n  }\n\n  ", "\n\n  /* Disabled */\n\n  &:disabled {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  /* Hover */\n\n  &:hover {\n    ", " {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  left: ", "px;\n  top: ", "px;\n  pointer-events: none;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.12);\n  animation: ", " 1.2s;\n  width: 100px;\n  height: 100px;\n  margin-top: -50px;\n  margin-left: -50px;\n  opacity: 0;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 12px 0;\n  position: relative;\n  width: 40px;\n  height: 40px;\n  box-shadow: inset 0 0 0 2px;\n  transform: translateZ(0);\n  border-radius: 50%;\n  &:before,\n  &:after {\n    border-radius: 50%;\n    position: absolute;\n    content: '';\n  }\n  &:before {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 45px 0 0 45px;\n    top: -2.5px;\n    left: -2.5px;\n    transform-origin: 25px 25px;\n    ", ";\n  }\n  &:after {\n    width: 25px;\n    height: 45px;\n    background: ", ";\n    border-radius: 0 45px 45px 0;\n    top: -2.5px;\n    left: 25px;\n    transform-origin: 0px 25px;\n    ", ";\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 2s infinite ease;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  animation: ", " 2s infinite ease 1.5s;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n\n  padding: 11px 20px 0px;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  border-top: 2px solid\n    ", ";\n\n  min-height: 40px;\n  justify-content: flex-end;\n  @media all and (min-width: 0) and (max-width: 640px) {\n    height: auto;\n    flex-direction: column;\n    justify-content: space-around;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  text-transform: ", ";\n  color: ", ";\n\n  padding: 0px 20px 11px;\n  &:first-child {\n    padding-top: 11px;\n  }\n\n  @media all and (min-width: 0) and (max-width: 640px) {\n    align-items: center;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  transition: top 0.25s ease;\n  position: absolute;\n  top: calc(50% + ", "px);\n  left: calc(50% + ", "px);\n  width: ", ";\n  height: ", ";\n  transform: translate(-50%, -50%);\n  border-radius: ", "px;\n  background: ", ";\n  color: ", ";\n  z-index: ", ";\n\n  @media all and (min-width: 0) and (max-width: 640px) {\n    text-align: center;\n    width: auto;\n    min-width: 200px;\n    height: auto;\n    top: 50%;\n    left: 50%;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      opacity: 1;\n      display: block;\n      visibility: visible;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: ", ";\n  transition: opacity 100s ease-in-out;\n\n  ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  opacity: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: ", ";\n  text-align: left;\n  background: ", ";\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  z-index: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  &&& {\n    box-sizing: border-box;\n  }\n  position: relative;\n  background: transparent;\n  border: none;\n  height: ", "px;\n  width: ", "px;\n  margin: ", ";\n  padding: 0;\n  cursor: pointer;\n  border-radius: ", ";\n\n  &:hover {\n    opacity: 0.7;\n  }\n\n  ", "\n\n  &:disabled {\n    opacity: ", ";\n    cursor: default;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute !important;\n  height: 1px;\n  width: 1px;\n  overflow: hidden;\n  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */\n  clip: rect(1px, 1px, 1px, 1px);\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n  &:-moz-focusring {\n    outline: none;\n    box-shadow: 0 0 2px ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  height: 2px;\n  width: 2px;\n  border-radius: 50%;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.6);\n  background: rgba(255, 255, 255, 0.87);\n  margin: 1px;\n  pointer-events: none;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: ", ";\n\n  box-sizing: border-box;\n  border: 2px solid transparent;\n  border-radius: ", ";\n  transition: border-color 300ms ease-in-out;\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  z-index: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", ";\n  pointer-events: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  -webkit-touch-callout: none;\n  user-select: none;\n  * {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: '", "', sans-serif;\n    /* css reset for a global box-sizing: border-box */\n    box-sizing: content-box;\n    /* todo: fix the issue with these settings */\n    font-size: inherit;\n    color: inherit;\n    line-height: normal;\n\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n\n    &::-webkit-scrollbar-track {\n      border-radius: 10px;\n      background-color: transparent;\n      margin: 1px;\n    }\n\n    &::-webkit-scrollbar {\n      width: 6px;\n      height: 6px;\n      background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      border-radius: 10px;\n      box-shadow: inset 0 0 14px rgba(0, 0, 0, 0.4);\n      background-color: rgba(255, 255, 255, 0.2);\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\nfrom {\n  opacity: 1;\n  transform: scale(0);\n}\nto {\n  opacity: 0;\n  transform: scale(10);\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { A as ab, B as oe, D as Mb, E as Wb, F as xi, G as cb, H as Ji, I as f, J as qp, K as pe, L as Ym, M as Py, N as qb, O as bs, P as Ye, R as Zb, S as De, T as C, U as he, V as A, a as Tp, b as de, c as wn, d as g, e as $e, f as Be, g as Gt, h as jt, i as ze, j as y, k as W, l as j, m as L, o as Yr, p as hb, q as oy, r as lb, t as Kb, u as $, v as iy, w as Tb, x as zb, y as _t, z as _ } from "./chunk.WNPNZHNS.js";
var Ra = Object.getOwnPropertySymbols,
    id = Object.prototype.propertyIsEnumerable;

var Pe = function Pe(i, e) {
  var t = {};

  for (var r in i) {
    ab.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  }

  if (i != null && Ra) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Ra(i)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var r = _step.value;
        e.indexOf(r) < 0 && id.call(i, r) && (t[r] = i[r]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return t;
};

var a = function a(i, e, t, r) {
  for (var o = r > 1 ? void 0 : r ? cb(e, t) : e, n = i.length - 1, s; n >= 0; n--) {
    (s = i[n]) && (o = (r ? s(e, t, o) : s(o)) || o);
  }

  return r && o && lb(e, t, o), o;
};

var dr = Ym(function (u0, vc) {
  var Om = "Expected a function",
      _c = 0 / 0,
      Tm = "[object Symbol]",
      Pm = /^\s+|\s+$/g,
      Mm = /^[-+]0x[0-9a-f]+$/i,
      Bm = /^0b[01]+$/i,
      zm = /^0o[0-7]+$/i,
      Lm = parseInt,
      Um = typeof global == "object" && global && global.Object === Object && global,
      Nm = typeof self == "object" && self && self.Object === Object && self,
      Hm = Um || Nm || Function("return this")(),
      Wm = Object.prototype,
      jm = Wm.toString,
      Gm = Math.max,
      Vm = Math.min,
      zs = function zs() {
    return Hm.Date.now();
  };

  function $m(i, e, t) {
    var r,
        o,
        n,
        s,
        l,
        c,
        p = 0,
        m = !1,
        h = !1,
        b = !0;
    if (typeof i != "function") throw new TypeError(Om);
    e = Sc(e) || 0, Ls(t) && (m = !!t.leading, h = "maxWait" in t, n = h ? Gm(Sc(t.maxWait) || 0, e) : n, b = "trailing" in t ? !!t.trailing : b);

    function v(T) {
      var Z = r,
          ae = o;
      return r = o = void 0, p = T, s = i.apply(ae, Z), s;
    }

    function x(T) {
      return p = T, l = setTimeout(M, e), m ? v(T) : s;
    }

    function I(T) {
      var Z = T - c,
          ae = T - p,
          Qe = e - Z;
      return h ? Vm(Qe, n - ae) : Qe;
    }

    function R(T) {
      var Z = T - c,
          ae = T - p;
      return c === void 0 || Z >= e || Z < 0 || h && ae >= n;
    }

    function M() {
      var T = zs();
      if (R(T)) return Q(T);
      l = setTimeout(M, I(T));
    }

    function Q(T) {
      return l = void 0, b && r ? v(T) : (r = o = void 0, s);
    }

    function se() {
      l !== void 0 && clearTimeout(l), p = 0, r = c = o = l = void 0;
    }

    function ve() {
      return l === void 0 ? s : Q(zs());
    }

    function _e() {
      var T = zs(),
          Z = R(T);

      if (r = arguments, o = this, c = T, Z) {
        if (l === void 0) return x(c);
        if (h) return l = setTimeout(M, e), v(c);
      }

      return l === void 0 && (l = setTimeout(M, e)), s;
    }

    return _e.cancel = se, _e.flush = ve, _e;
  }

  function Ls(i) {
    var e = typeof i;
    return !!i && (e == "object" || e == "function");
  }

  function Km(i) {
    return !!i && typeof i == "object";
  }

  function qm(i) {
    return typeof i == "symbol" || Km(i) && jm.call(i) == Tm;
  }

  function Sc(i) {
    if (typeof i == "number") return i;
    if (qm(i)) return _c;

    if (Ls(i)) {
      var e = typeof i.valueOf == "function" ? i.valueOf() : i;
      i = Ls(e) ? e + "" : e;
    }

    if (typeof i != "string") return i === 0 ? i : +i;
    i = i.replace(Pm, "");
    var t = Bm.test(i);
    return t || zm.test(i) ? Lm(i.slice(2), t ? 2 : 8) : Mm.test(i) ? _c : +i;
  }

  vc.exports = $m;
});
var fr = Ym(function (UA, bu) {
  var yu = "Expected a function",
      vu = 0 / 0,
      gf = "[object Symbol]",
      bf = /^\s+|\s+$/g,
      yf = /^[-+]0x[0-9a-f]+$/i,
      vf = /^0b[01]+$/i,
      _f = /^0o[0-7]+$/i,
      Sf = parseInt,
      Df = typeof global == "object" && global && global.Object === Object && global,
      xf = typeof self == "object" && self && self.Object === Object && self,
      Cf = Df || xf || Function("return this")(),
      wf = Object.prototype,
      Ef = wf.toString,
      kf = Math.max,
      If = Math.min,
      ua = function ua() {
    return Cf.Date.now();
  };

  function Ff(i, e, t) {
    var r,
        o,
        n,
        s,
        l,
        c,
        p = 0,
        m = !1,
        h = !1,
        b = !0;
    if (typeof i != "function") throw new TypeError(yu);
    e = _u(e) || 0, Uo(t) && (m = !!t.leading, h = "maxWait" in t, n = h ? kf(_u(t.maxWait) || 0, e) : n, b = "trailing" in t ? !!t.trailing : b);

    function v(T) {
      var Z = r,
          ae = o;
      return r = o = void 0, p = T, s = i.apply(ae, Z), s;
    }

    function x(T) {
      return p = T, l = setTimeout(M, e), m ? v(T) : s;
    }

    function I(T) {
      var Z = T - c,
          ae = T - p,
          Qe = e - Z;
      return h ? If(Qe, n - ae) : Qe;
    }

    function R(T) {
      var Z = T - c,
          ae = T - p;
      return c === void 0 || Z >= e || Z < 0 || h && ae >= n;
    }

    function M() {
      var T = ua();
      if (R(T)) return Q(T);
      l = setTimeout(M, I(T));
    }

    function Q(T) {
      return l = void 0, b && r ? v(T) : (r = o = void 0, s);
    }

    function se() {
      l !== void 0 && clearTimeout(l), p = 0, r = c = o = l = void 0;
    }

    function ve() {
      return l === void 0 ? s : Q(ua());
    }

    function _e() {
      var T = ua(),
          Z = R(T);

      if (r = arguments, o = this, c = T, Z) {
        if (l === void 0) return x(c);
        if (h) return l = setTimeout(M, e), v(c);
      }

      return l === void 0 && (l = setTimeout(M, e)), s;
    }

    return _e.cancel = se, _e.flush = ve, _e;
  }

  function Af(i, e, t) {
    var r = !0,
        o = !0;
    if (typeof i != "function") throw new TypeError(yu);
    return Uo(t) && (r = "leading" in t ? !!t.leading : r, o = "trailing" in t ? !!t.trailing : o), Ff(i, e, {
      leading: r,
      maxWait: e,
      trailing: o
    });
  }

  function Uo(i) {
    var e = typeof i;
    return !!i && (e == "object" || e == "function");
  }

  function Rf(i) {
    return !!i && typeof i == "object";
  }

  function Of(i) {
    return typeof i == "symbol" || Rf(i) && Ef.call(i) == gf;
  }

  function _u(i) {
    if (typeof i == "number") return i;
    if (Of(i)) return vu;

    if (Uo(i)) {
      var e = typeof i.valueOf == "function" ? i.valueOf() : i;
      i = Uo(e) ? e + "" : e;
    }

    if (typeof i != "string") return i === 0 ? i : +i;
    i = i.replace(bf, "");
    var t = vf.test(i);
    return t || _f.test(i) ? Sf(i.slice(2), t ? 2 : 8) : yf.test(i) ? vu : +i;
  }

  bu.exports = Af;
});
var rd = "An invariant failed, however the error is obfuscated because this is an production build.",
    Ir = [];
Object.freeze(Ir);
var Oa = {};
Object.freeze(Oa);
var od = {};

function gi() {
  return typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : od;
}

function Ce() {
  return ++E.mobxGuid;
}

function V(i) {
  throw Rt(!1, i), "X";
}

function Rt(i, e) {
  if (!i) throw new Error("[mobx] " + (e || rd));
}

var Ta = [];

function mt(i, e) {
  return !1;
}

function Jo(i) {
  var e = !1;
  return function () {
    if (!e) return e = !0, i.apply(this, arguments);
  };
}

var Pa = function Pa() {};

function nd(i) {
  var e = [];
  return i.forEach(function (t) {
    e.indexOf(t) === -1 && e.push(t);
  }), e;
}

function Zo(i) {
  return i !== null && typeof i == "object";
}

function bi(i) {
  if (i === null || typeof i != "object") return !1;
  var e = Object.getPrototypeOf(i);
  return e === Object.prototype || e === null;
}

function sd(i) {
  if (yi(i) || et(i)) return i;
  if (Array.isArray(i)) return new Map(i);

  if (bi(i)) {
    var e = new Map();

    for (var t in i) {
      e.set(t, i[t]);
    }

    return e;
  } else return V("Cannot convert to map from '" + i + "'");
}

function ad(i, e) {
  for (var t = 0; t < e.length; t++) {
    ht(i, e[t], i[e[t]]);
  }
}

function ht(i, e, t) {
  Object.defineProperty(i, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: t
  });
}

function Hi(i, e, t) {
  Object.defineProperty(i, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: t
  });
}

function ld(i, e) {}

function Ot(i, e) {
  var t = "isMobX" + i;
  return e.prototype[t] = !0, function (r) {
    return Zo(r) && r[t] === !0;
  };
}

function cd(i, e) {
  return typeof i == "number" && typeof e == "number" && isNaN(i) && isNaN(e);
}

function yi(i) {
  return gi().Map !== void 0 && i instanceof gi().Map;
}

function Wi(i) {
  return i instanceof Set;
}

function ft(i) {
  for (var e = [];;) {
    var t = i.next();
    if (t.done) break;
    e.push(t.value);
  }

  return e;
}

function Ma() {
  return typeof Symbol == "function" && Symbol.toPrimitive || "@@toPrimitive";
}

function Ba(i) {
  return i === null ? null : typeof i == "object" ? "" + i : i;
}

function za(i, e) {
  for (var t = i.next(); !t.done;) {
    e(t.value), t = i.next();
  }
}

function La() {
  return typeof Symbol == "function" && Symbol.iterator || "@@iterator";
}

function Qo(i, e) {
  Hi(i, La(), e);
}

function ji(i) {
  return i[La()] = ud, i;
}

function en() {
  return typeof Symbol == "function" && Symbol.toStringTag || "@@toStringTag";
}

function ud() {
  return this;
}

var Fr = function () {
  function i(e) {
    e === void 0 && (e = "Atom@" + Ce()), this.name = e, this.isPendingUnobservation = !1, this.isBeingObserved = !1, this.observers = [], this.observersIndexes = {}, this.diffValue = 0, this.lastAccessedBy = 0, this.lowestObserverState = N.NOT_TRACKING;
  }

  return i.prototype.onBecomeUnobserved = function () {}, i.prototype.onBecomeObserved = function () {}, i.prototype.reportObserved = function () {
    return Ua(this);
  }, i.prototype.reportChanged = function () {
    gt(), dd(this), bt();
  }, i.prototype.toString = function () {
    return this.name;
  }, i;
}(),
    tn = Ot("Atom", Fr);

function Ar(i, e, t) {
  e === void 0 && (e = Pa), t === void 0 && (t = Pa);
  var r = new Fr(i);
  return pd(r, e), Na(r, t), r;
}

function Ha(i, e) {
  return i === e;
}

function md(i, e) {
  return rn(i, e);
}

function hd(i, e) {
  return rn(i, e, 1);
}

function fd(i, e) {
  return cd(i, e) || Ha(i, e);
}

var Rr = {
  identity: Ha,
  structural: md,
  default: fd,
  shallow: hd
};

var _on = function on(i, e) {
  return _on = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, r) {
    t.__proto__ = r;
  } || function (t, r) {
    for (var o in r) {
      r.hasOwnProperty(o) && (t[o] = r[o]);
    }
  }, _on(i, e);
};

function Wa(i, e) {
  _on(i, e);

  function t() {
    this.constructor = i;
  }

  i.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}

var _q = function q() {
  return _q = Object.assign || function (e) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }, _q.apply(this, arguments);
};

function nn(i, e) {
  var t = typeof Symbol == "function" && i[Symbol.iterator];
  if (!t) return i;
  var r = t.call(i),
      o,
      n = [],
      s;

  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done;) {
      n.push(o.value);
    }
  } catch (l) {
    s = {
      error: l
    };
  } finally {
    try {
      o && !o.done && (t = r.return) && t.call(r);
    } finally {
      if (s) throw s.error;
    }
  }

  return n;
}

function sn() {
  for (var i = [], e = 0; e < arguments.length; e++) {
    i = i.concat(nn(arguments[e]));
  }

  return i;
}

var gd = {},
    bd = {};

function yd(i, e) {
  var t = e ? gd : bd;
  return t[i] || (t[i] = {
    configurable: !0,
    enumerable: e,
    get: function get() {
      return Yt(this), this[i];
    },
    set: function set(r) {
      Yt(this), this[i] = r;
    }
  });
}

function Yt(i) {
  if (i.__mobxDidRunLazyInitializers !== !0) {
    var e = i.__mobxDecorators;

    if (e) {
      ht(i, "__mobxDidRunLazyInitializers", !0);

      for (var t in e) {
        var r = e[t];
        r.propertyCreator(i, r.prop, r.descriptor, r.decoratorTarget, r.decoratorArguments);
      }
    }
  }
}

function ja(i, e) {
  return function () {
    var r,
        o = function o(s, l, c, p) {
      if (p === !0) return e(s, l, c, s, r), null;

      if (!Object.prototype.hasOwnProperty.call(s, "__mobxDecorators")) {
        var m = s.__mobxDecorators;
        ht(s, "__mobxDecorators", _q({}, m));
      }

      return s.__mobxDecorators[l] = {
        prop: l,
        propertyCreator: e,
        descriptor: c,
        decoratorTarget: s,
        decoratorArguments: r
      }, yd(l, i);
    };

    return vd(arguments) ? (r = Ir, o.apply(null, arguments)) : (r = Array.prototype.slice.call(arguments), o);
  };
}

function vd(i) {
  return (i.length === 2 || i.length === 3) && typeof i[1] == "string" || i.length === 4 && i[3] === !0;
}

function Gi(i, e, t) {
  return Or(i) ? i : Array.isArray(i) ? S.array(i, {
    name: t
  }) : bi(i) ? S.object(i, void 0, {
    name: t
  }) : yi(i) ? S.map(i, {
    name: t
  }) : Wi(i) ? S.set(i, {
    name: t
  }) : i;
}

function _d(i, e, t) {
  return i == null || Jt(i) || Xt(i) || et(i) || Tt(i) ? i : Array.isArray(i) ? S.array(i, {
    name: t,
    deep: !1
  }) : bi(i) ? S.object(i, void 0, {
    name: t,
    deep: !1
  }) : yi(i) ? S.map(i, {
    name: t,
    deep: !1
  }) : Wi(i) ? S.set(i, {
    name: t,
    deep: !1
  }) : V(!1);
}

function Tr(i) {
  return i;
}

function Sd(i, e, t) {
  return rn(i, e) ? e : i;
}

function Pr(i) {
  Rt(i);
  var e = ja(!0, function (r, o, n, s, l) {
    var c = n ? n.initializer ? n.initializer.call(r) : n.value : void 0;
    Dd(r, o, c, i);
  }),
      t = typeof process != "undefined" && process.env && !1 ? function () {
    return arguments.length < 2 ? V("Incorrect decorator invocation. @observable decorator doesn't expect any arguments") : e.apply(null, arguments);
  } : e;
  return t.enhancer = i, t;
}

var Ga = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0
},
    xd = {
  deep: !1,
  name: void 0,
  defaultDecorator: void 0
};
Object.freeze(Ga);
Object.freeze(xd);

function vi(i) {
  return i == null ? Ga : typeof i == "string" ? {
    name: i,
    deep: !0
  } : i;
}

function Mr(i) {
  return i.defaultDecorator ? i.defaultDecorator.enhancer : i.deep === !1 ? Tr : Gi;
}

var an = Pr(Gi),
    Cd = Pr(_d),
    Va = Pr(Tr),
    wd = Pr(Sd);

function Ed(i, e, t) {
  if (typeof arguments[1] == "string") return an.apply(null, arguments);
  if (Or(i)) return i;
  var r = bi(i) ? S.object(i, e, t) : Array.isArray(i) ? S.array(i, e) : yi(i) ? S.map(i, e) : Wi(i) ? S.set(i, e) : i;
  if (r !== i) return r;
  V(!1);
}

var $a = {
  box: function box(i, e) {
    arguments.length > 2 && yt("box");
    var t = vi(e);
    return new Pt(i, Mr(t), t.name, !0, t.equals);
  },
  shallowBox: function shallowBox(i, e) {
    return arguments.length > 2 && yt("shallowBox"), mt("observable.shallowBox", "observable.box(value, { deep: false })"), S.box(i, {
      name: e,
      deep: !1
    });
  },
  array: function array(i, e) {
    arguments.length > 2 && yt("array");
    var t = vi(e);
    return new tt(i, Mr(t), t.name);
  },
  shallowArray: function shallowArray(i, e) {
    return arguments.length > 2 && yt("shallowArray"), mt("observable.shallowArray", "observable.array(values, { deep: false })"), S.array(i, {
      name: e,
      deep: !1
    });
  },
  map: function map(i, e) {
    arguments.length > 2 && yt("map");
    var t = vi(e);
    return new Br(i, Mr(t), t.name);
  },
  shallowMap: function shallowMap(i, e) {
    return arguments.length > 2 && yt("shallowMap"), mt("observable.shallowMap", "observable.map(values, { deep: false })"), S.map(i, {
      name: e,
      deep: !1
    });
  },
  set: function set(i, e) {
    arguments.length > 2 && yt("set");
    var t = vi(e);
    return new zr(i, Mr(t), t.name);
  },
  object: function object(i, e, t) {
    typeof arguments[1] == "string" && yt("object");
    var r = vi(t);
    return kd({}, i, e, r);
  },
  shallowObject: function shallowObject(i, e) {
    return typeof arguments[1] == "string" && yt("shallowObject"), mt("observable.shallowObject", "observable.object(values, {}, { deep: false })"), S.object(i, {}, {
      name: e,
      deep: !1
    });
  },
  ref: Va,
  shallow: Cd,
  deep: an,
  struct: wd
},
    S = Ed;
Object.keys($a).forEach(function (i) {
  return S[i] = $a[i];
});

function yt(i) {
  V("Expected one or two arguments to observable." + i + ". Did you accidentally try to use observable." + i + " as decorator?");
}

var Lr = ja(!1, function (i, e, t, r, o) {
  var n = t.get,
      s = t.set,
      l = o[0] || {};
  Id(i, e, _q({
    get: n,
    set: s
  }, l));
}),
    Fd = Lr({
  equals: Rr.structural
}),
    u = function u(e, t, r) {
  if (typeof t == "string" || e !== null && typeof e == "object" && arguments.length === 1) return Lr.apply(null, arguments);
  var o = typeof t == "object" ? t : {};
  return o.get = e, o.set = typeof t == "function" ? t : o.set, o.name = o.name || e.name || "", new Mt(o);
};

u.struct = Fd;
var N;

(function (i) {
  i[i.NOT_TRACKING = -1] = "NOT_TRACKING", i[i.UP_TO_DATE = 0] = "UP_TO_DATE", i[i.POSSIBLY_STALE = 1] = "POSSIBLY_STALE", i[i.STALE = 2] = "STALE";
})(N || (N = {}));

var He;

(function (i) {
  i[i.NONE = 0] = "NONE", i[i.LOG = 1] = "LOG", i[i.BREAK = 2] = "BREAK";
})(He || (He = {}));

var Ur = function () {
  function i(e) {
    this.cause = e;
  }

  return i;
}();

function Vi(i) {
  return i instanceof Ur;
}

function ln(i) {
  switch (i.dependenciesState) {
    case N.UP_TO_DATE:
      return !1;

    case N.NOT_TRACKING:
    case N.STALE:
      return !0;

    case N.POSSIBLY_STALE:
      {
        for (var e = Zt(!0), t = _i(), r = i.observing, o = r.length, n = 0; n < o; n++) {
          var s = r[n];

          if (Nr(s)) {
            if (E.disableErrorBoundaries) s.get();else try {
              s.get();
            } catch (l) {
              return Bt(t), vt(e), !0;
            }
            if (i.dependenciesState === N.STALE) return Bt(t), vt(e), !0;
          }
        }

        return Ka(i), Bt(t), vt(e), !1;
      }
  }
}

function Si(i) {
  var e = i.observers.length > 0;
  E.computationDepth > 0 && e && V(!1), !E.allowStateChanges && (e || E.enforceActions === "strict") && V(!1);
}

function Ad(i) {}

function qa(i, e, t) {
  var r = Zt(!0);
  Ka(i), i.newObserving = new Array(i.observing.length + 100), i.unboundDepsCount = 0, i.runId = ++E.runId;
  var o = E.trackingDerivation;
  E.trackingDerivation = i;
  var n;
  if (E.disableErrorBoundaries === !0) n = e.call(t);else try {
    n = e.call(t);
  } catch (s) {
    n = new Ur(s);
  }
  return E.trackingDerivation = o, Od(i), i.observing.length === 0 && Rd(i), vt(r), n;
}

function Rd(i) {}

function Od(i) {
  for (var e = i.observing, t = i.observing = i.newObserving, r = N.UP_TO_DATE, o = 0, n = i.unboundDepsCount, s = 0; s < n; s++) {
    var l = t[s];
    l.diffValue === 0 && (l.diffValue = 1, o !== s && (t[o] = l), o++), l.dependenciesState > r && (r = l.dependenciesState);
  }

  for (t.length = o, i.newObserving = null, n = e.length; n--;) {
    var l = e[n];
    l.diffValue === 0 && Ya(l, i), l.diffValue = 0;
  }

  for (; o--;) {
    var l = t[o];
    l.diffValue === 1 && (l.diffValue = 0, Td(l, i));
  }

  r !== N.UP_TO_DATE && (i.dependenciesState = r, i.onBecomeStale());
}

function cn(i) {
  var e = i.observing;
  i.observing = [];

  for (var t = e.length; t--;) {
    Ya(e[t], i);
  }

  i.dependenciesState = N.NOT_TRACKING;
}

function un(i) {
  var e = _i(),
      t = i();

  return Bt(e), t;
}

function _i() {
  var i = E.trackingDerivation;
  return E.trackingDerivation = null, i;
}

function Bt(i) {
  E.trackingDerivation = i;
}

function Zt(i) {
  var e = E.allowStateReads;
  return E.allowStateReads = i, e;
}

function vt(i) {
  E.allowStateReads = i;
}

function Ka(i) {
  if (i.dependenciesState !== N.UP_TO_DATE) {
    i.dependenciesState = N.UP_TO_DATE;

    for (var e = i.observing, t = e.length; t--;) {
      e[t].lowestObserverState = N.UP_TO_DATE;
    }
  }
}

var Hr = 0,
    Pd = 1,
    Xa = Object.getOwnPropertyDescriptor(function () {}, "name"),
    db = Xa && Xa.configurable;

function Qt(i, e) {
  var t = function t() {
    return Ja(i, e, this, arguments);
  };

  return t.isMobxAction = !0, t;
}

function Ja(i, e, t, r) {
  var o = Md(i, t, r);

  try {
    return e.apply(t, r);
  } catch (n) {
    throw o.error = n, n;
  } finally {
    Bd(o);
  }
}

function Md(i, e, t) {
  var r = ge() && !!i,
      o = 0;

  if (r) {
    o = Date.now();
    var n = t && t.length || 0,
        s = new Array(n);
    if (n > 0) for (var l = 0; l < n; l++) {
      s[l] = t[l];
    }
    we({
      type: "action",
      name: i,
      object: e,
      arguments: s
    });
  }

  var c = _i();

  gt();
  var p = $i(!0),
      m = Zt(!0),
      h = {
    prevDerivation: c,
    prevAllowStateChanges: p,
    prevAllowStateReads: m,
    notifySpy: r,
    startTime: o,
    actionId: Pd++,
    parentActionId: Hr
  };
  return Hr = h.actionId, h;
}

function Bd(i) {
  Hr !== i.actionId && V("invalid action stack. did you forget to finish an action?"), Hr = i.parentActionId, i.error !== void 0 && (E.suppressReactionErrors = !0), Ki(i.prevAllowStateChanges), vt(i.prevAllowStateReads), bt(), Bt(i.prevDerivation), i.notifySpy && Ee({
    time: Date.now() - i.startTime
  }), E.suppressReactionErrors = !1;
}

function Za(i, e) {
  var t = $i(i),
      r;

  try {
    r = e();
  } finally {
    Ki(t);
  }

  return r;
}

function $i(i) {
  var e = E.allowStateChanges;
  return E.allowStateChanges = i, e;
}

function Ki(i) {
  E.allowStateChanges = i;
}

var Pt = function (i) {
  Wa(e, i);

  function e(t, r, o, n, s) {
    o === void 0 && (o = "ObservableValue@" + Ce()), n === void 0 && (n = !0), s === void 0 && (s = Rr.default);
    var l = i.call(this, o) || this;
    return l.enhancer = r, l.name = o, l.equals = s, l.hasUnreportedChange = !1, l.value = r(t, void 0, o), n && ge() && ei({
      type: "create",
      name: l.name,
      newValue: "" + l.value
    }), l;
  }

  return e.prototype.dehanceValue = function (t) {
    return this.dehancer !== void 0 ? this.dehancer(t) : t;
  }, e.prototype.set = function (t) {
    var r = this.value;

    if (t = this.prepareNewValue(t), t !== E.UNCHANGED) {
      var o = ge();
      o && we({
        type: "update",
        name: this.name,
        newValue: t,
        oldValue: r
      }), this.setNewValue(t), o && Ee();
    }
  }, e.prototype.prepareNewValue = function (t) {
    if (Si(this), it(this)) {
      var r = rt(this, {
        object: this,
        type: "update",
        newValue: t
      });
      if (!r) return E.UNCHANGED;
      t = r.newValue;
    }

    return t = this.enhancer(t, this.value, this.name), this.equals(this.value, t) ? E.UNCHANGED : t;
  }, e.prototype.setNewValue = function (t) {
    var r = this.value;
    this.value = t, this.reportChanged(), We(this) && je(this, {
      type: "update",
      object: this,
      newValue: t,
      oldValue: r
    });
  }, e.prototype.get = function () {
    return this.reportObserved(), this.dehanceValue(this.value);
  }, e.prototype.intercept = function (t) {
    return qi(this, t);
  }, e.prototype.observe = function (t, r) {
    return r && t({
      object: this,
      type: "update",
      newValue: this.value,
      oldValue: void 0
    }), Yi(this, t);
  }, e.prototype.toJSON = function () {
    return this.get();
  }, e.prototype.toString = function () {
    return this.name + "[" + this.value + "]";
  }, e.prototype.valueOf = function () {
    return Ba(this.get());
  }, e;
}(Fr);

Pt.prototype[Ma()] = Pt.prototype.valueOf;

var zd = Ot("ObservableValue", Pt),
    Mt = function () {
  function i(e) {
    this.dependenciesState = N.NOT_TRACKING, this.observing = [], this.newObserving = null, this.isBeingObserved = !1, this.isPendingUnobservation = !1, this.observers = [], this.observersIndexes = {}, this.diffValue = 0, this.runId = 0, this.lastAccessedBy = 0, this.lowestObserverState = N.UP_TO_DATE, this.unboundDepsCount = 0, this.__mapid = "#" + Ce(), this.value = new Ur(null), this.isComputing = !1, this.isRunningSetter = !1, this.isTracing = He.NONE, Rt(e.get, "missing option for computed: get"), this.derivation = e.get, this.name = e.name || "ComputedValue@" + Ce(), e.set && (this.setter = Qt(this.name + "-setter", e.set)), this.equals = e.equals || (e.compareStructural || e.struct ? Rr.structural : Rr.default), this.scope = e.context, this.requiresReaction = !!e.requiresReaction, this.keepAlive = !!e.keepAlive;
  }

  return i.prototype.onBecomeStale = function () {
    Ud(this);
  }, i.prototype.onBecomeUnobserved = function () {}, i.prototype.onBecomeObserved = function () {}, i.prototype.get = function () {
    this.isComputing && V("Cycle detected in computation " + this.name + ": " + this.derivation), E.inBatch === 0 && this.observers.length === 0 && !this.keepAlive ? ln(this) && (this.warnAboutUntrackedRead(), gt(), this.value = this.computeValue(!1), bt()) : (Ua(this), ln(this) && this.trackAndCompute() && Ld(this));
    var e = this.value;
    if (Vi(e)) throw e.cause;
    return e;
  }, i.prototype.peek = function () {
    var e = this.computeValue(!1);
    if (Vi(e)) throw e.cause;
    return e;
  }, i.prototype.set = function (e) {
    if (this.setter) {
      Rt(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"), this.isRunningSetter = !0;

      try {
        this.setter.call(this.scope, e);
      } finally {
        this.isRunningSetter = !1;
      }
    } else Rt(!1, !1);
  }, i.prototype.trackAndCompute = function () {
    ge() && ei({
      object: this.scope,
      type: "compute",
      name: this.name
    });
    var e = this.value,
        t = this.dependenciesState === N.NOT_TRACKING,
        r = this.computeValue(!0),
        o = t || Vi(e) || Vi(r) || !this.equals(e, r);
    return o && (this.value = r), o;
  }, i.prototype.computeValue = function (e) {
    this.isComputing = !0, E.computationDepth++;
    var t;
    if (e) t = qa(this, this.derivation, this.scope);else if (E.disableErrorBoundaries === !0) t = this.derivation.call(this.scope);else try {
      t = this.derivation.call(this.scope);
    } catch (r) {
      t = new Ur(r);
    }
    return E.computationDepth--, this.isComputing = !1, t;
  }, i.prototype.suspend = function () {
    this.keepAlive || (cn(this), this.value = void 0);
  }, i.prototype.observe = function (e, t) {
    var r = this,
        o = !0,
        n = void 0;
    return Nd(function () {
      var s = r.get();

      if (!o || t) {
        var l = _i();

        e({
          type: "update",
          object: r,
          newValue: s,
          oldValue: n
        }), Bt(l);
      }

      o = !1, n = s;
    });
  }, i.prototype.warnAboutUntrackedRead = function () {}, i.prototype.toJSON = function () {
    return this.get();
  }, i.prototype.toString = function () {
    return this.name + "[" + this.derivation.toString() + "]";
  }, i.prototype.valueOf = function () {
    return Ba(this.get());
  }, i;
}();

Mt.prototype[Ma()] = Mt.prototype.valueOf;
var Nr = Ot("ComputedValue", Mt);

var Wr = function () {
  function i() {
    this.version = 5, this.UNCHANGED = {}, this.trackingDerivation = null, this.computationDepth = 0, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !0, this.allowStateReads = !0, this.enforceActions = !1, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.computedConfigurable = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1;
  }

  return i;
}(),
    jr = !0,
    Qa = !1,
    E = function () {
  var i = gi();
  return i.__mobxInstanceCount > 0 && !i.__mobxGlobals && (jr = !1), i.__mobxGlobals && i.__mobxGlobals.version !== new Wr().version && (jr = !1), jr ? i.__mobxGlobals ? (i.__mobxInstanceCount += 1, i.__mobxGlobals.UNCHANGED || (i.__mobxGlobals.UNCHANGED = {}), i.__mobxGlobals) : (i.__mobxInstanceCount = 1, i.__mobxGlobals = new Wr()) : (setTimeout(function () {
    Qa || V("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
  }, 1), new Wr());
}();

function Hd() {
  (E.pendingReactions.length || E.inBatch || E.isRunningReactions) && V("isolateGlobalState should be called before MobX is running any reactions"), Qa = !0, jr && (--gi().__mobxInstanceCount == 0 && (gi().__mobxGlobals = void 0), E = new Wr());
}

function Td(i, e) {
  var t = i.observers.length;
  t && (i.observersIndexes[e.__mapid] = t), i.observers[t] = e, i.lowestObserverState > e.dependenciesState && (i.lowestObserverState = e.dependenciesState);
}

function Ya(i, e) {
  if (i.observers.length === 1) i.observers.length = 0, el(i);else {
    var t = i.observers,
        r = i.observersIndexes,
        o = t.pop();

    if (o !== e) {
      var n = r[e.__mapid] || 0;
      n ? r[o.__mapid] = n : delete r[o.__mapid], t[n] = o;
    }

    delete r[e.__mapid];
  }
}

function el(i) {
  i.isPendingUnobservation === !1 && (i.isPendingUnobservation = !0, E.pendingUnobservations.push(i));
}

function gt() {
  E.inBatch++;
}

function bt() {
  if (--E.inBatch == 0) {
    tl();

    for (var i = E.pendingUnobservations, e = 0; e < i.length; e++) {
      var t = i[e];
      t.isPendingUnobservation = !1, t.observers.length === 0 && (t.isBeingObserved && (t.isBeingObserved = !1, t.onBecomeUnobserved()), t instanceof Mt && t.suspend());
    }

    E.pendingUnobservations = [];
  }
}

function Ua(i) {
  Ad(i);
  var e = E.trackingDerivation;
  return e !== null ? (e.runId !== i.lastAccessedBy && (i.lastAccessedBy = e.runId, e.newObserving[e.unboundDepsCount++] = i, i.isBeingObserved || (i.isBeingObserved = !0, i.onBecomeObserved())), !0) : (i.observers.length === 0 && E.inBatch > 0 && el(i), !1);
}

function dd(i) {
  if (i.lowestObserverState !== N.STALE) {
    i.lowestObserverState = N.STALE;

    for (var e = i.observers, t = e.length; t--;) {
      var r = e[t];
      r.dependenciesState === N.UP_TO_DATE && (r.isTracing !== He.NONE && il(r, i), r.onBecomeStale()), r.dependenciesState = N.STALE;
    }
  }
}

function Ld(i) {
  if (i.lowestObserverState !== N.STALE) {
    i.lowestObserverState = N.STALE;

    for (var e = i.observers, t = e.length; t--;) {
      var r = e[t];
      r.dependenciesState === N.POSSIBLY_STALE ? r.dependenciesState = N.STALE : r.dependenciesState === N.UP_TO_DATE && (i.lowestObserverState = N.UP_TO_DATE);
    }
  }
}

function Ud(i) {
  if (i.lowestObserverState === N.UP_TO_DATE) {
    i.lowestObserverState = N.POSSIBLY_STALE;

    for (var e = i.observers, t = e.length; t--;) {
      var r = e[t];
      r.dependenciesState === N.UP_TO_DATE && (r.dependenciesState = N.POSSIBLY_STALE, r.isTracing !== He.NONE && il(r, i), r.onBecomeStale());
    }
  }
}

function il(i, e) {
  if (console.log("[mobx.trace] '" + i.name + "' is invalidated due to a change in: '" + e.name + "'"), i.isTracing === He.BREAK) {
    var t = [];
    rl(dn(i), t, 1), new Function("debugger;\n/*\nTracing '" + i.name + "'\n\nYou are entering this break point because derivation '" + i.name + "' is being traced and '" + e.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (i instanceof Mt ? i.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + t.join("\n") + "\n*/\n    ")();
  }
}

function rl(i, e, t) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }

  e.push("" + new Array(t).join("	") + i.name), i.dependencies && i.dependencies.forEach(function (r) {
    return rl(r, e, t + 1);
  });
}

var zt = function () {
  function i(e, t, r, o) {
    e === void 0 && (e = "Reaction@" + Ce()), o === void 0 && (o = !1), this.name = e, this.onInvalidate = t, this.errorHandler = r, this.requiresObservable = o, this.observing = [], this.newObserving = [], this.dependenciesState = N.NOT_TRACKING, this.diffValue = 0, this.runId = 0, this.unboundDepsCount = 0, this.__mapid = "#" + Ce(), this.isDisposed = !1, this._isScheduled = !1, this._isTrackPending = !1, this._isRunning = !1, this.isTracing = He.NONE;
  }

  return i.prototype.onBecomeStale = function () {
    this.schedule();
  }, i.prototype.schedule = function () {
    this._isScheduled || (this._isScheduled = !0, E.pendingReactions.push(this), tl());
  }, i.prototype.isScheduled = function () {
    return this._isScheduled;
  }, i.prototype.runReaction = function () {
    if (!this.isDisposed) {
      if (gt(), this._isScheduled = !1, ln(this)) {
        this._isTrackPending = !0;

        try {
          this.onInvalidate(), this._isTrackPending && ge() && ei({
            name: this.name,
            type: "scheduled-reaction"
          });
        } catch (e) {
          this.reportExceptionInDerivation(e);
        }
      }

      bt();
    }
  }, i.prototype.track = function (e) {
    gt();
    var t = ge(),
        r;
    t && (r = Date.now(), we({
      name: this.name,
      type: "reaction"
    })), this._isRunning = !0;
    var o = qa(this, e, void 0);
    this._isRunning = !1, this._isTrackPending = !1, this.isDisposed && cn(this), Vi(o) && this.reportExceptionInDerivation(o.cause), t && Ee({
      time: Date.now() - r
    }), bt();
  }, i.prototype.reportExceptionInDerivation = function (e) {
    var t = this;

    if (this.errorHandler) {
      this.errorHandler(e, this);
      return;
    }

    if (E.disableErrorBoundaries) throw e;
    var r = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
    E.suppressReactionErrors ? console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)") : console.error(r, e), ge() && ei({
      type: "error",
      name: this.name,
      message: r,
      error: "" + e
    }), E.globalReactionErrorHandlers.forEach(function (o) {
      return o(e, t);
    });
  }, i.prototype.dispose = function () {
    this.isDisposed || (this.isDisposed = !0, this._isRunning || (gt(), cn(this), bt()));
  }, i.prototype.getDisposer = function () {
    var e = this.dispose.bind(this);
    return e.$mobx = this, e;
  }, i.prototype.toString = function () {
    return "Reaction[" + this.name + "]";
  }, i.prototype.trace = function (e) {
    e === void 0 && (e = !1), Wd(this, e);
  }, i;
}();

var ol = 100,
    pn = function pn(i) {
  return i();
};

function tl() {
  E.inBatch > 0 || E.isRunningReactions || pn(jd);
}

function jd() {
  E.isRunningReactions = !0;

  for (var i = E.pendingReactions, e = 0; i.length > 0;) {
    ++e === ol && (console.error("Reaction doesn't converge to a stable state after " + ol + " iterations." + (" Probably there is a cycle in the reactive function: " + i[0])), i.splice(0));

    for (var t = i.splice(0), r = 0, o = t.length; r < o; r++) {
      t[r].runReaction();
    }
  }

  E.isRunningReactions = !1;
}

var Gr = Ot("Reaction", zt);

function Gd(i) {
  var e = pn;

  pn = function pn(t) {
    return i(function () {
      return e(t);
    });
  };
}

function ge() {
  return !!E.spyListeners.length;
}

function ei(i) {
  if (!!E.spyListeners.length) for (var e = E.spyListeners, t = 0, r = e.length; t < r; t++) {
    e[t](i);
  }
}

function we(i) {
  var e = _q(_q({}, i), {
    spyReportStart: !0
  });

  ei(e);
}

var Vd = {
  spyReportEnd: !0
};

function Ee(i) {
  ei(i ? _q(_q({}, i), {
    spyReportEnd: !0
  }) : Vd);
}

function mn(i) {
  return E.spyListeners.push(i), Jo(function () {
    E.spyListeners = E.spyListeners.filter(function (e) {
      return e !== i;
    });
  });
}

function $d() {
  V(!1);
}

function nl(i) {
  return function (e, t, r) {
    if (r) {
      if (r.value) return {
        value: Qt(i, r.value),
        enumerable: !1,
        configurable: !0,
        writable: !0
      };
      var o = r.initializer;
      return {
        enumerable: !1,
        configurable: !0,
        writable: !0,
        initializer: function initializer() {
          return Qt(i, o.call(this));
        }
      };
    }

    return Kd(i).apply(this, arguments);
  };
}

function Kd(i) {
  return function (e, t, r) {
    Object.defineProperty(e, t, {
      configurable: !0,
      enumerable: !1,
      get: function get() {},
      set: function set(o) {
        ht(this, t, d(i, o));
      }
    });
  };
}

function qd(i, e, t, r) {
  return r === !0 ? (hn(i, e, t.value), null) : t ? {
    configurable: !0,
    enumerable: !1,
    get: function get() {
      return hn(this, e, t.value || t.initializer.call(this)), this[e];
    },
    set: $d
  } : {
    enumerable: !1,
    configurable: !0,
    set: function set(o) {
      hn(this, e, o);
    },
    get: function get() {}
  };
}

var d = function d(e, t, r, o) {
  if (arguments.length === 1 && typeof e == "function") return Qt(e.name || "<unnamed action>", e);
  if (arguments.length === 2 && typeof t == "function") return Qt(e, t);
  if (arguments.length === 1 && typeof e == "string") return nl(e);
  if (o === !0) e[t] = Qt(e.name || t, r.value);else return nl(t).apply(null, arguments);
};

d.bound = qd;

function re(i, e) {
  var t = typeof i == "string" ? i : i.name || "<unnamed action>",
      r = typeof i == "function" ? i : e;
  return Ja(t, r, this, void 0);
}

function hn(i, e, t) {
  ht(i, e, Qt(e, t.bind(i)));
}

function Nd(i, e) {
  e === void 0 && (e = Oa);
  var t = e && e.name || i.name || "Autorun@" + Ce(),
      r = !e.scheduler && !e.delay,
      o;
  if (r) o = new zt(t, function () {
    this.track(l);
  }, e.onError, e.requiresObservable);else {
    var n = Yd(e),
        s = !1;
    o = new zt(t, function () {
      s || (s = !0, n(function () {
        s = !1, o.isDisposed || o.track(l);
      }));
    }, e.onError, e.requiresObservable);
  }

  function l() {
    i(o);
  }

  return o.schedule(), o.getDisposer();
}

var Xd = function Xd(i) {
  return i();
};

function Yd(i) {
  return i.scheduler ? i.scheduler : i.delay ? function (e) {
    return setTimeout(e, i.delay);
  } : Xd;
}

function pd(i, e, t) {
  return sl("onBecomeObserved", i, e, t);
}

function Na(i, e, t) {
  return sl("onBecomeUnobserved", i, e, t);
}

function sl(i, e, t, r) {
  var o = typeof r == "function" ? Lt(e, t) : Lt(e),
      n = typeof r == "function" ? r : t,
      s = o[i];
  return typeof s != "function" ? V(!1) : (o[i] = function () {
    s.call(this), n.call(this);
  }, function () {
    o[i] = s;
  });
}

function al(i) {
  var e = i.enforceActions,
      t = i.computedRequiresReaction,
      r = i.computedConfigurable,
      o = i.disableErrorBoundaries,
      n = i.arrayBuffer,
      s = i.reactionScheduler,
      l = i.reactionRequiresObservable,
      c = i.observableRequiresReaction;

  if (i.isolateGlobalState === !0 && Hd(), e !== void 0) {
    (typeof e == "boolean" || e === "strict") && mt("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
    var p = void 0;

    switch (e) {
      case !0:
      case "observed":
        p = !0;
        break;

      case !1:
      case "never":
        p = !1;
        break;

      case "strict":
      case "always":
        p = "strict";
        break;

      default:
        V("Invalid value for 'enforceActions': '" + e + "', expected 'never', 'always' or 'observed'");
    }

    E.enforceActions = p, E.allowStateChanges = !(p === !0 || p === "strict");
  }

  t !== void 0 && (E.computedRequiresReaction = !!t), l !== void 0 && (E.reactionRequiresObservable = !!l), c !== void 0 && (E.observableRequiresReaction = !!c, E.allowStateReads = !E.observableRequiresReaction), r !== void 0 && (E.computedConfigurable = !!r), o !== void 0 && (o === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on."), E.disableErrorBoundaries = !!o), typeof n == "number" && fn(n), s && Gd(s);
}

function kd(i, e, t, r) {
  if (!1 && t) for (var o in t) {
    ;
  }
  r = vi(r);
  var n = r.defaultDecorator || (r.deep === !1 ? Va : an);
  Yt(i), gn(i, r.name, n.enhancer), gt();

  try {
    for (var s = Object.getOwnPropertyNames(e), l = 0, c = s.length; l < c; l++) {
      var o = s[l],
          p = Object.getOwnPropertyDescriptor(e, o),
          m = t && o in t ? t[o] : p.get ? Lr : n,
          h = m(i, o, p, !0);
      h && Object.defineProperty(i, o, h);
    }
  } finally {
    bt();
  }

  return i;
}

function dn(i, e) {
  return ll(Lt(i, e));
}

function ll(i) {
  var e = {
    name: i.name
  };
  return i.observing && i.observing.length > 0 && (e.dependencies = nd(i.observing).map(ll)), e;
}

function Jd() {
  this.message = "FLOW_CANCELLED";
}

Jd.prototype = Object.create(Error.prototype);

function Zd(i, e) {
  if (i == null) return !1;

  if (e !== void 0) {
    if (Jt(i)) {
      var t = i.$mobx;
      return t.values && !!t.values[e];
    }

    return !1;
  }

  return Jt(i) || !!i.$mobx || tn(i) || Gr(i) || Nr(i);
}

function Or(i) {
  return arguments.length !== 1 && V(!1), Zd(i);
}

function Qd(i) {
  return Jt(i) ? i.$mobx.getKeys() : et(i) || Tt(i) ? ft(i.keys()) : Xt(i) ? i.map(function (e, t) {
    return t;
  }) : V(!1);
}

var ep = {
  detectCycles: !0,
  exportMapsAsObjects: !0,
  recurseEverything: !1
};

function Di(i, e, t, r) {
  return r.detectCycles && i.set(e, t), t;
}

function Ut(i, e, t) {
  if (!e.recurseEverything && !Or(i) || typeof i != "object") return i;
  if (i === null) return null;
  if (i instanceof Date) return i;
  if (zd(i)) return Ut(i.get(), e, t);
  Or(i) && Qd(i);
  var r = e.detectCycles === !0;
  if (r && i !== null && t.has(i)) return t.get(i);

  if (Xt(i) || Array.isArray(i)) {
    var o = Di(t, i, [], e),
        n = i.map(function (x) {
      return Ut(x, e, t);
    });
    o.length = n.length;

    for (var s = 0, l = n.length; s < l; s++) {
      o[s] = n[s];
    }

    return o;
  }

  if (Tt(i) || Object.getPrototypeOf(i) === Set.prototype) if (e.exportMapsAsObjects === !1) {
    var c = Di(t, i, new Set(), e);
    return i.forEach(function (x) {
      c.add(Ut(x, e, t));
    }), c;
  } else {
    var p = Di(t, i, [], e);
    return i.forEach(function (x) {
      p.push(Ut(x, e, t));
    }), p;
  }
  if (et(i) || Object.getPrototypeOf(i) === Map.prototype) if (e.exportMapsAsObjects === !1) {
    var m = Di(t, i, new Map(), e);
    return i.forEach(function (x, I) {
      m.set(I, Ut(x, e, t));
    }), m;
  } else {
    var h = Di(t, i, {}, e);
    return i.forEach(function (x, I) {
      h[I] = Ut(x, e, t);
    }), h;
  }
  var b = Di(t, i, {}, e);

  for (var v in i) {
    b[v] = Ut(i[v], e, t);
  }

  return b;
}

function k(i, e) {
  typeof e == "boolean" && (e = {
    detectCycles: e
  }), e || (e = ep), e.detectCycles = e.detectCycles === void 0 ? e.recurseEverything === !0 : e.detectCycles === !0;
  var t;
  return e.detectCycles && (t = new Map()), Ut(i, e, t);
}

function Wd() {
  for (var i = [], e = 0; e < arguments.length; e++) {
    i[e] = arguments[e];
  }

  var t = !1;
  typeof i[i.length - 1] == "boolean" && (t = i.pop());
  var r = tp(i);
  if (!r) return V(!1);
  r.isTracing === He.NONE && console.log("[mobx.trace] '" + r.name + "' tracing enabled"), r.isTracing = t ? He.BREAK : He.LOG;
}

function tp(i) {
  switch (i.length) {
    case 0:
      return E.trackingDerivation;

    case 1:
      return Lt(i[0]);

    case 2:
      return Lt(i[0], i[1]);
  }
}

function ot(i, e) {
  e === void 0 && (e = void 0), gt();

  try {
    return i.apply(e);
  } finally {
    bt();
  }
}

function it(i) {
  return i.interceptors !== void 0 && i.interceptors.length > 0;
}

function qi(i, e) {
  var t = i.interceptors || (i.interceptors = []);
  return t.push(e), Jo(function () {
    var r = t.indexOf(e);
    r !== -1 && t.splice(r, 1);
  });
}

function rt(i, e) {
  var t = _i();

  try {
    var r = i.interceptors;
    if (r) for (var o = 0, n = r.length; o < n && (e = r[o](e), Rt(!e || e.type, "Intercept handlers should return nothing or a change object"), !!e); o++) {
      ;
    }
    return e;
  } finally {
    Bt(t);
  }
}

function We(i) {
  return i.changeListeners !== void 0 && i.changeListeners.length > 0;
}

function Yi(i, e) {
  var t = i.changeListeners || (i.changeListeners = []);
  return t.push(e), Jo(function () {
    var r = t.indexOf(e);
    r !== -1 && t.splice(r, 1);
  });
}

function je(i, e) {
  var t = _i(),
      r = i.changeListeners;

  if (!!r) {
    r = r.slice();

    for (var o = 0, n = r.length; o < n; o++) {
      r[o](e);
    }

    Bt(t);
  }
}

var ip = 1e4,
    rp = function () {
  var i = !1,
      e = {};
  return Object.defineProperty(e, "0", {
    set: function set() {
      i = !0;
    }
  }), Object.create(e)["0"] = 1, i === !1;
}(),
    bn = 0,
    yn = function () {
  function i() {}

  return i;
}();

function op(i, e) {
  typeof Object.setPrototypeOf != "undefined" ? Object.setPrototypeOf(i.prototype, e) : typeof i.prototype.__proto__ != "undefined" ? i.prototype.__proto__ = e : i.prototype = e;
}

op(yn, Array.prototype);
Object.isFrozen(Array) && ["constructor", "push", "shift", "concat", "pop", "unshift", "replace", "find", "findIndex", "splice", "reverse", "sort"].forEach(function (i) {
  Object.defineProperty(yn.prototype, i, {
    configurable: !0,
    writable: !0,
    value: Array.prototype[i]
  });
});

var cl = function () {
  function i(e, t, r, o) {
    this.array = r, this.owned = o, this.values = [], this.lastKnownLength = 0, this.atom = new Fr(e || "ObservableArray@" + Ce()), this.enhancer = function (n, s) {
      return t(n, s, e + "[..]");
    };
  }

  return i.prototype.dehanceValue = function (e) {
    return this.dehancer !== void 0 ? this.dehancer(e) : e;
  }, i.prototype.dehanceValues = function (e) {
    return this.dehancer !== void 0 && e.length > 0 ? e.map(this.dehancer) : e;
  }, i.prototype.intercept = function (e) {
    return qi(this, e);
  }, i.prototype.observe = function (e, t) {
    return t === void 0 && (t = !1), t && e({
      object: this.array,
      type: "splice",
      index: 0,
      added: this.values.slice(),
      addedCount: this.values.length,
      removed: [],
      removedCount: 0
    }), Yi(this, e);
  }, i.prototype.getArrayLength = function () {
    return this.atom.reportObserved(), this.values.length;
  }, i.prototype.setArrayLength = function (e) {
    if (typeof e != "number" || e < 0) throw new Error("[mobx.array] Out of range: " + e);
    var t = this.values.length;
    if (e !== t) if (e > t) {
      for (var r = new Array(e - t), o = 0; o < e - t; o++) {
        r[o] = void 0;
      }

      this.spliceWithArray(t, 0, r);
    } else this.spliceWithArray(e, t - e);
  }, i.prototype.updateArrayLength = function (e, t) {
    if (e !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
    this.lastKnownLength += t, t > 0 && e + t + 1 > bn && fn(e + t + 1);
  }, i.prototype.spliceWithArray = function (e, t, r) {
    var o = this;
    Si(this.atom);
    var n = this.values.length;

    if (e === void 0 ? e = 0 : e > n ? e = n : e < 0 && (e = Math.max(0, n + e)), arguments.length === 1 ? t = n - e : t == null ? t = 0 : t = Math.max(0, Math.min(t, n - e)), r === void 0 && (r = Ir), it(this)) {
      var s = rt(this, {
        object: this.array,
        type: "splice",
        index: e,
        removedCount: t,
        added: r
      });
      if (!s) return Ir;
      t = s.removedCount, r = s.added;
    }

    r = r.length === 0 ? r : r.map(function (p) {
      return o.enhancer(p, void 0);
    });
    var l = r.length - t;
    this.updateArrayLength(n, l);
    var c = this.spliceItemsIntoValues(e, t, r);
    return (t !== 0 || r.length !== 0) && this.notifyArraySplice(e, r, c), this.dehanceValues(c);
  }, i.prototype.spliceItemsIntoValues = function (e, t, r) {
    var o;
    if (r.length < ip) return (o = this.values).splice.apply(o, sn([e, t], r));
    var n = this.values.slice(e, e + t);
    return this.values = this.values.slice(0, e).concat(r, this.values.slice(e + t)), n;
  }, i.prototype.notifyArrayChildUpdate = function (e, t, r) {
    var o = !this.owned && ge(),
        n = We(this),
        s = n || o ? {
      object: this.array,
      type: "update",
      index: e,
      newValue: t,
      oldValue: r
    } : null;
    o && we(_q(_q({}, s), {
      name: this.atom.name
    })), this.atom.reportChanged(), n && je(this, s), o && Ee();
  }, i.prototype.notifyArraySplice = function (e, t, r) {
    var o = !this.owned && ge(),
        n = We(this),
        s = n || o ? {
      object: this.array,
      type: "splice",
      index: e,
      removed: r,
      added: t,
      removedCount: r.length,
      addedCount: t.length
    } : null;
    o && we(_q(_q({}, s), {
      name: this.atom.name
    })), this.atom.reportChanged(), n && je(this, s), o && Ee();
  }, i;
}(),
    tt = function (i) {
  Wa(e, i);

  function e(t, r, o, n) {
    o === void 0 && (o = "ObservableArray@" + Ce()), n === void 0 && (n = !1);
    var s = i.call(this) || this,
        l = new cl(o, r, s, n);

    if (Hi(s, "$mobx", l), t && t.length) {
      var c = $i(!0);
      s.spliceWithArray(0, 0, t), Ki(c);
    }

    return rp && Object.defineProperty(l.array, "0", np), s;
  }

  return e.prototype.intercept = function (t) {
    return this.$mobx.intercept(t);
  }, e.prototype.observe = function (t, r) {
    return r === void 0 && (r = !1), this.$mobx.observe(t, r);
  }, e.prototype.clear = function () {
    return this.splice(0);
  }, e.prototype.concat = function () {
    for (var t = [], r = 0; r < arguments.length; r++) {
      t[r] = arguments[r];
    }

    return this.$mobx.atom.reportObserved(), Array.prototype.concat.apply(this.peek(), t.map(function (o) {
      return Xt(o) ? o.peek() : o;
    }));
  }, e.prototype.replace = function (t) {
    return this.$mobx.spliceWithArray(0, this.$mobx.values.length, t);
  }, e.prototype.toJS = function () {
    return this.slice();
  }, e.prototype.toJSON = function () {
    return this.toJS();
  }, e.prototype.peek = function () {
    return this.$mobx.atom.reportObserved(), this.$mobx.dehanceValues(this.$mobx.values);
  }, e.prototype.find = function (t, r, o) {
    o === void 0 && (o = 0), arguments.length === 3 && mt("The array.find fromIndex argument to find will not be supported anymore in the next major");
    var n = this.findIndex.apply(this, arguments);
    return n === -1 ? void 0 : this.get(n);
  }, e.prototype.findIndex = function (t, r, o) {
    o === void 0 && (o = 0), arguments.length === 3 && mt("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");

    for (var n = this.peek(), s = n.length, l = o; l < s; l++) {
      if (t.call(r, n[l], l, this)) return l;
    }

    return -1;
  }, e.prototype.splice = function (t, r) {
    for (var o = [], n = 2; n < arguments.length; n++) {
      o[n - 2] = arguments[n];
    }

    switch (arguments.length) {
      case 0:
        return [];

      case 1:
        return this.$mobx.spliceWithArray(t);

      case 2:
        return this.$mobx.spliceWithArray(t, r);
    }

    return this.$mobx.spliceWithArray(t, r, o);
  }, e.prototype.spliceWithArray = function (t, r, o) {
    return this.$mobx.spliceWithArray(t, r, o);
  }, e.prototype.push = function () {
    for (var t = [], r = 0; r < arguments.length; r++) {
      t[r] = arguments[r];
    }

    var o = this.$mobx;
    return o.spliceWithArray(o.values.length, 0, t), o.values.length;
  }, e.prototype.pop = function () {
    return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
  }, e.prototype.shift = function () {
    return this.splice(0, 1)[0];
  }, e.prototype.unshift = function () {
    for (var t = [], r = 0; r < arguments.length; r++) {
      t[r] = arguments[r];
    }

    var o = this.$mobx;
    return o.spliceWithArray(0, 0, t), o.values.length;
  }, e.prototype.reverse = function () {
    var t = this.slice();
    return t.reverse.apply(t, arguments);
  }, e.prototype.sort = function (t) {
    var r = this.slice();
    return r.sort.apply(r, arguments);
  }, e.prototype.remove = function (t) {
    var r = this.$mobx.dehanceValues(this.$mobx.values).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }, e.prototype.move = function (t, r) {
    mt("observableArray.move is deprecated, use .slice() & .replace() instead");

    function o(l) {
      if (l < 0) throw new Error("[mobx.array] Index out of bounds: " + l + " is negative");
      var c = this.$mobx.values.length;
      if (l >= c) throw new Error("[mobx.array] Index out of bounds: " + l + " is not smaller than " + c);
    }

    if (o.call(this, t), o.call(this, r), t !== r) {
      var n = this.$mobx.values,
          s;
      t < r ? s = sn(n.slice(0, t), n.slice(t + 1, r + 1), [n[t]], n.slice(r + 1)) : s = sn(n.slice(0, r), [n[t]], n.slice(r, t), n.slice(t + 1)), this.replace(s);
    }
  }, e.prototype.get = function (t) {
    var r = this.$mobx;

    if (r) {
      if (t < r.values.length) return r.atom.reportObserved(), r.dehanceValue(r.values[t]);
      console.warn("[mobx.array] Attempt to read an array index (" + t + ") that is out of bounds (" + r.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
    }
  }, e.prototype.set = function (t, r) {
    var o = this.$mobx,
        n = o.values;

    if (t < n.length) {
      Si(o.atom);
      var s = n[t];

      if (it(o)) {
        var l = rt(o, {
          type: "update",
          object: this,
          index: t,
          newValue: r
        });
        if (!l) return;
        r = l.newValue;
      }

      r = o.enhancer(r, s);
      var c = r !== s;
      c && (n[t] = r, o.notifyArrayChildUpdate(t, r, s));
    } else if (t === n.length) o.spliceWithArray(t, 0, [r]);else throw new Error("[mobx.array] Index out of bounds, " + t + " is larger than " + n.length);
  }, e;
}(yn);

Qo(tt.prototype, function () {
  this.$mobx.atom.reportObserved();
  var i = this,
      e = 0;
  return ji({
    next: function next() {
      return e < i.length ? {
        value: i[e++],
        done: !1
      } : {
        done: !0,
        value: void 0
      };
    }
  });
});
Object.defineProperty(tt.prototype, "length", {
  enumerable: !1,
  configurable: !0,
  get: function get() {
    return this.$mobx.getArrayLength();
  },
  set: function set(i) {
    this.$mobx.setArrayLength(i);
  }
});
ht(tt.prototype, en(), "Array");
["indexOf", "join", "lastIndexOf", "slice", "toString", "toLocaleString"].forEach(function (i) {
  var e = Array.prototype[i];
  Rt(typeof e == "function", "Base function not defined on Array prototype: '" + i + "'"), ht(tt.prototype, i, function () {
    return e.apply(this.peek(), arguments);
  });
});
["every", "filter", "forEach", "map", "some"].forEach(function (i) {
  var e = Array.prototype[i];
  Rt(typeof e == "function", "Base function not defined on Array prototype: '" + i + "'"), ht(tt.prototype, i, function (t, r) {
    var o = this,
        n = this.$mobx;
    n.atom.reportObserved();
    var s = n.dehanceValues(n.values);
    return s[i](function (l, c) {
      return t.call(r, l, c, o);
    }, r);
  });
});
["reduce", "reduceRight"].forEach(function (i) {
  ht(tt.prototype, i, function () {
    var e = this,
        t = this.$mobx;
    t.atom.reportObserved();
    var r = arguments[0];
    return arguments[0] = function (o, n, s) {
      return n = t.dehanceValue(n), r(o, n, s, e);
    }, t.values[i].apply(t.values, arguments);
  });
});
ad(tt.prototype, ["constructor", "intercept", "observe", "clear", "concat", "get", "replace", "toJS", "toJSON", "peek", "find", "findIndex", "splice", "spliceWithArray", "push", "pop", "set", "shift", "unshift", "reverse", "sort", "remove", "move", "toString", "toLocaleString"]);
var np = ul(0);

function ul(i) {
  return {
    enumerable: !1,
    configurable: !1,
    get: function get() {
      return this.get(i);
    },
    set: function set(e) {
      this.set(i, e);
    }
  };
}

function sp(i) {
  Object.defineProperty(tt.prototype, "" + i, ul(i));
}

function fn(i) {
  for (var e = bn; e < i; e++) {
    sp(e);
  }

  bn = i;
}

fn(1e3);
var ap = Ot("ObservableArrayAdministration", cl);

function Xt(i) {
  return Zo(i) && ap(i.$mobx);
}

var lp = {},
    Br = function () {
  function i(e, t, r) {
    if (t === void 0 && (t = Gi), r === void 0 && (r = "ObservableMap@" + Ce()), this.enhancer = t, this.name = r, this.$mobx = lp, this._keysAtom = Ar(this.name + ".keys()"), typeof Map != "function") throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
    this._data = new Map(), this._hasMap = new Map(), this.merge(e);
  }

  return i.prototype._has = function (e) {
    return this._data.has(e);
  }, i.prototype.has = function (e) {
    var t = this;
    if (!E.trackingDerivation) return this._has(e);

    var r = this._hasMap.get(e);

    if (!r) {
      var o = r = new Pt(this._has(e), Tr, this.name + "." + Vr(e) + "?", !1);
      this._hasMap.set(e, o), Na(o, function () {
        return t._hasMap.delete(e);
      });
    }

    return r.get();
  }, i.prototype.set = function (e, t) {
    var r = this._has(e);

    if (it(this)) {
      var o = rt(this, {
        type: r ? "update" : "add",
        object: this,
        newValue: t,
        name: e
      });
      if (!o) return this;
      t = o.newValue;
    }

    return r ? this._updateValue(e, t) : this._addValue(e, t), this;
  }, i.prototype.delete = function (e) {
    var t = this;

    if (Si(this._keysAtom), it(this)) {
      var r = rt(this, {
        type: "delete",
        object: this,
        name: e
      });
      if (!r) return !1;
    }

    if (this._has(e)) {
      var o = ge(),
          n = We(this),
          r = n || o ? {
        type: "delete",
        object: this,
        oldValue: this._data.get(e).value,
        name: e
      } : null;
      return o && we(_q(_q({}, r), {
        name: this.name,
        key: e
      })), ot(function () {
        t._keysAtom.reportChanged(), t._updateHasMapEntry(e, !1);

        var l = t._data.get(e);

        l.setNewValue(void 0), t._data.delete(e);
      }), n && je(this, r), o && Ee(), !0;
    }

    return !1;
  }, i.prototype._updateHasMapEntry = function (e, t) {
    var r = this._hasMap.get(e);

    r && r.setNewValue(t);
  }, i.prototype._updateValue = function (e, t) {
    var r = this._data.get(e);

    if (t = r.prepareNewValue(t), t !== E.UNCHANGED) {
      var o = ge(),
          n = We(this),
          s = n || o ? {
        type: "update",
        object: this,
        oldValue: r.value,
        name: e,
        newValue: t
      } : null;
      o && we(_q(_q({}, s), {
        name: this.name,
        key: e
      })), r.setNewValue(t), n && je(this, s), o && Ee();
    }
  }, i.prototype._addValue = function (e, t) {
    var r = this;
    Si(this._keysAtom), ot(function () {
      var l = new Pt(t, r.enhancer, r.name + "." + Vr(e), !1);
      r._data.set(e, l), t = l.value, r._updateHasMapEntry(e, !0), r._keysAtom.reportChanged();
    });
    var o = ge(),
        n = We(this),
        s = n || o ? {
      type: "add",
      object: this,
      name: e,
      newValue: t
    } : null;
    o && we(_q(_q({}, s), {
      name: this.name,
      key: e
    })), n && je(this, s), o && Ee();
  }, i.prototype.get = function (e) {
    return this.has(e) ? this.dehanceValue(this._data.get(e).get()) : this.dehanceValue(void 0);
  }, i.prototype.dehanceValue = function (e) {
    return this.dehancer !== void 0 ? this.dehancer(e) : e;
  }, i.prototype.keys = function () {
    return this._keysAtom.reportObserved(), this._data.keys();
  }, i.prototype.values = function () {
    var e = this,
        t = this.keys();
    return ji({
      next: function next() {
        var r = t.next(),
            o = r.done,
            n = r.value;
        return {
          done: o,
          value: o ? void 0 : e.get(n)
        };
      }
    });
  }, i.prototype.entries = function () {
    var e = this,
        t = this.keys();
    return ji({
      next: function next() {
        var r = t.next(),
            o = r.done,
            n = r.value;
        return {
          done: o,
          value: o ? void 0 : [n, e.get(n)]
        };
      }
    });
  }, i.prototype.forEach = function (e, t) {
    var r = this;
    this._keysAtom.reportObserved(), this._data.forEach(function (o, n) {
      return e.call(t, r.get(n), n, r);
    });
  }, i.prototype.merge = function (e) {
    var t = this;
    return et(e) && (e = e.toJS()), ot(function () {
      var r = $i(!0);

      try {
        bi(e) ? Object.keys(e).forEach(function (o) {
          return t.set(o, e[o]);
        }) : Array.isArray(e) ? e.forEach(function (o) {
          var n = nn(o, 2),
              s = n[0],
              l = n[1];
          return t.set(s, l);
        }) : yi(e) ? e.constructor !== Map ? V("Cannot initialize from classes that inherit from Map: " + e.constructor.name) : e.forEach(function (o, n) {
          return t.set(n, o);
        }) : e != null && V("Cannot initialize map from " + e);
      } finally {
        Ki(r);
      }
    }), this;
  }, i.prototype.clear = function () {
    var e = this;
    ot(function () {
      un(function () {
        e._data.forEach(function (t, r) {
          return e.delete(r);
        });
      });
    });
  }, i.prototype.replace = function (e) {
    var t = this;
    return ot(function () {
      var r = sd(e),
          o = new Map(),
          n = !1;
      if (za(t._data.keys(), function (m) {
        if (!r.has(m)) {
          var h = t.delete(m);
          if (h) n = !0;else {
            var b = t._data.get(m);

            o.set(m, b);
          }
        }
      }), za(r.entries(), function (m) {
        var h = nn(m, 2),
            b = h[0],
            v = h[1],
            x = t._data.has(b);

        if (t.set(b, v), t._data.has(b)) {
          var I = t._data.get(b);

          o.set(b, I), x || (n = !0);
        }
      }), !n) if (t._data.size !== o.size) t._keysAtom.reportChanged();else for (var s = t._data.keys(), l = o.keys(), c = s.next(), p = l.next(); !c.done;) {
        if (c.value !== p.value) {
          t._keysAtom.reportChanged();

          break;
        }

        c = s.next(), p = l.next();
      }
      t._data = o;
    }), this;
  }, Object.defineProperty(i.prototype, "size", {
    get: function get() {
      return this._keysAtom.reportObserved(), this._data.size;
    },
    enumerable: !0,
    configurable: !0
  }), i.prototype.toPOJO = function () {
    var e = this,
        t = {};
    return this.forEach(function (r, o) {
      return t[typeof o == "symbol" ? o : Vr(o)] = e.get(o);
    }), t;
  }, i.prototype.toJS = function () {
    return new Map(this);
  }, i.prototype.toJSON = function () {
    return this.toPOJO();
  }, i.prototype.toString = function () {
    var e = this;
    return this.name + "[{ " + ft(this.keys()).map(function (t) {
      return Vr(t) + ": " + ("" + e.get(t));
    }).join(", ") + " }]";
  }, i.prototype.observe = function (e, t) {
    return Yi(this, e);
  }, i.prototype.intercept = function (e) {
    return qi(this, e);
  }, i;
}();

function Vr(i) {
  return i && i.toString ? i.toString() : new String(i).toString();
}

Qo(Br.prototype, function () {
  return this.entries();
});
Hi(Br.prototype, en(), "Map");

var et = Ot("ObservableMap", Br),
    cp = {},
    zr = function () {
  function i(e, t, r) {
    if (t === void 0 && (t = Gi), r === void 0 && (r = "ObservableSet@" + Ce()), this.name = r, this.$mobx = cp, this._data = new Set(), this._atom = Ar(this.name), typeof Set != "function") throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
    this.enhancer = function (o, n) {
      return t(o, n, r);
    }, e && this.replace(e);
  }

  return i.prototype.dehanceValue = function (e) {
    return this.dehancer !== void 0 ? this.dehancer(e) : e;
  }, i.prototype.clear = function () {
    var e = this;
    ot(function () {
      un(function () {
        e._data.forEach(function (t) {
          e.delete(t);
        });
      });
    });
  }, i.prototype.forEach = function (e, t) {
    var r = this;
    this._atom.reportObserved(), this._data.forEach(function (o) {
      e.call(t, o, o, r);
    });
  }, Object.defineProperty(i.prototype, "size", {
    get: function get() {
      return this._atom.reportObserved(), this._data.size;
    },
    enumerable: !0,
    configurable: !0
  }), i.prototype.add = function (e) {
    var t = this;

    if (Si(this._atom), it(this)) {
      var r = rt(this, {
        type: "add",
        object: this,
        newValue: e
      });
      if (!r) return this;
    }

    if (!this.has(e)) {
      ot(function () {
        t._data.add(t.enhancer(e, void 0)), t._atom.reportChanged();
      });
      var o = ge(),
          n = We(this),
          r = n || o ? {
        type: "add",
        object: this,
        newValue: e
      } : null;
      o && !1 && we(r), n && je(this, r), o && !1 && Ee();
    }

    return this;
  }, i.prototype.delete = function (e) {
    var t = this;

    if (it(this)) {
      var r = rt(this, {
        type: "delete",
        object: this,
        oldValue: e
      });
      if (!r) return !1;
    }

    if (this.has(e)) {
      var o = ge(),
          n = We(this),
          r = n || o ? {
        type: "delete",
        object: this,
        oldValue: e
      } : null;
      return o && !1 && we(_q(_q({}, r), {
        name: this.name
      })), ot(function () {
        t._atom.reportChanged(), t._data.delete(e);
      }), n && je(this, r), o && !1 && Ee(), !0;
    }

    return !1;
  }, i.prototype.has = function (e) {
    return this._atom.reportObserved(), this._data.has(this.dehanceValue(e));
  }, i.prototype.entries = function () {
    var e = 0,
        t = ft(this.keys()),
        r = ft(this.values());
    return ji({
      next: function next() {
        var o = e;
        return e += 1, o < r.length ? {
          value: [t[o], r[o]],
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, i.prototype.keys = function () {
    return this.values();
  }, i.prototype.values = function () {
    this._atom.reportObserved();

    var e = this,
        t = 0,
        r;
    return this._data.values !== void 0 ? r = ft(this._data.values()) : (r = [], this._data.forEach(function (o) {
      return r.push(o);
    })), ji({
      next: function next() {
        return t < r.length ? {
          value: e.dehanceValue(r[t++]),
          done: !1
        } : {
          done: !0
        };
      }
    });
  }, i.prototype.replace = function (e) {
    var t = this;
    return Tt(e) && (e = e.toJS()), ot(function () {
      var r = $i(!0);

      try {
        Array.isArray(e) ? (t.clear(), e.forEach(function (o) {
          return t.add(o);
        })) : Wi(e) ? (t.clear(), e.forEach(function (o) {
          return t.add(o);
        })) : e != null && V("Cannot initialize set from " + e);
      } finally {
        Ki(r);
      }
    }), this;
  }, i.prototype.observe = function (e, t) {
    return Yi(this, e);
  }, i.prototype.intercept = function (e) {
    return qi(this, e);
  }, i.prototype.toJS = function () {
    return new Set(this);
  }, i.prototype.toString = function () {
    return this.name + "[ " + ft(this.keys()).join(", ") + " ]";
  }, i;
}();

Qo(zr.prototype, function () {
  return this.values();
});
Hi(zr.prototype, en(), "Set");

var Tt = Ot("ObservableSet", zr),
    dl = function () {
  function i(e, t, r) {
    this.target = e, this.name = t, this.defaultEnhancer = r, this.values = {};
  }

  return i.prototype.read = function (e, t) {
    if (!(this.target !== e && (this.illegalAccess(e, t), !this.values[t]))) return this.values[t].get();
  }, i.prototype.write = function (e, t, r) {
    var o = this.target;
    o !== e && this.illegalAccess(e, t);
    var n = this.values[t];

    if (n instanceof Mt) {
      n.set(r);
      return;
    }

    if (it(this)) {
      var s = rt(this, {
        type: "update",
        object: o,
        name: t,
        newValue: r
      });
      if (!s) return;
      r = s.newValue;
    }

    if (r = n.prepareNewValue(r), r !== E.UNCHANGED) {
      var l = We(this),
          c = ge(),
          s = l || c ? {
        type: "update",
        object: o,
        oldValue: n.value,
        name: t,
        newValue: r
      } : null;
      c && we(_q(_q({}, s), {
        name: this.name,
        key: t
      })), n.setNewValue(r), l && je(this, s), c && Ee();
    }
  }, i.prototype.remove = function (e) {
    if (!!this.values[e]) {
      var t = this.target;

      if (it(this)) {
        var r = rt(this, {
          object: t,
          name: e,
          type: "remove"
        });
        if (!r) return;
      }

      try {
        gt();
        var o = We(this),
            n = ge(),
            s = this.values[e].get();
        this.keys && this.keys.remove(e), delete this.values[e], delete this.target[e];
        var r = o || n ? {
          type: "remove",
          object: t,
          oldValue: s,
          name: e
        } : null;
        n && we(_q(_q({}, r), {
          name: this.name,
          key: e
        })), o && je(this, r), n && Ee();
      } finally {
        bt();
      }
    }
  }, i.prototype.illegalAccess = function (e, t) {
    console.warn("Property '" + t + "' of '" + e + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
  }, i.prototype.observe = function (e, t) {
    return Yi(this, e);
  }, i.prototype.intercept = function (e) {
    return qi(this, e);
  }, i.prototype.getKeys = function () {
    var e = this;
    return this.keys === void 0 && (this.keys = new tt(Object.keys(this.values).filter(function (t) {
      return e.values[t] instanceof Pt;
    }), Tr, "keys(" + this.name + ")", !0)), this.keys.slice();
  }, i;
}();

function gn(i, e, t) {
  e === void 0 && (e = ""), t === void 0 && (t = Gi);
  var r = i.$mobx;
  return r || (bi(i) || (e = (i.constructor.name || "ObservableObject") + "@" + Ce()), e || (e = "ObservableObject@" + Ce()), r = new dl(i, e, t), Hi(i, "$mobx", r), r);
}

function Dd(i, e, t, r) {
  var o = gn(i);

  if (ld(i, e), it(o)) {
    var n = rt(o, {
      object: i,
      name: e,
      type: "add",
      newValue: t
    });
    if (!n) return;
    t = n.newValue;
  }

  var s = o.values[e] = new Pt(t, r, o.name + "." + e, !1);
  t = s.value, Object.defineProperty(i, e, up(e)), o.keys && o.keys.push(e), dp(o, i, e, t);
}

function Id(i, e, t) {
  var r = gn(i);
  t.name = r.name + "." + e, t.context = i, r.values[e] = new Mt(t), Object.defineProperty(i, e, pp(e));
}

var pl = Object.create(null),
    ml = Object.create(null);

function up(i) {
  return pl[i] || (pl[i] = {
    configurable: !0,
    enumerable: !0,
    get: function get() {
      return this.$mobx.read(this, i);
    },
    set: function set(e) {
      this.$mobx.write(this, i, e);
    }
  });
}

function hl(i) {
  var e = i.$mobx;
  return e || (Yt(i), i.$mobx);
}

function pp(i) {
  return ml[i] || (ml[i] = {
    configurable: E.computedConfigurable,
    enumerable: !1,
    get: function get() {
      return hl(this).read(this, i);
    },
    set: function set(e) {
      hl(this).write(this, i, e);
    }
  });
}

function dp(i, e, t, r) {
  var o = We(i),
      n = ge(),
      s = o || n ? {
    type: "add",
    object: e,
    name: t,
    newValue: r
  } : null;
  n && we(_q(_q({}, s), {
    name: i.name,
    key: t
  })), o && je(i, s), n && Ee();
}

var mp = Ot("ObservableObjectAdministration", dl);

function Jt(i) {
  return Zo(i) ? (Yt(i), mp(i.$mobx)) : !1;
}

function Lt(i, e) {
  if (typeof i == "object" && i !== null) {
    if (Xt(i)) return e !== void 0 && V(!1), i.$mobx.atom;
    if (Tt(i)) return i.$mobx;

    if (et(i)) {
      var t = i;
      if (e === void 0) return t._keysAtom;

      var r = t._data.get(e) || t._hasMap.get(e);

      return r || V(!1), r;
    }

    if (Yt(i), e && !i.$mobx && i[e], Jt(i)) {
      if (!e) return V(!1);
      var r = i.$mobx.values[e];
      return r || V(!1), r;
    }

    if (tn(i) || Nr(i) || Gr(i)) return i;
  } else if (typeof i == "function" && Gr(i.$mobx)) return i.$mobx;

  return V(!1);
}

function fl(i, e) {
  if (i || V("Expecting some object"), e !== void 0) return fl(Lt(i, e));
  if (tn(i) || Nr(i) || Gr(i) || et(i) || Tt(i)) return i;
  if (Yt(i), i.$mobx) return i.$mobx;
  V(!1);
}

function hp(i, e) {
  var t;
  return e !== void 0 ? t = Lt(i, e) : Jt(i) || et(i) || Tt(i) ? t = fl(i) : t = Lt(i), t.name;
}

var gl = Object.prototype.toString;

function rn(i, e, t) {
  return t === void 0 && (t = -1), vn(i, e, t);
}

function vn(i, e, t, r, o) {
  if (i === e) return i !== 0 || 1 / i == 1 / e;
  if (i == null || e == null) return !1;
  if (i !== i) return e !== e;
  var n = typeof i;
  if (n !== "function" && n !== "object" && typeof e != "object") return !1;
  i = bl(i), e = bl(e);
  var s = gl.call(i);
  if (s !== gl.call(e)) return !1;

  switch (s) {
    case "[object RegExp]":
    case "[object String]":
      return "" + i == "" + e;

    case "[object Number]":
      return +i != +i ? +e != +e : +i == 0 ? 1 / +i == 1 / e : +i == +e;

    case "[object Date]":
    case "[object Boolean]":
      return +i == +e;

    case "[object Symbol]":
      return typeof Symbol != "undefined" && Symbol.valueOf.call(i) === Symbol.valueOf.call(e);
  }

  var l = s === "[object Array]";

  if (!l) {
    if (typeof i != "object" || typeof e != "object") return !1;
    var c = i.constructor,
        p = e.constructor;
    if (c !== p && !(typeof c == "function" && c instanceof c && typeof p == "function" && p instanceof p) && "constructor" in i && "constructor" in e) return !1;
  }

  if (t === 0) return !1;
  t < 0 && (t = -1), r = r || [], o = o || [];

  for (var m = r.length; m--;) {
    if (r[m] === i) return o[m] === e;
  }

  if (r.push(i), o.push(e), l) {
    if (m = i.length, m !== e.length) return !1;

    for (; m--;) {
      if (!vn(i[m], e[m], t - 1, r, o)) return !1;
    }
  } else {
    var h = Object.keys(i),
        b = void 0;
    if (m = h.length, Object.keys(e).length !== m) return !1;

    for (; m--;) {
      if (b = h[m], !(fp(e, b) && vn(i[b], e[b], t - 1, r, o))) return !1;
    }
  }

  return r.pop(), o.pop(), !0;
}

function bl(i) {
  return Xt(i) ? i.peek() : yi(i) || et(i) || Wi(i) || Tt(i) ? ft(i.entries()) : i;
}

function fp(i, e) {
  return Object.prototype.hasOwnProperty.call(i, e);
}

try {} catch (i) {
  _n = gi(), typeof process == "undefined" && (_n.process = {}), _n.process.env = {};
}

var _n;

(function () {
  function i() {}

  if (i.name !== "testCodeMinification" && !1 && typeof process != "undefined" && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
    var e = ["process", "env", "NODE_ENV"].join(".");
    console.warn("[mobx] you are running a minified build, but '" + e + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
  }
})();

var Sn = "$mobx";
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: mn,
  extras: {
    getDebugName: hp
  },
  $mobx: Sn
});

var Dn = function Dn() {
  return window && window.navigator && window.navigator.userAgent || "";
},
    ti = function ti() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Dn();
  return i.indexOf("Edge") !== -1;
},
    Me = function Me() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Dn();
  return !!i.match(/msie|trident/i);
};

var yl = function yl() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Dn();
  return !!i.match(/iP(hone|od|ad)|AppleWebKit/);
},
    vl = function vl() {
  var i = document.createElement("canvas"),
      e = i.getContext("webgl") || i.getContext("experimental-webgl");
  return e && e instanceof WebGLRenderingContext;
};

var _l = function _l(i) {
  return i.replace(hb, "");
};

var ii = function ii(i) {
  try {
    return new URL(i), !0;
  } catch (e) {
    return !1;
  }
};

var Sl = function Sl(i) {
  return i instanceof HTMLImageElement;
};

var Dl = function Dl() {
  _classCallCheck(this, Dl);

  this.enabled = !0;
  this.threshold = 20;
  this.snapToHorizontalCenter = !0;
  this.snapToVerticalCenter = !0;
  this.snapToLeft = .1;
  this.snapToRight = .1;
  this.snapToTop = .1;
  this.snapToBottom = .1;
},
    xl = function xl() {
  _classCallCheck(this, xl);

  this.enabled = !0;
  this.threshold = 20;
  this.angles = [0, 45, 90, 135, 180, 225, 270, 315];
},
    xn = function xn() {
  _classCallCheck(this, xn);

  this.position = new Dl();
  this.rotation = new xl();
};

var Cn = function Cn() {
  _classCallCheck(this, Cn);

  this.categories = [];
  this.flattenCategories = !1;
};

var En = function En() {
  _classCallCheck(this, En);

  this.categories = [];
  this.flattenCategories = !1;
  this.categoryHeaderType = wn.CARD;
  this.enablePreviewThumbnails = !1;
};

function $r(i) {
  return i.lightColor !== void 0;
}

function gp(i) {
  return i.lutURI !== void 0;
}

var kn = function kn() {
  _classCallCheck(this, kn);

  this.items = [];
};

var In = function In() {
  _classCallCheck(this, In);

  this.items = [];
};

var Fn = function Fn() {
  _classCallCheck(this, Fn);

  this.enableWebcam = !1;
  this.enableUpload = !1;
  this.flattenCategories = !1;
  this.categoryHeaderType = wn.CARD;
};

var An = function An() {
  _classCallCheck(this, An);

  this.items = [];
};

var Rn = function Rn() {
  _classCallCheck(this, Rn);

  this.categories = [];
  this.canvasActions = [de.BRING_TO_FRONT, de.FLIP, de.DUPLICATE, de.DELETE];
  this.flattenCategories = !1;
  this.categoryHeaderType = wn.CARD;
  this.enableCustomUpload = !0;
  this.customStickerTintMode = "none";
};

var On = function On() {
  _classCallCheck(this, On);

  this.fonts = [];
  this.canvasActions = [de.EDIT, de.BRING_TO_FRONT, de.DUPLICATE, de.DELETE];
  this.disableAutoScaling = !1;
};

function bp(i) {
  return i.provider === void 0 || i.provider === "file";
}

function yp(i) {
  return i.provider === "google";
}

var Tn = function Tn() {
  _classCallCheck(this, Tn);

  this.defaultSize = .05;
  this.defaultHardness = .5;
};

var Pn = function Pn() {
  _classCallCheck(this, Pn);

  this.items = [];
  this.canvasActions = [de.EDIT, de.BRING_TO_FRONT, de.INVERT, de.DUPLICATE, de.DELETE];
};

var Mn = function Mn() {
  _classCallCheck(this, Mn);

  this.categories = [];
  this.enableRotation = !0;
  this.enableFlip = !0;
  this.flattenCategories = !1;
  this.categoryHeaderType = wn.TEXT;
};

var Xi =
/*#__PURE__*/
function () {
  function Xi() {
    _classCallCheck(this, Xi);

    this.events = {};
  }

  _createClass(Xi, [{
    key: "addListener",
    value: function addListener(e, t) {
      return (this.events[e] || (this.events[e] = [])).push(t), this;
    }
  }, {
    key: "removeListener",
    value: function removeListener(e, t) {
      var r = this.events[e];
      if (!r) return this;
      var o = r.lastIndexOf(t);
      return o === -1 ? this : (r.splice(o, 1), this);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(e) {
      return this.events[e] = void 0, this;
    }
  }, {
    key: "on",
    value: function on(e, t) {
      return this.addListener(e, t);
    }
  }, {
    key: "off",
    value: function off(e, t) {
      return this.removeListener(e, t);
    }
  }, {
    key: "emit",
    value: function emit(e) {
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }

      var r = this.events[e];
      return !r || !r.length ? !1 : (r.slice(0).forEach(function (o) {
        return o.apply(null, t);
      }), !0);
    }
  }]);

  return Xi;
}();

var Bn = Tb;
var zn = Mb;
var Cl = zb;
var vp = [{
  identifier: "imgly_font_open_sans_bold",
  fontFamily: "Open Sans",
  fontWeight: "bold",
  fontURI: "./fonts/imgly_font_open_sans_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2189,
    descender: -600
  }
}, {
  identifier: "imgly_font_aleo_bold",
  fontFamily: "Aleo",
  fontWeight: "bold",
  fontURI: "./fonts/imgly_font_aleo_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 805,
    descender: -195
  }
}, {
  identifier: "imgly_font_amaticsc",
  fontFamily: "Amatic SC",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_amaticsc.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1016,
    descender: -245
  }
}, {
  identifier: "imgly_font_archivo_black",
  fontFamily: "Archivo",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_archivo_black.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 878,
    descender: -210
  }
}, {
  identifier: "imgly_font_bungee_inline",
  fontFamily: "Bungee Inline",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_bungee_inline.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 860,
    descender: -140
  }
}, {
  identifier: "imgly_font_fira_sans_regular",
  fontFamily: "Fira Sans",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_fira_sans_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 935,
    descender: -265
  }
}, {
  identifier: "imgly_font_campton_bold",
  fontFamily: "Campton Book",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_campton_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 770,
    descender: -294
  }
}, {
  identifier: "imgly_font_carter_one",
  fontFamily: "Carter One",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_carter_one.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2264,
    descender: -890
  }
}, {
  identifier: "imgly_font_codystar",
  fontFamily: "Codystar",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_codystar.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1024,
    ascender: 953,
    descender: -255
  }
}, {
  identifier: "imgly_font_galano_grotesque_bold",
  fontFamily: "Galano Grotesque",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_galano_grotesque_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 800,
    descender: -200
  }
}, {
  identifier: "imgly_font_krona_one",
  fontFamily: "Krona One",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_krona_one.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2030,
    descender: -530
  }
}, {
  identifier: "imgly_font_kumar_one_outline",
  fontFamily: "Kumar One Outline",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_kumar_one_outline.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1137,
    descender: -642
  }
}, {
  identifier: "imgly_font_lobster",
  fontFamily: "Lobster",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_lobster.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1e3,
    descender: -250
  }
}, {
  identifier: "imgly_font_molle",
  fontFamily: "Molle",
  fontWeight: "normal",
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_molle.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1852,
    descender: -701
  }
}, {
  identifier: "imgly_font_monoton",
  fontFamily: "Monoton",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_monoton.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2366,
    descender: -822
  }
}, {
  identifier: "imgly_font_nixie_one",
  fontFamily: "Nixie One",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_nixie_one.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 926,
    descender: -210
  }
}, {
  identifier: "imgly_font_notable",
  fontFamily: "Notable",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_notable.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1143,
    descender: -157
  }
}, {
  identifier: "imgly_font_ostrich_sans_black",
  fontFamily: "Ostrich",
  fontWeight: 800,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_black.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 950,
    descender: -250
  }
}, {
  identifier: "imgly_font_ostrich_sans_bold",
  fontFamily: "Ostrich",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 950,
    descender: -250
  }
}, {
  identifier: "imgly_font_oswald_semi_bold",
  fontFamily: "Oswald SemiBold",
  googleFamily: "Oswald",
  fontWeight: 600,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_oswald_semi_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1193,
    descender: -289
  }
}, {
  identifier: "imgly_font_palanquin_dark_semi_bold",
  fontFamily: "Palanquin Dark SemiBold",
  googleFamily: "Palanquin Dark",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_palanquin_dark_semi_bold.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1320,
    descender: -491
  }
}, {
  identifier: "imgly_font_poppins",
  fontFamily: "Poppins",
  fontWeight: "bold",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_poppins.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1050,
    descender: -350
  }
}, {
  identifier: "imgly_font_permanent_marker",
  fontFamily: "Permanent Marker",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_permanent_marker.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1024,
    ascender: 1136,
    descender: -325
  }
}, {
  identifier: "imgly_font_roboto_black_italic",
  fontFamily: "Roboto Black",
  fontWeight: "bold",
  fontStyle: "italic",
  googleFamily: "Roboto",
  fontURI: "./fonts/imgly_font_roboto_black_italic.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1900,
    descender: -500
  }
}, {
  identifier: "imgly_font_roboto_light_italic",
  fontFamily: "Roboto Light",
  googleFamily: "Roboto",
  fontWeight: 300,
  fontStyle: "italic",
  fontURI: "./fonts/imgly_font_roboto_light_italic.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1900,
    descender: -500
  }
}, {
  identifier: "imgly_font_sancreek",
  fontFamily: "Sancreek",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_sancreek.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2104,
    descender: -738
  }
}, {
  identifier: "imgly_font_stint_ultra_expanded",
  fontFamily: "Stint Ultra Expanded",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_stint_ultra_expanded.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1853,
    descender: -483
  }
}, {
  identifier: "imgly_font_trash_hand",
  fontFamily: "Trash Hand",
  fontWeight: "normal",
  fontURI: "./fonts/imgly_font_trash_hand.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 759,
    descender: -304
  }
}, {
  identifier: "imgly_font_vt323",
  fontFamily: "VT323",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_vt323.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 800,
    descender: -200
  }
}, {
  identifier: "imgly_font_yeseva_one",
  fontFamily: "Yeseva One",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_yeseva_one.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 915,
    descender: -240
  }
}, {
  identifier: "imgly_font_abril_fatface_regular",
  fontFamily: "Abril Fatface",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_abril_fatface_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 1058,
    descender: -291
  }
}, {
  identifier: "imgly_font_amberlight",
  fontFamily: "Amberlight",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_amberlight.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 750,
    descender: -250
  }
}, {
  identifier: "imgly_font_montserrat_light",
  fontFamily: "Montserrat Light",
  googleFamily: "Montserrat",
  fontWeight: 300,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_montserrat_light.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 968,
    descender: -251
  }
}, {
  identifier: "imgly_font_handycheera_regular",
  fontFamily: "Handycheera",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_handycheera_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2199,
    descender: -808
  }
}, {
  identifier: "imgly_font_ostrich_sans_heavy",
  fontFamily: "Ostrich",
  fontWeight: 900,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ostrich_sans_heavy.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 674,
    descender: 0
  }
}, {
  identifier: "imgly_font_petit_formal_script",
  fontFamily: "Petit Formal Script",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_petit_formal_script.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2033,
    descender: -527
  }
}, {
  identifier: "imgly_font_rasa_500",
  fontFamily: "Rasa",
  fontWeight: 500,
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_rasa_500.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2750,
    ascender: 2300,
    descender: -1050
  }
}, {
  identifier: "imgly_font_rasa_regular",
  fontFamily: "Rasa",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_rasa_regular.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2750,
    ascender: 2300,
    descender: -1050
  }
}, {
  identifier: "imgly_font_roboto_black",
  fontFamily: "Roboto Black",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_roboto_black.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1900,
    descender: -500
  }
}, {
  identifier: "imgly_font_roboto_light",
  fontFamily: "Roboto Light",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_roboto_light.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 1900,
    descender: -500
  }
}, {
  identifier: "imgly_font_sue_ellen_francisco",
  fontFamily: "Sue Ellen Francisco",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_sue_ellen_francisco.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1024,
    ascender: 1362,
    descender: -634
  }
}, {
  identifier: "imgly_font_ultra",
  fontFamily: "Ultra",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_ultra.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 2048,
    ascender: 2066,
    descender: -561
  }
}, {
  identifier: "imgly_font_wolesbro",
  fontFamily: "Wolesbro",
  fontWeight: "normal",
  fontStyle: "normal",
  fontURI: "./fonts/imgly_font_wolesbro.woff",
  format: "woff",
  textMetrics: {
    unitsPerEm: 1e3,
    ascender: 925,
    descender: -575
  }
}],
    Ln = vp;
var _p = ["imgly_font_open_sans_bold", "imgly_font_aleo_bold", "imgly_font_amaticsc", "imgly_font_archivo_black", "imgly_font_bungee_inline", "imgly_font_campton_bold", "imgly_font_carter_one", "imgly_font_codystar", "imgly_font_fira_sans_regular", "imgly_font_galano_grotesque_bold", "imgly_font_krona_one", "imgly_font_kumar_one_outline", "imgly_font_lobster", "imgly_font_molle", "imgly_font_monoton", "imgly_font_nixie_one", "imgly_font_notable", "imgly_font_ostrich_sans_black", "imgly_font_ostrich_sans_bold", "imgly_font_oswald_semi_bold", "imgly_font_palanquin_dark_semi_bold", "imgly_font_poppins", "imgly_font_permanent_marker", "imgly_font_roboto_black_italic", "imgly_font_roboto_light_italic", "imgly_font_sancreek", "imgly_font_stint_ultra_expanded", "imgly_font_trash_hand", "imgly_font_vt323", "imgly_font_yeseva_one"],
    Sp = ["imgly_font_abril_fatface_regular", "imgly_font_amberlight", "imgly_font_bungee_inline", "imgly_font_campton_bold", "imgly_font_galano_grotesque_bold", "imgly_font_handycheera_regular", "imgly_font_montserrat_light", "imgly_font_ostrich_sans_black", "imgly_font_ostrich_sans_bold", "imgly_font_ostrich_sans_heavy", "imgly_font_permanent_marker", "imgly_font_petit_formal_script", "imgly_font_rasa_500", "imgly_font_rasa_regular", "imgly_font_roboto_black", "imgly_font_roboto_light", "imgly_font_roboto_black_italic", "imgly_font_roboto_light_italic", "imgly_font_sue_ellen_francisco", "imgly_font_ultra", "imgly_font_wolesbro"];
var Dp = [{
  identifier: "imgly_frame_dia",
  name: "Dia",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_dia/imgly_frame_dia_thumb.png",
  imageGroups: {
    top: {
      mid: {
        image: "./items/imgly_frame_dia/imgly_frame_dia_top.png",
        mode: "repeat"
      }
    },
    left: {
      start: "./items/imgly_frame_dia/imgly_frame_dia_top_corner_left.png",
      mid: "./items/imgly_frame_dia/imgly_frame_dia_left.png",
      end: "./items/imgly_frame_dia/imgly_frame_dia_bottom_corner_left.png"
    },
    right: {
      start: "./items/imgly_frame_dia/imgly_frame_dia_top_corner_right.png",
      mid: "./items/imgly_frame_dia/imgly_frame_dia_right.png",
      end: "./items/imgly_frame_dia/imgly_frame_dia_bottom_corner_right.png"
    },
    bottom: {
      mid: {
        image: "./items/imgly_frame_dia/imgly_frame_dia_bottom.png",
        mode: "repeat"
      }
    }
  }
}, {
  identifier: "imgly_frame_art_decor",
  name: "Art Decor",
  tintable: !0,
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_art_decor/imgly_frame_art_decor_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_art_decor/imgly_frame_art_decor_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_art_decor/imgly_frame_art_decor_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_black_passepartout",
  name: "Black Passepartout",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_black_passepartout/imgly_frame_black_passepartout_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_wood_passepartout",
  name: "Wood Passepartout",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_wood_passepartout/imgly_frame_wood_passepartout_bottom_corner_right.png"
    }
  }
}, {
  identifier: "imgly_frame_lowpoly_shadow",
  name: "Low Poly",
  layoutMode: "horizontal-inside",
  thumbnailURI: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_thumb.png",
  imageGroups: {
    top: {
      start: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_left.png",
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_top_corner_right.png"
    },
    left: {
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_left.png",
        mode: "stretch"
      }
    },
    right: {
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_right.png",
        mode: "stretch"
      }
    },
    bottom: {
      start: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_left.png",
      mid: {
        image: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom.png",
        mode: "stretch"
      },
      end: "./items/imgly_frame_lowpoly_shadow/imgly_frame_lowpoly_shadow_bottom_corner_right.png"
    }
  }
}],
    Un = Dp;
var Nn = Wb;
var xp = [{
  identifier: "imgly_sticker_emoticons",
  name: "Emoticons",
  thumbnailURI: "./categories/emoticons.png",
  items: [{
    identifier: "imgly_sticker_emoticons_grin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_grin.svg",
    tintMode: "none",
    name: "Grin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_laugh",
    stickerURI: "./emoticons/imgly_sticker_emoticons_laugh.svg",
    tintMode: "none",
    name: "Laugh",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_smile",
    stickerURI: "./emoticons/imgly_sticker_emoticons_smile.svg",
    tintMode: "none",
    name: "Smile",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wink",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wink.svg",
    tintMode: "none",
    name: "Wink",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_tongue_out_wink",
    stickerURI: "./emoticons/imgly_sticker_emoticons_tongue_out_wink.svg",
    tintMode: "none",
    name: "Tongue out wink",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_angel",
    stickerURI: "./emoticons/imgly_sticker_emoticons_angel.svg",
    tintMode: "none",
    name: "Angel",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_kisses",
    stickerURI: "./emoticons/imgly_sticker_emoticons_kisses.svg",
    tintMode: "none",
    name: "Kisses",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_loving",
    stickerURI: "./emoticons/imgly_sticker_emoticons_loving.svg",
    tintMode: "none",
    name: "Loving",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_kiss",
    stickerURI: "./emoticons/imgly_sticker_emoticons_kiss.svg",
    tintMode: "none",
    name: "Kiss",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wave",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wave.svg",
    tintMode: "none",
    name: "Wave",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_nerd",
    stickerURI: "./emoticons/imgly_sticker_emoticons_nerd.svg",
    tintMode: "none",
    name: "Nerd",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_cool",
    stickerURI: "./emoticons/imgly_sticker_emoticons_cool.svg",
    tintMode: "none",
    name: "Cool",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_blush",
    stickerURI: "./emoticons/imgly_sticker_emoticons_blush.svg",
    tintMode: "none",
    name: "Blush",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_duckface",
    stickerURI: "./emoticons/imgly_sticker_emoticons_duckface.svg",
    tintMode: "none",
    name: "Duckface",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_furious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_furious.svg",
    tintMode: "none",
    name: "Furious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_angry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_angry.svg",
    tintMode: "none",
    name: "Angry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_steaming_furious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_steaming_furious.svg",
    tintMode: "none",
    name: "Steaming Furious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sad",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sad.svg",
    tintMode: "none",
    name: "Sad",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_anxious",
    stickerURI: "./emoticons/imgly_sticker_emoticons_anxious.svg",
    tintMode: "none",
    name: "Anxious",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_cry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_cry.svg",
    tintMode: "none",
    name: "Cry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sobbing",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sobbing.svg",
    tintMode: "none",
    name: "Sobbing",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_loud_cry",
    stickerURI: "./emoticons/imgly_sticker_emoticons_loud_cry.svg",
    tintMode: "none",
    name: "Loud Cry",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wide_grin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wide_grin.svg",
    tintMode: "none",
    name: "Wide grin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_impatient",
    stickerURI: "./emoticons/imgly_sticker_emoticons_impatient.svg",
    tintMode: "none",
    name: "Impatient",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_tired",
    stickerURI: "./emoticons/imgly_sticker_emoticons_tired.svg",
    tintMode: "none",
    name: "Tired",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_asleep",
    stickerURI: "./emoticons/imgly_sticker_emoticons_asleep.svg",
    tintMode: "none",
    name: "Asleep",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sleepy",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sleepy.svg",
    tintMode: "none",
    name: "Sleepy",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_deceased",
    stickerURI: "./emoticons/imgly_sticker_emoticons_deceased.svg",
    tintMode: "none",
    name: "Deceased",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_attention",
    stickerURI: "./emoticons/imgly_sticker_emoticons_attention.svg",
    tintMode: "none",
    name: "Attention",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_question",
    stickerURI: "./emoticons/imgly_sticker_emoticons_question.svg",
    tintMode: "none",
    name: "Question",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_not_speaking_to_you",
    stickerURI: "./emoticons/imgly_sticker_emoticons_not_speaking_to_you.svg",
    tintMode: "none",
    name: "Not speaking to you",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sick",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sick.svg",
    tintMode: "none",
    name: "Sick",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_pumpkin",
    stickerURI: "./emoticons/imgly_sticker_emoticons_pumpkin.svg",
    tintMode: "none",
    name: "Pumpkin",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_boxer",
    stickerURI: "./emoticons/imgly_sticker_emoticons_boxer.svg",
    tintMode: "none",
    name: "Boxer",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_idea",
    stickerURI: "./emoticons/imgly_sticker_emoticons_idea.svg",
    tintMode: "none",
    name: "Idea",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_smoking",
    stickerURI: "./emoticons/imgly_sticker_emoticons_smoking.svg",
    tintMode: "none",
    name: "Smoking",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_beer",
    stickerURI: "./emoticons/imgly_sticker_emoticons_beer.svg",
    tintMode: "none",
    name: "Beer",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_skateboard",
    stickerURI: "./emoticons/imgly_sticker_emoticons_skateboard.svg",
    tintMode: "none",
    name: "Skateboard",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_guitar",
    stickerURI: "./emoticons/imgly_sticker_emoticons_guitar.svg",
    tintMode: "none",
    name: "Guitar",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_music",
    stickerURI: "./emoticons/imgly_sticker_emoticons_music.svg",
    tintMode: "none",
    name: "Music",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_sunbathing",
    stickerURI: "./emoticons/imgly_sticker_emoticons_sunbathing.svg",
    tintMode: "none",
    name: "Sunbathing",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_hippie",
    stickerURI: "./emoticons/imgly_sticker_emoticons_hippie.svg",
    tintMode: "none",
    name: "Hippie",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_humourous",
    stickerURI: "./emoticons/imgly_sticker_emoticons_humourous.svg",
    tintMode: "none",
    name: "Humourous",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_hitman",
    stickerURI: "./emoticons/imgly_sticker_emoticons_hitman.svg",
    tintMode: "none",
    name: "Hitman",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_harry_potter",
    stickerURI: "./emoticons/imgly_sticker_emoticons_harry_potter.svg",
    tintMode: "none",
    name: "Harry Potter",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_business",
    stickerURI: "./emoticons/imgly_sticker_emoticons_business.svg",
    tintMode: "none",
    name: "Business",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_batman",
    stickerURI: "./emoticons/imgly_sticker_emoticons_batman.svg",
    tintMode: "none",
    name: "Batman",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_skull",
    stickerURI: "./emoticons/imgly_sticker_emoticons_skull.svg",
    tintMode: "none",
    name: "Skull",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_ninja",
    stickerURI: "./emoticons/imgly_sticker_emoticons_ninja.svg",
    tintMode: "none",
    name: "Ninja",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_masked",
    stickerURI: "./emoticons/imgly_sticker_emoticons_masked.svg",
    tintMode: "none",
    name: "Masked",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_alien",
    stickerURI: "./emoticons/imgly_sticker_emoticons_alien.svg",
    tintMode: "none",
    name: "Alien",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_wrestler",
    stickerURI: "./emoticons/imgly_sticker_emoticons_wrestler.svg",
    tintMode: "none",
    name: "Wrestler",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_devil",
    stickerURI: "./emoticons/imgly_sticker_emoticons_devil.svg",
    tintMode: "none",
    name: "Devil",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_star",
    stickerURI: "./emoticons/imgly_sticker_emoticons_star.svg",
    tintMode: "none",
    name: "Star",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_baby_chicken",
    stickerURI: "./emoticons/imgly_sticker_emoticons_baby_chicken.svg",
    tintMode: "none",
    name: "Baby Chicken",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_rabbit",
    stickerURI: "./emoticons/imgly_sticker_emoticons_rabbit.svg",
    tintMode: "none",
    name: "Rabbit",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_pig",
    stickerURI: "./emoticons/imgly_sticker_emoticons_pig.svg",
    tintMode: "none",
    name: "Pig",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_emoticons_chicken",
    stickerURI: "./emoticons/imgly_sticker_emoticons_chicken.svg",
    tintMode: "none",
    name: "Chicken",
    resizeMode: "keepAspect"
  }]
}, {
  identifier: "imgly_sticker_shapes",
  name: "Shapes",
  thumbnailURI: "./categories/shapes.png",
  items: [{
    identifier: "imgly_sticker_shapes_badge_01",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_01.svg",
    tintMode: "solid",
    name: "Shape Badge 01",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_04",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_04.svg",
    tintMode: "solid",
    name: "Shape Badge 04",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_12",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_12.svg",
    tintMode: "solid",
    name: "Shape Badge 12",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_06",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_06.svg",
    tintMode: "solid",
    name: "Shape Badge 06",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_13",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_13.svg",
    tintMode: "solid",
    name: "Shape Badge 13",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_36",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_36.svg",
    tintMode: "solid",
    name: "Shape Badge 36",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_08",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_08.svg",
    tintMode: "solid",
    name: "Shape Badge 08",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_11",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_11.svg",
    tintMode: "solid",
    name: "Shape Badge 11",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_35",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_35.svg",
    tintMode: "solid",
    name: "Shape Badge 35",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_28",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_28.svg",
    tintMode: "solid",
    name: "Shape Badge 28",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_32",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_32.svg",
    tintMode: "solid",
    name: "Shape Badge 32",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_15",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_15.svg",
    tintMode: "solid",
    name: "Shape Badge 15",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_20",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_20.svg",
    tintMode: "solid",
    name: "Shape Badge 20",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_18",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_18.svg",
    tintMode: "solid",
    name: "Shape Badge 18",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_badge_19",
    stickerURI: "./shapes/imgly_sticker_shapes_badge_19.svg",
    tintMode: "solid",
    name: "Shape Badge 19",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_arrow_02",
    stickerURI: "./shapes/imgly_sticker_shapes_arrow_02.svg",
    tintMode: "solid",
    name: "Shape Arrow 02",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_arrow_03",
    stickerURI: "./shapes/imgly_sticker_shapes_arrow_03.svg",
    tintMode: "solid",
    name: "Shape Arrow 03",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_01",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_01.svg",
    tintMode: "solid",
    name: "Shape Spray 01",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_04",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_04.svg",
    tintMode: "solid",
    name: "Shape Spray 04",
    resizeMode: "keepAspect"
  }, {
    identifier: "imgly_sticker_shapes_spray_03",
    stickerURI: "./shapes/imgly_sticker_shapes_spray_03.svg",
    tintMode: "solid",
    name: "Shape Spray 03",
    resizeMode: "keepAspect"
  }]
}],
    Hn = xp;
var Cp = [{
  thumbnailURI: "./items/dark/imgly_text_design_icon_thislayoutisgreat.png",
  identifier: "imgly_text_design_blocks",
  name: "Blocks"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_fatandfast.png",
  identifier: "imgly_text_design_rotated",
  name: "Rotated"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_summerfeeling.png",
  identifier: "imgly_text_design_blocks_light",
  name: "Blocks Light"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_typewithstyle.png",
  identifier: "imgly_text_design_equal_width",
  name: "Equal Width"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_inthebox.png",
  identifier: "imgly_text_design_masked",
  name: "Masked"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_bluefriday.png",
  identifier: "imgly_text_design_celebrate",
  name: "Celebrate"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_decorative.png",
  identifier: "imgly_text_design_sunshine",
  name: "Sunshine"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_specialdeals.png",
  identifier: "imgly_text_design_masked_badge",
  name: "Masked Badge"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_doublelines.png",
  identifier: "imgly_text_design_blocks_condensed",
  name: "Blocks Condensed"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_celebrate.png",
  identifier: "imgly_text_design_celebrate_simple",
  name: "Celebrate Simple"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_beerandburger.png",
  identifier: "imgly_text_design_equal_width_fat",
  name: "Equal Width Fat"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_watercolor.png",
  identifier: "imgly_text_design_watercolor",
  name: "Watercolor"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_particle.png",
  identifier: "imgly_text_design_particles",
  name: "Particles"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_yeah.png",
  identifier: "imgly_text_design_masked_speech_bubble",
  name: "Masked Speech Bubble"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_thisisadream.png",
  identifier: "imgly_text_design_masked_speech_bubble_comic",
  name: "Masked Speech Bubble Comic"
}, {
  thumbnailURI: "./items/dark/imgly_text_design_icon_fatface.png",
  identifier: "imgly_text_design_multiline",
  name: "Multiline"
}],
    wp = Cp;
var Ep = [{
  thumbnailURI: "./items/light/imgly_text_design_icon_thislayoutisgreat.png",
  identifier: "imgly_text_design_blocks",
  name: "Blocks"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_fatandfast.png",
  identifier: "imgly_text_design_rotated",
  name: "Rotated"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_summerfeeling.png",
  identifier: "imgly_text_design_blocks_light",
  name: "Blocks Light"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_typewithstyle.png",
  identifier: "imgly_text_design_equal_width",
  name: "Equal Width"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_inthebox.png",
  identifier: "imgly_text_design_masked",
  name: "Masked"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_bluefriday.png",
  identifier: "imgly_text_design_celebrate",
  name: "Celebrate"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_decorative.png",
  identifier: "imgly_text_design_sunshine",
  name: "Sunshine"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_specialdeals.png",
  identifier: "imgly_text_design_masked_badge",
  name: "Masked Badge"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_doublelines.png",
  identifier: "imgly_text_design_blocks_condensed",
  name: "Blocks Condensed"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_celebrate.png",
  identifier: "imgly_text_design_celebrate_simple",
  name: "Celebrate Simple"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_beerandburger.png",
  identifier: "imgly_text_design_equal_width_fat",
  name: "Equal Width Fat"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_watercolor.png",
  identifier: "imgly_text_design_watercolor",
  name: "Watercolor"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_particle.png",
  identifier: "imgly_text_design_particles",
  name: "Particles"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_yeah.png",
  identifier: "imgly_text_design_masked_speech_bubble",
  name: "Masked Speech Bubble"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_thisisadream.png",
  identifier: "imgly_text_design_masked_speech_bubble_comic",
  name: "Masked Speech Bubble Comic"
}, {
  thumbnailURI: "./items/light/imgly_text_design_icon_fatface.png",
  identifier: "imgly_text_design_multiline",
  name: "Multiline"
}],
    kp = Ep;
var Wn = Kb;
var jn = {};
qb(jn, {
  isMobile: function isMobile() {
    return wl;
  }
});

function wl() {
  if (typeof navigator == "undefined") return !1;
  var i = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0, 4));
}

var Gn =
/*#__PURE__*/
function (_Xi) {
  _inherits(Gn, _Xi);

  function Gn(e, t) {
    var _this;

    _classCallCheck(this, Gn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Gn).call(this));
    _this.image = e, _this.options = t;
    return _this;
  }

  _createClass(Gn, [{
    key: "needsResize",
    value: function needsResize() {
      var e = this.resizedDimensions();
      return e.x < this.image.width || e.y < this.image.height;
    }
  }, {
    key: "resizedDimensions",
    value: function resizedDimensions() {
      var e = this.options,
          t = {
        width: this.image.width,
        height: this.image.height
      },
          r = _.fromSize(t),
          o = _.fromSize(t),
          n = e.maxMegaPixels;

      if (n) {
        var c = (wl() ? n.mobile : n.desktop) * 1e6,
            p = t.width / t.height,
            m = t.height / t.width,
            h = new _(Math.floor(Math.sqrt(c * p)), Math.floor(Math.sqrt(c * m)));
        h.x <= t.width && h.y <= t.height && (r = h);
      }

      var s = e.maxDimensions;
      s && (s.height < t.height || s.width < t.width) && (o = new _(s.width, s.height));
      var l = new _(Math.min(r.x, o.x), Math.min(r.y, o.y));
      return _.proportionalFit(l, _.fromSize(t)).floored;
    }
  }, {
    key: "downscaleIfNecessary",
    value: function downscaleIfNecessary() {
      var e = this.resizedDimensions();
      if (!(e.x < this.image.width || e.y < this.image.height)) return this.image;
      this.emit(Ji.BEGAN_IMAGE_DOWNSCALING, this.image);
      var r = document.createElement("canvas");
      r.width = e.x, r.height = e.y;
      var o = r.getContext("2d"),
          n = this.image;
      return o.imageSmoothingQuality = "high", o.drawImage(n, 0, 0, n.width, n.height, 0, 0, e.x, e.y), this.emit(Ji.IMAGE_DOWNSCALED, {
        width: e.x,
        height: e.y
      }), r;
    }
  }, {
    key: "downscaleImageIfNecessary",
    value: function downscaleImageIfNecessary() {
      var e = this.image,
          t = this.resizedDimensions();
      if (!(t.x < this.image.width || t.y < this.image.height)) return e;
      this.emit(Ji.BEGAN_IMAGE_DOWNSCALING, e);
      var o = new Image();
      return o.width = t.x, o.height = t.y, o.src = e.src, this.emit(Ji.IMAGE_DOWNSCALED, {
        width: t.x,
        height: t.y
      }), o;
    }
  }]);

  return Gn;
}(Xi);

var Ip = function Ip(i) {
  return i.key === "Escape";
};

var El = function El(i) {
  return function (e) {
    Ip(e) && i(e);
  };
};

var me = Zb;

function Fp(i, e) {
  var t = 0;

  for (var r = i.length - 1; r >= 0; r--) {
    var o = i[r];
    o === "." ? i.splice(r, 1) : o === ".." ? (i.splice(r, 1), t++) : t && (i.splice(r, 1), t--);
  }

  if (e) for (; t--; t) {
    i.unshift("..");
  }
  return i;
}

function Ap(i) {
  return i.charAt(0) === "/";
}

function Rp(i) {
  var e = Ap(i),
      t = i.substr(-1) === "/";
  return i = Fp(i.split("/").filter(Boolean), !e).join("/"), !i && !e && (i = "."), i && t && (i += "/"), (e ? "/" : "") + i;
}

var kl = function kl() {
  for (var _len2 = arguments.length, i = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    i[_key2] = arguments[_key2];
  }

  return Rp(i.join("/"));
};

var Vn = function Vn(i, e, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      t = _ref2[0],
      r = _ref2[1];

  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var n = i[e];

  if (n) {
    if (n < t) return console.error("".concat(e, " must be greater than or equal to ").concat(t)), t;
    if (n > r) return console.error("".concat(e, " must be less than or equal to ").concat(r)), r;
  }

  return n || o;
},
    Ge = function Ge(i, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [1, 1, 1, 1];
  var r = i[e],
      o = !0;
  return r && r.forEach(function (n) {
    n < 0 && (console.error("".concat(n, " in ").concat(e, " must be greater than or equal to 0")), o = !1), n > 1 && (console.error("".concat(n, " in ").concat(e, " must be less than or equal to 1")), o = !1);
  }), o && r || t;
};

var Op = {
  italic: "i"
},
    Kr =
/*#__PURE__*/
function () {
  function Kr(e) {
    _classCallCheck(this, Kr);

    this.assetManager = e;
    this.injectedFonts = {};
    this.loadedFonts = {};

    this.getGoogleFamiliesString = function (e) {
      var t = e.reduce(function (r, o) {
        var n = o.fontFamily,
            s = o.fontStyle,
            _o$fontWeight = o.fontWeight,
            l = _o$fontWeight === void 0 ? 400 : _o$fontWeight;
        return r[n] = (r[n] || []).concat("".concat(l).concat(Op[s] || "")), r;
      }, {});
      return Object.keys(t).map(function (r) {
        var o = t[r].length ? ":".concat(t[r].join(",")) : "";
        return r.replace(" ", "+") + o;
      }).join("|");
    };
  }

  _createClass(Kr, [{
    key: "getFontWithId",
    value: function getFontWithId(e) {
      var t = this.assetManager.getFontAsset(e);
      if (!t) throw new Error("The requested font does not exist as an asset.");
      return t;
    }
  }, {
    key: "isFontLoaded",
    value: function isFontLoaded(e) {
      return this.loadedFonts[e] !== void 0;
    }
  }, {
    key: "injectAllFonts",
    value: function injectAllFonts() {
      var e = this.assetManager.getFontAssets();
      this.injectFonts(e);
    }
  }, {
    key: "loadAllFonts",
    value: function loadAllFonts() {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var e;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e = this.assetManager.getFontAssets();
                return _context.abrupt("return", this.loadFonts(e));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loadFontsWithIdentifiers",
    value: function loadFontsWithIdentifiers(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = e.map(function (r) {
                  return _this2.getFontWithId(r);
                });
                return _context2.abrupt("return", this.loadFonts(t));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "loadFonts",
    value: function loadFonts(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.injectFonts(e);
                t = new Array();
                return _context3.abrupt("return", (e.forEach(function (r) {
                  t.push(_this3.loadFont(r, !1));
                }), new Promise(function (r, o) {
                  Promise.all(t).then(function () {
                    return r();
                  }).catch(function (n) {
                    return o(n);
                  });
                })));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "loadFont",
    value: function loadFont(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (r, o) {
                  _this4.isFontLoaded(e.identifier) && r(), t && _this4.injectFonts([e]), new iy(e).load().then(function () {
                    _this4.loadedFonts[e.identifier] = e, r();
                  }).catch(function () {
                    o(e.identifier);
                  });
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "loadFontWithIdentifier",
    value: function loadFontWithIdentifier(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var r;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                r = this.assetManager.getFontAsset(e);

                if (r) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("The requested font asset with identifier ".concat(e, " does not exist!"));

              case 3:
                return _context5.abrupt("return", this.loadFont(r, t));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "injectFonts",
    value: function injectFonts(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.assetManager.getPathForCategory("font");
      var r = e.filter(yp),
          o = e.filter(bp);
      r.length > 0 && this.addGoogleFontLinks(r), o.length > 0 && this.addWebFontCSS(o, t);
    }
  }, {
    key: "addGoogleFontLinks",
    value: function addGoogleFontLinks(e) {
      var _this5 = this;

      var t = e.filter(function (s) {
        return !_this5.injectedFonts[s.identifier];
      });
      if (t.length === 0) return;
      var r = this.getGoogleFamiliesString(t),
          o = document.createElement("link");
      o.rel = "stylesheet", o.href = "https://fonts.googleapis.com/css?family=".concat(r), document.getElementsByTagName("head")[0].appendChild(o), e.forEach(function (s) {
        _this5.injectedFonts[s.identifier] = s;
      });
    }
  }, {
    key: "addWebFontCSS",
    value: function addWebFontCSS(e, t) {
      var _this6 = this;

      var r = e.filter(function (l) {
        return !_this6.injectedFonts[l.identifier];
      });
      if (r.length === 0) return;
      var n = "\n      /* Injected by PhotoEditorSDK */\n      ".concat(Kr.createFontFacesCSS(r, t).join("\n"), "\n    "),
          s = document.createElement("style");
      s.innerHTML = n, document.head.appendChild(s), e.forEach(function (l) {
        _this6.injectedFonts[l.identifier] = l;
      });
    }
  }], [{
    key: "createFontFacesCSS",
    value: function createFontFacesCSS(e, t) {
      return e.map(function (r) {
        var o = t(r.fontURI);
        return "@font-face {\n        font-family: \"".concat(r.fontFamily, "\";\n        src: url('").concat(o, "') format('").concat(r.format || "woff", "');\n        font-weight: ").concat(r.fontWeight || "normal", ";\n        font-style: ").concat(r.fontStyle || "normal", ";\n      }");
      });
    }
  }]);

  return Kr;
}();

var qr =
/*#__PURE__*/
function () {
  function qr(e) {
    var _this7 = this;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

    _classCallCheck(this, qr);

    this.basePath = "assets/";
    this.areCustomAssetsAllowed = !1;

    this.getAssets = function (e) {
      switch (e) {
        case "overlay":
          return _this7.overlayAssets;

        case "filter":
          return _this7.filterCategories;

        case "font":
          return _this7.fontAssets;

        case "focus":
          return _this7.focusAssets;

        case "adjustment":
          return _this7.adjustmentCategories;

        case "sticker":
          return _this7.stickerCategories;

        case "textdesign":
          return _this7.textDesignAssets;

        case "frame":
          return _this7.frameAssets;

        case "transform":
          return _this7.transformCategories;
      }

      return [];
    };

    this.getPath = function (e) {
      for (var _len3 = arguments.length, t = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        t[_key3 - 1] = arguments[_key3];
      }

      if (t.length === 1 && t[0].match(/(ftp|http|https):\/\//) && ii(t[0])) return t[0];
      var r = kl.apply(void 0, [e].concat(t));
      if ((!t || t.length === 0) && ii(e)) return e;

      if (_this7.basePath.match(/(ftp|http|https):\/\//)) {
        var _o2 = _this7.basePath.length;
        return _this7.basePath[_o2 - 1] !== "/" && (_this7.basePath = "".concat(_this7.basePath, "/")), _this7.basePath + r;
      }

      return kl(_this7.basePath, r);
    };

    this.getPathForCategory = function (e) {
      return function () {
        for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          t[_key4] = arguments[_key4];
        }

        return _this7.getPath.apply(_this7, [e].concat(t));
      };
    };

    this.addCustomStickerAsset = function (e, t, r) {
      e.forEach(function (o) {
        var n = o.thumbnailURI,
            s = o.name,
            l = o.stickerURI,
            c = o.identifier,
            p = o.tintMode,
            m = o.resizeMode,
            h = _this7.stickerCategories.find(function (v) {
          return v.identifier === t;
        }),
            b = {
          identifier: c,
          name: s,
          thumbnailURI: n,
          stickerURI: l,
          tintMode: p,
          resizeMode: m
        };

        if (h) h.items.push(b);else {
          var v = {
            identifier: t,
            name: r,
            thumbnailURI: n,
            items: [b]
          };
          _this7.stickerCategories = [v].concat(_toConsumableArray(_this7.stickerCategories));
        }
      }), _this7.stickerAssets = _this7.stickerCategories.reduce(_this7.allOptions, []);
    };

    this.getItemPath = function (e, t, r) {
      var o = e.find(function (n) {
        return n.identifier === t;
      });
      return o && (o[r] || o.path) || "";
    };

    this.isNonExistingFont = function (e) {
      return !Ln.find(function (t) {
        return t.identifier === e.identifier;
      }) && !Tp[e.identifier];
    };

    this.replaceDeprecatedFont = function (e) {
      return Tp[e.identifier] ? Ln.find(function (t) {
        return t.identifier === oy(e.identifier, !0);
      }) : e;
    };

    e && e.basePath && (this.basePath = e.basePath), this.areCustomAssetsAllowed = t;
    var r = zn.reduce(this.allOptions, []);
    e && e.filter ? this.filterCategories = this.configuredCategory(zn, e.filter, r) : this.filterCategories = zn, this.lutFilterAssets = this.filterCategories.reduce(this.allOptions, []).filter(function (m) {
      return gp(m);
    }), this.duoToneFilterAssets = this.filterCategories.reduce(this.allOptions, []).filter(function (m) {
      return $r(m);
    });
    var o = Bn.reduce(this.allOptions, []);
    e && e.adjustment ? this.adjustmentCategories = this.configuredCategory(Bn, e.adjustment, o) : this.adjustmentCategories = Bn, this.fontAssets = Ln.reduce(this.allOptions, []);

    var n = _p.map(function (m) {
      return _this7.getFontAsset(m);
    });

    if (e && e.text && e.text.fonts && e.text.fonts.length > 0) {
      var m = e.text.fonts.filter(this.isNonExistingFont),
          h = e.text.fonts.filter(function (b) {
        return !_this7.isNonExistingFont(b);
      }).map(function (b) {
        return _this7.replaceDeprecatedFont(b);
      }).map(function (b) {
        return _this7.getFontAsset(b.identifier);
      });
      n = e.text.fonts ? [].concat(_toConsumableArray(h), _toConsumableArray(m)) : n, this.fontAssets = e.text.fonts ? [].concat(_toConsumableArray(this.fontAssets), _toConsumableArray(m)) : this.fontAssets;
    }

    this.textToolFontAssets = n;
    var s = e && e.focus && e.focus.items && e.focus.items.length ? e.focus.items.map(function (m) {
      return Cl.find(function (h) {
        return h.identifier === m.identifier;
      });
    }) : Cl;
    this.focusAssets = s, e && e.overlay && e.overlay.items ? this.overlayAssets = this.configuredItem(e.overlay.items, Nn, Nn) : this.overlayAssets = Nn, e && e.frame && e.frame.items ? this.frameAssets = this.configuredItem(e.frame.items, Un, Un) : this.frameAssets = Un;
    var l = Hn.reduce(this.allOptions, []);
    e && e.sticker ? this.stickerCategories = this.configuredCategory(Hn, e.sticker, l) : this.stickerCategories = Hn, this.stickerAssets = this.stickerCategories.reduce(this.allOptions, []);
    var c = wp;
    e && e.theme === "light" && (c = kp), this.textDesignAssets = e && e.textdesign && e.textdesign.items && e.textdesign.items.length ? e.textdesign.items.map(function (m) {
      return c.find(function (h) {
        return h.identifier === m.identifier;
      });
    }) : c, this.textDesignToolFontAssets = Sp.map(function (m) {
      return _this7.getFontAsset(m);
    });
    var p = Wn.reduce(this.allOptions, []);
    e && e.transform ? this.transformCategories = this.configuredCategory(Wn, e.transform, p) : this.transformCategories = Wn, this.transformAssets = this.transformCategories.reduce(this.allOptions, []), this.fontManager = new Kr(this);
  }

  _createClass(qr, [{
    key: "getFontManager",
    value: function getFontManager() {
      return this.fontManager;
    }
  }, {
    key: "getAssetSource",
    value: function getAssetSource(e, t) {
      switch (e) {
        case "filter":
          if (this.getLUTFilterAsset(t)) return this.getPath(e, this.getItemPath(this.lutFilterAssets, t, "lutURI"));
          break;

        case "overlay":
          return this.getPath(e, this.getItemPath(this.overlayAssets, t, "overlayURI"));

        case "font":
          return this.getPath(e, this.getItemPath(this.fontAssets, t, "fontURI"));

        case "sticker":
          var o = this.stickerAssets.find(function (n) {
            return n.identifier === t;
          });

          if (o) {
            if (o.stickerURI.substr(0, 10) === "data:image") return o.stickerURI;

            if (t.includes("imgly_sticker") && o.stickerURI.includes(".svg") && Me()) {
              var s = this.getPath(e, this.getItemPath(this.stickerAssets, t, "stickerURI")).split("/");
              return s.splice(s.length - 1, 0, "base"), s[s.length - 1] = s[s.length - 1].replace(".svg", ".png"), s.join("/");
            }

            return this.getPath(e, this.getItemPath(this.stickerAssets, t, "stickerURI"));
          }

          throw new Error("Cannot resolve this type of sticker asset yet");

        case "textdesign":
          return this.getPath(e, "engine", t);

        case "frame":
          return this.getPath(e, t);
      }

      throw new Error("Cannot resolve this type of asset yet");
    }
  }, {
    key: "getDuotoneFilterAsset",
    value: function getDuotoneFilterAsset(e) {
      return this.duoToneFilterAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getLUTFilterAsset",
    value: function getLUTFilterAsset(e) {
      return this.lutFilterAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getOverlayAsset",
    value: function getOverlayAsset(e) {
      return this.overlayAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getStickerAsset",
    value: function getStickerAsset(e) {
      return this.stickerAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getFontAsset",
    value: function getFontAsset(e) {
      return this.fontAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getTextDesignAssets",
    value: function getTextDesignAssets(e) {
      return this.textDesignAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getFrameAsset",
    value: function getFrameAsset(e) {
      return this.frameAssets.filter(function (t) {
        return t.identifier === e;
      })[0];
    }
  }, {
    key: "getFontAssets",
    value: function getFontAssets() {
      return this.fontAssets;
    }
  }, {
    key: "getFontAssetsForText",
    value: function getFontAssetsForText() {
      return this.textToolFontAssets;
    }
  }, {
    key: "getFontAssetsForTextDesign",
    value: function getFontAssetsForTextDesign() {
      return this.textDesignToolFontAssets;
    }
  }, {
    key: "getFrameAssets",
    value: function getFrameAssets() {
      return this.frameAssets;
    }
  }, {
    key: "allOptions",
    value: function allOptions(e, t) {
      return Object.prototype.hasOwnProperty.call(t, "items") ? [].concat(_toConsumableArray(e), _toConsumableArray(t.items)) : [].concat(_toConsumableArray(e), [t]);
    }
  }, {
    key: "configuredCategory",
    value: function configuredCategory(e, t, r) {
      var _this8 = this;

      return t.categories && t.categories.length ? t.categories.reduce(function (o, n) {
        var s = e.find(function (l) {
          return l.identifier === n.identifier;
        });
        return s ? o.push(f(f(f({}, s), n), {
          items: _this8.configuredItem(n.items, r, s.items).filter(Boolean)
        })) : _this8.areCustomAssetsAllowed && o.push(f(f({}, n), {
          items: _this8.configuredItem(n.items, r, n.items).filter(Boolean)
        })), o;
      }, []) : e;
    }
  }, {
    key: "configuredItem",
    value: function configuredItem(e, t, r) {
      var _this9 = this;

      return e && e.length ? e.reduce(function (o, n) {
        var s = t.find(function (l) {
          return l.identifier === n.identifier;
        });
        return s ? o.push(f(f({}, s), n)) : _this9.areCustomAssetsAllowed && o.push(n), o;
      }, []).filter(Boolean) : r;
    }
  }]);

  return qr;
}();

function Ve(i) {
  return typeof i == "number";
}

var X =
/*#__PURE__*/
function () {
  _createClass(X, null, [{
    key: "IDENTITY",
    get: function get() {
      return new X({
        x: 0,
        y: 0
      });
    }
  }]);

  function X(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      x: 1,
      y: 1
    };
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, X);

    this.position = e, this.scale = t, this.rotation = r;
  }

  return X;
}();

function $n(i) {
  return typeof i != "string" && !Array.isArray(i) && i.a === void 0;
}

function Kn(i) {
  return typeof i != "string" && Array.isArray(i) && i.length === 3;
}

function qn(i) {
  return typeof i != "string" && !Array.isArray(i) && i.a !== void 0;
}

function Yn(i) {
  return typeof i != "string" && Array.isArray(i) && i.length === 4;
}

function Pp(i) {
  return typeof i == "string";
}

var Il =
/*#__PURE__*/
function () {
  function Il(e, t) {
    _classCallCheck(this, Il);

    this.engine = t;
    this.transform = X.IDENTITY;
    this.canvasPivot = {
      x: 0,
      y: 0
    };
    this.previewQuality = 1;
    this.canvas = e;
  }

  _createClass(Il, [{
    key: "setQuality",
    value: function setQuality(e) {
      this.previewQuality = Math.min(Math.max(e, .01), 1);
    }
  }, {
    key: "getTransform",
    value: function getTransform() {
      return this.transform;
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      this.transform = e;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.transform.position;
    }
  }, {
    key: "setPosition",
    value: function setPosition(e, t) {
      var r;
      typeof e == "number" ? r = {
        x: e,
        y: t === void 0 ? e : t
      } : r = e;
      var o = this.transform.scale,
          n = this.transform.rotation;
      this.setTransform(new X(r, o, n));
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this.transform.scale;
    }
  }, {
    key: "setScale",
    value: function setScale(e, t) {
      var r;
      typeof e != "number" ? r = e : r = {
        x: e,
        y: t === void 0 ? e : t
      };
      var o = this.transform.position,
          n = this.transform.rotation;
      this.setTransform(new X(o, r, n));
    }
  }, {
    key: "getRotation",
    value: function getRotation() {
      return this.transform.rotation;
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      var t = this.transform.position,
          r = this.transform.scale;
      this.setTransform(new X(t, r, e));
    }
  }, {
    key: "getCanvasPivot",
    value: function getCanvasPivot() {
      return this.canvasPivot;
    }
  }, {
    key: "setCanvasPivot",
    value: function setCanvasPivot(e, t) {
      typeof e == "number" ? this.canvasPivot = {
        x: e,
        y: typeof t === void 0 ? e : t
      } : this.canvasPivot = e;
    }
  }, {
    key: "getCanvasBounds",
    value: function getCanvasBounds() {
      var e = this.canvasPivot,
          _this$canvas = this.canvas,
          t = _this$canvas.width,
          r = _this$canvas.height;
      return new _t(-e.x * t, -e.y * r, t, r);
    }
  }, {
    key: "quality",
    get: function get() {
      return this.previewQuality;
    }
  }]);

  return Il;
}();

function Fl(i) {
  return i.getTransform !== void 0;
}

function Mp(i) {
  return i.getContainer !== void 0;
}

var Al =
/*#__PURE__*/
function (_Xi2) {
  _inherits(Al, _Xi2);

  function Al(e) {
    var _this10;

    _classCallCheck(this, Al);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(Al).call(this));
    _this10.config = e;
    return _this10;
  }

  _createClass(Al, [{
    key: "getOutputDimensions",
    value: function getOutputDimensions() {
      var e = this.getOutputContainer();
      return e ? e.getResolution() : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getSmallerOutputSide",
    value: function getSmallerOutputSide() {
      var e = this.getOutputContainer();
      if (!e) return 0;
      var t = e.getResolution();
      return Math.min(t.width, t.height);
    }
  }, {
    key: "convertPointFromPreviewIntoOutputSpace",
    value: function convertPointFromPreviewIntoOutputSpace(e, t) {
      var r = $.getInverted(A.rectTransformToAffineTransform(t));
      return $.transformPoint(r, e);
    }
  }, {
    key: "convertPointFromPreviewIntoWorldSpace",
    value: function convertPointFromPreviewIntoWorldSpace(e, t, r) {
      var o = $.getInverted(A.rectTransformToAffineTransform(t)),
          n = r ? this.getOutputContainer().getBaseLocalToParentMatrix() : this.getOutputContainer().getLocalToParentMatrix(),
          s = $.multiply(n, o);
      return $.transformPoint(s, e);
    }
  }, {
    key: "convertPointFromPreviewIntoFlippedPreviewSpace",
    value: function convertPointFromPreviewIntoFlippedPreviewSpace(e) {
      var t = this.getOutputContainer().getFlipTransformMatrix();
      return $.transformPoint(t, e);
    }
  }, {
    key: "convertPointFromWorldIntoPreviewSpace",
    value: function convertPointFromWorldIntoPreviewSpace(e, t) {
      var r = A.rectTransformToAffineTransform(t),
          o = $.getInverted(this.getOutputContainer().getLocalToParentMatrix()),
          n = $.multiply(r, o);
      return $.transformPoint(n, e);
    }
  }, {
    key: "convertPointFromOutputIntoPreviewSpace",
    value: function convertPointFromOutputIntoPreviewSpace(e, t) {
      var r = A.rectTransformToAffineTransform(t);
      return $.transformPoint(r, e);
    }
  }, {
    key: "getContainersAtPreviewPoint",
    value: function getContainersAtPreviewPoint(e, t) {
      var r = new Array(),
          o = this.convertPointFromPreviewIntoWorldSpace(e, t),
          n = this.getRootContainers();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var s = _step2.value;
          this.accumulateContainersAtWorldPointInHierarchy(o, s, r);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return r;
    }
  }, {
    key: "isPreviewPointInContainer",
    value: function isPreviewPointInContainer(e, t, r) {
      var o = this.convertPointFromPreviewIntoWorldSpace(e, r);
      return this.isWorldPointInContainer(o, t);
    }
  }, {
    key: "isWorldPointInContainer",
    value: function isWorldPointInContainer(e, t) {
      var r = A.getLocalToWorldMatrix(t),
          o = $.getInverted(r),
          n = $.transformPoint(o, e);
      return _t.contains(t.getBounds(), n);
    }
  }, {
    key: "accumulateContainersAtWorldPointInHierarchy",
    value: function accumulateContainersAtWorldPointInHierarchy(e, t, r) {
      this.isWorldPointInContainer(e, t) && r.push(t);
      var o = t.getChildren();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = o[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var n = _step3.value;
          Fl(n) && this.accumulateContainersAtWorldPointInHierarchy(e, n, r);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return Al;
}(Xi);

var nt =
/*#__PURE__*/
function () {
  function nt(e) {
    _classCallCheck(this, nt);

    this.engine = e;
    this.id = xi();
  }

  _createClass(nt, [{
    key: "getID",
    value: function getID() {
      return this.id;
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      return this.engine.getRootContainers()[0];
    }
  }, {
    key: "getIndexInParent",
    value: function getIndexInParent() {
      var e = this.engine.rootOperations;

      for (var t = 0; t < e.length; t += 1) {
        if (e[t].getID() === this.id) return t;
      }

      return -1;
    }
  }, {
    key: "setIndexInParent",
    value: function setIndexInParent(e) {
      this.engine.moveIndex(this, e);
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.getIndexInParent() !== -1;
    }
  }]);

  return nt;
}();

var Rl =
/*#__PURE__*/
function (_nt) {
  _inherits(Rl, _nt);

  function Rl(e, t, r) {
    var _this11;

    _classCallCheck(this, Rl);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Rl).call(this, t));
    _this11.operation = r;
    _this11.type = "adjustments";

    _this11.setProperties(e);

    return _this11;
  }

  _createClass(Rl, [{
    key: "getProperties",
    value: function getProperties() {
      var e = this.operation.getOptions(),
          t = e.gamma - 1;
      return {
        brightness: e.brightness || 0,
        saturation: e.saturation || 0,
        contrast: e.contrast || 0,
        gamma: (t < 0 ? 2 * t : t) || 0,
        clarity: e.clarity || 0,
        exposure: e.exposure || 0,
        shadows: e.shadows * .5 || 0,
        highlights: e.highlights || 0,
        whites: e.whites || 0,
        blacks: e.blacks || 0,
        temperature: e.temperature || 0,
        sharpness: e.sharpness || 0
      };
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      e.gamma !== void 0 && (e.gamma = 1 + (e.gamma < 0 ? .5 * e.gamma : e.gamma)), e.shadows && (e.shadows = e.shadows * 2), this.operation.set(e);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "adjustments";
    }
  }]);

  return Rl;
}(nt);

var St = function St(i) {
  if (qn(i)) return new pe.Color(i.r, i.g, i.b, i.a);
  if (Yn(i)) return new pe.Color(i[0], i[1], i[2], i[3]);
  if ($n(i)) return new pe.Color(i.r, i.g, i.b, 1);
  if (Kn(i)) return new pe.Color(i[0], i[1], i[2], 1);

  if (Pp(i)) {
    var _i$match = i.match(/[0-9A-fa-f]{1,2}/g),
        _i$match2 = _slicedToArray(_i$match, 3),
        e = _i$match2[0],
        t = _i$match2[1],
        r = _i$match2[2];

    return new pe.Color(parseInt(e, 16) / 255, parseInt(t, 16) / 255, parseInt(r, 16) / 255, 1);
  }

  throw new Error("Invalid color type");
};

var K =
/*#__PURE__*/
function () {
  _createClass(K, [{
    key: "x",
    get: function get() {
      return this._x;
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    }
  }]);

  function K() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, K);

    this._x = e, this._y = t;
  }

  _createClass(K, [{
    key: "set",
    value: function set(e, t) {
      return this._x = e, this._y = t, this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new K(this._x, this._y);
    }
  }, {
    key: "copy",
    value: function copy(e) {
      return this._x = e.x, this._y = e.y, this;
    }
  }, {
    key: "clamped",
    value: function clamped() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var r = typeof e == "number" ? {
        x: e,
        y: e
      } : e,
          o = typeof t == "number" ? {
        x: t,
        y: t
      } : t;
      return this._x = Math.max(r.x, this._x), this._y = Math.max(r.y, this._y), this._x = Math.min(o.x, this._x), this._y = Math.min(o.y, this._y), this;
    }
  }, {
    key: "divide",
    value: function divide(e, t) {
      return typeof e == "number" || e === null ? (this._x /= e, this._y /= typeof t == "undefined" ? e : t) : (this._x /= e.x, this._y /= e.y), this;
    }
  }, {
    key: "subtract",
    value: function subtract(e, t) {
      return typeof e == "number" || e === null ? (this._x -= e, this._y -= typeof t == "undefined" ? e : t) : (this._x -= e.x, this._y -= e.y), this;
    }
  }, {
    key: "multiply",
    value: function multiply(e, t) {
      return typeof e == "number" || e === null ? (this._x *= e, this._y *= typeof t == "undefined" ? e : t) : (this._x *= e.x, this._y *= e.y), this;
    }
  }, {
    key: "add",
    value: function add(e, t) {
      return typeof e == "number" || e === null ? (this._x += e, this._y += typeof t == "undefined" ? e : t) : (this._x += e.x, this._y += e.y), this;
    }
  }, {
    key: "dot",
    value: function dot(e, t) {
      return typeof e == "number" || e === null ? this._x * e + this._y * (typeof t == "undefined" ? e : t) : this._x * e.x + this._y * e.y;
    }
  }, {
    key: "equals",
    value: function equals(e, t) {
      return typeof e == "number" || e === null ? e === this._x && t === this._y : e.x === this._x && e.y === this._y;
    }
  }, {
    key: "flip",
    value: function flip() {
      var e = this._x;
      return this._x = this._y, this._y = e, this;
    }
  }, {
    key: "round",
    value: function round() {
      return this._x = Math.round(this._x), this._y = Math.round(this._y), this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      return this._x = Math.ceil(this._x), this._y = Math.ceil(this._y), this;
    }
  }, {
    key: "floor",
    value: function floor() {
      return this._x = this._x | 0, this._y = this._y | 0, this;
    }
  }, {
    key: "abs",
    value: function abs() {
      return this._x = Math.abs(this._x), this._y = Math.abs(this._y), this;
    }
  }, {
    key: "len",
    value: function len() {
      return Math.sqrt(this._x * this._x + this._y * this._y);
    }
  }, {
    key: "min",
    value: function min() {
      return Math.min(this._x, this._y);
    }
  }, {
    key: "max",
    value: function max() {
      return Math.max(this._x, this._y);
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return {
        x: this._x,
        y: this._y
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Vector2({ x: ".concat(this._x, ", y: ").concat(this._y, " })");
    }
  }, {
    key: "roundDecimal",
    value: function roundDecimal(e) {
      return this._x = parseFloat(this._x.toFixed(e)), this._y = parseFloat(this._y.toFixed(e)), this;
    }
  }, {
    key: "asArray",
    value: function asArray() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return e ? [this._y, this._x] : [this._x, this._y];
    }
  }], [{
    key: "fromObject",
    value: function fromObject(e) {
      return new K(e.x, e.y);
    }
  }, {
    key: "fromSize",
    value: function fromSize(e) {
      return new K(e.width, e.height);
    }
  }, {
    key: "NULL",
    get: function get() {
      return new K(0, 0);
    }
  }]);

  return K;
}();

var ri =
/*#__PURE__*/
function () {
  function ri(e) {
    _classCallCheck(this, ri);

    this.engine = e;
    this.id = xi(), this.transform = X.IDENTITY, this.bounds = _t.ZERO;
  }

  _createClass(ri, [{
    key: "getID",
    value: function getID() {
      return this.id;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var e = this.engine.getRootContainers();
      if (!(e.length === 0 || this.id === e[0].id)) return e[0];
    }
  }, {
    key: "getIndexInParent",
    value: function getIndexInParent() {
      var e = this.engine.rootOperations;

      for (var t = 0; t < e.length; t += 1) {
        if (e[t].getID() === this.id) return t;
      }

      return -1;
    }
  }, {
    key: "setIndexInParent",
    value: function setIndexInParent(e) {
      this.engine.moveIndex(this, e);
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var e = this.engine.getRootContainers();
      return e.length > 0 && (this.id === e[0].id || this.id === this.engine.getOutputContainer().id) ? this.engine.rootOperations : [];
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      return this.bounds;
    }
  }, {
    key: "setPivotOnSelfAndSprite",
    value: function setPivotOnSelfAndSprite(e, t, r) {
      typeof t == "number" ? (this.setPivotInternal(t, r), e.setPivot(new K(t, r))) : (this.setPivotInternal(t), e.setPivot(K.fromObject(t)));
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      this.setPivotInternal(e, t);
    }
  }, {
    key: "getPivot",
    value: function getPivot() {
      var e = this.getBounds();
      return {
        x: -e.minX / e.width,
        y: -e.minY / e.height
      };
    }
  }, {
    key: "getTransform",
    value: function getTransform() {
      return this.transform;
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      this.transform = e;
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      this.setTransform(this.transform);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.transform.position;
    }
  }, {
    key: "setPosition",
    value: function setPosition(e, t) {
      var r;
      typeof e == "number" ? r = {
        x: e,
        y: t === void 0 ? e : t
      } : r = e;
      var o = this.transform.scale,
          n = this.transform.rotation;
      this.setTransform(new X(r, o, n));
    }
  }, {
    key: "getScale",
    value: function getScale() {
      return this.transform.scale;
    }
  }, {
    key: "setScale",
    value: function setScale(e, t) {
      var r;
      typeof e != "number" ? r = e : r = {
        x: e,
        y: t === void 0 ? e : t
      };
      var _this$transform = this.transform,
          o = _this$transform.position,
          n = _this$transform.rotation;
      this.setTransform(new X(o, r, n));
    }
  }, {
    key: "getRotation",
    value: function getRotation() {
      return this.transform.rotation;
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      var _this$transform2 = this.transform,
          t = _this$transform2.position,
          r = _this$transform2.scale;
      this.setTransform(new X(t, r, e));
    }
  }, {
    key: "getSizeInWorldSpace",
    value: function getSizeInWorldSpace() {
      return A.getSizeInWorldSpace(this);
    }
  }, {
    key: "getSizeInOutputSpace",
    value: function getSizeInOutputSpace() {
      return A.getSizeInOutputSpace(this, this.engine.getOutputContainer());
    }
  }, {
    key: "setSizeInWorldSpace",
    value: function setSizeInWorldSpace(e) {
      var t = this.getBounds();
      this.setScale(e.width / t.width, e.height / t.height);
    }
  }, {
    key: "setSizeInOutputSpace",
    value: function setSizeInOutputSpace(e) {
      var t = this.engine.getOutputContainer().getScale();
      this.setSizeInWorldSpace({
        width: e.width / t.x,
        height: e.height / t.y
      });
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return this.getIndexInParent() !== -1;
    }
  }, {
    key: "setPivotInternal",
    value: function setPivotInternal(e, t) {
      var r = this.getBounds();
      typeof e == "number" ? this.setBoundsFromSize(r.width, r.height, {
        x: e,
        y: t
      }) : this.setBoundsFromSize(r.width, r.height, e);
    }
  }, {
    key: "setBoundsFromSize",
    value: function setBoundsFromSize(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getPivot();
      this.bounds = new _t(-r.x * e, -r.y * t, e, t);
    }
  }]);

  return ri;
}();

var Ol =
/*#__PURE__*/
function (_ri) {
  _inherits(Ol, _ri);

  function Ol(e, t) {
    var _this12;

    _classCallCheck(this, Ol);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(Ol).call(this, t));
    _this12.type = "drawing";
    _this12.drawing = e, _this12.operation = t.createSpriteOperation(), _this12.sprite = _this12.operation.createBrush({}), _this12.operation.addSprite(_this12.sprite), _this12.radialBrush = _this12.sprite._createRadialBrush();
    var o = t.getRootContainers()[0].getBounds();
    _this12.bounds = new _t(0, 0, o.width, o.height), _this12.setTransform(X.IDENTITY), _this12.operation.setDirty(!0), _this12.setData(e);
    return _this12;
  }

  _createClass(Ol, [{
    key: "beginStroke",
    value: function beginStroke(e) {
      if (this.currentStroke) throw new Error("A brush stroke has already been started but not finished.");
      if (e.id !== "imgly_brush_radial") throw new Error("This adapter does not support any brush faces other than the radial img.ly brush.");
      this.currentBrush = e, this.currentStroke = {
        brush: e,
        path: {
          controlPoints: []
        }
      }, this.radialBrush.setColor(St(e.color)), this.radialBrush.setHardness(e.hardness), this.radialBrush.setSize(e.size), this.currentPath = this.sprite.createPath(this.radialBrush.clone());
    }
  }, {
    key: "addPointToCurrentStroke",
    value: function addPointToCurrentStroke(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (!this.currentStroke || !this.currentBrush || !this.currentPath) throw new Error('A brush stroke has to first be started with a call to "beginStroke(brush:Brush)"');

      if (this.currentStroke.path.controlPoints.length) {
        var c = this.currentStroke.path.controlPoints,
            p = c[c.length - 1],
            m = this.currentBrush.size / 10;
        if (Math.sqrt(e.x - Math.pow(p.x, 2) + (e.y - Math.pow(p.y, 2))) < m) return;
      }

      var r = this.engine.getOutputContainer(),
          o = this.engine.getRootContainers()[0],
          n = A.pointFromSpaceToSpace(e, o, r, !0),
          s = A.absoluteToRelativePoint(n, r, !1),
          l = r.getBounds();
      this.currentPath.addControlPoint(K.fromObject(s)), this.currentStroke.path.controlPoints.push(e), t && this.sprite.render(K.fromObject({
        x: l.width,
        y: l.height
      }));
    }
  }, {
    key: "endStroke",
    value: function endStroke() {
      if (!this.currentStroke || !this.currentPath || !this.currentBrush) return;
      this.currentStroke.path.controlPoints.length && this.drawing.strokes.push(this.currentStroke), this.currentStroke = void 0, this.currentBrush = void 0, this.currentPath.setClosed(!0);
      var e = this.engine.getOutputContainer().getBounds();
      this.sprite.render(K.fromObject({
        x: e.width,
        y: e.height
      })), this.currentPath = void 0;
    }
  }, {
    key: "setData",
    value: function setData(e) {
      this.drawing = f(f({}, this.drawing), e), this.drawing.strokes && (this.drawing.strokes = []), this.sprite.clearPersistCanvas(), this.sprite.clearCanvas(), this.sprite.setPaths([]), this.drawStrokes(e.strokes);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.drawing;
    }
  }, {
    key: "updateData",
    value: function updateData() {
      this.setData(this.getData());
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "drawStrokes",
    value: function drawStrokes(e) {
      var _this13 = this;

      e.forEach(function (t) {
        _this13.beginStroke(t.brush), t.path.controlPoints.forEach(function (r) {
          _this13.addPointToCurrentStroke(r, !0);
        }), _this13.endStroke();
      });
    }
  }]);

  return Ol;
}(ri);

var Tl =
/*#__PURE__*/
function (_nt2) {
  _inherits(Tl, _nt2);

  function Tl(e, t, r, o) {
    var _this14;

    _classCallCheck(this, Tl);

    _this14 = _possibleConstructorReturn(this, _getPrototypeOf(Tl).call(this, o));
    _this14.filterOperation = t;
    _this14.type = "duotone-filter";
    t.set({
      intensity: r.colorIntensity
    }), t.set({
      filter: e
    }), o.pesdk.setAllOperationsToDirty();
    return _this14;
  }

  _createClass(Tl, [{
    key: "getProperties",
    value: function getProperties() {
      return {
        colorIntensity: this.filterOperation.getOptions().intensity
      };
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      var r = this.filterOperation.getOptions().intensity;
      e.colorIntensity !== void 0 && (r = Math.min(Math.max(e.colorIntensity, 0), 1)), this.filterOperation.set({
        intensity: r
      });
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.filterOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "filter";
    }
  }]);

  return Tl;
}(nt);

var Pl =
/*#__PURE__*/
function () {
  function Pl(e, t) {
    _classCallCheck(this, Pl);

    this.engine = t;
    this.loaded = !1;
    this.loading = !1;
    this.asset = f({}, e);
  }

  _createClass(Pl, [{
    key: "load",
    value: function load() {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this15 = this;

        var e, t;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.loaded) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", Promise.resolve());

              case 2:
                if (!this.loading) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return", Promise.reject(new Error("Called Frame#load while it's already loading")));

              case 4:
                this.loading = !0;
                e = this.asset.imageGroups, t = [];
                return _context6.abrupt("return", (["top", "left", "right", "bottom"].forEach(function (r) {
                  if (!e[r]) return;
                  var o = e[r];
                  ["start", "mid", "end"].forEach(function (n) {
                    n in o && t.push(_this15.loadPart(r, n));
                  });
                }), Promise.all(t).then(function () {
                  _this15.loaded = !0, _this15.loading = !1;
                }).catch(function () {
                  _this15.loaded = !1, _this15.loading = !1;
                })));

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "getFrame",
    value: function getFrame() {
      return f(f({}, this.asset), {
        defaultName: this.asset.name,
        thumbnail: this.asset.thumbnailURI
      });
    }
  }, {
    key: "getIdentifier",
    value: function getIdentifier() {
      return this.asset.identifier;
    }
  }, {
    key: "getDefaultName",
    value: function getDefaultName() {
      return this.asset.name;
    }
  }, {
    key: "getThumbnail",
    value: function getThumbnail() {
      return this.asset.thumbnailURI;
    }
  }, {
    key: "getTintable",
    value: function getTintable() {
      return this.asset.tintable || !1;
    }
  }, {
    key: "getLayoutMode",
    value: function getLayoutMode() {
      return this.asset.layoutMode;
    }
  }, {
    key: "getImageGroups",
    value: function getImageGroups() {
      return this.asset.imageGroups;
    }
  }, {
    key: "loadPart",
    value: function loadPart(e, t) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this16 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", new Promise(function (r, o) {
                  var n = _this16.asset.imageGroups,
                      s = n[e][t],
                      l = s;
                  typeof s != "string" && "image" in s && (l = s.image);
                  var c = new Image();
                  c.addEventListener("load", function () {
                    typeof s != "string" ? _this16.asset.imageGroups[e][t].image = c : _this16.asset.imageGroups[e][t] = c, r(c);
                  }), c.addEventListener("error", function () {
                    o(new Error("Failed to load image at ".concat(c.src)));
                  }), c.crossOrigin = _this16.engine.configuration.crossOrigin || "anonymus", c.src = _this16.engine.assetProvider.getAssetSource("frame", l);
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }]);

  return Pl;
}();

var Ml =
/*#__PURE__*/
function (_nt3) {
  _inherits(Ml, _nt3);

  function Ml(e, t, r) {
    var _this17;

    _classCallCheck(this, Ml);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(Ml).call(this, r));
    _this17.frameOperation = e;
    _this17.type = "frame";
    _this17.setProperties(t), r.pesdk.setAllOperationsToDirty();
    return _this17;
  }

  _createClass(Ml, [{
    key: "setProperties",
    value: function setProperties(e) {
      if (this.props = f(f({}, this.props), e), typeof e.opacity == "number" && this.frameOperation.set({
        alpha: e.opacity
      }), e.tintColor && this.frameOperation.set({
        tintColor: St(e.tintColor)
      }), e.width) {
        var t = this.engine.getOutputContainer().getBounds(),
            r = Math.min(t.width, t.height),
            o = e.width / r;
        this.frameOperation.set({
          scale: o
        });
      }

      this.frameOperation.setDirty(!0);
    }
  }, {
    key: "getProperties",
    value: function getProperties() {
      return this.props;
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.frameOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "frame";
    }
  }]);

  return Ml;
}(nt);

var Bl =
/*#__PURE__*/
function (_nt4) {
  _inherits(Bl, _nt4);

  function Bl(e, t, r) {
    var _this18;

    _classCallCheck(this, Bl);

    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(Bl).call(this, t));
    _this18.blurOperation = r;
    _this18.type = "gaussian-blur";

    _this18.setProperties(e);

    return _this18;
  }

  _createClass(Bl, [{
    key: "getProperties",
    value: function getProperties() {
      var e = this.engine.getOutputContainer(),
          t = e.getBounds(),
          r = Math.min(t.size.width, t.size.height);
      return {
        blurRadius: A.scalarFromSpaceToSpace(this.blurOperation.getOptions().blurRadius * r, e, this.getContainer())
      };
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      if (e.blurRadius !== void 0) {
        var t = this.engine.pesdk.getOutputDimensions(),
            r = Math.min(t.x, t.y),
            o = this.getContainer(),
            n = this.engine.getOutputContainer(),
            l = A.scalarFromSpaceToSpace(e.blurRadius, o, n) / r;
        this.blurOperation.set({
          blurRadius: l
        });
      }
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.blurOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "blur";
    }
  }]);

  return Bl;
}(nt);

var zl =
/*#__PURE__*/
function (_ri2) {
  _inherits(zl, _ri2);

  function zl(e, t) {
    var _this19;

    _classCallCheck(this, zl);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(zl).call(this, t));
    _this19.data = e;
    _this19.type = "image";
    var r = t.configuration.downscaleOptions;
    if (!r) _this19.downscaleOptions = {
      maxDimensions: {
        width: t.maxTextureDimension,
        height: t.maxTextureDimension
      }
    };else {
      var n = r.maxDimensions;
      _this19.downscaleOptions = {
        maxMegaPixels: r.maxMegaPixels,
        maxDimensions: {
          width: Math.min(t.maxTextureDimension, n ? n.width : Number.MAX_VALUE),
          height: Math.min(t.maxTextureDimension, n ? n.height : Number.MAX_VALUE)
        }
      };
    }

    _this19.setData(e);

    var o = _this19.data.image;
    _this19.bounds = new _t(_.ZERO, {
      width: o.width,
      height: o.height
    });
    return _this19;
  }

  _createClass(zl, [{
    key: "setData",
    value: function setData(e) {
      var _this20 = this;

      if (this.data = f(f({}, this.data), e), e.image) {
        var t = e.image,
            r;

        if (t instanceof HTMLImageElement && (r = this.engine.pesdk.parseExif(t), r)) {
          var n = r.getTags();

          if (n && n.Orientation) {
            var s = n.Orientation !== 1 && n.Orientation !== 2,
                l = [2, 4, 5, 7].indexOf(n.Orientation) !== -1;

            if (s || l) {
              if (Me() || ti() || !CSS.supports("image-orientation", "from-image")) {
                var c = this.engine.pesdk.createOperation("exif-orientation", {}, !1);
                c.setTags(n), t = c.applyTo(t);
              }

              r.setOrientation(1), n.Orientation = 1;
            }
          }
        }

        var o = new Gn(t, this.downscaleOptions);
        o.on(Ji.IMAGE_DOWNSCALED, function (_ref3) {
          var n = _ref3.width,
              s = _ref3.height;

          _this20.engine.emit(Yr.IMAGE_DOWNSCALED, {
            width: n,
            height: s
          });
        }), o.on(Ji.BEGAN_IMAGE_DOWNSCALING, function () {
          _this20.engine.emit(Yr.BEGAN_IMAGE_DOWNSCALING);
        }), t = o.downscaleIfNecessary(), this.data.image = t, this.engine.pesdk.setImage(t, r), this.setBoundsFromSize(t.width, t.height);
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      throw new Error("This container does not support modifying the pivot");
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      throw new Error("This container has no associated operation");
    }
  }]);

  return zl;
}(ri);

var Ll =
/*#__PURE__*/
function (_nt5) {
  _inherits(Ll, _nt5);

  function Ll(e, t, r) {
    var _this21;

    _classCallCheck(this, Ll);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(Ll).call(this, t));
    _this21.props = e;
    _this21.blurOperation = r;
    _this21.type = "linear-blur";

    _this21.setProperties(e);

    return _this21;
  }

  _createClass(Ll, [{
    key: "getProperties",
    value: function getProperties() {
      return this.props;
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      this.props = f(f({}, this.props), e);
      var t = this.blurOperation.getOptions(),
          r = this.engine.getOutputContainer(),
          o = r.getBounds(),
          n = this.getContainer(),
          s = r.getBaseLocalToParentMatrix(),
          l = A.getBaseLocalToWorldMatrix(n),
          c = $.multiply($.getInverted(s), l),
          p = Math.min(o.size.width, o.size.height);

      if (e.blurRadius !== void 0) {
        var m = A.scalarFromSpaceToSpace(e.blurRadius, n, r);
        t.blurRadius = m / p;
      }

      if (e.start !== void 0) {
        var _m2 = $.transformPoint(c, e.start),
            h = A.absoluteToRelativePoint(_m2, r, !1);

        t.controlPoint1 = h;
      }

      if (e.end !== void 0) {
        var _m3 = $.transformPoint(c, e.end),
            _h2 = A.absoluteToRelativePoint(_m3, r, !1);

        t.controlPoint2 = _h2;
      }

      this.blurOperation.set(t);
    }
  }, {
    key: "updateProperties",
    value: function updateProperties() {
      var e = this.getProperties();
      this.setProperties(e);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.blurOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "linear-focus";
    }
  }]);

  return Ll;
}(nt);

var Ul =
/*#__PURE__*/
function (_nt6) {
  _inherits(Ul, _nt6);

  function Ul(e, t, r, o) {
    var _this22;

    _classCallCheck(this, Ul);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(Ul).call(this, o));
    _this22.filter = e;
    _this22.filterOperation = t;
    _this22.props = r;
    _this22.type = "lut-filter";
    t.set({
      intensity: r.intensity
    }), t.set({
      filter: e
    }), o.pesdk.setAllOperationsToDirty();
    return _this22;
  }

  _createClass(Ul, [{
    key: "getProperties",
    value: function getProperties() {
      return {
        intensity: this.filterOperation.getOptions().intensity,
        lutImage: this.props.lutImage,
        horizontalTileCount: this.props.horizontalTileCount,
        verticalTileCount: this.props.verticalTileCount
      };
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      var t = this.filterOperation.getOptions(),
          r = typeof e.intensity == "number" ? e.intensity : t.intensity;
      this.filterOperation.set({
        intensity: r
      });
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.filterOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "filter";
    }
  }]);

  return Ul;
}(nt);

var Nl =
/*#__PURE__*/
function (_nt7) {
  _inherits(Nl, _nt7);

  function Nl(e, t, r) {
    var _this23;

    _classCallCheck(this, Nl);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(Nl).call(this, t));
    _this23.props = e;
    _this23.blurOperation = r;
    _this23.type = "mirrored-blur";

    _this23.setProperties(e);

    return _this23;
  }

  _createClass(Nl, [{
    key: "getProperties",
    value: function getProperties() {
      return this.props;
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      this.props = f(f({}, this.props), e);
      var t = this.blurOperation.getOptions(),
          r = this.engine.getOutputContainer(),
          o = r.getBounds(),
          n = this.getContainer(),
          s = r.getBaseLocalToParentMatrix(),
          l = A.getBaseLocalToWorldMatrix(n),
          c = $.multiply($.getInverted(s), l),
          p = Math.min(o.size.width, o.size.height);

      if (e.blurRadius !== void 0) {
        var m = A.scalarFromSpaceToSpace(e.blurRadius, n, r);
        t.blurRadius = m / p;
      }

      if (e.gradientSize !== void 0) {
        var h = A.scalarFromSpaceToSpace(e.gradientSize, n, r) / p;
        t.gradientSize = h;
      }

      if (e.clearAreaWidth !== void 0) {
        var _h3 = A.scalarFromSpaceToSpace(e.clearAreaWidth, n, r) / p;

        t.size = _h3 * .5;
      }

      if (e.mirrorAxisOrigin !== void 0) {
        var _m4 = $.transformPoint(c, e.mirrorAxisOrigin),
            _h4 = A.absoluteToRelativePoint(_m4, r, !1);

        t.start = _h4;
      }

      if (e.mirrorAxisDirection !== void 0) {
        var _m5 = $.transformPoint(c, e.mirrorAxisDirection),
            _h5 = A.absoluteToRelativePoint(_m5, r, !1);

        t.end = _h5;
      }

      this.blurOperation.set(t);
    }
  }, {
    key: "updateProperties",
    value: function updateProperties() {
      var e = this.getProperties();
      this.setProperties(e);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.blurOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "mirrored-focus";
    }
  }]);

  return Nl;
}(nt);

var Hl =
/*#__PURE__*/
function (_ri3) {
  _inherits(Hl, _ri3);

  function Hl(e, t, r, o) {
    var _this24;

    _classCallCheck(this, Hl);

    _this24 = _possibleConstructorReturn(this, _getPrototypeOf(Hl).call(this, o));
    _this24.settings = e;
    _this24.operation = t;
    _this24.flipOperation = r;
    _this24.type = "output";
    _this24.flipTransform = $.IDENTITY;
    _this24.blockTransformUpdate = !1;
    _this24.transformUpdateWhileBlock = !1;
    _this24.bounds = new _t({
      x: 0,
      y: 0
    }, _this24.settings.resolution), _this24.setData(e);
    return _this24;
  }

  _createClass(Hl, [{
    key: "pauseChildrenUpdates",
    value: function pauseChildrenUpdates() {
      this.transformUpdateWhileBlock = !1, this.blockTransformUpdate = !0;
    }
  }, {
    key: "resumeChildrenUpdates",
    value: function resumeChildrenUpdates() {
      this.blockTransformUpdate = !1, this.transformUpdateWhileBlock && this.updateChildrenContainers();
    }
  }, {
    key: "setData",
    value: function setData(e) {
      if (this.settings = f(f({}, this.settings), e), e.resolution && (this.setBoundsFromSize(e.resolution.width, e.resolution.height), this.setTransform(this.transform), this.operation.set({
        outputResolution: new K(e.resolution.width, e.resolution.height)
      })), e.flipHorizontally !== void 0) {
        var t = e.flipHorizontally;
        this.updateFlipTransform(), this.flipOperation.set({
          flipHorizontally: t
        });
      }

      if (e.flipVertically !== void 0) {
        var _t2 = e.flipVertically;
        this.updateFlipTransform(), this.flipOperation.set({
          flipVertically: _t2
        });
      }

      this.operation.setDirty(!0), this.flipOperation.setDirty(!0);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.settings;
    }
  }, {
    key: "setResolution",
    value: function setResolution(e) {
      this.setData({
        resolution: e
      });
    }
  }, {
    key: "getResolution",
    value: function getResolution() {
      return this.getData().resolution;
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      if (this.transform.rotation !== e.rotation || this.transform.position !== e.position || this.transform.scale !== e.scale) {
        this.transform = e;
        var t = this.flipTransform;
        this.flipTransform = $.IDENTITY;
        var r = this.engine.getRootContainers()[0],
            o = A.pointFromSpaceToSpace({
          x: 0,
          y: 0
        }, r, this),
            n = -e.rotation,
            s = K.fromObject(o).clone().subtract(K.fromObject(this.getBounds().origin));
        this.operation.set({
          pivot: new K(0, 0),
          position: s,
          scale: new K(1 / e.scale.x, 1 / e.scale.y),
          rotation: n
        }), this.flipTransform = t, this.operation.setDirty(!0), this.updateChildrenContainers();
      }
    }
  }, {
    key: "rotate90",
    value: function rotate90() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = e ? -Math.PI * .5 : Math.PI * .5,
          r = this.getResolution(),
          o = this.getPivot(),
          n = this.getBounds(),
          s = {
        x: n.midX,
        y: n.midY
      },
          l = A.getPointInWorldSpace(s, this);
      this.setPivot(.5, .5), this.setPosition(l), this.setRotation(this.getRotation() - t);
      var c = {
        width: r.height,
        height: r.width
      };
      this.setResolution(c);
      var p = {
        x: -c.width * (.5 - o.x),
        y: -c.height * (.5 - o.y)
      },
          m = A.getPointInWorldSpace(p, this);
      this.setPivot(o), this.setPosition(m), this.updateChildrenContainers();
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      _get(_getPrototypeOf(Hl.prototype), "setPivotInternal", this).call(this, e, t), this.setTransform(this.transform);
    }
  }, {
    key: "getTransform",
    value: function getTransform() {
      return this.transform;
    }
  }, {
    key: "getBaseLocalToParentMatrix",
    value: function getBaseLocalToParentMatrix() {
      return A.rectTransformToAffineTransform(this.getTransform());
    }
  }, {
    key: "getLocalToParentMatrix",
    value: function getLocalToParentMatrix() {
      var e = A.rectTransformToAffineTransform(this.getTransform());
      return $.multiply(e, this.flipTransform);
    }
  }, {
    key: "getFlipTransformMatrix",
    value: function getFlipTransformMatrix() {
      return this.flipTransform;
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return !0;
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "updateFlipTransform",
    value: function updateFlipTransform() {
      var _this$settings = this.settings,
          e = _this$settings.flipHorizontally,
          t = _this$settings.flipVertically;
      if (!e && !t) this.flipTransform = $.IDENTITY;else {
        var r = this.getPivot(),
            o = this.getBounds(),
            n = e ? -1 : 1,
            s = e ? -2 * (r.x - .5) * o.width : 0,
            l = t ? -1 : 1,
            c = t ? -2 * (r.y - .5) * o.height : 0;
        this.flipTransform = new $(n, 0, 0, l, s, c);
      }
    }
  }, {
    key: "updateChildrenContainers",
    value: function updateChildrenContainers() {
      if (this.blockTransformUpdate) {
        this.transformUpdateWhileBlock = !0;
        return;
      }

      this.engine.rootOperations.forEach(function (e) {
        Fl(e) ? (e.updateTransform(), "updateData" in e && e.updateData()) : "updateProperties" in e && e.updateProperties();
      });
    }
  }]);

  return Hl;
}(ri);

var Xn =
/*#__PURE__*/
function (_nt8) {
  _inherits(Xn, _nt8);

  function Xn(e, t, r) {
    var _this25;

    _classCallCheck(this, Xn);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(Xn).call(this, r));
    _this25.overlayOperation = e;
    _this25.type = "overlay";
    var o = t.blendMode || r.mapBlendMode(e.getBlendMode());
    e.set({
      blendMode: r.reverseMapBlendMode(o)
    }), e.set({
      image: t.image
    }), r.pesdk.setAllOperationsToDirty();
    return _this25;
  }

  _createClass(Xn, [{
    key: "getProperties",
    value: function getProperties() {
      var e = this.overlayOperation.getOptions();
      return {
        image: e.image,
        blendMode: this.engine.mapBlendMode(e.blendMode),
        opacity: e.alpha
      };
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      var t = this.overlayOperation.getOptions();
      typeof e.opacity == "number" && (t.alpha = e.opacity), e.blendMode !== void 0 && (t.blendMode = this.engine.reverseMapBlendMode(e.blendMode)), this.overlayOperation.set(t), this.overlayOperation.setDirty(!0);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.overlayOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "overlay";
    }
  }, {
    key: "setFlipHorizontally",
    value: function setFlipHorizontally(e) {
      this.overlayOperation.setFlipHorizontally(e);
    }
  }, {
    key: "setFlipVertically",
    value: function setFlipVertically(e) {
      this.overlayOperation.setFlipVertically(e);
    }
  }, {
    key: "getFlipHorizontally",
    value: function getFlipHorizontally() {
      return this.overlayOperation.getFlipHorizontally();
    }
  }, {
    key: "getFlipVertically",
    value: function getFlipVertically() {
      return this.overlayOperation.getFlipVertically();
    }
  }]);

  return Xn;
}(nt);

var Wl =
/*#__PURE__*/
function (_nt9) {
  _inherits(Wl, _nt9);

  function Wl(e, t, r) {
    var _this26;

    _classCallCheck(this, Wl);

    _this26 = _possibleConstructorReturn(this, _getPrototypeOf(Wl).call(this, t));
    _this26.props = e;
    _this26.blurOperation = r;
    _this26.type = "radial-blur";

    _this26.setProperties(e);

    return _this26;
  }

  _createClass(Wl, [{
    key: "getProperties",
    value: function getProperties() {
      return this.props;
    }
  }, {
    key: "setProperties",
    value: function setProperties(e) {
      this.props = f(f({}, this.props), e);
      var t = this.blurOperation.getOptions(),
          r = this.engine.getOutputContainer(),
          o = r.getBounds(),
          n = this.getContainer(),
          s = r.getBaseLocalToParentMatrix(),
          l = A.getBaseLocalToWorldMatrix(n),
          c = $.multiply($.getInverted(s), l),
          p = Math.min(o.size.width, o.size.height);

      if (e.blurRadius !== void 0) {
        var m = A.scalarFromSpaceToSpace(e.blurRadius, n, r);
        t.blurRadius = m / p;
      }

      if (e.center !== void 0) {
        var _m6 = $.transformPoint(c, e.center),
            h = A.absoluteToRelativePoint(_m6, r, !1);

        t.position = h;
      }

      if (e.radius !== void 0) {
        var _h6 = A.scalarFromSpaceToSpace(e.radius, n, r) / p;

        t.radius = _h6;
      }

      if (e.gradientSize !== void 0) {
        var _h7 = A.scalarFromSpaceToSpace(e.gradientSize, n, r) / p;

        t.gradientRadius = _h7;
      }

      this.blurOperation.set(t);
    }
  }, {
    key: "updateProperties",
    value: function updateProperties() {
      var e = this.getProperties();
      this.setProperties(e);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.blurOperation;
    }
  }, {
    key: "getTypeIdentifier",
    value: function getTypeIdentifier() {
      return "radial-focus";
    }
  }]);

  return Wl;
}(nt);

var Jn =
/*#__PURE__*/
function (_ri4) {
  _inherits(Jn, _ri4);

  function Jn(e, t) {
    var _this27;

    _classCallCheck(this, Jn);

    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Jn).call(this, t));
    _this27.data = e;
    _this27.type = "sticker";

    var r = e.image,
        o = _this27.engine.pesdk.parseExif(e.image);

    if (o) {
      var s = o.getTags();

      if (s && s.Orientation) {
        var l = s.Orientation !== 1 && s.Orientation !== 2,
            c = [2, 4, 5, 7].indexOf(s.Orientation) !== -1;

        if (l || c) {
          var p = _this27.engine.pesdk.createOperation("exif-orientation", {}, !1);

          p.setTags(s), r = p.applyTo(e.image), o.setOrientation(1), s.Orientation = 1;
        }
      }
    }

    r = new Gn(r, {
      maxMegaPixels: {
        desktop: 10,
        mobile: 5
      }
    }).downscaleImageIfNecessary(), _this27.operation = t.createSpriteOperation(), _this27.sprite = _this27.operation.createSticker({
      identifier: "",
      image: r,
      position: new K(0, 0),
      dimensions: new K(1, 1),
      rotation: 0,
      smoothDownscaling: !1
    }), _this27.operation.addSprite(_this27.sprite), _this27.bounds = new _t({
      x: 0,
      y: 0
    }, {
      width: r.width,
      height: r.height
    }), _this27.setTransform(X.IDENTITY), _this27.sprite.setPivot(new K(0, 0)), _this27.operation.setDirty(!0), _this27.setData(e);
    return _this27;
  }

  _createClass(Jn, [{
    key: "setData",
    value: function setData(e) {
      this.data = f(f({}, this.data), e), e.id && (this.id = e.id), Ve(e.opacity) && e.opacity >= 0 && this.sprite.setAlpha(e.opacity), e.tintColor && this.sprite.setTintColor(St(e.tintColor)), e.tintMode && this.sprite.setTintMode(e.tintMode), this.operation.setDirty(!0);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "updateData",
    value: function updateData() {
      this.setData(this.getData());
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      _get(_getPrototypeOf(Jn.prototype), "setTransform", this).call(this, e);

      var t = this.engine.getOutputContainer(),
          r = this.getParent(),
          o = {
        width: this.bounds.width * e.scale.x,
        height: this.bounds.height * e.scale.y
      },
          n = A.sizeFromSpaceToSpace(o, r, t);
      this.sprite.setDimensions(K.fromSize(n));
      var s = A.pointFromSpaceToSpace(e.position, r, t, !0),
          l = A.absoluteToRelativePoint(s, t, !1);
      this.sprite.setPosition(new K(l.x, l.y));
      var c = A.getRotationBetweenCoordinateSpaces(r, t),
          p = e.rotation + c;
      this.sprite.setRotation(p), this.operation.setDirty(!0);
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      this.setPivotOnSelfAndSprite(this.sprite, e, t);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "setFlipHorizontally",
    value: function setFlipHorizontally(e) {
      this.sprite.setFlipHorizontally(e);
    }
  }, {
    key: "setFlipVertically",
    value: function setFlipVertically(e) {
      this.sprite.setFlipVertically(e);
    }
  }, {
    key: "getFlipHorizontally",
    value: function getFlipHorizontally() {
      return this.sprite.getFlipHorizontally();
    }
  }, {
    key: "getFlipVertically",
    value: function getFlipVertically() {
      return this.sprite.getFlipVertically();
    }
  }]);

  return Jn;
}(ri);

var Zi = function Zi(i) {
  return 2 * Math.PI - i;
},
    Bp = function Bp(i) {
  return -i;
},
    Qi = function Qi(_ref4) {
  var i = _ref4.rotation,
      e = _ref4.flipHorizontally,
      t = _ref4.flipVertically;
  var r = i;
  return e && (r = Zi(r)), t && (r = Bp(r)), r;
};

function zp(i, e) {
  if (e) {
    var t = 1 / e.unitsPerEm * i,
        r = e.ascender * t,
        o = e.descender * t;
    return r + Math.abs(o);
  }

  return i * 1.1;
}

var Xr =
/*#__PURE__*/
function () {
  function Xr(e) {
    _classCallCheck(this, Xr);

    this.context = e;
    this.sourceLines = [];
    this.maxWidth = 100;
  }

  _createClass(Xr, [{
    key: "getLines",
    value: function getLines() {
      var e = [],
          t = [],
          r = this.sourceLines.length;

      for (var o = 0; o < r; o += 1) {
        var n = this.sourceLines[o],
            s = Xr.buildWords(n),
            l = s.length;

        for (var c = 0; c < l; c += 1) {
          var p = s[c],
              m = t.concat(p).join("").replace(/\s+$/i, "");

          if (this.getWidth(m) > this.maxWidth) {
            t.length > 0 && (e.push(t.join("")), t = [p]);
            var b = p.replace(/\s+$/i, "");

            if (this.getWidth(b) > this.maxWidth) {
              var v = this.splitWord(p);
              e = e.concat(v.lines), v.rest && (t = [v.rest]);
            }
          } else t.push(p);
        }

        e.push(t.join("")), t = [];
      }

      return e;
    }
  }, {
    key: "splitWord",
    value: function splitWord(e) {
      var t = {
        lines: [],
        rest: null
      },
          r = e.length,
          o = [];

      for (var n = 0; n < r; n += 1) {
        var s = e[n];
        this.getWidth(o.concat(s).join("")) > this.maxWidth ? (o.length > 0 && t.lines.push(o.join("")), o = [s]) : o.push(s), n === r - 1 && o.length > 0 && (t.rest = o.join(""));
      }

      return t;
    }
  }, {
    key: "getWidth",
    value: function getWidth(e) {
      return this.context.measureText(e).width;
    }
  }, {
    key: "setText",
    value: function setText(e) {
      this.sourceLines = e.split("\n");
    }
  }, {
    key: "setMaxWidth",
    value: function setMaxWidth(e) {
      this.maxWidth = e;
    }
  }], [{
    key: "buildWords",
    value: function buildWords(e) {
      var t = [],
          r = "",
          o = e.length;

      for (var n = 0; n < o; n += 1) {
        var s = e[n];
        r += s, (s === " " || s === "-" || n === o - 1) && (t.push(r), r = "");
      }

      return t;
    }
  }]);

  return Xr;
}();

function er(i, e, t, r, o, n, s) {
  i.font = "".concat(t.fontStyle || "normal", " ").concat(t.fontWeight || "normal", " ").concat(r, "px \"").concat(t.fontFamily, "\"");
  var l = new Xr(i);
  l.setText(e), l.setMaxWidth(n);
  var c = l.getLines().map(function (b) {
    return b.replace(/\s+$/i, "");
  }),
      p = zp(r, s),
      m = p * o,
      h = p / 5;
  return {
    width: n + h * 2,
    height: c.length * m + h * 2
  };
}

var Nt =
/*#__PURE__*/
function (_ri5) {
  _inherits(Nt, _ri5);

  function Nt(e, t) {
    var _this28;

    _classCallCheck(this, Nt);

    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(Nt).call(this, t));
    _this28.text = e;
    _this28.type = "text";

    if (!Nt.measureContext) {
      var c = document.createElement("canvas");
      Nt.measureContext = c.getContext("2d");
    }

    _this28.operation = t.createSpriteOperation();

    var r = _this28.engine.getOutputContainer(),
        o = _this28.getParent(),
        n = r.getBounds();

    _this28.sprite = _this28.operation.createText({
      text: e.text,
      position: new K(0, 0),
      rotation: 0,
      fontSize: A.scalarFromSpaceToSpace(e.fontSize / n.height, o, r),
      lineHeight: e.lineHeight,
      fontIdentifier: e.fontIdentifier,
      alignment: e.alignment,
      color: St(e.textColor),
      backgroundColor: St(e.backgroundColor),
      maxWidth: A.scalarFromSpaceToSpace(e.width / n.width, o, r)
    });
    var s = t.assetProvider.getFontManager().getFontWithId(e.fontIdentifier);
    _this28.sprite.setFontFamily(s.fontFamily), _this28.sprite.setFontWeight(s.fontWeight || "normal"), _this28.sprite.setFontStyle(s.fontStyle || "normal"), _this28.sprite.setFontIdentifier(s.identifier), _this28.sprite.setTextMetrics(s.textMetrics), _this28.sprite.setPivot(new K(0, 0)), _this28.operation.addSprite(_this28.sprite);
    var l = er(Nt.measureContext, e.text, s, e.fontSize, e.lineHeight, e.width, s.textMetrics);
    _this28.bounds = new _t(0, 0, l.width, l.height), _this28.setTransform(X.IDENTITY), _this28.operation.setDirty(!0);
    return _this28;
  }

  _createClass(Nt, [{
    key: "setData",
    value: function setData(e) {
      this.text = f(f({}, this.text), e);
      var t = this.engine.assetProvider.getFontManager().getFontWithId(e.fontIdentifier || this.text.fontIdentifier);

      if (e.fontIdentifier && (this.sprite.setFontFamily(t.fontFamily), this.sprite.setFontWeight(t.fontWeight || "normal"), this.sprite.setFontStyle(t.fontStyle || "normal"), this.sprite.setFontIdentifier(t.identifier), this.sprite.setTextMetrics(t.textMetrics)), e.id && (this.id = e.id), e.text && this.sprite.setText(e.text), e.fontSize) {
        var o = this.engine.getOutputContainer(),
            n = this.getParent(),
            s = A.scalarFromSpaceToSpace(e.fontSize, n, o),
            l = o.getBounds();
        this.sprite.setFontSize(s / l.height);
      }

      if (e.alignment && this.sprite.setAlignment(e.alignment), e.lineHeight && this.sprite.setLineHeight(e.lineHeight), e.textColor && this.sprite.setColor(St(e.textColor)), e.backgroundColor && this.sprite.setBackgroundColor(St(e.backgroundColor)), e.width) {
        var _o3 = this.engine.getOutputContainer(),
            _n2 = this.getParent(),
            _s2 = A.scalarFromSpaceToSpace(e.width, _n2, _o3),
            _l2 = _o3.getBounds();

        this.sprite.setMaxWidth(_s2 / _l2.width);
      }

      var r = er(Nt.measureContext, this.text.text, t, this.text.fontSize, this.text.lineHeight, this.text.width, t.textMetrics);
      this.setBoundsFromSize(r.width, r.height), this.operation.setDirty(!0);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.text;
    }
  }, {
    key: "updateData",
    value: function updateData() {
      this.setData(this.getData());
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      _get(_getPrototypeOf(Nt.prototype), "setTransform", this).call(this, e);

      var t = this.engine.getOutputContainer(),
          r = this.getParent(),
          o = A.pointFromSpaceToSpace(e.position, r, t, !0),
          n = A.absoluteToRelativePoint(o, t, !1);
      this.sprite.setPosition(new K(n.x, n.y));
      var s = A.getRotationBetweenCoordinateSpaces(r, t);
      this.sprite.setRotation(e.rotation + s), this.operation.setDirty(!0);
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      this.setPivotOnSelfAndSprite(this.sprite, e, t);
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "setFlipHorizontally",
    value: function setFlipHorizontally(e) {
      this.sprite.setRotation(this.getFlippedRotation({
        flipHorizontally: e
      })), this.sprite.setFlipHorizontally(e);
    }
  }, {
    key: "setFlipVertically",
    value: function setFlipVertically(e) {
      this.sprite.setRotation(this.getFlippedRotation({
        flipVertically: e
      })), this.sprite.setFlipVertically(e);
    }
  }, {
    key: "getFlipHorizontally",
    value: function getFlipHorizontally() {
      return this.sprite.getFlipHorizontally();
    }
  }, {
    key: "getFlipVertically",
    value: function getFlipVertically() {
      return this.sprite.getFlipVertically();
    }
  }, {
    key: "getFlippedRotation",
    value: function getFlippedRotation(_ref5) {
      var e = _ref5.flipVertically,
          t = _ref5.flipHorizontally;
      var r = e || this.getFlipVertically(),
          o = t || this.getFlipHorizontally(),
          n = this.getRotation();
      return (r || o) && (n = Zi(n)), n;
    }
  }]);

  return Nt;
}(ri);

var Zn = 1e3,
    Ci =
/*#__PURE__*/
function (_ri6) {
  _inherits(Ci, _ri6);

  function Ci(e, t, r) {
    var _this29;

    _classCallCheck(this, Ci);

    _this29 = _possibleConstructorReturn(this, _getPrototypeOf(Ci).call(this, r));
    _this29.textDesign = e;
    _this29.layout = t;
    _this29.type = "text-design";
    _this29.currentLayoutSize = void 0;
    _this29.layoutID = t.identifier, _this29.operation = r.createSpriteOperation();

    var o = _this29.engine.getOutputContainer(),
        n = _this29.getParent(),
        s = o.getBounds(),
        l = Math.min(s.width, s.height);

    t.seed(e.seed), _this29.bounds = _this29.calculateBounds(_this29.textDesign, _this29.layout);
    var c = e.width;
    _this29.sprite = _this29.operation.createTextDesign({
      text: e.text,
      layout: t,
      inverted: e.inverted,
      color: St(e.color),
      width: A.scalarFromSpaceToSpace(e.width / l, n, o),
      padding: e.padding / c,
      seed: e.seed
    }), _this29.updatePivot(), _this29.operation.addSprite(_this29.sprite), _this29.setTransform(X.IDENTITY), _this29.operation.setDirty(!0);
    return _this29;
  }

  _createClass(Ci, [{
    key: "calculateBounds",
    value: function calculateBounds(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var o = e.inverted && r ? Math.max(0, 2 * e.padding) : 0,
          n = e.width / Zn;

      if (this.currentLayoutSize === void 0) {
        t.seed(e.seed);
        var s = t.generateLayoutData(e.text, Zn);
        this.currentLayoutData = s, this.currentLayoutSize = s.getSize();
      }

      return new _t(0, 0, this.currentLayoutSize.width * n + o, this.currentLayoutSize.height * n + o);
    }
  }, {
    key: "findNextUniqueSeed",
    value: function findNextUniqueSeed(e, t, r) {
      var o = r,
          n = this.currentLayoutData ? Ci.stringify(this.currentLayoutData.getRows()) : "",
          s;

      for (var l = 0; l < 20 && (t.seed(o), s = t.generateLayoutData(e.text, Zn), n === Ci.stringify(s.getRows())); l += 1) {
        o += 1;
      }

      return t.seed(o), this.currentLayoutData = s, o;
    }
  }, {
    key: "setData",
    value: function setData(e) {
      if (this.textDesign = f(f({}, this.textDesign), e), e.id && (this.id = e.id), e.padding !== void 0) {
        var t = this.textDesign.width;
        this.sprite.setPadding(e.padding / t);
      } else e.width && (this.textDesign.padding = this.sprite.getPadding() * this.textDesign.width);

      if (e.seed !== void 0 && (e.seed < 0 && (e.seed = this.findNextUniqueSeed(this.textDesign, this.layout, Date.now()), this.textDesign.seed = e.seed), this.currentLayoutSize = void 0, this.layout.seed(e.seed), this.sprite.setSeed(e.seed), this.sprite.setLayout(this.layout)), e.color && this.sprite.setColor(St(e.color)), e.inverted !== void 0 && this.sprite.setInverted(e.inverted), e.text && (this.currentLayoutSize = void 0, this.sprite.setText(e.text)), e.width) {
        var _t3 = this.engine.getOutputContainer(),
            r = this.getParent(),
            o = _t3.getBounds(),
            n = Math.min(o.width, o.height),
            s = A.scalarFromSpaceToSpace(e.width / n, r, _t3);

        this.sprite.setWidth(s);
      }

      if (e.padding !== void 0 || e.seed !== void 0 || e.inverted !== void 0 || e.text || e.width) {
        var _t4 = this.calculateBounds(this.textDesign, this.layout);

        this.setBoundsFromSize(_t4.width, _t4.height), this.updatePivot();
      }

      this.operation.setDirty(!0);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.textDesign;
    }
  }, {
    key: "updateData",
    value: function updateData() {
      this.setData(this.getData());
    }
  }, {
    key: "setTransform",
    value: function setTransform(e) {
      _get(_getPrototypeOf(Ci.prototype), "setTransform", this).call(this, e);

      var t = this.engine.getOutputContainer(),
          r = this.getParent();
      if (e.scale.x !== 1 || e.scale.y !== 1) throw new Error("This engine doesn't support scaling TextDesign containers! You can change the bounds using the width property of the TextDesign data.");
      var o = A.pointFromSpaceToSpace(e.position, r, t, !0),
          n = A.absoluteToRelativePoint(o, t, !1);
      this.sprite.setPosition(new K(n.x, n.y));
      var s = A.getRotationBetweenCoordinateSpaces(r, t);
      this.sprite.setRotation(e.rotation + s), this.operation.setDirty(!0);
    }
  }, {
    key: "setPivot",
    value: function setPivot(e, t) {
      typeof e == "number" ? _get(_getPrototypeOf(Ci.prototype), "setPivot", this).call(this, e, t) : _get(_getPrototypeOf(Ci.prototype), "setPivot", this).call(this, e), this.updatePivot();
    }
  }, {
    key: "getOperation",
    value: function getOperation() {
      return this.operation;
    }
  }, {
    key: "getLayoutID",
    value: function getLayoutID() {
      return this.layoutID;
    }
  }, {
    key: "setFlipHorizontally",
    value: function setFlipHorizontally(e) {
      this.sprite.setFlipHorizontally(e);
    }
  }, {
    key: "setFlipVertically",
    value: function setFlipVertically(e) {
      this.sprite.setFlipVertically(e);
    }
  }, {
    key: "getFlipHorizontally",
    value: function getFlipHorizontally() {
      return this.sprite.getFlipHorizontally();
    }
  }, {
    key: "getFlipVertically",
    value: function getFlipVertically() {
      return this.sprite.getFlipVertically();
    }
  }, {
    key: "updatePivot",
    value: function updatePivot() {
      var e = this.textDesign.inverted ? Math.max(0, this.textDesign.padding) : 0,
          t = new _(this.bounds.width - 2 * e, this.bounds.height - 2 * e),
          r = this.getPivot(),
          o = new _(r.x * this.bounds.width, r.y * this.bounds.height),
          n = new _(e, e),
          l = o.subtract(n).divide(t);
      this.sprite.setPivot(new K(l.x, l.y));
    }
  }], [{
    key: "stringify",
    value: function stringify(e) {
      return JSON.stringify(e, Ci.serializer());
    }
  }, {
    key: "serializer",
    value: function serializer() {
      var e = [],
          t = [],
          r = function r(o, n) {
        return e[0] === n ? "[Circular ~]" : "[Circular ~.".concat(t.slice(0, e.indexOf(n)).join("."), "]");
      };

      return function (n, s) {
        var l = this;

        if (e.length > 0) {
          var c = e.indexOf(l);
          ~c ? (e.splice(c + 1), t.splice(c, Infinity, n)) : (e.push(l), t.push(n)), ~e.indexOf(s) && (s = r.call(l, n, s));
        } else e.push(s);

        return s;
      };
    }
  }]);

  return Ci;
}(ri);

var Jr = "imgly_font_open_sans_bold",
    tr =
/*#__PURE__*/
function (_Al) {
  _inherits(tr, _Al);

  function tr(e) {
    var _this30;

    _classCallCheck(this, tr);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(tr).call(this, e));
    _this30.previews = Array();
    _this30.rootOperationStack = [];
    _this30.deferredRenderQueue = [];
    _this30.operationStackOffset = 1;

    _this30.enforceOperationOrder = function () {
      _this30.refreshFlipIndex(), _this30.refreshFrameIndex();
    };

    if (_this30.assetProvider = e.assetProvider || new qr(), _this30.wrapper = new Py({
      license: e.license,
      crossOrigin: e.crossOrigin,
      assets: {
        resolver: function resolver(t, r) {
          return _this30.resolveAssetForSDK(t, r);
        }
      },
      editor: {
        preferredRenderer: e.preferredRenderer,
        pixelRatio: 1
      }
    }), _this30.editor = _this30.wrapper.getEditor(), _this30.sdk = _this30.editor.getSDK(), _this30.sdk.setRenderMode("adapter"), _this30.tempCanvas = document.createElement("canvas"), _this30.sdk.setCanvas(_this30.tempCanvas), e.preferredRenderer === "webgl") {
      var t = document.createElement("canvas"),
          r = t.getContext("webgl") || t.getContext("experimental-webgl");
      _this30.maxTextureDimension = r.getParameter(r.MAX_TEXTURE_SIZE);
    } else _this30.maxTextureDimension = Infinity;

    return _this30;
  }

  _createClass(tr, [{
    key: "dispose",
    value: function dispose() {
      this.pesdk.dispose(), this.wrapper.dispose();
    }
  }, {
    key: "render",
    value: function render(e) {
      var _this31 = this;

      return new Promise(function (t) {
        var r = function r() {
          return new Promise(function (o) {
            var n = e.canvas,
                s = e.getTransform(),
                l = _this31.outputContainer.getPivot(),
                c = e.getCanvasBounds(),
                p = e.quality,
                m = _this31.tempCanvas;

            _this31.sdk.setTextureQuality(p);

            var h = _this31.sdk.getOutputDimensions();

            return m.width = h.x, m.height = h.y, _this31.sdk.getRenderer().resizeTo(new K(m.width, m.height)), _this31.sdk.render(!0).then(function () {
              var b = n.getContext("2d");
              b.clearRect(0, 0, n.width, n.height), b.save(), b.translate(-c.minX, -c.minY), b.translate(s.position.x, s.position.y), b.rotate(s.rotation), b.scale(s.scale.x, s.scale.y), b.translate(-l.x * m.width, -l.y * m.height), b.scale(1 / e.quality, 1 / e.quality), b.drawImage(m, 0, 0), b.restore(), t(), _this31.deferredRenderQueue.shift(), _this31.deferredRenderQueue.length ? (_this31.sdk.setAllOperationsToDirty(), Promise.resolve(_this31.deferredRenderQueue[0]().then(o))) : o();
            });
          });
        };

        _this31.deferredRenderQueue.push(r), _this31.deferredRenderQueue.length === 1 && r();
      });
    }
  }, {
    key: "createPreview",
    value: function createPreview(e) {
      var t = new Il(e, this);
      return this.previews.push(t), t;
    }
  }, {
    key: "export",
    value: function _export() {
      return C(this, arguments,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this32 = this;

        var e,
            t,
            r,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                e = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : $e.IMAGE;
                t = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : Be.PNG;
                r = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 1;
                return _context8.abrupt("return", new Promise(function (o) {
                  var n = function n() {
                    return new Promise(function (s) {
                      return _this32.sdk.export(_this32.mapToRenderType(e), _this32.mapToImageFormat(t), r).then(function (l) {
                        o(l), _this32.deferredRenderQueue.shift(), _this32.deferredRenderQueue.length ? Promise.resolve(_this32.deferredRenderQueue[0]().then(s)) : s();
                      });
                    });
                  };

                  _this32.deferredRenderQueue.push(n), _this32.deferredRenderQueue.length === 1 && n();
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "getRootContainers",
    value: function getRootContainers() {
      return [this.rootContainer];
    }
  }, {
    key: "getOutputContainer",
    value: function getOutputContainer() {
      return this.outputContainer;
    }
  }, {
    key: "findContainerByID",
    value: function findContainerByID(e) {
      return e === this.rootContainer.getID() ? this.rootContainer : this.rootOperationStack.find(function (t) {
        return t.getID() === e;
      });
    }
  }, {
    key: "findEffectByID",
    value: function findEffectByID(e) {
      return this.rootOperationStack.find(function (t) {
        return t.getID() === e;
      });
    }
  }, {
    key: "addImage",
    value: function addImage(e, t, r) {
      if (this.rootContainer) throw new Error("A background image already exists - did you mean to use addSticker?");
      var o = new zl(e, this);

      if (this.rootContainer = o, !this.outputContainer) {
        var _o$getBounds = o.getBounds(),
            n = _o$getBounds.width,
            s = _o$getBounds.height,
            l = {
          resolution: {
            width: n,
            height: s
          },
          flipHorizontally: !1,
          flipVertically: !1
        },
            c = this.sdk.createOperation("output", {}, !1),
            p = this.sdk.createOperation("flip", {}, !1);

        this.insertIntoOperationsStack(c, this.operationStackOffset - 1), this.insertIntoOperationsStack(p, this.operationStackOffset), this.outputContainer = new Hl(l, c, p, this);
      }

      return o;
    }
  }, {
    key: "addSticker",
    value: function addSticker(e, t, r) {
      if (!t) throw new Error("This engine does not support adding stickers as root elements.");
      this.ensureContainerIsRoot(t);
      var o = new Jn(e, this);
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addStickerFromAssets",
    value: function addStickerFromAssets(e, t, r) {
      var _this33 = this;

      if (!t) throw new Error("This engine does not support adding stickers as root elements.");
      return this.ensureContainerIsRoot(t), new Promise(function (o, n) {
        var s = new Image();
        s.onload = function () {
          var l = {
            image: s,
            opacity: 1
          },
              c = new Jn(l, _this33);
          _this33.addToStackAtIndex(c, r), o(c);
        }, s.onerror = function (l) {
          n(l);
        }, s.crossOrigin = _this33.config.crossOrigin || null, s.src = _this33.assetProvider.getAssetSource("sticker", e);
      });
    }
  }, {
    key: "addText",
    value: function addText(e, t, r) {
      if (!t) throw new Error("This engine does not support adding text as root elements.");
      if (!this.assetProvider.getFontManager().isFontLoaded(e.fontIdentifier || Jr)) throw new Error("Adding text synchronously only works if the required font is already loded! Consider using the asynchronous addTextWithFontLoading function instead!");
      this.ensureContainerIsRoot(t);
      var n = f({
        text: "",
        fontIdentifier: Jr,
        fontSize: 20,
        lineHeight: 1,
        alignment: "center",
        textColor: [1, 1, 1],
        backgroundColor: [0, 0, 0, 0],
        width: 100
      }, e),
          s = new Nt(n, this);
      return this.addToStackAtIndex(s, r), s;
    }
  }, {
    key: "addTextWithFontLoading",
    value: function addTextWithFontLoading(e, t, r) {
      var _this34 = this;

      if (!t) throw new Error("This engine does not support adding text as root elements.");
      var o = this.assetProvider.getFontManager(),
          n = e.fontIdentifier || Jr;
      return new Promise(function (s, l) {
        o.loadFontWithIdentifier(n).then(function () {
          _this34.ensureContainerIsRoot(t);

          var c = f({
            text: "",
            fontIdentifier: Jr,
            fontSize: 20,
            lineHeight: 1,
            alignment: "center",
            textColor: [1, 1, 1],
            backgroundColor: [0, 0, 0, 0],
            width: 100
          }, e),
              p = new Nt(c, _this34);
          _this34.addToStackAtIndex(p, r), s(p);
        }).catch(l);
      });
    }
  }, {
    key: "addTextDesignAsync",
    value: function addTextDesignAsync() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "imgly_text_design_blocks";
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var r = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var _this35 = this;

        var n, s, l, c, m, h;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (r) {
                  _context9.next = 2;
                  break;
                }

                throw new Error("This engine does not support adding TextDesign as a root element.");

              case 2:
                n = f({
                  seed: Date.now(),
                  padding: 0,
                  text: "",
                  color: [0, 0, 0],
                  inverted: !1,
                  width: 100
                }, t), s = this.wrapper.getTextDesignLayoutByID(e);

                if (s) {
                  _context9.next = 5;
                  break;
                }

                throw new Error("The layout could not be loaded for the given id: ".concat(e));

              case 5:
                l = s.getImagePaths().map(function (v) {
                  var x = v.split("/").pop() || "";
                  return {
                    path: v,
                    fullPath: _this35.assetProvider.getAssetSource("textdesign", x)
                  };
                }), c = this.wrapper.getTextDesignAssetManager(), m = this.wrapper.getTextDesignFontManager().getVariationsByIdentifier();
                c.setFonts(m);
                _context9.next = 9;
                return c.loadImages(l);

              case 9:
                s.onImagesLoaded();
                h = Object.keys(m);
                return _context9.abrupt("return", this.assetProvider.getFontManager().loadFontsWithIdentifiers(h).then(function () {
                  _this35.ensureContainerIsRoot(r);

                  var v = new Ci(n, s, _this35);
                  return _this35.addToStackAtIndex(v, o), Promise.resolve(v);
                }));

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "addDrawing",
    value: function addDrawing(e, t, r) {
      if (!t) throw new Error("This engine does not support DrawingContainers as root elements.");
      this.ensureContainerIsRoot(t);
      var o = new Ol(e, this);
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addGaussianBlur",
    value: function addGaussianBlur(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Bl(e, this, this.sdk.createOperation("blur", {}, !1));
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addRadialBlur",
    value: function addRadialBlur(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Wl(e, this, this.sdk.createOperation("radial-focus", {}, !1));
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addMirroredBlur",
    value: function addMirroredBlur(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Nl(e, this, this.sdk.createOperation("mirrored-focus", {}, !1));
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addLinearBlur",
    value: function addLinearBlur(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Ll(e, this, this.sdk.createOperation("linear-focus", {}, !1));
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addDuoToneFilter",
    value: function addDuoToneFilter(e, t, r) {
      throw new Error("Not supported! Use addDuoToneFilterFromAssets instead");
    }
  }, {
    key: "addDuoToneFilterFromAssets",
    value: function addDuoToneFilterFromAssets(e, t, r) {
      var _this36 = this;

      this.ensureContainerIsRoot(t);
      var n = this.sdk.getOperationsStack().getByIdentifier("filter");
      if (n && n.getIdentifier() !== e) throw new Error("This engine doesn't support multiple types of filter operations at once!");
      var s = n || this.sdk.createOperation("filter", {}, !1);
      return new Promise(function (l, c) {
        try {
          var p = _this36.assetProvider.getDuotoneFilterAsset(e),
              m = {
            colorIntensity: p.defaultIntensity || 0
          },
              h = new pe.Operations.FilterOperation.Filters.DuoToneFilter({
            intensity: m.colorIntensity,
            lightColor: pe.Color.fromHex(p.lightColor),
            darkColor: pe.Color.fromHex(p.darkColor)
          }),
              b = new Tl(h, s, m, _this36);

          _this36.addToStackAtIndex(b, r), l(b);
        } catch (p) {
          p && c(p);
        }
      });
    }
  }, {
    key: "addLUTFilter",
    value: function addLUTFilter(e, t, r) {
      throw new Error("Not supported! Use addLUTFilterFromAssets instead");
    }
  }, {
    key: "addLUTFilterFromAssets",
    value: function addLUTFilterFromAssets(e, t, r) {
      var _this37 = this;

      this.ensureContainerIsRoot(t);
      var n = this.sdk.getOperationsStack().getByIdentifier("filter");
      if (n && n.getIdentifier() !== e) throw new Error("This engine doesn't support multiple types filter operations at once!");
      var s = n || this.sdk.createOperation("filter", {}, !1);
      return this.getLutFilterImage(e).then(function (l) {
        var c = _this37.assetProvider.getLUTFilterAsset(e),
            p = {
          horizontalTileCount: c.horizontalTileCount || 5,
          verticalTileCount: c.verticalTileCount || 5,
          intensity: c.defaultIntensity || 1
        },
            m = new pe.Operations.FilterOperation.Filters.ThreeDLUTFilter(f(f({}, p), {
          image: l
        })),
            h = f(f({}, p), {
          lutImage: new Image()
        }),
            b = new Ul(m, s, h, _this37);

        return _this37.addToStackAtIndex(b, r), b;
      });
    }
  }, {
    key: "getLutFilterImage",
    value: function getLutFilterImage(e) {
      var _this38 = this;

      return new Promise(function (t, r) {
        var o = new Image();
        o.addEventListener("load", function () {
          t(o);
        }), o.addEventListener("error", function (n) {
          r(n);
        }), o.crossOrigin = _this38.config.crossOrigin || null, o.src = _this38.assetProvider.getAssetSource("filter", e);
      });
    }
  }, {
    key: "addAdjustments",
    value: function addAdjustments(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Rl(e, this, this.sdk.createOperation("adjustments", {}, !1));
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addOverlay",
    value: function addOverlay(e, t, r) {
      this.ensureContainerIsRoot(t);
      var o = new Xn(this.sdk.createOperation("overlay", {}, !1), e, this);
      return this.addToStackAtIndex(o, r), o;
    }
  }, {
    key: "addOverlayFromAssets",
    value: function addOverlayFromAssets(e, t, r) {
      var _this39 = this;

      return this.ensureContainerIsRoot(t), new Promise(function (o, n) {
        var s = _this39.sdk.getOperationsStack(),
            l = s.getByIdentifier("overlay");

        l && l.getIdentifier() !== e && s.remove(l);

        var c = l || _this39.sdk.createOperation("overlay", {}, !1),
            p = new Image();

        p.onload = function () {
          var m = {
            image: p,
            opacity: 1,
            blendMode: j.NORMAL
          },
              h = new Xn(c, m, _this39);
          _this39.addToStackAtIndex(h, r), o(h);
        }, p.onerror = function (m) {
          n(m);
        }, p.crossOrigin = _this39.config.crossOrigin || null, p.src = _this39.assetProvider.getAssetSource("overlay", e);
      });
    }
  }, {
    key: "addFrame",
    value: function addFrame(e, t, r) {
      throw new Error("Not supported!");
    }
  }, {
    key: "addFrameFromAssets",
    value: function addFrameFromAssets(e, t, r) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var o, n, s, l, c, p, m;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.ensureContainerIsRoot(t);
                o = this.assetProvider.getFrameAsset(e);

                if (o) {
                  _context10.next = 4;
                  break;
                }

                throw new Error("The requested asset does not exist! ".concat(e));

              case 4:
                n = new Pl(o, this);
                _context10.next = 7;
                return n.load();

              case 7:
                s = this.getOutputContainer().getBounds(), l = Math.min(s.width, s.height), c = this.sdk.createOperation("frame", {}, !1);
                c.setFrame(n.getFrame());
                p = {
                  opacity: 1,
                  tintColor: [1, 1, 1],
                  tintable: !1,
                  width: Math.max(1, .1 * l),
                  imageGroups: n.getFrame().imageGroups
                }, m = new Ml(c, p, this);
                return _context10.abrupt("return", (this.addToStackAtIndex(m, r), Promise.resolve(m)));

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "removeEffect",
    value: function removeEffect(e) {
      if (!e.isValid()) return;
      var r = e.getOperation();
      this.sdk.removeOperation(r), this.sdk.setAllOperationsToDirty(), this.rootOperationStack.splice(e.getIndexInParent(), 1);
    }
  }, {
    key: "removeContainer",
    value: function removeContainer(e) {
      if (!e.isValid() || e.type === "output") return;
      var r = e.getOperation();
      this.sdk.removeOperation(r), this.sdk.setAllOperationsToDirty(), this.rootOperationStack.splice(e.getIndexInParent(), 1);
    }
  }, {
    key: "refreshOutputIndex",
    value: function refreshOutputIndex() {
      var e = this.sdk.getOperationsStack().getIndexByIdentifier("output");
      this.moveInOperationsStack(e, this.operationStackOffset - 1);
    }
  }, {
    key: "refreshFlipIndex",
    value: function refreshFlipIndex() {
      var e = this.sdk.getOperationsStack().getIndexByIdentifier("flip"),
          t = this.sdk.getOperationsStack().getStack().length - 1;
      e !== t && this.moveInOperationsStack(e, t);
    }
  }, {
    key: "refreshFrameIndex",
    value: function refreshFrameIndex() {
      var e = this.sdk.getOperationsStack().getIndexByIdentifier("frame"),
          t = this.sdk.getOperationsStack().getStack().length - 1;
      e !== -1 && e !== t && this.moveInOperationsStack(e, t);
    }
  }, {
    key: "mapToRenderType",
    value: function mapToRenderType(e) {
      switch (e) {
        case $e.IMAGE:
          return pe.RenderType.IMAGE;

        case $e.DATA_URL:
          return pe.RenderType.DATAURL;

        case $e.BLOB:
          return pe.RenderType.BLOB;

        case $e.MSBLOB:
          return pe.RenderType.MSBLOB;

        default:
          return pe.RenderType.IMAGE;
      }
    }
  }, {
    key: "mapToImageFormat",
    value: function mapToImageFormat(e) {
      switch (e) {
        case Be.PNG:
          return pe.ImageFormat.PNG;

        case Be.JPEG:
          return pe.ImageFormat.JPEG;

        default:
          return null;
      }
    }
  }, {
    key: "mapBlendMode",
    value: function mapBlendMode(e) {
      switch (e) {
        case he.NORMAL:
          return j.NORMAL;

        case he.OVERLAY:
          return j.OVERLAY;

        case he.HARD_LIGHT:
          return j.HARD_LIGHT;

        case he.SOFT_LIGHT:
          return j.SOFT_LIGHT;

        case he.MULTIPLY:
          return j.MULTIPLY;

        case he.DARKEN:
          return j.DARKEN;

        case he.LIGHTEN:
          return j.LIGHTEN;

        case he.SCREEN:
          return j.SCREEN;

        case he.COLOR_BURN:
          return j.COLOR_BURN;

        default:
          return j.NORMAL;
      }
    }
  }, {
    key: "reverseMapBlendMode",
    value: function reverseMapBlendMode(e) {
      switch (e) {
        case j.NORMAL:
          return he.NORMAL;

        case j.OVERLAY:
          return he.OVERLAY;

        case j.HARD_LIGHT:
          return he.HARD_LIGHT;

        case j.SOFT_LIGHT:
          return he.SOFT_LIGHT;

        case j.MULTIPLY:
          return he.MULTIPLY;

        case j.DARKEN:
          return he.DARKEN;

        case j.LIGHTEN:
          return he.LIGHTEN;

        case j.SCREEN:
          return he.SCREEN;

        case j.COLOR_BURN:
          return he.COLOR_BURN;

        default:
          return he.NORMAL;
      }
    }
  }, {
    key: "createSpriteOperation",
    value: function createSpriteOperation() {
      return this.sdk.createOperation("sprite", {}, !1);
    }
  }, {
    key: "moveIndex",
    value: function moveIndex(e, t) {
      var r = this.getSiblingIndex(e);
      if (r === -1) throw new Error("The item to be moved is not part of any stack.");
      this.moveInStack(this.rootOperationStack, r, t);
      var o = this.operationStackOffset;
      this.moveInOperationsStack(r + o, t + o), this.enforceOperationOrder();
    }
  }, {
    key: "ensureContainerIsRoot",
    value: function ensureContainerIsRoot(e) {
      if (e.getID() !== this.rootContainer.getID()) throw new Error("This engine doesn't support adding this effect/container to anything other than the root image container");
    }
  }, {
    key: "addToStackAtIndex",
    value: function addToStackAtIndex(e, t) {
      if (t && t < 0) throw new Error("The given index may not be negative: ".concat(t));
      t === void 0 ? this.rootOperationStack.push(e) : this.rootOperationStack.splice(t, 0, e);
      var r = this.rootOperationStack.length - 1,
          o = t !== void 0 ? t : r;
      o += this.operationStackOffset, Mp(e) ? this.insertIntoOperationsStack(e.getOperation(), o) : this.insertIntoOperationsStack(e.getOperation(), o), this.sdk.setAllOperationsToDirty();
    }
  }, {
    key: "insertIntoOperationsStack",
    value: function insertIntoOperationsStack(e, t) {
      var r = this.sdk.getOperationsStack().getStack(),
          o = r.length,
          n = Math.max(Math.min(t, o), 0);

      for (var s = o - 1; s >= n; s -= 1) {
        var l = r[s];
        r[s + 1] = l;
      }

      r[n] = e, this.sdk.setAllOperationsToDirty(), this.enforceOperationOrder();
    }
  }, {
    key: "moveInStack",
    value: function moveInStack(e, t, r) {
      var o = e.length,
          n = Math.max(Math.min(t, o - 1), 0),
          s = Math.max(Math.min(r, o - 1), 0);
      if (n === s) return;
      var l = e[n];
      if (n < s) for (var c = n + 1; c <= s; c += 1) {
        e[c - 1] = e[c];
      } else for (var _c2 = n - 1; _c2 >= s; _c2 -= 1) {
        e[_c2 + 1] = e[_c2];
      }
      e[s] = l;
    }
  }, {
    key: "moveInOperationsStack",
    value: function moveInOperationsStack(e, t) {
      var r = this.sdk.getOperationsStack().getStack(),
          o = r.length,
          n = Math.min(Math.max(0, e), o - 1),
          s = Math.min(Math.max(0, t), o - 1);
      if (n === s) return;
      var l = r[n];
      if (n < s) for (var c = n + 1; c <= s; c += 1) {
        r[c - 1] = r[c];
      } else for (var _c3 = n - 1; _c3 >= s; _c3 -= 1) {
        r[_c3 + 1] = r[_c3];
      }
      r[s] = l, this.sdk.getOperationsStack().setAllToDirty();
    }
  }, {
    key: "getSiblingIndex",
    value: function getSiblingIndex(e) {
      return e.getIndexInParent();
    }
  }, {
    key: "resolveAssetForSDK",
    value: function resolveAssetForSDK(e, t) {
      switch (t = t, e) {
        case "filter":
          return this.assetProvider.getAssetSource("filter", t.identifier);

        case "overlay":
          return this.assetProvider.getAssetSource("overlay", t.identifier);

        case "font":
          return this.assetProvider.getAssetSource("font", t.identifier);
      }

      return "";
    }
  }, {
    key: "configuration",
    get: function get() {
      return this.config;
    }
  }, {
    key: "pesdk",
    get: function get() {
      return this.sdk;
    }
  }, {
    key: "rootOperations",
    get: function get() {
      return this.rootOperationStack;
    }
  }]);

  return tr;
}(Al);

var Qn =
/*#__PURE__*/
function () {
  function Qn(e) {
    var _this40 = this;

    _classCallCheck(this, Qn);

    this.isEmpty = !1;
    this.isValid = !1;

    this.isWhiteLabel = function () {
      return _this40.isValid && _this40.licenseChecker.isWhiteLabel();
    };

    this.areCustomAssetsAllowed = function () {
      return _this40.isEmpty || _this40.isValid && _this40.licenseChecker.areCustomAssetsAllowed();
    };

    e && e.length !== 0 ? (this.licenseChecker = new pe.LicenseChecker(e), this.isValid = this.licenseChecker.validate()) : e === "" && (this.isEmpty = !0);
  }

  _createClass(Qn, [{
    key: "isToolAllowed",
    value: function isToolAllowed(e) {
      return this.licenseChecker && this.isValid ? this.licenseChecker.isToolAllowed(e) : !0;
    }
  }]);

  return Qn;
}();

var es = function es(i) {
  var e = Number(i).toString(16);
  return e.length < 2 && (e = "0".concat(e)), e;
},
    jl = function jl(i, e, t) {
  var r = es(i * 255),
      o = es(e * 255),
      n = es(t * 255);
  return "#".concat(r).concat(o).concat(n);
},
    ir = function ir(i) {
  if (Yn(i)) {
    var _i2 = _slicedToArray(i, 4),
        e = _i2[0],
        t = _i2[1],
        r = _i2[2],
        o = _i2[3];

    return "rgba(".concat(e * 255, ", ").concat(t * 255, ", ").concat(r * 255, ", ").concat(o, ")");
  }

  if (qn(i)) {
    var _e2 = i.r,
        _t5 = i.g,
        _r2 = i.b,
        _o4 = i.a;
    return "rgba(".concat(_e2 * 255, ", ").concat(_t5 * 255, ", ").concat(_r2 * 255, ", ").concat(_o4, ")");
  }

  if (Kn(i)) {
    var _i3 = _slicedToArray(i, 3),
        _e3 = _i3[0],
        _t6 = _i3[1],
        _r3 = _i3[2];

    return jl(_e3, _t6, _r3);
  }

  if ($n(i)) {
    var _e4 = i.r,
        _t7 = i.g,
        _r4 = i.b;
    return jl(_e4, _t7, _r4);
  }

  return i;
},
    Ke = function Ke(i) {
  return i.map(function (e) {
    return {
      identifier: e.name,
      color: e.color,
      colorString: ir(e.color)
    };
  });
},
    xe = {
  black: [0 / 255, 0 / 255, 0 / 255, 1],
  white: [255 / 255, 255 / 255, 255 / 255, 1],
  gray: [191 / 255, 191 / 255, 191 / 255, 1],
  blue: [102 / 255, 134 / 255, 255 / 255, 1],
  skyBlue: [102 / 255, 204 / 255, 255 / 255, 1],
  red: [231 / 255, 80 / 255, 80 / 255, 1],
  orange: [242 / 255, 136 / 255, 85 / 255, 1],
  yellow: [255 / 255, 247 / 255, 99 / 255, 1]
},
    ts = {
  transparent: [0 / 255, 0 / 255, 0 / 255, 0],
  black: [0 / 255, 0 / 255, 0 / 255, 1],
  white: [255 / 255, 255 / 255, 255 / 255, 1],
  blue: [102 / 255, 134 / 255, 255 / 255, 1],
  skyBlue: [102 / 255, 204 / 255, 255 / 255, 1],
  red: [231 / 255, 80 / 255, 80 / 255, 1],
  orange: [242 / 255, 136 / 255, 85 / 255, 1],
  yellow: [255 / 255, 247 / 255, 99 / 255, 1]
};

var Zr = [g.LIBRARY, [g.TRANSFORM, g.FILTER, g.ADJUSTMENT], [g.FOCUS, g.FRAME, g.OVERLAY], [g.TEXT, g.TEXT_DESIGN, g.STICKER, g.BRUSH]];
var is = {
  license: "",
  order: "default",
  language: "en",
  theme: "dark",
  layout: "advanced",
  mainCanvasActions: [de.UNDO, de.REDO, de.EXPORT, de.CLOSE],
  displayResizeWarning: !1,
  displayCloseWarning: !0,
  displayCanvasRendererWarning: !0,
  displayToolControlBarTitle: !0,
  engine: {
    crossOrigin: "anonymous",
    downscaleOptions: {
      maxMegaPixels: {
        desktop: 10,
        mobile: 5
      }
    },
    preferredRenderer: vl() ? "webgl" : "canvas"
  },
  enableZoom: !0,
  forceCrop: !1,
  assetBaseUrl: "assets/",
  defaultTool: g.FILTER,
  tools: Zr,
  snapping: new xn(),
  filter: new En(),
  focus: new kn(),
  adjustment: new Cn(),
  library: new Fn(),
  overlay: new An(),
  sticker: new Rn(),
  text: new On(),
  textdesign: new Pn(),
  frame: new In(),
  brush: new Tn(),
  transform: new Mn(),
  export: {
    image: {
      exportType: $e.IMAGE,
      format: Be.PNG,
      quality: .9,
      enableDownload: !0
    },
    filename: "photoeditorsdk-export"
  },
  custom: {}
};
var Qr = (_Qr = {}, _defineProperty(_Qr, ze.BRIGHTNESS, 0), _defineProperty(_Qr, ze.SATURATION, 0), _defineProperty(_Qr, ze.CONTRAST, 0), _defineProperty(_Qr, ze.GAMMA, 0), _defineProperty(_Qr, ze.CLARITY, 0), _defineProperty(_Qr, ze.EXPOSURE, 0), _defineProperty(_Qr, ze.SHADOWS, 0), _defineProperty(_Qr, ze.HIGHLIGHTS, 0), _defineProperty(_Qr, ze.WHITES, 0), _defineProperty(_Qr, ze.BLACKS, 0), _defineProperty(_Qr, ze.TEMPERATURE, 0), _defineProperty(_Qr, ze.SHARPNESS, 0), _Qr);

var wi =
/*#__PURE__*/
function () {
  function wi() {
    _classCallCheck(this, wi);

    this.snapshots = [];
    this.observeIndex = S.box(-1);
  }

  _createClass(wi, [{
    key: "addSnapshot",
    value: function addSnapshot(e) {
      this.index === this.snapshots.length - 1 ? this.snapshots = this.snapshots.concat(JSON.stringify(e)) : this.snapshots = [].concat(_toConsumableArray(this.snapshots.slice(0, this.index + 1)), [JSON.stringify(e)]), this.observeIndex.set(this.snapshots.length - 1);
    }
  }, {
    key: "getCurrentState",
    value: function getCurrentState() {
      return this.snapshots[this.index];
    }
  }, {
    key: "reset",
    value: function reset() {
      this.snapshots = [], this.observeIndex.set(-1);
    }
  }, {
    key: "undo",
    value: function undo() {
      return this.canUndo ? (this.observeIndex.set(this.index - 1), JSON.parse(this.getCurrentState())) : null;
    }
  }, {
    key: "redo",
    value: function redo() {
      return this.canRedo ? (this.observeIndex.set(this.index + 1), JSON.parse(this.getCurrentState())) : null;
    }
  }, {
    key: "discardSnapshotsfromIndex",
    value: function discardSnapshotsfromIndex(e) {
      e > 0 && e < this.snapshots.length - 1 && (this.snapshots = this.snapshots.slice(0, e), this.observeIndex.set(this.snapshots.length - 1));
    }
  }, {
    key: "index",
    get: function get() {
      return this.observeIndex.get();
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this.index > 0;
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this.snapshots.length - 1 > this.index;
    }
  }]);

  return wi;
}();

a([u], wi.prototype, "index", 1), a([u], wi.prototype, "canUndo", 1), a([u], wi.prototype, "canRedo", 1);
var F;

(function (i) {
  i.ADD = "add", i.EDIT = "edit", i.DELETE = "delete";
})(F || (F = {}));

var oi =
/*#__PURE__*/
function () {
  function oi(e) {
    var _this41 = this;

    _classCallCheck(this, oi);

    this.localTransformStartIndex = null;
    this.awaitHistoryChange = !1;
    this.isDirtySinceSave = !1;

    this.undo = function () {
      return C(_this41, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        var _e5;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this.awaitHistoryChange) {
                  _context11.next = 7;
                  break;
                }

                this.awaitHistoryChange = !0;
                _e5 = this.appHistoryManager.undo();
                _context11.next = 5;
                return this.applyState(_e5);

              case 5:
                this.awaitHistoryChange = !1;
                this.canUndo || (this.isDirtySinceSave = !1);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    };

    this.redo = function () {
      return C(_this41, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _e6;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (this.awaitHistoryChange) {
                  _context12.next = 6;
                  break;
                }

                this.awaitHistoryChange = !0;
                _e6 = this.appHistoryManager.redo();
                _context12.next = 5;
                return this.applyState(_e6);

              case 5:
                this.awaitHistoryChange = !1;

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    };

    this.editor = e, this.appHistoryManager = new wi();
  }

  _createClass(oi, [{
    key: "getHistoryState",
    value: function getHistoryState() {
      var _ref6;

      var e = k(this.editor.adjustmentsToolStore.state),
          t = k(this.editor.filterToolStore.state),
          r = this.editor.focusToolStore.getFocusStateForHistory(),
          o = k(this.editor.overlayToolStore.state),
          n = k(this.editor.frameToolStore.state),
          s = this.editor.brushToolStore.strokes || {
        strokes: []
      },
          l = this.editor.spriteStore.getSpriteHistoryState(),
          c = this.editor.transformToolStore.serializableState;
      return _ref6 = {}, _defineProperty(_ref6, g.ADJUSTMENT, e), _defineProperty(_ref6, g.FILTER, t), _defineProperty(_ref6, g.FOCUS, r), _defineProperty(_ref6, g.OVERLAY, o), _defineProperty(_ref6, g.FRAME, n), _defineProperty(_ref6, g.BRUSH, s), _defineProperty(_ref6, "sprite", l), _defineProperty(_ref6, g.TRANSFORM, c), _ref6;
    }
  }, {
    key: "addInitialSnapshot",
    value: function addInitialSnapshot() {
      var e = this.getHistoryState();
      this.appHistoryManager.addSnapshot({
        state: e,
        type: F.ADD,
        description: "Initial State"
      });
    }
  }, {
    key: "addSnapshot",
    value: function addSnapshot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getHistoryState();
      var t = arguments.length > 1 ? arguments[1] : undefined;
      var r = arguments.length > 2 ? arguments[2] : undefined;
      e && ((e.sprite || e.transform) && (e = f(f({}, this.getHistoryState()), e)), this.appHistoryManager.addSnapshot({
        state: e,
        type: t,
        description: r
      }), this.editor.configStore.events.onHistoryChange(), this.isDirtySinceSave || (this.isDirtySinceSave = !0));
    }
  }, {
    key: "saveTransformLocalSnapshotIndex",
    value: function saveTransformLocalSnapshotIndex() {
      this.localTransformStartIndex === null && (this.localTransformStartIndex = this.appHistoryManager.snapshots.length);
    }
  }, {
    key: "removeTransformLocalSnapshots",
    value: function removeTransformLocalSnapshots() {
      this.localTransformStartIndex !== null && (this.appHistoryManager.discardSnapshotsfromIndex(this.localTransformStartIndex - 1), this.localTransformStartIndex = null);
    }
  }, {
    key: "applyState",
    value: function applyState(t) {
      return C(this, arguments,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(_ref7) {
        var e, r, _i4, _r5, o;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                e = _ref7.state;
                _context13.prev = 1;

                if (!e) {
                  _context13.next = 49;
                  break;
                }

                r = Object.keys(e);
                _i4 = 0, _r5 = r;

              case 5:
                if (!(_i4 < _r5.length)) {
                  _context13.next = 47;
                  break;
                }

                o = _r5[_i4];
                _context13.t0 = o;
                _context13.next = _context13.t0 === g.FILTER ? 10 : _context13.t0 === g.ADJUSTMENT ? 13 : _context13.t0 === g.OVERLAY ? 16 : _context13.t0 === g.FRAME ? 19 : _context13.t0 === g.FOCUS ? 22 : _context13.t0 === g.BRUSH ? 25 : _context13.t0 === "sprite" ? 28 : _context13.t0 === "localTransform" ? 31 : _context13.t0 === g.TRANSFORM ? 34 : 44;
                break;

              case 10:
                _context13.next = 12;
                return this.editor.filterToolStore.updateStateFromHistory(e[o]);

              case 12:
                return _context13.abrupt("break", 44);

              case 13:
                _context13.next = 15;
                return this.editor.adjustmentsToolStore.updateStateFromHistory(e[o]);

              case 15:
                return _context13.abrupt("break", 44);

              case 16:
                _context13.next = 18;
                return this.editor.overlayToolStore.updateStateFromHistory(e[o]);

              case 18:
                return _context13.abrupt("break", 44);

              case 19:
                _context13.next = 21;
                return this.editor.frameToolStore.updateStateFromHistory(e[o]);

              case 21:
                return _context13.abrupt("break", 44);

              case 22:
                _context13.next = 24;
                return this.editor.focusToolStore.updateStateFromHistory(e[o], this.editor.canvasStore.sizeVector);

              case 24:
                return _context13.abrupt("break", 44);

              case 25:
                _context13.next = 27;
                return this.editor.brushToolStore.updateStateFromHistory(e[o]);

              case 27:
                return _context13.abrupt("break", 44);

              case 28:
                _context13.next = 30;
                return this.editor.spriteStore.updateStateFromHistory(e[o]);

              case 30:
                return _context13.abrupt("break", 44);

              case 31:
                _context13.next = 33;
                return this.editor.transformToolStore.updateLocalStateFromHistory(e.localTransform);

              case 33:
                return _context13.abrupt("break", 44);

              case 34:
                this.editor.outputContainer.pauseChildrenUpdates();
                this.editor.transformToolStore.onEnter();
                this.editor.transformToolStore.updateStateFromSerialization(e[o], !1);
                this.editor.transformToolStore.onLeave();
                this.editor.transformToolStore.onEnter();
                this.editor.transformToolStore.onLeave();
                this.editor.outputContainer.resumeChildrenUpdates();
                _context13.next = 43;
                return this.editor.wait();

              case 43:
                return _context13.abrupt("break", 44);

              case 44:
                _i4++;
                _context13.next = 5;
                break;

              case 47:
                _context13.next = 49;
                return this.editor.renderPromise();

              case 49:
                _context13.next = 54;
                break;

              case 51:
                _context13.prev = 51;
                _context13.t1 = _context13["catch"](1);
                console.error(_context13.t1), this.editor.modalStore.showActionModal({
                  type: oe.ERROR,
                  identifier: "unexpectedError",
                  error: _context13.t1,
                  handleConfirm: function handleConfirm() {
                    window.location.reload();
                  }
                });

              case 54:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[1, 51]]);
      }));
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      return this.appHistoryManager.snapshots.length > 1;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.appHistoryManager.reset(), this.isDirtySinceSave = !1;
    }
  }, {
    key: "canUndo",
    get: function get() {
      return this.appHistoryManager.canUndo;
    }
  }, {
    key: "canRedo",
    get: function get() {
      return this.appHistoryManager.canRedo;
    }
  }]);

  return oi;
}();

a([d], oi.prototype, "undo", 2), a([d], oi.prototype, "redo", 2), a([u], oi.prototype, "canUndo", 1), a([u], oi.prototype, "canRedo", 1);

var ee =
/*#__PURE__*/
function () {
  function ee(e, t) {
    var _this42 = this;

    _classCallCheck(this, ee);

    this.assets = [];

    this.entityMapper = function (e) {
      return "items" in e ? _this42.categoryMapper(e) : _this42.itemMapper(e);
    };

    this.categoryMapper = function (e) {
      return e ? f(f({}, e), {
        thumbnailURI: _this42.getCategoryURI(e),
        name: _this42.config.locale[e.identifier] || e.name,
        items: e.items.map(_this42.itemMapper)
      }) : null;
    };

    this.itemMapper = function (e) {
      return f(f({}, e), {
        thumbnailURI: _this42.getItemURI(e),
        name: _this42.config.locale[e.identifier] || ("name" in e ? e.name : "")
      });
    };

    this.getCategoryURI = function (e) {
      return e.thumbnailURI && (ii(e.thumbnailURI) || e.thumbnailURI.substr(0, 10) === "data:image") ? e.thumbnailURI : _this42.config.getAssetPath(e[_this42.config.categoryKey] || "");
    };

    this.getItemURI = function (e) {
      return "thumbnailURI" in e && (ii(e.thumbnailURI) || e.thumbnailURI.substr(0, 10) === "data:image") ? e.thumbnailURI : _this42.config.getAssetPath(e[_this42.config.itemKey] || "");
    };

    this.config = t, this.assets = e.map(this.entityMapper).filter(Boolean);
  }

  _createClass(ee, [{
    key: "categories",
    get: function get() {
      return this.assets.reduce(function (e, t) {
        if (ee.isCategory(t)) return [].concat(_toConsumableArray(e), [t]);
      }, []).filter(Boolean);
    }
  }, {
    key: "items",
    get: function get() {
      return this.assets.reduce(function (e, t) {
        return ee.isCategory(t) ? [].concat(_toConsumableArray(e), _toConsumableArray(t.items)) : [].concat(_toConsumableArray(e), [t]);
      }, []).filter(Boolean);
    }
  }], [{
    key: "isCategory",
    value: function isCategory(e) {
      return Object.prototype.hasOwnProperty.call(e, "items");
    }
  }]);

  return ee;
}();

var Dt =
/*#__PURE__*/
function () {
  function Dt(e, t) {
    _classCallCheck(this, Dt);

    this.from = e, this.to = t;
  }

  _createClass(Dt, [{
    key: "contains",
    value: function contains(e) {
      return this.from <= e && e <= this.to;
    }
  }, {
    key: "clamp",
    value: function clamp(e) {
      return Math.min(Math.max(this.from, e), this.to);
    }
  }]);

  return Dt;
}();

var Lp = new Dt(-1, 1),
    Ei =
/*#__PURE__*/
function () {
  function Ei(e) {
    var _this43 = this;

    _classCallCheck(this, Ei);

    this.editAdjustments = function (_ref8) {
      var e = _ref8.type,
          t = _ref8.value;
      var r = Lp.clamp(t);
      _this43.state[e] = r;
    };

    this.reset = function () {
      re(function () {
        _this43.indexInContainer === -1 && (Object.keys(Qr).forEach(function (e) {
          _this43.state[e] = Qr[e];
        }), _this43.orderHelper.removeIndex(g.ADJUSTMENT));
      });
    };

    this.setAdjustmentEffect = function (e) {
      var t = _this43.orderHelper.addIndex(g.ADJUSTMENT);

      return _this43.effect ? _this43.effect.setProperties(e) : _this43.effect = _this43.engineMediator.engine.addAdjustments(e, _this43.engineMediator.image.container, t), _this43.effect.getProperties();
    };

    this.removeAdjustmentEffect = function () {
      _this43.effect && (_this43.engineMediator.engine.removeEffect(_this43.effect), _this43.indexInContainer === -1 && (_this43.effect = void 0));
    };

    this.engineMediator = e, this.state = Qr;
  }

  _createClass(Ei, [{
    key: "indexInContainer",
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    }
  }, {
    key: "orderHelper",
    get: function get() {
      return this.engineMediator.orderHelper;
    }
  }]);

  return Ei;
}();

a([S], Ei.prototype, "state", 2), a([d], Ei.prototype, "editAdjustments", 2), a([d], Ei.prototype, "reset", 2);

var H =
/*#__PURE__*/
function () {
  function H(e) {
    var _this44 = this;

    _classCallCheck(this, H);

    this.dirty = S.box(!1);

    this.editAdjustments = function (_ref9) {
      var e = _ref9.type,
          t = _ref9.value;
      _this44.pureSetAdjustment({
        type: e,
        value: t
      }), _this44.editor.render();
    };

    this.toolSnapshot = function () {
      _this44.dirty.set(!0), _this44.addSnapshot(F.EDIT, g.ADJUSTMENT);
    };

    this.addSnapshot = function (e, t) {
      _this44.editor.addSnapshot(void 0, e, t);
    };

    this.toggleOptionSelection = function (e) {
      _this44.selectedOption = e;
    };

    this.pureSetAdjustment = function (_ref10) {
      var e = _ref10.type,
          t = _ref10.value;

      var r = _this44.adjustmentsStore.setAdjustmentEffect(_defineProperty({}, e, t));

      _this44.adjustmentsStore.editAdjustments({
        type: e,
        value: r[e]
      });
    };

    this.pureReset = function () {
      _this44.dirty.set(!1), _this44.adjustmentsStore.removeAdjustmentEffect(), _this44.adjustmentsStore.reset(), _this44.selectedOption = "";
    };

    this.reset = function () {
      _this44.pureReset(), _this44.addSnapshot(F.DELETE, _this44.locale.controls.buttonReset), _this44.editor.render();
    };

    this.updateStateFromHistory = function (e) {
      re(function () {
        Object.keys(e).forEach(function (t) {
          _this44.pureSetAdjustment({
            type: t,
            value: e[t]
          });
        });
      });
    };

    this.updateStateFromSerialization = function (e) {
      _this44.updateStateFromHistory(e);
    };

    this.editor = e, this.adjustmentsStore = new Ei(this.editor.engineMediator), this.selectedOption = "";
    var t = this.editor.assetProvider.getAssets("adjustment");
    this.entityManager = new ee(t, f(f({}, this.config), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      locale: f(f({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("adjustment")
    }));
  }

  _createClass(H, [{
    key: "selectedAdjustmentType",
    get: function get() {
      return this.selectedOption;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this.dirty.get();
    }
  }, {
    key: "state",
    get: function get() {
      return this.adjustmentsStore.state;
    }
  }, {
    key: "selectedOptionLabel",
    get: function get() {
      var _this45 = this;

      var e = this.items.find(function (t) {
        return t ? t.identifier === _this45.selectedOption : !1;
      });
      return e ? e.name : "";
    }
  }, {
    key: "brightness",
    get: function get() {
      return this.state.brightness;
    }
  }, {
    key: "saturation",
    get: function get() {
      return this.state.saturation;
    }
  }, {
    key: "contrast",
    get: function get() {
      return this.state.contrast;
    }
  }, {
    key: "gamma",
    get: function get() {
      return this.state.gamma;
    }
  }, {
    key: "clarity",
    get: function get() {
      return this.state.clarity;
    }
  }, {
    key: "exposure",
    get: function get() {
      return this.state.exposure;
    }
  }, {
    key: "shadows",
    get: function get() {
      return this.state.shadows;
    }
  }, {
    key: "highlights",
    get: function get() {
      return this.state.highlights;
    }
  }, {
    key: "whites",
    get: function get() {
      return this.state.whites;
    }
  }, {
    key: "blacks",
    get: function get() {
      return this.state.blacks;
    }
  }, {
    key: "temperature",
    get: function get() {
      return this.state.temperature;
    }
  }, {
    key: "sharpness",
    get: function get() {
      return this.state.sharpness;
    }
  }, {
    key: "categories",
    get: function get() {
      return this.entityManager.categories;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.ADJUSTMENT];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.ADJUSTMENT];
    }
  }]);

  return H;
}();

a([S], H.prototype, "selectedOption", 2), a([S], H.prototype, "dirty", 2), a([d], H.prototype, "editAdjustments", 2), a([d], H.prototype, "toggleOptionSelection", 2), a([d], H.prototype, "pureSetAdjustment", 2), a([d], H.prototype, "pureReset", 2), a([d], H.prototype, "reset", 2), a([d], H.prototype, "updateStateFromHistory", 2), a([d], H.prototype, "updateStateFromSerialization", 2), a([u], H.prototype, "selectedAdjustmentType", 1), a([u], H.prototype, "isDirty", 1), a([u], H.prototype, "state", 1), a([u], H.prototype, "selectedOptionLabel", 1), a([u], H.prototype, "brightness", 1), a([u], H.prototype, "saturation", 1), a([u], H.prototype, "contrast", 1), a([u], H.prototype, "gamma", 1), a([u], H.prototype, "clarity", 1), a([u], H.prototype, "exposure", 1), a([u], H.prototype, "shadows", 1), a([u], H.prototype, "highlights", 1), a([u], H.prototype, "whites", 1), a([u], H.prototype, "blacks", 1), a([u], H.prototype, "temperature", 1), a([u], H.prototype, "sharpness", 1), a([u], H.prototype, "categories", 1), a([u], H.prototype, "items", 1), a([u], H.prototype, "config", 1), a([u], H.prototype, "locale", 1);
var eo = {
  identifier: "identity",
  intensity: 1,
  isDuotone: !1
};

var Up = new Dt(0, 1),
    Ht =
/*#__PURE__*/
function () {
  function Ht(e) {
    var _this46 = this;

    _classCallCheck(this, Ht);

    this.changeIdentifier = function (e) {
      _this46.state.identifier = e;
    };

    this.changeIfDuotone = function (e) {
      _this46.state.isDuotone = e;
    };

    this.changeIntensity = function (e) {
      var t = Up.clamp(e);
      _this46.state.intensity = t;
    };

    this.reset = function () {
      _this46.indexInContainer === -1 && (_this46.state.identifier = eo.identifier, _this46.state.intensity = eo.intensity, _this46.removeIndex());
    };

    this.setFilterEffect = function (_ref11) {
      var e = _ref11.identifier,
          t = _ref11.intensity,
          r = _ref11.isDuotone;
      var o = _this46.state;
      _this46.changeIdentifier(e), _this46.changeIntensity(t), _this46.changeIfDuotone(r), _this46.removeFilterEffect();

      var n = _this46.engineMediator.orderHelper.addIndex(g.FILTER);

      return r ? new Promise(function (s, l) {
        _this46.engineMediator.engine.addDuoToneFilterFromAssets(e, _this46.engineMediator.image.container, n).then(function (c) {
          _this46.effect = c, _this46.effect.setProperties({
            colorIntensity: t
          }), s();
        }).catch(function (c) {
          _this46.fallbackOnError(o), l(c);
        });
      }) : new Promise(function (s, l) {
        _this46.engineMediator.engine.addLUTFilterFromAssets(e, _this46.engineMediator.image.container, n).then(function (c) {
          _this46.effect = c, _this46.effect.setProperties({
            intensity: t
          }), s();
        }).catch(function (c) {
          _this46.fallbackOnError(o), l(c);
        });
      });
    };

    this.removeFilterEffect = function () {
      _this46.effect && (_this46.engineMediator.engine.removeEffect(_this46.effect), _this46.indexInContainer === -1 && (_this46.effect = void 0));
    };

    this.setEffectProperties = function (_ref12) {
      var e = _ref12.intensity;
      return _this46.effect ? (_this46.state.isDuotone ? _this46.effect.setProperties({
        colorIntensity: e
      }) : _this46.effect.setProperties({
        intensity: e
      }), _this46.effect.getProperties()) : null;
    };

    this.removeIndex = function () {
      _this46.engineMediator.orderHelper.removeIndex(g.FILTER);
    };

    this.fallbackOnError = function (e) {
      _this46.changeIdentifier(e.identifier), _this46.changeIntensity(e.intensity), e.identifier === "identity" && _this46.removeIndex();
    };

    this.engineMediator = e, this.state = eo;
  }

  _createClass(Ht, [{
    key: "indexInContainer",
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    }
  }]);

  return Ht;
}();

a([S], Ht.prototype, "state", 2), a([d], Ht.prototype, "changeIdentifier", 2), a([d], Ht.prototype, "changeIfDuotone", 2), a([d], Ht.prototype, "changeIntensity", 2), a([d], Ht.prototype, "reset", 2);

var rs = "identity",
    te =
/*#__PURE__*/
function () {
  function te(e) {
    var _this47 = this;

    _classCallCheck(this, te);

    this.selectFilter = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return C(_this47, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.t0 = e !== this.identifier;

                if (!_context14.t0) {
                  _context14.next = 6;
                  break;
                }

                _context14.next = 4;
                return this.filterStore.setFilterEffect({
                  identifier: e,
                  intensity: t,
                  isDuotone: this.isOptionDuoTone(e)
                });

              case 4:
                this.editor.render();
                this.addSnapshot(F.ADD, g.FILTER);

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    };

    this.changeIntensity = function (e) {
      var t = _this47.isOptionDuoTone(_this47.identifier),
          r = _this47.filterStore.setEffectProperties({
        intensity: e
      });

      if (r) {
        var o = t ? r.colorIntensity : r.intensity;
        _this47.filterStore.changeIntensity(o), _this47.editor.render();
      }
    };

    this.setImageAndGetPreviews = function () {
      return C(_this47, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var e;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                e = this.editor.activeStore.state.image;
                _context15.next = 3;
                return this.editor.previewThumbnails.addImageToContainer(e);

              case 3:
                _context15.next = 5;
                return this.getAllFilterPreview();

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    };

    this.getAllFilterPreview = function () {
      return C(_this47, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16() {
        var _this48 = this;

        var e, t, r, o;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                e = this.entityManager.items.map(function (n) {
                  return {
                    identifier: n.identifier,
                    isDuotone: _this48.isOptionDuoTone(n.identifier)
                  };
                });
                _context16.next = 3;
                return this.editor.previewThumbnails.getAllFilterPreviewThumbnails(e);

              case 3:
                t = _context16.sent;
                _context16.next = 6;
                return this.editor.wait();

              case 6:
                r = this.config, o = this.editor.configStore.assetProvider.getAssets("filter").map(function (n) {
                  return f(f({}, n), {
                    items: n.items.map(function (s) {
                      return f(f({}, s), {
                        thumbnailURI: t[s.identifier]
                      });
                    })
                  });
                });
                this.entityManager = new ee(o, f(f({}, r), {
                  categoryKey: "thumbnailURI",
                  itemKey: "thumbnailURI",
                  locale: this.locale.items,
                  getAssetPath: this.editor.getAssetPath("filter")
                }));

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    };

    this.toolSnapshot = function () {
      _this47.addSnapshot(F.EDIT, _this47.locale.controls.sliderIntensity);
    };

    this.addSnapshot = function (e, t) {
      _this47.editor.addSnapshot(void 0, e, t);
    };

    this.pureReset = function () {
      _this47.selectedCategory = rs, _this47.filterStore.removeFilterEffect(), _this47.filterStore.reset();
    };

    this.reset = function () {
      _this47.pureReset(), _this47.addSnapshot(F.DELETE, _this47.locale.controls.buttonReset), _this47.editor.render();
    };

    this.toggleCategorySelection = function (e) {
      _this47.selectedCategory = _this47.selectedCategory === e ? rs : e;
    };

    this.updateStateFromSerialization = function (_ref13) {
      var e = _ref13.identifier,
          t = _ref13.intensity;

      var r = _this47.doesFilterAssetExist(e);

      if (r) {
        var o = $r(r);
        return _this47.filterStore.setFilterEffect({
          identifier: e,
          intensity: t,
          isDuotone: o
        });
      }

      return new Promise(function (o, n) {
        n(new Error("Filter Asset ".concat(e, " doesn't exist")));
      });
    };

    this.updateStateFromHistory = function (e) {
      return C(_this47, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", e.identifier === "identity" ? (this.pureReset(), new Promise(function (t) {
                  t();
                })) : this.filterStore.setFilterEffect(e));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    };

    this.doesFilterAssetExist = function (e) {
      return _this47.entityManager.items.find(function (t) {
        return e === t.identifier;
      });
    };

    this.isOptionDuoTone = function (e) {
      var t = _this47.doesFilterAssetExist(e);

      return t ? $r(t) : !1;
    };

    this.editor = e, this.selectedCategory = rs, this.filterStore = new Ht(this.editor.engineMediator);
    var t = this.config,
        r = this.editor.configStore.assetProvider.getAssets("filter");
    this.entityManager = new ee(r, f(f({}, t), {
      categoryKey: "thumbnailURI",
      itemKey: "thumbnailURI",
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("filter")
    }));
  }

  _createClass(te, [{
    key: "state",
    get: function get() {
      return this.filterStore.state;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.state.identifier;
    }
  }, {
    key: "intensity",
    get: function get() {
      return this.state.intensity;
    }
  }, {
    key: "isDuotone",
    get: function get() {
      return this.state.isDuotone;
    }
  }, {
    key: "selectedCategoryIdentifier",
    get: function get() {
      return this.selectedCategory;
    }
  }, {
    key: "isOptionSelected",
    get: function get() {
      return this.identifier !== "identity";
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.FILTER];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.FILTER];
    }
  }, {
    key: "categories",
    get: function get() {
      return this.entityManager.categories;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }]);

  return te;
}();

a([S], te.prototype, "selectedCategory", 2), a([S], te.prototype, "entityManager", 2), a([d], te.prototype, "selectFilter", 2), a([d], te.prototype, "changeIntensity", 2), a([d], te.prototype, "pureReset", 2), a([d], te.prototype, "reset", 2), a([d], te.prototype, "toggleCategorySelection", 2), a([d], te.prototype, "updateStateFromSerialization", 2), a([d], te.prototype, "updateStateFromHistory", 2), a([u], te.prototype, "state", 1), a([u], te.prototype, "identifier", 1), a([u], te.prototype, "intensity", 1), a([u], te.prototype, "isDuotone", 1), a([u], te.prototype, "selectedCategoryIdentifier", 1), a([u], te.prototype, "isOptionSelected", 1), a([u], te.prototype, "config", 1), a([u], te.prototype, "locale", 1), a([u], te.prototype, "categories", 1), a([u], te.prototype, "items", 1);

function os(i) {
  return i && typeof i == "object" && Object.prototype.toString.call(i) !== "[object RegExp]" && Object.prototype.toString.call(i) !== "[object Date]";
}

function Np(i) {
  return Array.isArray(i) ? [] : {};
}

function ss(i, e) {
  return e && e.clone === !0 && os(i) ? ns(Np(i), i, e) : i;
}

function Hp(i, e, t) {
  var r = {};
  return os(i) && Object.keys(i).forEach(function (o) {
    r[o] = ss(i[o], t);
  }), Object.keys(e).forEach(function (o) {
    var n = os(e[o]) && i[o];
    r[o] = n ? ns(i[o], e[o], t) : ss(e[o], t);
  }), r;
}

function ns(i, e, t) {
  return Array.isArray(e) ? Array.isArray(i) ? e : ss(e, t) : Hp(i, e, t);
}

function Wt(i) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!Array.isArray(i) || i.length < 2) throw new Error("first argument should be an array with at least two elements");
  return i.reduce(function (t, r) {
    return ns(t, r, e);
  });
}

var as =
/*#__PURE__*/
function (_Xi3) {
  _inherits(as, _Xi3);

  function as() {
    _classCallCheck(this, as);

    return _possibleConstructorReturn(this, _getPrototypeOf(as).apply(this, arguments));
  }

  _createClass(as, [{
    key: "onExport",
    value: function onExport(e) {
      this.emit(jt.EXPORT, e);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.emit(jt.CLOSE);
    }
  }, {
    key: "onHistoryChange",
    value: function onHistoryChange() {
      this.emit(jt.HISTORY_CHANGE);
    }
  }, {
    key: "onEditorReady",
    value: function onEditorReady() {
      this.emit(jt.EDITOR_READY);
    }
  }, {
    key: "onErrorImageLoading",
    value: function onErrorImageLoading(e) {
      this.emit(jt.ERROR_IMAGE_LOADING, e);
    }
  }, {
    key: "onImageLoaded",
    value: function onImageLoaded() {
      this.emit(jt.IMAGE_LOAD);
    }
  }, {
    key: "onStickerUploadedAdd",
    value: function onStickerUploadedAdd(e) {
      this.emit(jt.STICKER_UPLOAD_ADD, e);
    }
  }, {
    key: "onToolChanged",
    value: function onToolChanged(e) {
      this.emit(jt.TOOL_ENTER, e);
    }
  }]);

  return as;
}(Xi);

var ls = {
  common: {
    error: "Fehler",
    warning: "Warnung",
    color: {
      colorPicker: {
        hex: "Hex",
        r: "R",
        g: "G",
        b: "B",
        sliderHue: "Farbe",
        sliderOpacity: "Farbe Transparenz"
      }
    }
  },
  mainCanvasActions: {
    buttonExport: "Bild Exportieren",
    buttonUndo: "R\xFCckg\xE4ngig machen",
    buttonRedo: "Wiederholen",
    buttonClose: "Schlie\xDFen"
  },
  infoModals: {
    exporting: {
      heading: "Exportieren...",
      body: "Einen Moment bitte..."
    },
    saving: {
      heading: "Speichere...",
      body: "Einen Moment bitte..."
    },
    loading: {
      heading: "Lade...",
      body: "Einen Moment bitte..."
    },
    resizing: {
      heading: "Bild wird bearbeitet...",
      body: "Einen Moment bitte..."
    },
    loadingFonts: {
      heading: "Lade Schriftarten...",
      body: "Einen Moment bitte..."
    },
    stickerLoading: {
      heading: "Lade Sticker...",
      body: "Einen Moment bitte..."
    }
  },
  errorModals: {
    imageLoading: {
      headingDelimiter: ":",
      body: "Laden des Bildes fehlgeschlagen. Dies kann verschiedene Gr\xFCnde haben, beispielsweise kann die Datei defekt sein oder der Dateityp wird nicht unterst\xFCtzt",
      buttonYes: "Neu Laden"
    },
    rendering: {
      headingDelimiter: ":",
      body: "Beim Rendern des Bildes ist ein Fehler aufgetreten",
      buttonYes: "Neu Laden"
    },
    fontLoading: {
      headingDelimiter: ":",
      heading: "Laden von Schriftarten ist fehlgeschlagen",
      body: "Die folgenden Schriftarten konnten nicht geladen werden: ${error}",
      buttonNo: "Schlie\xDFen"
    },
    webcamUnavailable: {
      headingDelimiter: ":",
      body: "Webcam-Bild kann nicht dargestellt werden. (Fehler: ${error})",
      buttonYes: "Schlie\xDFen"
    },
    stickerLoading: {
      headingDelimiter: ":",
      body: "Laden des Stickers fehlgeschlagen.",
      buttonNo: "Schlie\xDFen"
    },
    unexpectedError: {
      headingDelimiter: ":",
      body: "Ein unerwarteter Fehler ist aufgetreten, ${error}",
      buttonYes: "Neu Laden"
    }
  },
  warningModals: {
    imageResized: {
      headingDelimiter: ":",
      heading: "Bild verkleinert",
      body: "Ihr Bild \xFCbersteigt die maximale Gr\xF6sse von ${megapixels} megapixels und wurde auf ${width}x${height} Pixel verkleinert",
      buttonYes: "Weiter"
    },
    discardChanges: {
      headingDelimiter: ":",
      body: "Sind Sie sicher, dass Sie die \xC4nderungen verwerfen wollen?",
      buttonYes: "\xC4nderungen verwerfen",
      buttonNo: "\xC4nderungen beibehalten"
    },
    unsavedChanges: {
      headingDelimiter: ":",
      body: "Sind Sie sicher, dass Sie die \xC4nderungen verwerfen wollen?",
      buttonYes: "Beenden ohne zu speichern",
      buttonNo: "Schlie\xDFen"
    },
    unsupportedSerializationVersion: {
      headingDelimiter: ":",
      body: "Ihre Daten wurden von einem veralteten Format geladen und k\xF6nnten anders aussehen",
      buttonYes: "\xC4nderungen anwenden",
      buttonNo: "Abbrechen"
    },
    unsupportedWebGLRenderer: {
      body: "Es wurde ein Problem im Browser festgestellt, welches zu langen Ladezeiten f\xFChren kann. Bitte probieren sie einen anderen Browser.",
      buttonYes: "Weiter"
    }
  },
  library: {
    title: "Bibliothek",
    controls: {
      buttonUpload: "Bild Hochladen",
      buttonWebcamOpen: "Webcam \xD6ffnen",
      buttonWebcamClose: "Webcam Schlie\xDFen",
      placeholderSearch: "Bibliothek durchsuchen",
      noResults: "Keine Ergebnisse"
    }
  },
  filter: {
    title: "Filter",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      sliderIntensity: "Filter Intensit\xE4t"
    },
    categories: (_categories = {}, _defineProperty(_categories, De.DuoTone, "DuoTone"), _defineProperty(_categories, De.BW, "B & W"), _defineProperty(_categories, De.Vintage, "Vintage"), _defineProperty(_categories, De.Smooth, "Smooth"), _defineProperty(_categories, De.Cold, "Cold"), _defineProperty(_categories, De.Warm, "Warm"), _defineProperty(_categories, De.Legacy, "Legacy"), _categories),
    items: (_items = {}, _defineProperty(_items, y.Inferno, "Inferno"), _defineProperty(_items, y.Chestnut, "Chestnut"), _defineProperty(_items, y.Fixie, "Fixie"), _defineProperty(_items, y.Fridge, "Fridge"), _defineProperty(_items, y.Sunny70s, "Sunny 70s"), _defineProperty(_items, y.FlatBlack, "Flat Black"), _defineProperty(_items, y.Mellow, "Mellow"), _defineProperty(_items, y.HardStuff, "Hard Stuff"), _defineProperty(_items, y.Oldtimer, "Oldtimer"), _defineProperty(_items, y.AD1920, "1920 A.D."), _defineProperty(_items, y.Ancient, "Ancient"), _defineProperty(_items, y.Kalmen, "Kalmen"), _defineProperty(_items, y.Joran, "Joran"), _defineProperty(_items, y.Polaroid, "Polaroid"), _defineProperty(_items, y.Zephyr, "Zephyr"), _defineProperty(_items, y.Levante, "Levante"), _defineProperty(_items, y.Greyed, "Greyed"), _defineProperty(_items, y.Classic, "Classic"), _defineProperty(_items, y.Colorful, "Colorful"), _defineProperty(_items, y.Snappy, "Snappy"), _defineProperty(_items, y.Candy, "Candy"), _defineProperty(_items, y.Creamy, "Creamy"), _defineProperty(_items, y.LowFire, "Low Fire"), _defineProperty(_items, y.Colla, "Colla"), _defineProperty(_items, y.Sunrise, "Sunrise"), _defineProperty(_items, y.Moss, "Moss"), _defineProperty(_items, y.Food, "Food"), _defineProperty(_items, y.Glam, "Glam"), _defineProperty(_items, y.Gobblin, "Gobblin"), _defineProperty(_items, y.HighCarb, "High Carb"), _defineProperty(_items, y.Hicon, "Hicon"), _defineProperty(_items, y.K1, "K1"), _defineProperty(_items, y.K6, "K6"), _defineProperty(_items, y.Pebble, "Pebble"), _defineProperty(_items, y.Keen, "Keen"), _defineProperty(_items, y.Lemon, "Lemon"), _defineProperty(_items, y.Litho, "Litho"), _defineProperty(_items, y.Lomo, "Lomo"), _defineProperty(_items, y.Lomo100, "Lomo 100"), _defineProperty(_items, y.Lucid, "Lucid"), _defineProperty(_items, y.Neat, "Neat"), _defineProperty(_items, y.Pumpkin, "Pumpkin"), _defineProperty(_items, y.Solanus, "Solanus"), _defineProperty(_items, y.Pale, "Pale"), _defineProperty(_items, y.Pitched, "Pitched"), _defineProperty(_items, y.Weathered, "Weathered"), _defineProperty(_items, y.GreenGap, "Green Gap"), _defineProperty(_items, y.PolaSX, "Pola SX"), _defineProperty(_items, y.Pro400, "Pro 400"), _defineProperty(_items, y.Quozi, "Quozi"), _defineProperty(_items, y.Sepia, "Sepia"), _defineProperty(_items, y.Settled, "Settled"), _defineProperty(_items, y.Seventies, "Seventies"), _defineProperty(_items, y.Soft, "Soft"), _defineProperty(_items, y.Steel, "Steel"), _defineProperty(_items, y.Summer, "Summer"), _defineProperty(_items, y.Golden, "Golden"), _defineProperty(_items, y.Tender, "Tender"), _defineProperty(_items, y.Twilight, "Twilight"), _defineProperty(_items, y.Softy, "Softy"), _defineProperty(_items, y.Dusty, "Dusty"), _defineProperty(_items, y.Desert, "Desert"), _defineProperty(_items, y.Peach, "Peach"), _defineProperty(_items, y.Clash, "Clash"), _defineProperty(_items, y.Plum, "Plum"), _defineProperty(_items, y.Breezy, "Breezy"), _defineProperty(_items, y.DeepBlue, "Deep Blue"), _defineProperty(_items, y.Frog, "Frog"), _defineProperty(_items, y.Sunset, "Sunset"), _items)
  },
  adjustment: {
    title: "Korrekturen",
    controls: {
      buttonReset: "Zur\xFCcksetzen"
    },
    categories: {
      basics: "Grundlagen",
      refinements: "Feinheiten"
    },
    items: {
      brightness: "Helligkeit",
      saturation: "S\xE4ttigung",
      contrast: "Kontrast",
      gamma: "Gamma",
      sharpness: "Sch\xE4rfe",
      clarity: "Klarheit",
      exposure: "Belichtung",
      shadows: "Schatten",
      highlights: "Lichter",
      whites: "Wei\xDF",
      blacks: "Schwarz",
      temperature: "Temperatur"
    }
  },
  focus: {
    title: "Weichzeichnen",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      sliderIntensity: "Focus Intensit\xE4t"
    },
    items: {
      radial: "Kreisf\xF6rmig",
      mirrored: "Gespiegelt",
      linear: "Linear",
      gaussian: "Gau\xDFsch"
    },
    history: {
      focusPosition: "Focus Position",
      focusSize: "Focus Gr\xF6\xDFe"
    }
  },
  overlay: {
    title: "Overlays",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      sliderOpacity: "Overlay Transparenz",
      carouselBlendMode: "Overlay Mischmodus",
      blendModeNormal: "Normal",
      blendModeOverlay: "\xDCberblenden",
      blendModeHardLight: "Hartes Licht",
      blendModeSoftLight: "Weiches Licht",
      blendModeMultiply: "Multiplizieren",
      blendModeDarken: "Abdunkeln",
      blendModeLighten: "Aufhellen",
      blendModeScreen: "Screen",
      blendModeColorBurn: "Color Burn",
      tabOpacity: "Transparenz",
      tabBlendMode: "Mischmodus"
    },
    items: (_items2 = {}, _defineProperty(_items2, L.Bokeh, "Bokeh"), _defineProperty(_items2, L.Chop, "Chop"), _defineProperty(_items2, L.Clouds, "Clouds"), _defineProperty(_items2, L.Golden, "Golden"), _defineProperty(_items2, L.Grain, "Grain"), _defineProperty(_items2, L.Hearts, "Hearts"), _defineProperty(_items2, L.LightLeak1, "Light Leak 1"), _defineProperty(_items2, L.LightLeak2, "Light Leak 2"), _defineProperty(_items2, L.Metal, "Metal"), _defineProperty(_items2, L.Mosaic, "Mosaic"), _defineProperty(_items2, L.Painting, "Painting"), _defineProperty(_items2, L.Paper, "Paper"), _defineProperty(_items2, L.Rain, "Rain"), _defineProperty(_items2, L.Vintage, "Vintage"), _defineProperty(_items2, L.Wall1, "Wall"), _defineProperty(_items2, L.Wall2, "Wall 2"), _defineProperty(_items2, L.Wood, "Wood"), _items2)
  },
  sticker: {
    title: "Sticker",
    controls: {
      buttonUpload: "Sticker Hochladen",
      sliderOpacity: "Sticker Transparenz",
      selectColor: "Stickerfarbe",
      tabColor: "Farbe",
      tabOpacity: "Transparenz"
    },
    categories: {
      imgly_sticker_emoticons: "Emoticons",
      imgly_sticker_shapes: "Shapes",
      imgly_sticker_custom: "Custom"
    },
    items: {
      imgly_sticker_emoticons_alien: "Alien",
      imgly_sticker_emoticons_angel: "Angel",
      imgly_sticker_emoticons_angry: "Angry",
      imgly_sticker_emoticons_anxious: "Anxious",
      imgly_sticker_emoticons_asleep: "Asleep",
      imgly_sticker_emoticons_attention: "Attention",
      imgly_sticker_emoticons_baby_chicken: "Baby Chicken",
      imgly_sticker_emoticons_batman: "Batman",
      imgly_sticker_emoticons_beer: "Beer",
      imgly_sticker_emoticons_black: "Black",
      imgly_sticker_emoticons_blue: "Blue",
      imgly_sticker_emoticons_blush: "Blush",
      imgly_sticker_emoticons_boxer: "Boxer",
      imgly_sticker_emoticons_business: "Business",
      imgly_sticker_emoticons_chicken: "Chicken",
      imgly_sticker_emoticons_cool: "Cool",
      imgly_sticker_emoticons_cry: "Cry",
      imgly_sticker_emoticons_deceased: "Deceased",
      imgly_sticker_emoticons_devil: "Devil",
      imgly_sticker_emoticons_duckface: "Duckface",
      imgly_sticker_emoticons_furious: "Furious",
      imgly_sticker_emoticons_grin: "Grin",
      imgly_sticker_emoticons_guitar: "Guitar",
      imgly_sticker_emoticons_harry_potter: "Harry Potter",
      imgly_sticker_emoticons_hippie: "Hippie",
      imgly_sticker_emoticons_hitman: "Hitman",
      imgly_sticker_emoticons_humourous: "Humourous",
      imgly_sticker_emoticons_idea: "Idea",
      imgly_sticker_emoticons_impatient: "Impatient",
      imgly_sticker_emoticons_kiss: "Kiss",
      imgly_sticker_emoticons_kisses: "Kisses",
      imgly_sticker_emoticons_laugh: "Laugh",
      imgly_sticker_emoticons_loud_cry: "Loud Cry",
      imgly_sticker_emoticons_loving: "Loving",
      imgly_sticker_emoticons_masked: "Masked",
      imgly_sticker_emoticons_music: "Music",
      imgly_sticker_emoticons_nerd: "Nerd",
      imgly_sticker_emoticons_ninja: "Ninja",
      imgly_sticker_emoticons_not_speaking_to_you: "Not speaking to you",
      imgly_sticker_emoticons_pig: "Pig",
      imgly_sticker_emoticons_pumpkin: "Pumpkin",
      imgly_sticker_emoticons_question: "Question",
      imgly_sticker_emoticons_rabbit: "Rabbit",
      imgly_sticker_emoticons_sad: "Sad",
      imgly_sticker_emoticons_sick: "Sick",
      imgly_sticker_emoticons_skateboard: "Skateboard",
      imgly_sticker_emoticons_skull: "Skull",
      imgly_sticker_emoticons_sleepy: "Sleepy",
      imgly_sticker_emoticons_smile: "Smile",
      imgly_sticker_emoticons_smoking: "Smoking",
      imgly_sticker_emoticons_sobbing: "Sobbing",
      imgly_sticker_emoticons_star: "Star",
      imgly_sticker_emoticons_steaming_furious: "Steaming Furious",
      imgly_sticker_emoticons_sunbathing: "Sunbathing",
      imgly_sticker_emoticons_tired: "Tired",
      imgly_sticker_emoticons_tongue_out_wink: "Tongue out wink",
      imgly_sticker_emoticons_wave: "Wave",
      imgly_sticker_emoticons_wide_grin: "Wide Grin",
      imgly_sticker_emoticons_wink: "Wink",
      imgly_sticker_emoticons_wrestler: "Wrestler",
      imgly_sticker_shapes_arrow_02: "Arrow 1",
      imgly_sticker_shapes_arrow_03: "Arrow 2",
      imgly_sticker_shapes_badge_01: "Badge 1",
      imgly_sticker_shapes_badge_11: "Badge 5",
      imgly_sticker_shapes_badge_12: "Badge 6",
      imgly_sticker_shapes_badge_13: "Badge 7",
      imgly_sticker_shapes_badge_15: "Badge 8",
      imgly_sticker_shapes_badge_18: "Badge 9",
      imgly_sticker_shapes_badge_19: "Badge 10",
      imgly_sticker_shapes_badge_20: "Badge 11",
      imgly_sticker_shapes_badge_28: "Badge 12",
      imgly_sticker_shapes_badge_32: "Badge 13",
      imgly_sticker_shapes_badge_35: "Badge 14",
      imgly_sticker_shapes_badge_36: "Badge 15",
      imgly_sticker_shapes_badge_04: "Badge 2",
      imgly_sticker_shapes_badge_06: "Badge 3",
      imgly_sticker_shapes_badge_08: "Badge 4",
      imgly_sticker_shapes_spray_01: "Spray 1",
      imgly_sticker_shapes_spray_03: "Spray 2",
      imgly_sticker_shapes_spray_04: "Spray 3"
    },
    canvasActions: {
      buttonDelete: "L\xF6schen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren",
      buttonFlipHorizontal: "Horizontal spiegeln",
      buttonFlipVertical: "Vertikal spiegeln"
    },
    history: {
      add: "Sticker",
      resize: "Sticker resize",
      position: "Sticker position",
      color: "Sticker color",
      delete: "Sticker delete",
      order: "Sticker order",
      opacity: "Sticker opacity",
      flip: "Sticker flip"
    }
  },
  text: {
    title: "Text",
    controls: {
      buttonNew: "Neuer Text",
      dropdownFontFamily: "Schriftart",
      textFontSize: "Schriftgr\xF6\xDFe",
      selectAlignment: "Ausrichtung",
      selectFontColor: "Schriftfarbe",
      selectBackgroundColor: "Hintergrundfarbe",
      sliderLineSpacing: "Zeilenabstand",
      tabColor: "Farbe",
      tabBgColor: "Hintergrund",
      tabAlignment: "Ausrichtung",
      tabLineHeight: "Zeilenh\xF6he",
      tabFontSize: "Schriftgr\xF6\xDFe"
    },
    canvasControls: {
      placeholderText: "Etwas aufschreiben",
      buttonSave: "Fertig",
      buttonClose: "Abbrechen",
      inputText: "Texteingabe"
    },
    canvasActions: {
      buttonEdit: "Bearbeiten",
      buttonDelete: "L\xF6schen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren"
    },
    history: {
      add: "Text",
      edit: "Text edit",
      resize: "Text resize",
      position: "Text position",
      alignment: "Text alignment",
      textColor: "Text color",
      backgroundColor: "Text background color",
      fontFamily: "Font family",
      fontStyle: "Font style",
      lineSpacing: "Line spacing",
      width: "Text width",
      delete: "Text delete",
      order: "Text order"
    }
  },
  textdesign: {
    title: "Text Design",
    controls: {
      buttonNew: "Neues Text Design",
      buttonShuffle: "Shuffle Layout",
      selectColor: "Textfarbe",
      tabColor: "Farbe",
      tabShuffle: "Shuffle"
    },
    canvasControls: {
      placeholderText: "Etwas aufschreiben mit Style",
      buttonSave: "Done",
      buttonClose: "Schlie\xDFen",
      inputText: "Texteingabe"
    },
    canvasActions: {
      buttonEdit: "Bearbeiten",
      buttonInvert: "Invertieren",
      buttonDelete: "L\xF6schen",
      buttonBringToFront: "In den Vordergrund",
      buttonDuplicate: "Duplizieren"
    },
    history: {
      add: "Text design",
      edit: "Text design edit",
      resize: "Text design resize",
      position: "Text design position",
      color: "Text design color",
      shuffle: "Text design shuffle",
      invert: "Text design invert",
      padding: "Text design padding",
      order: "Text design order",
      delete: "Text design delete"
    }
  },
  frame: {
    title: "Rahmen",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      sliderOpacity: "Rahmen Transparenz",
      sliderSize: "Rahmen Dicke",
      selectColor: "Rahmen Farbe",
      tabColor: "Farbe",
      tabOpacity: "Transparenz",
      tabSize: "Dicke"
    },
    items: {
      imgly_frame_dia: "Dia",
      imgly_frame_art_decor: "Art Decor",
      imgly_frame_black_passepartout: "Black",
      imgly_frame_lowpoly_shadow: "Low Poly",
      imgly_frame_wood_passepartout: "Wood"
    }
  },
  brush: {
    title: "Malen",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      sliderSize: "Dicke",
      sliderHardness: "H\xE4rte",
      selectColor: "Farbe",
      tabSize: "Dicke",
      tabHardness: "H\xE4rte",
      tabColor: "Farbe"
    },
    history: {
      brushStroke: "Brush Stroke"
    }
  },
  transform: {
    title: "Zuschneiden",
    controls: {
      buttonReset: "Zur\xFCcksetzen",
      checkboxKeepResolution: "Fixiere Aufl\xF6sung",
      inputCropSize: "Bildgr\xF6\xDFe",
      inputHeight: "h",
      inputWidth: "b",
      tabFlipAndRotate: "Spiegeln & Drehen",
      tabResolution: "Aufl\xF6sung",
      tabCropSize: "Bildgr\xF6\xDFe"
    },
    categories: {
      imgly_transforms_common: "Standard",
      imgly_transforms_facebook: "Facebook",
      imgly_transforms_twitter: "Twitter",
      imgly_transforms_instagram: "Instagram"
    },
    items: {
      imgly_transform_common_custom: "Frei",
      imgly_transform_common_square: "Quadratisch",
      imgly_transform_common_4: "4:3",
      imgly_transform_common_16: "16:9",
      imgly_transform_common_3: "3:4",
      imgly_transform_common_9: "9:16",
      imgly_transform_facebook_profile: "Profile",
      imgly_transform_facebook_title: "Titel",
      imgly_transform_facebook_post: "Post",
      imgly_transform_instagram_story: "Story",
      imgly_transform_instagram_landscape: "Landscape",
      imgly_transform_instagram_portrait: "Portrait",
      imgly_transform_instagram_square: "Square",
      imgly_transform_twitter_profile: "Profile",
      imgly_transform_twitter_title: "Title",
      imgly_transform_twitter_post: "Post"
    },
    transformActions: {
      buttonFlipHorizontal: "Horizontal spiegeln",
      buttonFlipVertical: "Vertikal spiegeln",
      buttonRotateClockwise: "Drehe im Uhrzeigersinn",
      buttonRotateAntiClockwise: "Drehe gegen Uhrzeigersinn"
    }
  }
};
var ni = {
  common: {
    error: "Error",
    warning: "Warning",
    color: {
      colorPicker: {
        hex: "Hex",
        r: "R",
        g: "G",
        b: "B",
        sliderHue: "Color",
        sliderOpacity: "Color Opacity"
      }
    }
  },
  mainCanvasActions: {
    buttonExport: "Export Image",
    buttonUndo: "Undo",
    buttonRedo: "Redo",
    buttonClose: "Close"
  },
  infoModals: {
    exporting: {
      heading: "Exporting...",
      body: "Just a few seconds..."
    },
    saving: {
      heading: "Saving...",
      body: "Just a few seconds..."
    },
    loading: {
      heading: "Loading...",
      body: "Just a few seconds..."
    },
    resizing: {
      heading: "Resizing...",
      body: "Just a few seconds..."
    },
    loadingFonts: {
      heading: "Loading Fonts...",
      body: "Just a few seconds..."
    },
    stickerLoading: {
      heading: "Loading Sticker...",
      body: "Just a few seconds..."
    }
  },
  errorModals: {
    imageLoading: {
      headingDelimiter: ":",
      body: "Failed to load image. This can have multiple reasons, e.g. the file is corrupted or the file type is not supported",
      buttonYes: "Reload"
    },
    rendering: {
      headingDelimiter: ":",
      body: "An error has occurred while rendering the image",
      buttonYes: "Reload"
    },
    fontLoading: {
      headingDelimiter: ":",
      heading: "Failed to load font",
      body: "The following fonts could not be loaded: ${error}",
      buttonNo: "Close"
    },
    webcamUnavailable: {
      headingDelimiter: ":",
      body: "Unable to display webcam image (Error: ${error})",
      buttonYes: "Close"
    },
    stickerLoading: {
      headingDelimiter: ":",
      body: "Unable to load the sticker",
      buttonNo: "Close"
    },
    unexpectedError: {
      headingDelimiter: ":",
      body: "An unexpected error has occured ${error}",
      buttonYes: "Reload"
    }
  },
  warningModals: {
    imageResized: {
      headingDelimiter: ":",
      heading: "Image resized",
      body: "Your image exceeds the maximum size of ${megapixels} megapixels and has been resized to ${width}x${height} pixels",
      buttonYes: "Continue"
    },
    unsupportedSerializationVersion: {
      headingDelimiter: ":",
      body: "Your data was restored from a legacy data format and might look different",
      buttonYes: "Apply changes",
      buttonNo: "Cancel"
    },
    discardChanges: {
      headingDelimiter: ":",
      body: "You have unsaved changes. Are you sure you want to discard the changes?",
      buttonYes: "Discard changes",
      buttonNo: "Keep Changes"
    },
    unsavedChanges: {
      headingDelimiter: ":",
      body: "You have unsaved changes. Are you sure you want to exit?",
      buttonYes: "Exit without saving",
      buttonNo: "Cancel"
    },
    unsupportedWebGLRenderer: {
      body: "A problem has been detected in the browser that could cause long loading times. Please try a different browser.",
      buttonYes: "Continue"
    }
  },
  library: {
    title: "Library",
    controls: {
      buttonUpload: "Upload Image",
      buttonWebcamOpen: "Open Webcam",
      buttonWebcamClose: "Close Webcam",
      placeholderSearch: "Search Library",
      noResults: "No Results"
    }
  },
  filter: {
    title: "Filters",
    controls: {
      buttonReset: "Remove Filter",
      sliderIntensity: "Filter Intensity"
    },
    categories: (_categories2 = {}, _defineProperty(_categories2, De.DuoTone, "DuoTone"), _defineProperty(_categories2, De.BW, "B & W"), _defineProperty(_categories2, De.Vintage, "Vintage"), _defineProperty(_categories2, De.Smooth, "Smooth"), _defineProperty(_categories2, De.Cold, "Cold"), _defineProperty(_categories2, De.Warm, "Warm"), _defineProperty(_categories2, De.Legacy, "Legacy"), _categories2),
    items: (_items3 = {}, _defineProperty(_items3, y.Inferno, "Inferno"), _defineProperty(_items3, y.Chestnut, "Chestnut"), _defineProperty(_items3, y.Fixie, "Fixie"), _defineProperty(_items3, y.Fridge, "Fridge"), _defineProperty(_items3, y.Sunny70s, "Sunny 70s"), _defineProperty(_items3, y.FlatBlack, "Flat Black"), _defineProperty(_items3, y.Mellow, "Mellow"), _defineProperty(_items3, y.HardStuff, "Hard Stuff"), _defineProperty(_items3, y.Oldtimer, "Oldtimer"), _defineProperty(_items3, y.AD1920, "1920 A.D."), _defineProperty(_items3, y.Ancient, "Ancient"), _defineProperty(_items3, y.Kalmen, "Kalmen"), _defineProperty(_items3, y.Joran, "Joran"), _defineProperty(_items3, y.Polaroid, "Polaroid"), _defineProperty(_items3, y.Zephyr, "Zephyr"), _defineProperty(_items3, y.Levante, "Levante"), _defineProperty(_items3, y.Greyed, "Greyed"), _defineProperty(_items3, y.Classic, "Classic"), _defineProperty(_items3, y.Colorful, "Colorful"), _defineProperty(_items3, y.Snappy, "Snappy"), _defineProperty(_items3, y.Candy, "Candy"), _defineProperty(_items3, y.Creamy, "Creamy"), _defineProperty(_items3, y.LowFire, "Low Fire"), _defineProperty(_items3, y.Colla, "Colla"), _defineProperty(_items3, y.Sunrise, "Sunrise"), _defineProperty(_items3, y.Moss, "Moss"), _defineProperty(_items3, y.Food, "Food"), _defineProperty(_items3, y.Glam, "Glam"), _defineProperty(_items3, y.Gobblin, "Gobblin"), _defineProperty(_items3, y.HighCarb, "High Carb"), _defineProperty(_items3, y.Hicon, "Hicon"), _defineProperty(_items3, y.K1, "K1"), _defineProperty(_items3, y.K6, "K6"), _defineProperty(_items3, y.Pebble, "Pebble"), _defineProperty(_items3, y.Keen, "Keen"), _defineProperty(_items3, y.Lemon, "Lemon"), _defineProperty(_items3, y.Litho, "Litho"), _defineProperty(_items3, y.Lomo, "Lomo"), _defineProperty(_items3, y.Lomo100, "Lomo 100"), _defineProperty(_items3, y.Lucid, "Lucid"), _defineProperty(_items3, y.Neat, "Neat"), _defineProperty(_items3, y.Pumpkin, "Pumpkin"), _defineProperty(_items3, y.Solanus, "Solanus"), _defineProperty(_items3, y.Pale, "Pale"), _defineProperty(_items3, y.Pitched, "Pitched"), _defineProperty(_items3, y.Weathered, "Weathered"), _defineProperty(_items3, y.GreenGap, "Green Gap"), _defineProperty(_items3, y.PolaSX, "Pola SX"), _defineProperty(_items3, y.Pro400, "Pro 400"), _defineProperty(_items3, y.Quozi, "Quozi"), _defineProperty(_items3, y.Sepia, "Sepia"), _defineProperty(_items3, y.Settled, "Settled"), _defineProperty(_items3, y.Seventies, "Seventies"), _defineProperty(_items3, y.Soft, "Soft"), _defineProperty(_items3, y.Steel, "Steel"), _defineProperty(_items3, y.Summer, "Summer"), _defineProperty(_items3, y.Golden, "Golden"), _defineProperty(_items3, y.Tender, "Tender"), _defineProperty(_items3, y.Twilight, "Twilight"), _defineProperty(_items3, y.Softy, "Softy"), _defineProperty(_items3, y.Dusty, "Dusty"), _defineProperty(_items3, y.Desert, "Desert"), _defineProperty(_items3, y.Peach, "Peach"), _defineProperty(_items3, y.Clash, "Clash"), _defineProperty(_items3, y.Plum, "Plum"), _defineProperty(_items3, y.Breezy, "Breezy"), _defineProperty(_items3, y.DeepBlue, "Deep Blue"), _defineProperty(_items3, y.Frog, "Frog"), _defineProperty(_items3, y.Sunset, "Sunset"), _items3)
  },
  adjustment: {
    title: "Adjust",
    controls: {
      buttonReset: "Reset Adjustment"
    },
    categories: {
      basics: "Basic",
      refinements: "Refinements"
    },
    items: {
      brightness: "Brightness",
      saturation: "Saturation",
      contrast: "Contrast",
      gamma: "Gamma",
      sharpness: "Sharpness",
      clarity: "Clarity",
      exposure: "Exposure",
      shadows: "Shadows",
      highlights: "Highlights",
      whites: "Whites",
      blacks: "Blacks",
      temperature: "Temperature"
    }
  },
  focus: {
    title: "Focus",
    controls: {
      buttonReset: "Remove Focus",
      sliderIntensity: "Focus Intensity"
    },
    items: {
      radial: "Radial",
      mirrored: "Mirrored",
      linear: "Linear",
      gaussian: "Gaussian"
    },
    history: {
      focusPosition: "Focus Position",
      focusSize: "Focus Size"
    }
  },
  overlay: {
    title: "Overlays",
    controls: {
      buttonReset: "Remove Overlay",
      sliderOpacity: "Overlay Opacity",
      carouselBlendMode: "Overlay Blend mode",
      blendModeNormal: "Normal",
      blendModeOverlay: "Overlay",
      blendModeHardLight: "Hard Light",
      blendModeSoftLight: "Soft Light",
      blendModeMultiply: "Multiply",
      blendModeDarken: "Darken",
      blendModeLighten: "Lighten",
      blendModeScreen: "Screen",
      blendModeColorBurn: "Color Burn",
      tabOpacity: "Opacity",
      tabBlendMode: "Blend Mode"
    },
    items: (_items4 = {}, _defineProperty(_items4, L.Bokeh, "Bokeh"), _defineProperty(_items4, L.Chop, "Chop"), _defineProperty(_items4, L.Clouds, "Clouds"), _defineProperty(_items4, L.Golden, "Golden"), _defineProperty(_items4, L.Grain, "Grain"), _defineProperty(_items4, L.Hearts, "Hearts"), _defineProperty(_items4, L.LightLeak1, "Light Leak 1"), _defineProperty(_items4, L.LightLeak2, "Light Leak 2"), _defineProperty(_items4, L.Metal, "Metal"), _defineProperty(_items4, L.Mosaic, "Mosaic"), _defineProperty(_items4, L.Painting, "Painting"), _defineProperty(_items4, L.Paper, "Paper"), _defineProperty(_items4, L.Rain, "Rain"), _defineProperty(_items4, L.Vintage, "Vintage"), _defineProperty(_items4, L.Wall1, "Wall"), _defineProperty(_items4, L.Wall2, "Wall 2"), _defineProperty(_items4, L.Wood, "Wood"), _items4)
  },
  sticker: {
    title: "Stickers",
    controls: {
      buttonUpload: "Upload Sticker",
      sliderOpacity: "Sticker Opacity",
      selectColor: "Sticker Color",
      tabColor: "Color",
      tabOpacity: "Opacity"
    },
    categories: {
      imgly_sticker_emoticons: "Emoticons",
      imgly_sticker_shapes: "Shapes",
      imgly_sticker_custom: "Custom"
    },
    items: {
      imgly_sticker_emoticons_alien: "Alien",
      imgly_sticker_emoticons_angel: "Angel",
      imgly_sticker_emoticons_angry: "Angry",
      imgly_sticker_emoticons_anxious: "Anxious",
      imgly_sticker_emoticons_asleep: "Asleep",
      imgly_sticker_emoticons_attention: "Attention",
      imgly_sticker_emoticons_baby_chicken: "Baby Chicken",
      imgly_sticker_emoticons_batman: "Batman",
      imgly_sticker_emoticons_beer: "Beer",
      imgly_sticker_emoticons_black: "Black",
      imgly_sticker_emoticons_blue: "Blue",
      imgly_sticker_emoticons_blush: "Blush",
      imgly_sticker_emoticons_boxer: "Boxer",
      imgly_sticker_emoticons_business: "Business",
      imgly_sticker_emoticons_chicken: "Chicken",
      imgly_sticker_emoticons_cool: "Cool",
      imgly_sticker_emoticons_cry: "Cry",
      imgly_sticker_emoticons_deceased: "Deceased",
      imgly_sticker_emoticons_devil: "Devil",
      imgly_sticker_emoticons_duckface: "Duckface",
      imgly_sticker_emoticons_furious: "Furious",
      imgly_sticker_emoticons_grin: "Grin",
      imgly_sticker_emoticons_guitar: "Guitar",
      imgly_sticker_emoticons_harry_potter: "Harry Potter",
      imgly_sticker_emoticons_hippie: "Hippie",
      imgly_sticker_emoticons_hitman: "Hitman",
      imgly_sticker_emoticons_humourous: "Humourous",
      imgly_sticker_emoticons_idea: "Idea",
      imgly_sticker_emoticons_impatient: "Impatient",
      imgly_sticker_emoticons_kiss: "Kiss",
      imgly_sticker_emoticons_kisses: "Kisses",
      imgly_sticker_emoticons_laugh: "Laugh",
      imgly_sticker_emoticons_loud_cry: "Loud Cry",
      imgly_sticker_emoticons_loving: "Loving",
      imgly_sticker_emoticons_masked: "Masked",
      imgly_sticker_emoticons_music: "Music",
      imgly_sticker_emoticons_nerd: "Nerd",
      imgly_sticker_emoticons_ninja: "Ninja",
      imgly_sticker_emoticons_not_speaking_to_you: "Not speaking to you",
      imgly_sticker_emoticons_pig: "Pig",
      imgly_sticker_emoticons_pumpkin: "Pumpkin",
      imgly_sticker_emoticons_question: "Question",
      imgly_sticker_emoticons_rabbit: "Rabbit",
      imgly_sticker_emoticons_sad: "Sad",
      imgly_sticker_emoticons_sick: "Sick",
      imgly_sticker_emoticons_skateboard: "Skateboard",
      imgly_sticker_emoticons_skull: "Skull",
      imgly_sticker_emoticons_sleepy: "Sleepy",
      imgly_sticker_emoticons_smile: "Smile",
      imgly_sticker_emoticons_smoking: "Smoking",
      imgly_sticker_emoticons_sobbing: "Sobbing",
      imgly_sticker_emoticons_star: "Star",
      imgly_sticker_emoticons_steaming_furious: "Steaming Furious",
      imgly_sticker_emoticons_sunbathing: "Sunbathing",
      imgly_sticker_emoticons_tired: "Tired",
      imgly_sticker_emoticons_tongue_out_wink: "Tongue out wink",
      imgly_sticker_emoticons_wave: "Wave",
      imgly_sticker_emoticons_wide_grin: "Wide Grin",
      imgly_sticker_emoticons_wink: "Wink",
      imgly_sticker_emoticons_wrestler: "Wrestler",
      imgly_sticker_shapes_arrow_02: "Arrow 1",
      imgly_sticker_shapes_arrow_03: "Arrow 2",
      imgly_sticker_shapes_badge_01: "Badge 1",
      imgly_sticker_shapes_badge_11: "Badge 5",
      imgly_sticker_shapes_badge_12: "Badge 6",
      imgly_sticker_shapes_badge_13: "Badge 7",
      imgly_sticker_shapes_badge_15: "Badge 8",
      imgly_sticker_shapes_badge_18: "Badge 9",
      imgly_sticker_shapes_badge_19: "Badge 10",
      imgly_sticker_shapes_badge_20: "Badge 11",
      imgly_sticker_shapes_badge_28: "Badge 12",
      imgly_sticker_shapes_badge_32: "Badge 13",
      imgly_sticker_shapes_badge_35: "Badge 14",
      imgly_sticker_shapes_badge_36: "Badge 15",
      imgly_sticker_shapes_badge_04: "Badge 2",
      imgly_sticker_shapes_badge_06: "Badge 3",
      imgly_sticker_shapes_badge_08: "Badge 4",
      imgly_sticker_shapes_spray_01: "Spray 1",
      imgly_sticker_shapes_spray_03: "Spray 2",
      imgly_sticker_shapes_spray_04: "Spray 3"
    },
    canvasActions: {
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate",
      buttonFlipHorizontal: "Flip",
      buttonFlipVertical: "Flip"
    },
    history: {
      add: "Sticker",
      resize: "Sticker resize",
      position: "Sticker position",
      color: "Sticker color",
      delete: "Sticker delete",
      order: "Sticker order",
      opacity: "Sticker opacity",
      flip: "Sticker flip"
    }
  },
  text: {
    title: "Text",
    controls: {
      buttonNew: "New Text",
      dropdownFontFamily: "Font Family",
      textFontSize: "Font Size",
      selectAlignment: "Alignment",
      selectFontColor: "Font Color",
      selectBackgroundColor: "Background Color",
      sliderLineSpacing: "Line Spacing",
      tabColor: "Color",
      tabBgColor: "Bg Color",
      tabAlignment: "Alignment",
      tabLineHeight: "Line Height",
      tabFontSize: "Font Size"
    },
    canvasControls: {
      placeholderText: "Write Something",
      buttonSave: "Done",
      buttonClose: "Cancel",
      inputText: "Text Input"
    },
    canvasActions: {
      buttonEdit: "Edit",
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate"
    },
    history: {
      add: "Text",
      edit: "Text edit",
      resize: "Text resize",
      position: "Text position",
      alignment: "Text alignment",
      textColor: "Text color",
      backgroundColor: "Text background color",
      fontFamily: "Font family",
      fontStyle: "Font style",
      lineSpacing: "Line spacing",
      width: "Text width",
      delete: "Text delete",
      order: "Text order"
    }
  },
  textdesign: {
    title: "Text Design",
    controls: {
      buttonNew: "New Text Design",
      buttonShuffle: "Shuffle Layout",
      selectColor: "Text Color",
      tabColor: "Color",
      tabShuffle: "Shuffle"
    },
    canvasControls: {
      placeholderText: "Write Something With Style",
      buttonSave: "Done",
      buttonClose: "Schlie\xDFen",
      inputText: "Text Input"
    },
    canvasActions: {
      buttonEdit: "Edit",
      buttonInvert: "Invert",
      buttonDelete: "Delete",
      buttonBringToFront: "Move to front",
      buttonDuplicate: "Duplicate"
    },
    history: {
      add: "Text design",
      edit: "Text design edit",
      resize: "Text design resize",
      position: "Text design position",
      color: "Text design color",
      shuffle: "Text design shuffle",
      invert: "Text design invert",
      padding: "Text design padding",
      order: "Text design order",
      delete: "Text design delete"
    }
  },
  frame: {
    title: "Frames",
    controls: {
      buttonReset: "Remove Frame",
      sliderOpacity: "Frame Opacity",
      sliderSize: "Frame Size",
      selectColor: "Frame Color",
      tabColor: "Color",
      tabOpacity: "Opacity",
      tabSize: "Size"
    },
    items: {
      imgly_frame_dia: "Dia",
      imgly_frame_art_decor: "Art Decor",
      imgly_frame_black_passepartout: "Black",
      imgly_frame_lowpoly_shadow: "Low Poly",
      imgly_frame_wood_passepartout: "Wood"
    }
  },
  brush: {
    title: "Brush",
    controls: {
      buttonReset: "Remove Brush",
      sliderSize: "Brush Size",
      sliderHardness: "Brush Hardness",
      selectColor: "Brush Color",
      tabSize: "Size",
      tabHardness: "Hardness",
      tabColor: "Color"
    },
    history: {
      brushStroke: "Brush Stroke"
    }
  },
  transform: {
    title: "Transform",
    controls: {
      buttonReset: "Reset to default",
      checkboxKeepResolution: "Keep Resolution",
      inputCropSize: "Crop Size",
      inputHeight: "h",
      inputWidth: "w",
      tabFlipAndRotate: "Flip & Rotate",
      tabResolution: "Resolution",
      tabCropSize: "Crop Size"
    },
    categories: {
      imgly_transforms_common: "Common",
      imgly_transforms_facebook: "Facebook",
      imgly_transforms_twitter: "Twitter",
      imgly_transforms_instagram: "Instagram"
    },
    items: {
      imgly_transform_common_custom: "Custom",
      imgly_transform_common_square: "Square",
      imgly_transform_common_4: "4:3",
      imgly_transform_common_16: "16:9",
      imgly_transform_common_3: "3:4",
      imgly_transform_common_9: "9:16",
      imgly_transform_facebook_profile: "Profile",
      imgly_transform_facebook_title: "Title",
      imgly_transform_facebook_post: "Post",
      imgly_transform_instagram_story: "Story",
      imgly_transform_instagram_landscape: "Landscape",
      imgly_transform_instagram_portrait: "Portrait",
      imgly_transform_instagram_square: "Square",
      imgly_transform_twitter_profile: "Profile",
      imgly_transform_twitter_title: "Title",
      imgly_transform_twitter_post: "Post"
    },
    transformActions: {
      buttonFlipHorizontal: "Flip Horizontal",
      buttonFlipVertical: "Flip Vertical",
      buttonRotateClockwise: "Rotate Clockwise",
      buttonRotateAntiClockwise: "Rotate Counterclockwise"
    }
  }
};

var Gl = function Gl(i) {
  return i === "de" ? ls : ni;
},
    Vl = function Vl(i, e) {
  return e && e[i] ? Wt([Gl(i), e[i]]) : Gl(i) || ni;
};

var Wp = {
  headline1: {
    size: 16,
    letterSpacing: 1.5,
    case: "uppercase"
  },
  headline2: {
    size: 14,
    letterSpacing: .8,
    case: "uppercase"
  },
  body: {
    size: 13,
    letterSpacing: 0,
    case: "none"
  },
  label: {
    size: 13,
    letterSpacing: 0,
    case: "capitalize"
  },
  basicUICardLabel: {
    size: 12,
    letterSpacing: 0,
    case: "capitalize"
  },
  button1: {
    size: 12,
    letterSpacing: 1.2,
    case: "uppercase"
  },
  button2: {
    size: 14,
    letterSpacing: 0,
    case: "capitalize"
  },
  basicUITabLabel: {
    size: 14,
    letterSpacing: .8,
    case: "uppercase"
  }
},
    jp = {
  toast: 2,
  controlsBar: 5,
  buttonGroup: 5,
  toolControlBar: 6,
  toolbar: 7,
  label: 10,
  disable: 11,
  canvas: {
    knob: 4,
    bar: 5,
    controls: 5,
    snappingGuide: 1,
    crop: {
      grid: 2,
      dragImage: 3,
      backdrop: 4
    },
    webcam: {
      backdrop: 7
    }
  },
  input: {
    list: 6
  },
  button: {
    float: 5
  },
  dialog: {
    base: 100,
    backdrop: 1,
    container: 2
  },
  colorItem: {
    overlay: 2,
    background: 1,
    tiledBackground: 0
  }
},
    to = function to() {
  var i = 8,
      e = 230,
      t = 3 * i,
      r = e - 2 * t,
      o = (r - 2 * i) / 3,
      n = (r - i) / 2;
  return {
    advancedUIToolbar: {
      width: 55,
      itemHeight: 48,
      seperatorHeight: 20,
      marginBottom: 0
    },
    advancedUIToolControlBar: {
      width: e,
      padding: "".concat(2 * i, "px ").concat(t, "px"),
      marginBottom: 0
    },
    advancedCard: {
      small: {
        height: o,
        width: o
      },
      medium: {
        height: n,
        width: n
      },
      large: {
        height: 86,
        width: r
      }
    },
    advancedSpacer: 8,
    basicCanvasOffset: 40 + 76 - 88,
    basicUIToolbar: {
      openHeight: 88,
      closeHeight: 40
    },
    basicToolControlBar: {
      itemsBarHeight: 72,
      controlsBarHeight: 80,
      maxHeight: 72 + 40 + 4,
      maxWidth: 300
    },
    basicCard: {
      medium: {
        height: 56,
        width: 90
      },
      large: {
        height: 60,
        width: 110
      }
    },
    basicSpacer: 8,
    mainCanvasActionBar: {
      height: 50
    },
    crop: {
      minSize: 50
    },
    canvas: {
      marginTop: 0,
      transform: {
        minSliderWidth: 435,
        minValueWidth: 235,
        minFlipWidth: 160
      }
    },
    canvasControls: {
      sprite: {
        controlOffset: 16,
        rotateHandle: {
          height: 16
        },
        minSize: 30,
        controlPadding: 16
      },
      knob: {
        size: 16,
        touchable: {
          desktop: 24
        }
      },
      corner: {
        size: 14,
        touchable: {
          desktop: 24,
          mobile: 48
        },
        borderWidth: 4
      },
      width: {
        size: 14
      }
    },
    buttons: {
      float: {
        size: 56
      }
    },
    colorItem: {
      size: 20
    },
    color: {
      colorPicker: {
        width: 214,
        height: 370,
        saturationSlider: {
          height: 150
        },
        thumb: {
          size: 14
        },
        arrow: {
          width: 36
        }
      }
    },
    fontSystem: Wp,
    zIndex: jp
  };
};

var Gp = function Gp() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    primary: "#365afc",
    background: "#0B0B0B",
    foreground: "#FFFFFF"
  },
      _ref14$primary = _ref14.primary,
      i = _ref14$primary === void 0 ? "#365afc" : _ref14$primary,
      _ref14$background = _ref14.background,
      e = _ref14$background === void 0 ? "#0B0B0B" : _ref14$background,
      _ref14$foreground = _ref14.foreground,
      t = _ref14$foreground === void 0 ? "#FFFFFF" : _ref14$foreground;

  var r = "rgba(255, 255, 255, 0.90)",
      o = "rgba(255, 255, 255, 0.60)",
      n = "rgba(255, 255, 255, 0.38)",
      s = "#424242",
      l = "#333333",
      c = "#242424",
      p = "#171717",
      m = "#0B0B0B",
      h = "rgba(255, 255, 255, 0.08)",
      b = "rgba(0, 0, 0, 0.3)",
      v = "rgba(89, 121, 252, 0.20)",
      x = "0.3";
  return {
    shape: {
      radiusSmall: 2,
      radiusMedium: 4,
      radiusLarge: 4
    },
    typography: {
      fontFamily: "Fira Sans",
      provider: "google"
    },
    background: e,
    foreground: t,
    primary: i,
    warning: "#ffba5c",
    error: "#c2393a",
    success: "#39c26c",
    focusOutlineColor: "rgba(255, 255, 255, 0.12)",
    scrollbar: {
      handleColor: "rgba(255, 255, 255, 0.2)"
    },
    button: {
      outlinedBorderColor: l,
      activeForeground: i,
      containedPrimaryBackground: i,
      containedPrimaryForeground: r,
      outlinedPrimaryBackground: c,
      outlinedPrimaryForeground: r,
      outlinedSecondaryBackground: "transparent",
      outlinedSecondaryForeground: o,
      textPrimaryForeground: i,
      textSecondaryForeground: o,
      outlinedInactiveOverlayColor: b,
      textInactiveOpacity: "0.5",
      hoverOverlayColor: h
    },
    checkbox: {
      background: l,
      foreground: t,
      activeForeground: t,
      activeBackground: i,
      inactiveOpacity: x,
      hoverOpacity: "0.8"
    },
    modal: {
      background: c,
      bodyForeground: r,
      headerForeground: o,
      backdrop: "rgba(0, 0, 0, 0.6)"
    },
    card: {
      background: l,
      foreground: r,
      activeBorderColor: i,
      activeOverlayColor: v,
      labelBackground: "linear-gradient(transparent, rgba(0, 0, 0, 0.6))",
      labelForeground: r,
      inactiveOverlayColor: b,
      hoverOverlayColor: h
    },
    tabTitle: {
      foreground: o,
      background: "transparent",
      activeBackground: "transparent",
      activeBorderColor: i,
      activeForeground: r
    },
    dropdown: {
      background: "transparent",
      foreground: r,
      hoverBorderColor: o,
      borderColor: l,
      caretColor: n,
      listBackground: l,
      listBorderColor: l,
      listItemHoverBackground: s,
      listForeground: o,
      listShadow: "0 12px 17px 2px rgba(0,0,0,0.14),\n        0 5px 22px 4px rgba(0,0,0,0.12),\n        0 7px 8px -4px rgba(0,0,0,0.20)",
      inactiveOpacity: x
    },
    textInput: {
      foreground: r,
      hoverBorderColor: "rgba(255, 255, 255, 0.40)",
      background: "transparent",
      borderColor: l,
      inactiveOpacity: x
    },
    slider: {
      trackColor: "rgba(255, 255, 255, 0.4)",
      activeTrackColor: i,
      thumbBackground: p,
      thumbBorderColor: i,
      inactiveOpacity: x,
      hoverOpacity: "0.7"
    },
    selectColor: {
      activeBorderColor: i,
      inactiveOpacity: x
    },
    toolbar: {
      foreground: r,
      background: c,
      activeBackground: "transparent",
      activeForeground: i,
      borderColor: "transparent"
    },
    tooltip: {
      background: s,
      foreground: r
    },
    toolControlBar: {
      background: "rgba(23, 23, 23, 0.9)",
      borderColor: "transparent",
      shadow: "none",
      separatorColor: l,
      titleForeground: o,
      inputLabelForeground: o,
      inputLabelInactiveOpacity: x
    },
    mainCanvasActionBar: {
      background: "linear-gradient(0deg, transparent 0%,  rgba(0, 0, 0, 0.6) 98%)",
      foreground: r,
      borderColor: "none"
    },
    canvasActionBar: {
      background: s,
      foreground: r,
      separatorColor: n
    },
    canvas: {
      background: m,
      controlsOutline: "rgba(255, 255, 255, 0.5)",
      controlsColor: "#ffffff",
      cropBackdrop: "rgba(0, 0, 0, 0.5)"
    },
    colorPicker: {
      listBackground: l,
      listShadow: "0 12px 17px 2px rgba(0,0,0,0.14),\n        0 5px 22px 4px rgba(0,0,0,0.12),\n        0 7px 8px -4px rgba(0,0,0,0.20)",
      controlsColor: "#ffffff",
      inputBorderColor: s
    },
    colorItem: {
      borderRadius: "2px",
      margin: "1px"
    },
    webcam: {
      backdrop: "rgba(0, 0, 0, 0.3)",
      floatButton: t,
      background: m
    },
    snapping: {
      positionGuideColor: "#f0f",
      rotationGuideColor: "#0ff"
    },
    transform: {
      crops: {
        main: "#424242",
        highlight: "#565656",
        shadow: "#333333"
      }
    }
  };
},
    io = Gp;

var Vp = function Vp() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    primary: "#1e47fb",
    background: "#FBFBFB",
    foreground: "#000000"
  },
      _ref15$primary = _ref15.primary,
      i = _ref15$primary === void 0 ? "#1e47fb" : _ref15$primary,
      _ref15$background = _ref15.background,
      e = _ref15$background === void 0 ? "#FBFBFB" : _ref15$background,
      _ref15$foreground = _ref15.foreground,
      t = _ref15$foreground === void 0 ? "#000000" : _ref15$foreground;

  var r = "rgba(0, 0, 0, 0.90)",
      o = "rgba(0, 0, 0, 0.60)",
      n = "rgba(0, 0, 0, 0.38)",
      s = "#CCCCCC",
      l = "#D4D4D4",
      c = "#E6E6E6",
      p = "#EEEEEE",
      m = "#FBFBFB",
      h = "rgba(125, 125, 125, 0.12)",
      b = "rgba(30, 71, 251, 0.2)",
      v = "rgba(0, 0, 0, 0.3)",
      x = "0.3";
  return {
    shape: {
      radiusSmall: 2,
      radiusMedium: 4,
      radiusLarge: 4
    },
    typography: {
      fontFamily: "Fira Sans",
      provider: "google"
    },
    background: e,
    foreground: t,
    primary: i,
    warning: "#ffb045",
    error: "#c01a1b",
    success: "#17c658",
    focusOutlineColor: "rgba(125, 125, 125, 0.12)",
    scrollbar: {
      handleColor: "rgba(0, 0, 0, 0.2)"
    },
    button: {
      outlinedBorderColor: l,
      activeForeground: i,
      containedPrimaryBackground: i,
      containedPrimaryForeground: "rgba(255, 255, 255, 0.9)",
      outlinedPrimaryBackground: c,
      outlinedPrimaryForeground: r,
      outlinedSecondaryBackground: "transparent",
      outlinedSecondaryForeground: o,
      textPrimaryForeground: i,
      textSecondaryForeground: o,
      outlinedInactiveOverlayColor: v,
      textInactiveOpacity: "0.5",
      hoverOverlayColor: h
    },
    checkbox: {
      background: l,
      foreground: t,
      activeForeground: t,
      activeBackground: i,
      inactiveOpacity: x,
      hoverOpacity: "0.8"
    },
    modal: {
      background: c,
      bodyForeground: r,
      headerForeground: o,
      backdrop: "rgba(0, 0, 0, 0.6)"
    },
    card: {
      background: l,
      foreground: r,
      activeBorderColor: i,
      activeOverlayColor: b,
      labelBackground: "linear-gradient(transparent, rgba(0, 0, 0, 0.6))",
      labelForeground: "rgba(255, 255, 255, 0.87)",
      inactiveOverlayColor: v,
      hoverOverlayColor: h
    },
    tabTitle: {
      foreground: o,
      background: "transparent",
      activeBackground: "transparent",
      activeBorderColor: i,
      activeForeground: r
    },
    dropdown: {
      background: "transparent",
      foreground: r,
      hoverBorderColor: o,
      borderColor: l,
      listBackground: l,
      caretColor: n,
      listForeground: o,
      listBorderColor: l,
      listItemHoverBackground: s,
      listShadow: "0 8px 10px 1px rgba(0,0,0,0.14),\n        0 3px 14px 2px rgba(0,0,0,0.12),\n        0 5px 5px -3px rgba(0,0,0,0.20)",
      inactiveOpacity: x
    },
    textInput: {
      foreground: r,
      hoverBorderColor: r,
      background: "transparent",
      borderColor: l,
      inactiveOpacity: x
    },
    slider: {
      trackColor: s,
      activeTrackColor: i,
      thumbBackground: p,
      thumbBorderColor: i,
      inactiveOpacity: x,
      hoverOpacity: "0.7"
    },
    selectColor: {
      activeBorderColor: i,
      inactiveOpacity: x
    },
    toolbar: {
      foreground: r,
      background: l,
      activeBackground: "transparent",
      activeForeground: i,
      borderColor: "transparent"
    },
    tooltip: {
      background: s,
      foreground: r
    },
    toolControlBar: {
      background: "rgba(238, 238, 238, 0.9)",
      borderColor: p,
      shadow: "none",
      separatorColor: l,
      titleForeground: o,
      inputLabelForeground: o,
      inputLabelInactiveOpacity: x
    },
    mainCanvasActionBar: {
      background: "transparent",
      foreground: r,
      borderColor: "none"
    },
    canvasActionBar: {
      background: s,
      foreground: r,
      separatorColor: n
    },
    canvas: {
      background: m,
      controlsOutline: "rgba(255, 255, 255, 0.6)",
      controlsColor: "#ffffff",
      cropBackdrop: "rgba(255, 255, 255, 0.3)"
    },
    colorPicker: {
      listBackground: l,
      listShadow: "0 8px 10px 1px rgba(0,0,0,0.14),\n        0 3px 14px 2px rgba(0,0,0,0.12),\n        0 5px 5px -3px rgba(0,0,0,0.20)",
      controlsColor: "#ffffff",
      inputBorderColor: s
    },
    colorItem: {
      borderRadius: "2px",
      margin: "1px"
    },
    webcam: {
      backdrop: "rgba(0, 0, 0, 0.3)",
      floatButton: t,
      background: m
    },
    snapping: {
      positionGuideColor: "#f0f",
      rotationGuideColor: "#0ff"
    },
    transform: {
      crops: {
        main: "#B8B8B8",
        highlight: "#E6E6E6",
        shadow: "#D4D4D4"
      }
    }
  };
},
    cs = Vp;

var rr = io(),
    us = to(),
    I_ = f(f({}, rr), {
  measurements: us
});

var $p = function $p(i) {
  return i === "light" ? cs : io;
},
    $l = function $l(i, e) {
  var t = $p(i);

  if (e && e[i]) {
    var _e$i = e[i],
        r = _e$i.primary,
        o = _e$i.background,
        n = _e$i.foreground,
        s = {
      primary: r,
      background: o,
      foreground: n
    },
        l = Object.keys(s).reduce(function (c, p) {
      return s[p] ? f(f({}, c), _defineProperty({}, p, s[p])) : c;
    }, {});
    return Wt([t(l), e[i]]);
  }

  return t() || rr;
};

var Kp = ["canvas", "advancedUIToolbar", "advancedUIToolControlBar", "basicUIToolbar", "mainCanvasActionBar", "colorItem", "fontSystem"],
    Kl = function Kl(i) {
  var e = to();

  if (i) {
    var t = {};
    return Object.keys(i).forEach(function (r) {
      Kp.indexOf(r) !== -1 && (t[r] = i[r]);
    }), Wt([e, t]);
  }

  return e;
};

var Yp = {
  config: is,
  locale: ni,
  theme: rr,
  measurements: us
},
    ke =
/*#__PURE__*/
function () {
  function ke() {
    _classCallCheck(this, ke);

    this.checkDefaultToolAvailability = function (e, t) {
      return t.indexOf(e) !== -1;
    };

    this.state = S(Yp), this.events = new as(), this.licenseChecker = null;
  }

  _createClass(ke, [{
    key: "saveConfig",
    value: function saveConfig(e) {
      var _this49 = this,
          _p2,
          _p3;

      e.mainCanvasActions && e.mainCanvasActions.length !== 4 && (e.mainCanvasActions.length = 4);
      var r = Wt([is, e]);
      this.licenseChecker = new Qn(r.license), this.licenseChecker.areCustomAssetsAllowed() || (r.sticker.enableCustomUpload = !1);
      var o = Vl(r.language, r.custom.languages),
          n = $l(r.theme, r.custom.themes),
          s = Kl(r.custom.measurements),
          l = r.library.provider,
          c = [];
      r.adjustment.categories = r.adjustment.categories.reduce(function (b, v) {
        return b.push(f(f({}, v), {
          items: v.items.filter(function (x) {
            return qp[x.identifier] ? !0 : (c.push(x.identifier), !1);
          })
        })), b;
      }, []), c.length !== 0 && console.error("The following identifier are incorrect for the adjustment tool: ".concat(c.join(", "))), delete r.language, delete r.custom.languages, delete r.custom.themes, delete r.library.provider;
      var p = r.tools.reduce(function (b, v) {
        return typeof v == "object" ? [].concat(_toConsumableArray(b), _toConsumableArray(v)) : [].concat(_toConsumableArray(b), [v]);
      }, []);
      p.length || (console.error("Empty list input for tools"), p = Zr.reduce(function (b, v) {
        return typeof v == "object" ? [].concat(_toConsumableArray(b), _toConsumableArray(v)) : [].concat(_toConsumableArray(b), [v]);
      }, [])), p = p.filter(function (b) {
        return _this49.licenseChecker.isToolAllowed(b);
      }), this.checkDefaultToolAvailability(r.defaultTool, p) || (this.licenseChecker.isToolAllowed(r.defaultTool) && console.warn("Configured default tool ".concat(r.defaultTool, " is not a part of configured list of tools: [").concat(p.join(" "), "]")), (_p2 = p, _p3 = _slicedToArray(_p2, 1), r.defaultTool = _p3[0], _p2)), r.tools = p, this.state.config = r, this.state.locale = o, this.state.theme = n, this.state.measurements = s;
      var h = this.buildCustomAssetsConfig();
      return this.assetProvider = new qr(h, this.licenseChecker.areCustomAssetsAllowed()), this.loadThemeFont(), l;
    }
  }, {
    key: "loadThemeFont",
    value: function loadThemeFont() {
      var e = this.theme.typography;
      e.skipLoading || this.assetProvider.getFontManager().injectFonts([e]);
    }
  }, {
    key: "buildCustomAssetsConfig",
    value: function buildCustomAssetsConfig() {
      var e = this.tools,
          t = k(this.state.config),
          r = this.state.config.assetBaseUrl,
          o = this.state.theme,
          n = e.indexOf(g.FILTER) !== -1 ? t[g.FILTER] : void 0,
          s = e.indexOf(g.FOCUS) !== -1 ? t[g.FOCUS] : void 0,
          l = e.indexOf(g.ADJUSTMENT) !== -1 ? t[g.ADJUSTMENT] : void 0,
          c = e.indexOf(g.STICKER) !== -1 ? t[g.STICKER] : void 0,
          p = e.indexOf(g.FRAME) !== -1 ? t[g.FRAME] : void 0,
          m = e.indexOf(g.OVERLAY) !== -1 ? t[g.OVERLAY] : void 0,
          h = e.indexOf(g.TRANSFORM) !== -1 ? t[g.TRANSFORM] : void 0,
          b = e.indexOf(g.TEXT) !== -1 ? t[g.TEXT] : void 0,
          v = e.indexOf(g.TEXT_DESIGN) !== -1 ? t[g.TEXT_DESIGN] : void 0;
      return {
        basePath: r,
        theme: o,
        filter: n,
        focus: s,
        sticker: c,
        frame: p,
        overlay: m,
        transform: h,
        text: b,
        adjustment: l,
        textdesign: v
      };
    }
  }, {
    key: "config",
    get: function get() {
      return this.state.config;
    }
  }, {
    key: "locale",
    get: function get() {
      return this.state.locale;
    }
  }, {
    key: "theme",
    get: function get() {
      return this.state.theme;
    }
  }, {
    key: "measurements",
    get: function get() {
      return this.state.measurements;
    }
  }, {
    key: "tools",
    get: function get() {
      return this.config.tools.reduce(function (e, t) {
        return typeof t == "string" ? [].concat(_toConsumableArray(e), [t]) : [].concat(_toConsumableArray(e), [""], _toConsumableArray(t));
      }, []);
    }
  }, {
    key: "defaultTool",
    get: function get() {
      return this.config.defaultTool;
    }
  }, {
    key: "isOrderDefault",
    get: function get() {
      return this.config.order === "default";
    }
  }, {
    key: "isLayoutAdvanced",
    get: function get() {
      return this.config.layout === "advanced";
    }
  }, {
    key: "displayCloseButton",
    get: function get() {
      return this.config.mainCanvasActions.indexOf(de.CLOSE) !== -1;
    }
  }]);

  return ke;
}();

a([d], ke.prototype, "saveConfig", 1), a([u], ke.prototype, "config", 1), a([u], ke.prototype, "locale", 1), a([u], ke.prototype, "theme", 1), a([u], ke.prototype, "measurements", 1), a([u], ke.prototype, "tools", 1), a([u], ke.prototype, "defaultTool", 1), a([u], ke.prototype, "isOrderDefault", 1), a([u], ke.prototype, "isLayoutAdvanced", 1), a([u], ke.prototype, "displayCloseButton", 1);

var ds =
/*#__PURE__*/
function () {
  function ds(e) {
    _classCallCheck(this, ds);

    this.editor = e;
  }

  _createClass(ds, [{
    key: "setBackgroundImage",
    value: function setBackgroundImage(e) {
      this.container ? this.container.setData({
        image: e,
        originalImage: e
      }) : this.container = this.engine.addImage({
        image: e,
        originalImage: e,
        blendMode: j.NORMAL,
        opacity: 1
      });
    }
  }, {
    key: "getchildren",
    value: function getchildren() {
      return this.container.getChildren();
    }
  }, {
    key: "addImageToContainer",
    value: function addImageToContainer() {
      var _this50 = this;

      return new Promise(function (e, t) {
        var r = _this50.editor.activeStore.image;
        if (Sl(r)) _this50.setBackgroundImage(r), e();else {
          var o = _this50.editor.libraryStore.getRawUrl(r);

          _this50.getImageElement(o).then(function (n) {
            _this50.setBackgroundImage(n), e();
          }).catch(function (n) {
            t({
              identifier: "imageLoading",
              message: n.message
            });
          });
        }
      });
    }
  }, {
    key: "getImageElement",
    value: function getImageElement(e) {
      var _this51 = this;

      return new Promise(function (t, r) {
        var o = new Image();
        o.addEventListener("load", function () {
          t(o);
        }), o.addEventListener("error", function (n) {
          r(n);
        }), o.crossOrigin = _this51.editor.configStore.config.engine.crossOrigin, o.src = e;
      });
    }
  }, {
    key: "getImgageContainerId",
    value: function getImgageContainerId() {
      return this.container ? this.container.getID() : "";
    }
  }, {
    key: "engine",
    get: function get() {
      return this.editor.engine;
    }
  }]);

  return ds;
}();

var ps =
/*#__PURE__*/
function () {
  function ps(e) {
    var _this52 = this;

    _classCallCheck(this, ps);

    this.applyNewImageTransform = function () {
      var _this52$editor$engine = _this52.editor.engineMediator.image.container.getBounds(),
          e = _this52$editor$engine.size,
          t = _this52$editor$engine.width,
          r = _this52$editor$engine.height,
          o = _this52.container;

      o.setTransform(X.IDENTITY), o.setResolution(e), o.setPivot(.5, .5), o.setPosition({
        x: t / 2,
        y: r / 2
      });
    };

    this.editor = e;
  }

  _createClass(ps, [{
    key: "engine",
    get: function get() {
      return this.editor.engine;
    }
  }, {
    key: "container",
    get: function get() {
      return this.engine.getOutputContainer();
    }
  }]);

  return ps;
}();

var Xp = function Xp(i, e) {
  return new Promise(function (t, r) {
    var o = new XMLHttpRequest();
    o.onload = function () {
      var n = new FileReader();
      n.onloadend = function () {
        typeof n.result == "string" && n.result.substr(0, 10) === "data:image" ? t(n.result) : r(new Error("The image could not be loaded from ".concat(i)));
      }, n.onerror = function (s) {
        r(s);
      }, n.readAsDataURL(o.response);
    }, o.open("GET", i), o.responseType = "blob", o.withCredentials = e === "use-credentials", o.send();
  });
},
    ql = function ql(i, e) {
  return new Promise(function (t, r) {
    var o = new Image();
    o.onload = function () {
      t(o);
    }, o.onerror = function () {
      r(new Error("Failed to load image with src:".concat(i)));
    }, o.crossOrigin = e, o.src = i;
  });
},
    Jp = function Jp(i, e) {
  return new Promise(function (t, r) {
    Xp(i, e).then(function (o) {
      var n = new Image();
      n.addEventListener("load", function () {
        t(n);
      }), n.src = o;
    }).catch(function () {
      ql(i, e).then(function (o) {
        return t(o);
      }).catch(function (o) {
        r(o);
      });
    });
  });
},
    ms = function ms(r) {
  return C(void 0, [r],
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee18(_ref16) {
    var i, e, _ref16$crossOrigin, t;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            i = _ref16.url, e = _ref16.image, _ref16$crossOrigin = _ref16.crossOrigin, t = _ref16$crossOrigin === void 0 ? "anonymous" : _ref16$crossOrigin;
            _context18.prev = 1;
            return _context18.abrupt("return", e && e.src && e.src.substr(0, 5) === "data:" || e && e.src && e.src.includes(".svg") ? e : typeof i == "string" && i.substr(0, 5) === "data:" || typeof i == "string" && i.includes(".svg") ? ql(i, t) : Jp(i || e.src, t));

          case 5:
            _context18.prev = 5;
            _context18.t0 = _context18["catch"](1);
            throw new Error(_context18.t0);

          case 8:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[1, 5]]);
  }));
};

var Zp = {
  tool: null,
  isWebcam: !1,
  image: ""
},
    qe =
/*#__PURE__*/
function () {
  function qe(e) {
    var _this53 = this;

    _classCallCheck(this, qe);

    this.setImage = function (e) {
      return C(_this53, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19() {
        var t;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                t = this.editor.configStore.config.engine.crossOrigin;
                _context19.t0 = typeof e == "string";

                if (!_context19.t0) {
                  _context19.next = 6;
                  break;
                }

                _context19.next = 5;
                return ms({
                  url: ii(e) ? e : this.editor.assetProvider.getPath(e),
                  crossOrigin: t
                });

              case 5:
                this.state.image = _context19.sent;

              case 6:
                _context19.t1 = e instanceof HTMLImageElement;

                if (!_context19.t1) {
                  _context19.next = 11;
                  break;
                }

                _context19.next = 10;
                return ms({
                  image: e,
                  crossOrigin: t
                });

              case 10:
                this.state.image = _context19.sent;

              case 11:
                this.isWebcam && (this.state.isWebcam = !1);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    };

    this.newImage = function (e) {
      _this53.editor.init(e);
    };

    this.editor = e, this.state = S(Zp);
  }

  _createClass(qe, [{
    key: "selectTool",
    value: function selectTool(e) {
      var t = this.editor.configStore.licenseChecker;
      if (this.state.tool !== e && (t == null ? void 0 : t.isToolAllowed(e))) switch (this.editor.onToolChange(this.state.tool, e), this.state.tool = e, this.editor.configStore.events.onToolChanged(e), e) {
        case g.TEXT:
          this.editor.spriteStore.textToolStore.addOrselect();
          break;

        case g.TEXT_DESIGN:
          this.editor.spriteStore.textDesignToolStore.addOrselect();
          break;

        case g.BRUSH:
          {
            this.editor.brushToolStore.initSize();
            break;
          }

        case g.TRANSFORM:
          this.editor.transformToolStore.applyDefaultCrop();
          break;

        default:
          break;
      }
    }
  }, {
    key: "selectWebcam",
    value: function selectWebcam(e) {
      this.state.isWebcam = e;
    }
  }, {
    key: "webcamLabel",
    get: function get() {
      return this.editor.libraryStore.locale.controls.buttonWebcamClose;
    }
  }, {
    key: "tool",
    get: function get() {
      return this.state.tool;
    }
  }, {
    key: "isWebcam",
    get: function get() {
      return this.state.isWebcam;
    }
  }, {
    key: "image",
    get: function get() {
      return this.state.image;
    }
  }]);

  return qe;
}();

a([d], qe.prototype, "selectTool", 1), a([d], qe.prototype, "selectWebcam", 1), a([d], qe.prototype, "setImage", 2), a([d], qe.prototype, "newImage", 2), a([u], qe.prototype, "webcamLabel", 1), a([u], qe.prototype, "tool", 1), a([u], qe.prototype, "isWebcam", 1), a([u], qe.prototype, "image", 1);

var hs = {
  height: 150,
  width: 150
},
    fs =
/*#__PURE__*/
function () {
  function fs(e) {
    _classCallCheck(this, fs);

    this.canvasClickDisabled = S.box(!1);
    this.editor = e, this.state = S(fs.initialState);
  }

  _createClass(fs, [{
    key: "setCanvasElement",
    value: function setCanvasElement(e) {
      this.canvas = e, this.editor.engineMediator.preview.createPreview(e), this.updateCanvasDimensions(), this.editor.init(this.editor.configStore.config.image);
    }
  }, {
    key: "updateCanvasDimensions",
    value: function updateCanvasDimensions() {
      var e = ie.devicePixelRatio;
      this.canvas.width = this.canvasSize.width * e, this.canvas.height = this.canvasSize.height * e, this.canvas.style.width = "".concat(this.canvasSize.width, "px"), this.canvas.style.height = "".concat(this.canvasSize.height, "px");
    }
  }, {
    key: "saveDimensions",
    value: function saveDimensions(_ref17) {
      var e = _ref17.height,
          t = _ref17.width,
          r = _ref17.render;
      var o = this.editor.configStore.isLayoutAdvanced ? 0 : this.editor.configStore.measurements.basicCanvasOffset;
      e - o > hs.height && t > hs.width && (this.state.canvasSize.height = e - o, this.state.canvasSize.width = t, r && this.editor.resize());
    }
  }, {
    key: "disableCanvasClick",
    value: function disableCanvasClick() {
      this.canvasClickDisabled.set(!0);
    }
  }, {
    key: "enableCanvasClick",
    value: function enableCanvasClick() {
      this.canvasClickDisabled.set(!1);
    }
  }, {
    key: "getContainersAtPreviewPoint",
    value: function getContainersAtPreviewPoint(e) {
      var _this54 = this;

      var t = this.editor.engine.getContainersAtPreviewPoint(e, this.editor.engineMediator.preview.previewTransformWithoutDpr).map(function (r) {
        return r.getID();
      }).filter(function (r) {
        return r !== _this54.editor.engineMediator.image.getImgageContainerId();
      });
      this.editor.spriteStore.onCanvasClick(t);
    }
  }, {
    key: "isCanvasClickable",
    get: function get() {
      return !this.canvasClickDisabled.get();
    }
  }, {
    key: "canvasSize",
    get: function get() {
      return this.state.canvasSize;
    }
  }, {
    key: "sizeVector",
    get: function get() {
      return _.fromSize(this.state.canvasSize);
    }
  }, {
    key: "sizeVectorMagnitude",
    get: function get() {
      return this.sizeVector.magnitude;
    }
  }]);

  return fs;
}(),
    Ie = fs;

Ie.initialState = {
  canvasSize: hs
}, a([d], Ie.prototype, "setCanvasElement", 1), a([d], Ie.prototype, "updateCanvasDimensions", 1), a([d], Ie.prototype, "saveDimensions", 1), a([d], Ie.prototype, "disableCanvasClick", 1), a([d], Ie.prototype, "enableCanvasClick", 1), a([u], Ie.prototype, "isCanvasClickable", 1), a([u], Ie.prototype, "canvasSize", 1), a([u], Ie.prototype, "sizeVector", 1), a([u], Ie.prototype, "sizeVectorMagnitude", 1);

var Qp = {
  type: null,
  identifier: null,
  isVisible: !1,
  error: ""
},
    Le =
/*#__PURE__*/
function () {
  function Le(e) {
    var _this55 = this;

    _classCallCheck(this, Le);

    this.showActionModal = function (_ref18) {
      var e = _ref18.type,
          t = _ref18.identifier,
          r = _ref18.error,
          o = _ref18.handleConfirm,
          n = _ref18.handleDismiss;
      _this55.resetHandlers(), _this55.state.isVisible = !0, _this55.state.identifier = t, _this55.state.type = e, _this55.state.error = r || "", _this55.handleConfirm = o, _this55.handleDismiss = n;
    };

    this.hideModal = function () {
      _this55.state.isVisible = !1, _this55.state.type = null, _this55.state.error = "", _this55.state.identifier = null, _this55.resetHandlers();
    };

    this.resetHandlers = function () {
      _this55.handleConfirm = null, _this55.handleDismiss = null;
    };

    this.configStore = e.configStore, this.state = S(Qp);
  }

  _createClass(Le, [{
    key: "showInfoModal",
    value: function showInfoModal(e) {
      this.resetHandlers(), this.state.isVisible = !0, this.state.type = oe.INFO, this.state.identifier = e, this.state.error = "";
    }
  }, {
    key: "showTextEditModal",
    value: function showTextEditModal() {
      this.resetHandlers(), this.state.isVisible = !0, this.state.type = oe.TEXT_EDIT, this.state.identifier = "inputText", this.state.error = "";
    }
  }, {
    key: "getModalLocale",
    value: function getModalLocale() {
      var _this$state = this.state,
          e = _this$state.identifier,
          t = _this$state.error,
          r = _this$state.type,
          o = this.configStore.locale;
      if (!r || !e || r === oe.TEXT_EDIT) return null;

      if (r && e && o["".concat(r, "Modals")] && o["".concat(r, "Modals")][e]) {
        var n = o["".concat(r, "Modals")][e],
            s = n.body;
        s && typeof t == "object" ? Object.keys(t).forEach(function (c) {
          s = s.replace("${".concat(c, "}"), t[c]);
        }) : s && (s = s.replace("${error}", t));
        var l = n.heading;

        if (r === oe.ERROR || r === oe.WARNING) {
          var c = {
            error: o.common.error,
            warning: o.common.warning
          };
          l = "".concat(r === "error" ? c.error : c.warning).concat(n.headingDelimiter || "", " ").concat(n.header || "");
        }

        return {
          bodyLabel: s,
          headerLabel: l,
          buttonYes: n.buttonYes,
          buttonNo: n.buttonNo
        };
      }

      return null;
    }
  }, {
    key: "modalProps",
    get: function get() {
      var e = this.state.isVisible,
          t = this.getModalLocale();

      if (t) {
        var r = t.bodyLabel,
            o = t.headerLabel,
            n = t.buttonYes,
            s = t.buttonNo;
        return {
          headerLabel: o,
          bodyLabel: r,
          confirmLabel: n,
          dismissLabel: s,
          isVisible: e,
          handleClose: this.hideModal,
          handleConfirm: this.handleConfirm,
          handleDismiss: this.handleDismiss
        };
      }

      return {
        isVisible: !1
      };
    }
  }, {
    key: "isVisible",
    get: function get() {
      return this.state.isVisible;
    }
  }, {
    key: "type",
    get: function get() {
      return this.state.type;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.state.identifier;
    }
  }, {
    key: "positionOffset",
    get: function get() {
      var _this$configStore = this.configStore,
          e = _this$configStore.isLayoutAdvanced,
          _this$configStore$mea = _this$configStore.measurements,
          t = _this$configStore$mea.basicCanvasOffset,
          r = _this$configStore$mea.advancedUIToolControlBar,
          o = _this$configStore$mea.advancedUIToolbar,
          n = _this$configStore.isOrderDefault,
          s = (r.width + o.width) * (n ? 1 : -1);
      return e ? {
        x: s / 2,
        y: 0
      } : {
        x: 0,
        y: -t
      };
    }
  }]);

  return Le;
}();

a([d], Le.prototype, "showActionModal", 2), a([d], Le.prototype, "showInfoModal", 1), a([d], Le.prototype, "showTextEditModal", 1), a([d], Le.prototype, "hideModal", 2), a([u], Le.prototype, "modalProps", 1), a([u], Le.prototype, "isVisible", 1), a([u], Le.prototype, "type", 1), a([u], Le.prototype, "identifier", 1), a([u], Le.prototype, "positionOffset", 1);

var le =
/*#__PURE__*/
function () {
  function le(e) {
    var _this56 = this;

    _classCallCheck(this, le);

    this.defaultScale = 1;
    this.SCALE_LEVELS = [8.33, 12.5, 16.66, 25, 33.33, 50, 66.66, 100, 125, 150, 200, 300, 400, 500, 600].map(function (e) {
      return e / 100;
    });
    this.state = {
      position: {
        x: 0,
        y: 0
      },
      scaleIndex: -1
    };
    this.offset = {
      x: 0,
      y: 0
    };

    this.in = function () {
      _this56.canZoomIn && (_this56.state.scaleIndex += 1, _this56.scaleRender());
    };

    this.out = function () {
      if (_this56.canZoomOut) {
        _this56.state.scaleIndex -= 1;

        var _this56$checkOffset = _this56.checkOffset({
          x: 0,
          y: 0
        }),
            _e7 = _this56$checkOffset.canDragX,
            t = _this56$checkOffset.canDragY,
            r = _this56$checkOffset.maxOffsetX,
            o = _this56$checkOffset.maxOffsetY;

        t || (_this56.offset.y = o), _e7 || (_this56.offset.x = r), _this56.savePosition(), _this56.scaleRender();
      }
    };

    this.setOffset = function (e) {
      var _this56$checkOffset2 = _this56.checkOffset(e),
          t = _this56$checkOffset2.canDragX,
          r = _this56$checkOffset2.canDragY;

      t && (_this56.offset.x = e.x), r && (_this56.offset.y = e.y), _this56.scaleRender();
    };

    this.editor = e;
  }

  _createClass(le, [{
    key: "setInitialTransform",
    value: function setInitialTransform() {
      var _this57 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = this.editor.engineMediator.preview.transform;
      re(function () {
        _this57.setDefaultScale(Math.abs(e || t.scale.x)), _this57.setPosition(t.position);
      });
    }
  }, {
    key: "resetScale",
    value: function resetScale() {
      this.state.scaleIndex = -1;
    }
  }, {
    key: "resetPosition",
    value: function resetPosition() {
      var _this$editor$canvasSt = this.editor.canvasStore.canvas,
          e = _this$editor$canvasSt.width,
          t = _this$editor$canvasSt.height;
      this.setPosition({
        x: e / 2,
        y: t / 2
      });
    }
  }, {
    key: "resetOffset",
    value: function resetOffset() {
      this.offset = {
        x: 0,
        y: 0
      };
    }
  }, {
    key: "setPosition",
    value: function setPosition(e) {
      this.state.position.x = e.x, this.state.position.y = e.y;
    }
  }, {
    key: "savePosition",
    value: function savePosition() {
      this.setPosition(this.getPositionWithOffset()), this.offset = {
        x: 0,
        y: 0
      };
    }
  }, {
    key: "setDefaultScale",
    value: function setDefaultScale(e) {
      var _this58 = this;

      if (this.defaultScale !== 1) {
        var r = this.SCALE_LEVELS.findIndex(function (o) {
          return o === _this58.defaultScale;
        });
        r !== -1 && (this.SCALE_LEVELS = [].concat(_toConsumableArray(this.SCALE_LEVELS.slice(0, r)), _toConsumableArray(this.SCALE_LEVELS.slice(r + 1))));
      }

      var t = this.SCALE_LEVELS.findIndex(function (r, o) {
        return o === 0 ? e < r : o === _this58.SCALE_LEVELS.length - 1 ? r < e : _this58.SCALE_LEVELS[o - 1] < e && e < r;
      });
      if (t !== -1) this.SCALE_LEVELS = [].concat(_toConsumableArray(this.SCALE_LEVELS.slice(0, t)), [e], _toConsumableArray(this.SCALE_LEVELS.slice(t))), t === this.state.scaleIndex && this.resetScale(), this.state.scaleIndex = t, this.defaultScale = e;else {
        var _r6 = this.SCALE_LEVELS.findIndex(function (o) {
          return o === e;
        });

        _r6 === this.state.scaleIndex && this.resetScale(), _r6 !== -1 && (this.state.scaleIndex = _r6, this.defaultScale = e);
      }
    }
  }, {
    key: "setScaleToDefault",
    value: function setScaleToDefault() {
      this.state.scaleIndex = this.defaultIndex;
    }
  }, {
    key: "checkOffset",
    value: function checkOffset(e) {
      var t = window.devicePixelRatio || 1,
          r = this.scaledSize,
          o = this.previewSize,
          n = this.editor.engineMediator.preview.initialTransform.position,
          s = this.getPositionWithOffset(e),
          l = (r.width - o.width) * t / 2,
          c = (r.height - o.height) * t / 2,
          p = n.x - s.x,
          m = n.y - s.y,
          h = Math.abs(p),
          b = Math.abs(m),
          v = p > 0,
          x = m > 0,
          I = h - l,
          R = b - c;
      return {
        canDragX: I < 0,
        canDragY: R < 0,
        maxOffsetX: v ? -I : I,
        maxOffsetY: x ? -R : R
      };
    }
  }, {
    key: "calculateScale",
    value: function calculateScale() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.previewSize;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.defaultScale;
      var o = t.width,
          n = t.height,
          s = new _({
        x: o,
        y: n
      }),
          l = new _(Math.abs(s.x * Math.cos(e)) + Math.abs(s.y * Math.sin(e)), Math.abs(s.x * Math.sin(e)) + Math.abs(s.y * Math.cos(e))),
          c = s.subtract(l).divide(2).multiply(r).abs;
      return c.y > c.x ? c.y * 2 / s.y + r : c.x * 2 / s.x + r;
    }
  }, {
    key: "getPositionWithOffset",
    value: function getPositionWithOffset() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.offset;
      var t = this.position;
      return {
        x: t.x - e.x,
        y: t.y - e.y
      };
    }
  }, {
    key: "scaleRender",
    value: function scaleRender() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.editor.scale.getPositionWithOffset(),
          r = e ? this.defaultScale : this.scale,
          o = {
        x: r,
        y: r
      };
      this.editor.engineMediator.preview.container.setScale(o), this.editor.engineMediator.preview.container.setPosition(t), this.editor.engineMediator.preview.savePreviewTransform({
        scale: o,
        position: t,
        rotation: 0
      }), e || this.editor.render();
    }
  }, {
    key: "defaultIndex",
    get: function get() {
      var _this59 = this;

      return this.SCALE_LEVELS.findIndex(function (e) {
        return e === _this59.defaultScale;
      });
    }
  }, {
    key: "scale",
    get: function get() {
      var e = this.state.scaleIndex;
      return e !== -1 ? this.SCALE_LEVELS[e] : this.defaultScale;
    }
  }, {
    key: "zoomLevel",
    get: function get() {
      var e = window.devicePixelRatio || 1;
      return (this.scale / e * 100).toFixed(1);
    }
  }, {
    key: "canDrag",
    get: function get() {
      return this.defaultScale < this.scale;
    }
  }, {
    key: "canZoomOut",
    get: function get() {
      return this.state.scaleIndex > this.defaultIndex;
    }
  }, {
    key: "canZoomIn",
    get: function get() {
      return this.SCALE_LEVELS.length - 1 > this.state.scaleIndex;
    }
  }, {
    key: "position",
    get: function get() {
      return this.state.position;
    }
  }, {
    key: "scaledSize",
    get: function get() {
      var e = this.state.scaleIndex,
          t = e !== -1 ? this.SCALE_LEVELS[e] : this.defaultScale,
          r = this.previewSize;
      return {
        width: r.width * t / this.defaultScale,
        height: r.height * t / this.defaultScale
      };
    }
  }, {
    key: "previewSize",
    get: function get() {
      return this.editor.getPreviewSize();
    }
  }]);

  return le;
}();

a([S], le.prototype, "state", 2), a([d], le.prototype, "in", 2), a([d], le.prototype, "out", 2), a([d], le.prototype, "setInitialTransform", 1), a([d], le.prototype, "resetScale", 1), a([d], le.prototype, "resetPosition", 1), a([d], le.prototype, "setPosition", 1), a([d], le.prototype, "savePosition", 1), a([d], le.prototype, "setDefaultScale", 1), a([d], le.prototype, "setScaleToDefault", 1), a([u], le.prototype, "scale", 1), a([u], le.prototype, "zoomLevel", 1), a([u], le.prototype, "canDrag", 1), a([u], le.prototype, "canZoomOut", 1), a([u], le.prototype, "canZoomIn", 1), a([u], le.prototype, "position", 1), a([u], le.prototype, "scaledSize", 1);

var Yl = /^data:image\/(.+?);base64,/,
    em = function em(i) {
  return Yl.test(i);
},
    tm = function tm(i) {
  return i.match(/^data:([^;]+)/)[1];
},
    im = function im(i) {
  return i.replace(Yl, "");
},
    or =
/*#__PURE__*/
function () {
  function or(e) {
    var _this60 = this;

    _classCallCheck(this, or);

    this.applySerialization = function (e, t, r, o) {
      return C(_this60, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20() {
        var n, s, l, c, m, p, _m7;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.editor.resetToolStates();
                n = this.editor.activeStore.tool === g.TRANSFORM;
                n || this.editor.transformToolStore.onEnter(), this.editor.transformToolStore.reset(), n || this.editor.transformToolStore.onLeave();
                s = new t(this.editor), l = "Unexpected error occured", c = t.deserializeImage(e);

                if (!(c.image && c.image.data)) {
                  _context20.next = 20;
                  break;
                }

                m = c.image.data;
                _context20.next = 8;
                return this.editor.setImage(m);

              case 8:
                this.editor.scale.defaultScale = 1;
                this.editor.scale.resetOffset();
                this.editor.transformToolStore.reset();
                this.editor.activeStore.setImage(m);
                _context20.next = 14;
                return this.editor.engineMediator.image.addImageToContainer();

              case 14:
                this.editor.engineMediator.output.applyNewImageTransform();
                this.editor.engineMediator.preview.updateTransform();
                this.editor.scale.setInitialTransform();
                this.editor.transformToolStore.setCropDefaults();
                this.editor.historyStore.addInitialSnapshot();
                this.editor.transformToolStore.saveTransforms();

              case 20:
                p = s.deserializeTransformation(e);

                if (!p) {
                  _context20.next = 37;
                  break;
                }

                _context20.next = 24;
                return this.applyStateOnUI(p);

              case 24:
                _m7 = s.deserialize(e);

                if (!_m7) {
                  _context20.next = 34;
                  break;
                }

                _context20.next = 28;
                return this.applyStateOnUI(_m7);

              case 28:
                _context20.next = 30;
                return this.editor.render();

              case 30:
                this.editor.modalStore.identifier === "loading" && this.editor.modalStore.hideModal();
                r();
                _context20.next = 35;
                break;

              case 34:
                o(l);

              case 35:
                _context20.next = 38;
                break;

              case 37:
                o(l);

              case 38:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));
    };

    this.editor = e;
  }

  _createClass(or, [{
    key: "serialize",
    value: function serialize() {
      var _this61 = this;

      var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        image: !1
      },
          e = _ref19.image;

      var t = this.editor.activeStore.tool === g.TRANSFORM;
      return this.editor.modalStore.showInfoModal("saving"), new Promise(function (r, o) {
        import("./serialization/index.js").then(function (s) {
          return C(_this61, [s],
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee21(_ref20) {
            var n, _h8, _this$editor$imageCon, l, c, p, m, h, _ref21, b, v, x, I, R;

            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    n = _ref20.Serializer;
                    _context21.prev = 1;
                    t && this.editor.transformToolStore.onLeave();
                    _context21.next = 5;
                    return this.editor.wait();

                  case 5:
                    this.editor.transformToolStore.applyDefaultCrop(!1);
                    _this$editor$imageCon = this.editor.imageContainer.getData();
                    l = _this$editor$imageCon.originalImage;
                    c = this.editor.engineMediator.output.container.getResolution();
                    p = {
                      width: l.width,
                      height: l.height
                    };
                    m = new n(this.editor.transformToolStore.defaultCropMaskPosition, this.editor.transformToolStore.maxCropMaskSize, c, p, this.editor.engine.getRootContainers()[0], this.editor.engine.getOutputContainer());
                    h = (_h8 = {}, _defineProperty(_h8, g.ADJUSTMENT, k(this.editor.adjustmentsToolStore.state)), _defineProperty(_h8, g.FILTER, k(this.editor.filterToolStore.state)), _defineProperty(_h8, g.FOCUS, k(this.editor.focusToolStore.serializableState)), _defineProperty(_h8, g.OVERLAY, k(this.editor.overlayToolStore.state)), _defineProperty(_h8, g.FRAME, k(this.editor.frameToolStore.state)), _defineProperty(_h8, g.BRUSH, this.editor.brushToolStore.strokes || {
                      strokes: []
                    }), _h8);
                    _context21.next = 14;
                    return this.editor.spriteStore.serializableState();

                  case 14:
                    _ref21 = _context21.sent;
                    b = _ref21.sprite;
                    v = _ref21.customStickers;
                    b.spriteIdList = b.spriteIdList.sort(function (R, M) {
                      var Q = b.common[R].order,
                          se = b.common[M].order;
                      return Q - se;
                    }), h.sprite = b, h.customStickers = v, h.transform = this.editor.transformToolStore.serializableState;

                    if (e) {
                      R = or.getDataURL(l);
                      I = tm(R), x = im(R);
                    }

                    this.editor.modalStore.hideModal(), r(m.serialise(h, x, I)), t && this.editor.transformToolStore.onEnter();
                    _context21.next = 25;
                    break;

                  case 22:
                    _context21.prev = 22;
                    _context21.t0 = _context21["catch"](1);
                    this.editor.modalStore.hideModal(), o(_context21.t0);

                  case 25:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21, this, [[1, 22]]);
          }));
        });
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize(e) {
      var _this62 = this;

      return this.editor.modalStore.showInfoModal("loading"), new Promise(function (t, r) {
        try {
          import("./serialization/index.js").then(function (_ref22) {
            var o = _ref22.Deserializer;
            o.checkIsSerialisationValid(e) ? _this62.applySerialization(e, o, t, r) : (_this62.editor.modalStore.hideModal(), _this62.editor.modalStore.showActionModal({
              type: oe.WARNING,
              identifier: "unsupportedSerializationVersion",
              handleConfirm: function handleConfirm() {
                return _this62.applySerialization(e, o, t, r);
              }
            }));
          });
        } catch (o) {
          _this62.editor.modalStore.identifier === "loading" && _this62.editor.modalStore.hideModal(), r(o);
        }
      });
    }
  }, {
    key: "applyStateOnUI",
    value: function applyStateOnUI(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee22() {
        var t;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                t = this.editor.activeStore.tool === g.TRANSFORM;
                _context22.prev = 1;
                _context22.t0 = e.transform;

                if (!_context22.t0) {
                  _context22.next = 15;
                  break;
                }

                t || this.editor.transformToolStore.onEnter();
                this.editor.transformToolStore.updateStateFromSerialization(e.transform, !0);
                _context22.next = 8;
                return this.editor.wait();

              case 8:
                _context22.t1 = t;

                if (_context22.t1) {
                  _context22.next = 15;
                  break;
                }

                this.editor.transformToolStore.onLeave();
                this.editor.transformToolStore.onEnter();
                _context22.next = 14;
                return this.editor.wait();

              case 14:
                this.editor.transformToolStore.onLeave();

              case 15:
                _context22.t2 = e.filter;

                if (!_context22.t2) {
                  _context22.next = 19;
                  break;
                }

                _context22.next = 19;
                return this.editor.filterToolStore.updateStateFromSerialization(e.filter);

              case 19:
                e.adjustment && this.editor.adjustmentsToolStore.updateStateFromSerialization(e.adjustment);
                _context22.t3 = e.focus;

                if (!_context22.t3) {
                  _context22.next = 24;
                  break;
                }

                _context22.next = 24;
                return this.editor.focusToolStore.updateStateFromSerialization(e.focus);

              case 24:
                _context22.t4 = e.overlay;

                if (!_context22.t4) {
                  _context22.next = 28;
                  break;
                }

                _context22.next = 28;
                return this.editor.overlayToolStore.updateStateFromSerialization(e.overlay);

              case 28:
                _context22.t5 = e.sprite;

                if (!_context22.t5) {
                  _context22.next = 33;
                  break;
                }

                e.sprite.spriteIdList = e.sprite.spriteIdList.sort(function (r, o) {
                  var n = e.sprite.common[r].order,
                      s = e.sprite.common[o].order;
                  return n - s;
                });
                _context22.next = 33;
                return this.editor.spriteStore.updateStateFromSerialization(e.sprite, e.customStickers);

              case 33:
                e.brush && this.editor.brushToolStore.updateStateFromHistory(e.brush);
                _context22.t6 = e.frame;

                if (!_context22.t6) {
                  _context22.next = 38;
                  break;
                }

                _context22.next = 38;
                return this.editor.frameToolStore.updateStateFromSerialization(e.frame);

              case 38:
                this.editor.outputContainer.updateChildrenContainers();
                _context22.next = 44;
                break;

              case 41:
                _context22.prev = 41;
                _context22.t7 = _context22["catch"](1);
                console.error(_context22.t7), this.editor.modalStore.showActionModal({
                  type: oe.ERROR,
                  identifier: "unexpectedError",
                  error: _context22.t7,
                  handleConfirm: function handleConfirm() {
                    window.location.reload();
                  }
                });

              case 44:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[1, 41]]);
      }));
    }
  }], [{
    key: "getDataURL",
    value: function getDataURL(e) {
      if (e instanceof HTMLImageElement) {
        var o = e.src;
        if (em(o)) return o;
      }

      if (e instanceof HTMLCanvasElement) return e.toDataURL(Be.PNG);
      var t = document.createElement("canvas");
      return t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0), t.toDataURL(Be.PNG);
    }
  }]);

  return or;
}();

var st = {
  identifier: "identity",
  opacity: 1,
  width: 0,
  color: xe.white
};

var rm = new Dt(0, 1),
    xt =
/*#__PURE__*/
function () {
  function xt(e) {
    var _this63 = this;

    _classCallCheck(this, xt);

    this.changeIdentifier = function (e) {
      _this63.state.identifier = e;
    };

    this.changeOpacity = function (e) {
      var t = rm.clamp(e);
      _this63.state.opacity = t;
    };

    this.changeWidth = function (e) {
      _this63.state.width = e;
    };

    this.changeColor = function (e) {
      _this63.state.color = e;
    };

    this.reset = function () {
      _this63.indexInContainer === -1 && (_this63.state.identifier = st.identifier, _this63.state.opacity = st.opacity, _this63.state.width = st.width, _this63.state.color = st.color, _this63.removeIndex());
    };

    this.removeFrameEffect = function () {
      _this63.effect && (_this63.engine.removeEffect(_this63.effect), _this63.effect = void 0);
    };

    this.setEffectProperties = function (e) {
      return _this63.effect ? (_this63.removeIndex(), _this63.effect.setProperties(e), _this63.effect.getProperties()) : null;
    };

    this.setFrameEffect = function (_ref23) {
      var e = _ref23.identifier,
          t = _ref23.width,
          r = _ref23.opacity,
          o = _ref23.color;
      var n = f({}, _this63.state);
      _this63.changeIdentifier(e), _this63.changeWidth(t), _this63.changeOpacity(r), _this63.changeColor(o), _this63.removeFrameEffect();

      var s = _this63.engineMediator.orderHelper.addSprite(e);

      return new Promise(function (l, c) {
        _this63.engine.addFrameFromAssets(e, _this63.engineMediator.image.container, s).then(function (p) {
          _this63.effect = p, _this63.effect.setProperties({
            tintColor: o,
            opacity: r,
            width: t
          }), l();
        }).catch(function (p) {
          _this63.changeIdentifier(n.identifier), _this63.changeOpacity(n.opacity), _this63.changeWidth(n.width), _this63.changeColor(n.color), n.identifier === "identity" && _this63.removeIndex(), c(p);
        });
      });
    };

    this.removeIndex = function () {
      _this63.engineMediator.orderHelper.removeSprite(_this63.state.identifier);
    };

    this.engineMediator = e, this.state = st;
  }

  _createClass(xt, [{
    key: "engine",
    get: function get() {
      return this.engineMediator.engine;
    }
  }, {
    key: "imageContainer",
    get: function get() {
      return this.engineMediator.image.container;
    }
  }, {
    key: "indexInContainer",
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    }
  }]);

  return xt;
}();

a([S], xt.prototype, "state", 2), a([d], xt.prototype, "changeIdentifier", 2), a([d], xt.prototype, "changeOpacity", 2), a([d], xt.prototype, "changeWidth", 2), a([d], xt.prototype, "changeColor", 2), a([d], xt.prototype, "reset", 2);

var J =
/*#__PURE__*/
function () {
  function J(e) {
    var _this64 = this;

    _classCallCheck(this, J);

    this.colorList = ie.defaultColors;

    this.selectFrame = function (e) {
      return C(_this64, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee23() {
        var _t8;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!(e !== this.identifier)) {
                  _context23.next = 6;
                  break;
                }

                _t8 = .1 * this.editor.shortestOutputSide;
                _context23.next = 4;
                return this.frameStore.setFrameEffect({
                  identifier: e,
                  width: _t8,
                  opacity: 1,
                  color: st.color
                });

              case 4:
                this.editor.render();
                this.addSnapshot(F.ADD, g.FRAME);

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));
    };

    this.changeOpacity = function (e) {
      var t = _this64.frameStore.setEffectProperties({
        opacity: e
      });

      t && (_this64.frameStore.changeOpacity(t.opacity), _this64.editor.render());
    };

    this.changeWidth = function (e) {
      var t = _this64.frameStore.setEffectProperties({
        width: e
      });

      t && (_this64.frameStore.changeWidth(t.width), _this64.editor.render());
    };

    this.changeColor = function (e) {
      var t = _this64.frameStore.setEffectProperties({
        tintColor: e
      });

      t && (_this64.frameStore.changeColor(t.tintColor), _this64.editor.render());
    };

    this.colorSnapshot = function () {
      _this64.addSnapshot(F.EDIT, _this64.locale.controls.selectColor);
    };

    this.toolSnapshot = function (e) {
      _this64.addSnapshot(F.EDIT, e);
    };

    this.addSnapshot = function (e, t) {
      _this64.editor.addSnapshot(void 0, e, t);
    };

    this.pureReset = function () {
      _this64.frameStore.removeFrameEffect(), _this64.frameStore.reset();
    };

    this.reset = function () {
      _this64.pureReset(), _this64.addSnapshot(F.DELETE, _this64.locale.controls.buttonReset), _this64.editor.render();
    };

    this.updateStateFromHistory = function (e) {
      return e.identifier === "identity" ? (_this64.pureReset(), new Promise(function (t) {
        t();
      })) : _this64.frameStore.setFrameEffect(e);
    };

    this.updateStateFromSerialization = function (e) {
      return C(_this64, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee24() {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this.entityManager.items.find(function (r) {
                  return r.identifier === e.identifier;
                }) ? this.frameStore.setFrameEffect(e) : new Promise(function (r, o) {
                  o(new Error("Frame Asset doesn't exist"));
                }));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));
    };

    this.editor = e, this.frameStore = new xt(this.editor.engineMediator);
    var t = this.editor.assetProvider.getAssets("frame"),
        r = this.config;
    this.entityManager = new ee(t, f(f({}, r), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("frame")
    })), st.color = k(Ge(this.config, "defaultColor", st.color)), this.config.colors && this.config.colors.length > 0 && (this.colorList = Ke(k(this.config.colors)));
  }

  _createClass(J, [{
    key: "state",
    get: function get() {
      return this.frameStore.state;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.state.identifier;
    }
  }, {
    key: "color",
    get: function get() {
      return this.state.color;
    }
  }, {
    key: "size",
    get: function get() {
      return this.state.width;
    }
  }, {
    key: "tintable",
    get: function get() {
      var _this65 = this;

      var e = this.entityManager.items.find(function (t) {
        return t.identifier === _this65.identifier;
      });
      return e && e.tintable || !1;
    }
  }, {
    key: "opacity",
    get: function get() {
      return this.state.opacity;
    }
  }, {
    key: "minSize",
    get: function get() {
      return this.editor.shortestOutputSide * .05;
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this.editor.shortestOutputSide * .3;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.FRAME];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.FRAME];
    }
  }, {
    key: "localeColor",
    get: function get() {
      return this.editor.configStore.locale.common.color;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }, {
    key: "isOptionSelected",
    get: function get() {
      return this.identifier !== "identity";
    }
  }]);

  return J;
}();

a([d], J.prototype, "selectFrame", 2), a([d], J.prototype, "changeOpacity", 2), a([d], J.prototype, "changeWidth", 2), a([d], J.prototype, "changeColor", 2), a([d], J.prototype, "pureReset", 2), a([d], J.prototype, "reset", 2), a([d], J.prototype, "updateStateFromHistory", 2), a([d], J.prototype, "updateStateFromSerialization", 2), a([u], J.prototype, "state", 1), a([u], J.prototype, "identifier", 1), a([u], J.prototype, "color", 1), a([u], J.prototype, "size", 1), a([u], J.prototype, "tintable", 1), a([u], J.prototype, "opacity", 1), a([u], J.prototype, "minSize", 1), a([u], J.prototype, "maxSize", 1), a([u], J.prototype, "config", 1), a([u], J.prototype, "locale", 1), a([u], J.prototype, "localeColor", 1), a([u], J.prototype, "items", 1), a([u], J.prototype, "isOptionSelected", 1);

var om = {
  categories: [],
  query: ""
},
    Fe =
/*#__PURE__*/
function () {
  function Fe(e) {
    var _this66 = this;

    _classCallCheck(this, Fe);

    this.initProvider = function (e) {
      e && (_this66.libraryProvider = new e());
    };

    this.fetchImages = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return C(_this66, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee25() {
        var _this67 = this;

        var t, r, o;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!this.libraryProvider) {
                  _context25.next = 16;
                  break;
                }

                t = null;
                _context25.prev = 2;
                _context25.next = 5;
                return this.libraryProvider.getCategories();

              case 5:
                r = _context25.sent;
                _context25.next = 8;
                return this.libraryProvider.searchImages(e);

              case 8:
                o = _context25.sent;
                t = r.map(function (n, s) {
                  var l = o.filter(function (c) {
                    return c.category === n.name;
                  });
                  return {
                    identifier: n.name,
                    name: n.name,
                    thumbnailURI: n.coverImageUrl,
                    items: l.map(function (c) {
                      return {
                        name: c.title || "image".concat(s),
                        identifier: "".concat(n.name, "-").concat(c.title, "-").concat(s),
                        thumbnailURI: c.thumbUrl,
                        rawUrl: c.rawUrl,
                        authorName: c.authorName,
                        authorAvatar: c.authorAvatar
                      };
                    })
                  };
                }).filter(function (n) {
                  return n.items.length;
                });
                _context25.next = 15;
                break;

              case 12:
                _context25.prev = 12;
                _context25.t0 = _context25["catch"](2);
                console.log(_context25.t0);

              case 15:
                re(function () {
                  _this67.state.query = e, _this67.state.categories = t;
                });

              case 16:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[2, 12]]);
      }));
    };

    this.toggleCategorySelection = function (e) {
      _this66.selectedCategory = _this66.selectedCategory !== e ? e : "";
    };

    this.getRawUrl = function (e) {
      var t = _this66.items.findIndex(function (r) {
        return r.identifier === e;
      });

      return t !== -1 ? _this66.items[t].rawUrl : e;
    };

    this.configStore = e.configStore, this.state = S(om), this.selectedCategory = "";
  }

  _createClass(Fe, [{
    key: "selectedCategoryIdentifier",
    get: function get() {
      return this.selectedCategory;
    }
  }, {
    key: "categories",
    get: function get() {
      return this.state.categories;
    }
  }, {
    key: "items",
    get: function get() {
      return this.state.categories.map(function (e) {
        return e.items;
      }).reduce(function (e, t) {
        return [].concat(_toConsumableArray(e), _toConsumableArray(t));
      }, []);
    }
  }, {
    key: "query",
    get: function get() {
      return this.state.query;
    }
  }, {
    key: "config",
    get: function get() {
      return this.configStore.config[g.LIBRARY];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.configStore.locale[g.LIBRARY];
    }
  }]);

  return Fe;
}();

a([S], Fe.prototype, "selectedCategory", 2), a([d], Fe.prototype, "initProvider", 2), a([d], Fe.prototype, "fetchImages", 2), a([d], Fe.prototype, "toggleCategorySelection", 2), a([u], Fe.prototype, "selectedCategoryIdentifier", 1), a([u], Fe.prototype, "categories", 1), a([u], Fe.prototype, "items", 1), a([u], Fe.prototype, "query", 1), a([u], Fe.prototype, "config", 1), a([u], Fe.prototype, "locale", 1);
var nr = {
  identifier: "identity",
  opacity: 1,
  blendMode: j.LIGHTEN
};

var nm = new Dt(0, 1),
    Ct =
/*#__PURE__*/
function () {
  function Ct(e, t) {
    var _this68 = this;

    _classCallCheck(this, Ct);

    this.changeIdentifier = function (e) {
      _this68.state.identifier = e;
    };

    this.changeOpacity = function (e) {
      var t = nm.clamp(e);
      _this68.state.opacity = t;
    };

    this.changeBlendMode = function (e) {
      _this68.state.blendMode = e;
    };

    this.reset = function () {
      _this68.indexInContainer === -1 && (_this68.state.identifier = nr.identifier, _this68.state.opacity = nr.opacity, _this68.state.blendMode = nr.blendMode, _this68.removeIndex());
    };

    this.correctOverlayFlip = function () {
      var _this68$editor$output = _this68.editor.outputContainer.getData(),
          e = _this68$editor$output.flipHorizontally,
          t = _this68$editor$output.flipVertically;

      _this68.effect && (_this68.effect.setFlipHorizontally(e), _this68.effect.setFlipVertically(t));
    };

    this.removeOverlayEffect = function () {
      _this68.effect && (_this68.removeIndex(), _this68.engineMediator.engine.removeEffect(_this68.effect), _this68.effect = void 0);
    };

    this.setEffectProperties = function (e) {
      return _this68.effect ? (_this68.effect.setProperties(e), _this68.effect.getProperties()) : null;
    };

    this.setOverlayEffect = function (_ref24) {
      var e = _ref24.identifier,
          t = _ref24.blendMode,
          r = _ref24.opacity;
      var o = f({}, _this68.state);
      _this68.changeIdentifier(e), _this68.changeOpacity(r), _this68.changeBlendMode(t), _this68.removeOverlayEffect();

      var n = _this68.engineMediator.orderHelper.addIndex(g.OVERLAY);

      return new Promise(function (s, l) {
        _this68.engineMediator.engine.addOverlayFromAssets(e, _this68.engineMediator.image.container, n).then(function (c) {
          _this68.effect = c, _this68.effect.setProperties({
            blendMode: t,
            opacity: r
          }), _this68.correctOverlayFlip(), s();
        }).catch(function (c) {
          _this68.changeIdentifier(o.identifier), _this68.changeOpacity(o.opacity), _this68.changeBlendMode(o.blendMode), o.identifier === "identity" && _this68.removeIndex(), l(c);
        });
      });
    };

    this.removeIndex = function () {
      _this68.engineMediator.orderHelper.removeIndex(g.OVERLAY);
    };

    this.engineMediator = e, this.editor = t, this.state = nr;
  }

  _createClass(Ct, [{
    key: "indexInContainer",
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    }
  }]);

  return Ct;
}();

a([S], Ct.prototype, "state", 2), a([d], Ct.prototype, "changeIdentifier", 2), a([d], Ct.prototype, "changeOpacity", 2), a([d], Ct.prototype, "changeBlendMode", 2), a([d], Ct.prototype, "reset", 2), a([d], Ct.prototype, "correctOverlayFlip", 2);

var ce =
/*#__PURE__*/
function () {
  function ce(e) {
    var _this69 = this;

    _classCallCheck(this, ce);

    this.selectOverlay = function (e) {
      return C(_this69, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee26() {
        var _t9;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (!(e !== this.identifier)) {
                  _context26.next = 6;
                  break;
                }

                _t9 = this.defaultBlendModeForIdentifier(e);
                _context26.next = 4;
                return this.overlayStore.setOverlayEffect({
                  identifier: e,
                  opacity: 1,
                  blendMode: _t9
                });

              case 4:
                this.addSnapshot(F.ADD, g.OVERLAY);
                this.editor.render();

              case 6:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));
    };

    this.changeOpacity = function (e) {
      var t = _this69.overlayStore.setEffectProperties({
        opacity: e
      });

      t && (_this69.overlayStore.changeOpacity(t.opacity), _this69.editor.render());
    };

    this.toolSnapshot = function () {
      _this69.addSnapshot(F.EDIT, _this69.locale.controls.sliderOpacity);
    };

    this.addSnapshot = function (e, t) {
      _this69.editor.addSnapshot(void 0, e, t);
    };

    this.changeBlendMode = function (e) {
      var t = _this69.overlayStore.setEffectProperties({
        blendMode: e
      });

      t && (_this69.overlayStore.changeBlendMode(t.blendMode), _this69.addSnapshot(F.EDIT, _this69.locale.controls.carouselBlendMode), _this69.editor.render());
    };

    this.pureReset = function () {
      _this69.overlayStore.removeOverlayEffect(), _this69.overlayStore.reset();
    };

    this.reset = function () {
      _this69.pureReset(), _this69.addSnapshot(F.DELETE, _this69.locale.controls.buttonReset), _this69.editor.render();
    };

    this.updateStateFromSerialization = function (e) {
      return C(_this69, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee27() {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.entityManager.items.find(function (r) {
                  return r.identifier === e.identifier;
                }) ? this.overlayStore.setOverlayEffect(e) : new Promise(function (r, o) {
                  o(new Error("Overlay Asset ".concat(e.identifier, " doesn't exist")));
                }));

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));
    };

    this.updateStateFromHistory = function (e) {
      return C(_this69, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee28() {
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", e.identifier === "identity" ? (this.pureReset(), new Promise(function (t) {
                  t();
                })) : this.overlayStore.setOverlayEffect(e));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));
    };

    this.correctOverlayFlip = function () {
      _this69.overlayStore.correctOverlayFlip();
    };

    this.defaultBlendModeForIdentifier = function (e) {
      var t = _this69.entityManager.items.findIndex(function (r) {
        return r.identifier === e;
      });

      return t !== -1 ? _this69.entityManager.items[t].defaultBlendMode : j.LIGHTEN;
    };

    this.editor = e, this.overlayStore = new Ct(this.editor.engineMediator, e);
    var t = this.editor.assetProvider.getAssets("overlay"),
        r = this.config;
    this.entityManager = new ee(t, f(f({}, r), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("overlay")
    }));
  }

  _createClass(ce, [{
    key: "state",
    get: function get() {
      return this.overlayStore.state;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.overlayStore.state.identifier;
    }
  }, {
    key: "opacity",
    get: function get() {
      return this.overlayStore.state.opacity;
    }
  }, {
    key: "blendMode",
    get: function get() {
      return this.overlayStore.state.blendMode;
    }
  }, {
    key: "isOptionSelected",
    get: function get() {
      return this.identifier !== "identity";
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.OVERLAY];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.OVERLAY];
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }, {
    key: "allBlendModes",
    get: function get() {
      var e = this.locale.controls;
      return Object.keys(j).map(function (t) {
        var r = j[t],
            o = "blendMode".concat(r.charAt(0).toUpperCase()).concat(r.slice(1));
        return {
          identifier: r,
          value: e[o]
        };
      });
    }
  }]);

  return ce;
}();

a([d], ce.prototype, "selectOverlay", 2), a([d], ce.prototype, "changeOpacity", 2), a([d], ce.prototype, "changeBlendMode", 2), a([d], ce.prototype, "pureReset", 2), a([d], ce.prototype, "reset", 2), a([d], ce.prototype, "updateStateFromSerialization", 2), a([d], ce.prototype, "updateStateFromHistory", 2), a([d], ce.prototype, "correctOverlayFlip", 2), a([u], ce.prototype, "state", 1), a([u], ce.prototype, "identifier", 1), a([u], ce.prototype, "opacity", 1), a([u], ce.prototype, "blendMode", 1), a([u], ce.prototype, "isOptionSelected", 1), a([u], ce.prototype, "config", 1), a([u], ce.prototype, "locale", 1), a([u], ce.prototype, "items", 1), a([u], ce.prototype, "allBlendModes", 1);

var sm = function sm(i) {
  var e = atob(i.split(",")[1]),
      t = i.split(",")[0].split(":")[1].split(";")[0],
      r = new ArrayBuffer(e.length),
      o = new Uint8Array(r);

  for (var n = 0; n < e.length; n += 1) {
    o[n] = e.charCodeAt(n);
  }

  return new Blob([r], {
    type: t
  });
},
    gs = sm;

var ro = Ye(bs());

var sr =
/*#__PURE__*/
function () {
  _createClass(sr, null, [{
    key: "isImageElement",
    value: function isImageElement(e) {
      return e instanceof HTMLImageElement;
    }
  }]);

  function sr(_ref25) {
    var e = _ref25.license,
        t = _ref25.assetProvider,
        r = _ref25.crossOrigin;

    _classCallCheck(this, sr);

    this.crossOrigin = r, this.engine = new tr({
      license: e,
      crossOrigin: r,
      assetProvider: t,
      downscaleOptions: {
        maxDimensions: {
          width: 100,
          height: 100
        }
      }
    });
  }

  _createClass(sr, [{
    key: "getAllFilterPreviewThumbnails",
    value: function getAllFilterPreviewThumbnails(e) {
      var _this70 = this;

      return new Promise(function (t, r) {
        var o = [],
            n = [];
        e.forEach(function (s) {
          s.isDuotone ? o.push(s.identifier) : n.push(s.identifier);
        }), _this70.getAllDuotonePreview(o).then(function (s) {
          _this70.getAllLutPreview(n).then(function (l) {
            t(Object.assign(s, l));
          });
        }).catch(function (s) {
          r(s);
        });
      });
    }
  }, {
    key: "getAllDuotonePreview",
    value: function getAllDuotonePreview(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee30() {
        var _this71 = this;

        var t, r;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = {};

                if (e.length) {
                  _context30.next = 3;
                  break;
                }

                return _context30.abrupt("return", t);

              case 3:
                _context30.next = 5;
                return this.engine.addDuoToneFilterFromAssets(e[0], this.container);

              case 5:
                r = _context30.sent;
                _context30.next = 8;
                return ro.default(e, function (o) {
                  return C(_this71, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee29() {
                    var n, l;
                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            n = this.engine.assetProvider.getDuotoneFilterAsset(o);
                            r.filterOperation.getFilter().set({
                              intensity: .5,
                              lightColor: pe.Color.fromHex(n.lightColor),
                              darkColor: pe.Color.fromHex(n.darkColor)
                            });
                            _context29.next = 4;
                            return this.engine.export($e.DATA_URL, Be.PNG);

                          case 4:
                            l = _context29.sent;
                            t[o] = l;

                          case 6:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29, this);
                  }));
                }, {
                  concurrency: 1
                });

              case 8:
                this.engine.removeEffect(r);
                return _context30.abrupt("return", t);

              case 10:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));
    }
  }, {
    key: "loadLutAssets",
    value: function loadLutAssets(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee32() {
        var _this72 = this;

        var t;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                t = {};
                _context32.next = 3;
                return ro.default(e, function (r) {
                  return C(_this72, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee31() {
                    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                      while (1) {
                        switch (_context31.prev = _context31.next) {
                          case 0:
                            _context31.next = 2;
                            return this.engine.getLutFilterImage(r);

                          case 2:
                            t[r] = _context31.sent;

                          case 3:
                          case "end":
                            return _context31.stop();
                        }
                      }
                    }, _callee31, this);
                  }));
                });

              case 3:
                return _context32.abrupt("return", t);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32);
      }));
    }
  }, {
    key: "getAllLutPreview",
    value: function getAllLutPreview(e) {
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee34() {
        var _this73 = this;

        var t, r, o;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                t = {};

                if (e.length) {
                  _context34.next = 3;
                  break;
                }

                return _context34.abrupt("return", t);

              case 3:
                _context34.next = 5;
                return this.loadLutAssets(e);

              case 5:
                r = _context34.sent;
                _context34.next = 8;
                return this.engine.addLUTFilterFromAssets(e[0], this.container);

              case 8:
                o = _context34.sent;
                _context34.next = 11;
                return ro.default(e, function (n) {
                  return C(_this73, null,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee33() {
                    var s, l, c, p;
                    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            s = this.engine.assetProvider.getLUTFilterAsset(n), l = o.filterOperation.getFilter(), c = {
                              horizontalTileCount: s.horizontalTileCount || 5,
                              verticalTileCount: s.verticalTileCount || 5,
                              image: r[n]
                            };
                            l.set(f(f({}, c), {
                              intensity: s.defaultIntensity || 1
                            })), o.setProperties({
                              intensity: 1
                            }), l._lutPrimitive.set(c);
                            _context33.next = 4;
                            return this.engine.export($e.DATA_URL, Be.PNG);

                          case 4:
                            p = _context33.sent;
                            t[n] = p;

                          case 6:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33, this);
                  }));
                }, {
                  concurrency: 1
                });

              case 11:
                this.engine.removeEffect(o);
                return _context34.abrupt("return", t);

              case 13:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));
    }
  }, {
    key: "addImageToContainer",
    value: function addImageToContainer(e) {
      var _this74 = this;

      return new Promise(function (t, r) {
        var o;
        sr.isImageElement(e) ? (o = e, _this74.setBackgroundImage(o), t()) : _this74.getImageElement(e).then(function (n) {
          o = n, _this74.setBackgroundImage(o), t();
        }).catch(function (n) {
          r({
            identifier: "imageLoading",
            message: n.message
          });
        });
      });
    }
  }, {
    key: "getImageElement",
    value: function getImageElement(e) {
      var _this75 = this;

      return new Promise(function (t, r) {
        var o = new Image();
        o.addEventListener("load", function () {
          t(o);
        }), o.addEventListener("error", function (n) {
          r(n);
        }), o.crossOrigin = _this75.crossOrigin, o.src = e;
      });
    }
  }, {
    key: "setBackgroundImage",
    value: function setBackgroundImage(e) {
      this.container ? this.container.setData({
        image: e
      }) : this.container = this.engine.addImage({
        image: e,
        blendMode: j.NORMAL,
        opacity: 1
      });

      var _this$container$getBo = this.container.getBounds(),
          t = _this$container$getBo.size;

      this.engine.getOutputContainer().setResolution(t);
    }
  }]);

  return sr;
}();

var ar = {
  size: 0,
  color: xe.white,
  hardness: 0,
  maximumSize: .125,
  minimumSize: 0,
  maximumHardness: 1,
  minimumHardness: 0
};

var Y =
/*#__PURE__*/
function () {
  function Y(e) {
    var _this76 = this;

    _classCallCheck(this, Y);

    this.colorList = ie.defaultColors;
    this.dirty = S.box(!1);
    this.id = "";

    this.containerId = function () {
      return _this76.id;
    };

    this.initSize = function () {
      var _this76$state = _this76.state,
          e = _this76$state.minimumSize,
          t = _this76$state.maximumSize,
          r = _this76.size;
      r === 0 && _this76.changeSize(Vn(_this76.config, "defaultSize", [e, t]));
    };

    this.changeColor = function (e) {
      _this76.state.color = e;
    };

    this.changeSize = function (e) {
      _this76.state.size = e;
    };

    this.changeRelativeSize = function (e) {
      var _this76$state2 = _this76.state,
          t = _this76$state2.maximumSize,
          r = _this76$state2.minimumSize;
      _this76.state.size = (t - r) * e / 100 + r;
    };

    this.changeHardness = function (e) {
      _this76.state.hardness = e;
    };

    this.reset = function () {
      _this76.pureReset(), _this76.addSnapshot(F.DELETE, _this76.locale.controls.buttonReset), _this76.editor.render();
    };

    this.editor = e, this.state = f(f({}, ar), {
      hardness: Vn(this.config, "defaultHardness", [ar.minimumHardness, ar.maximumHardness]),
      color: k(Ge(this.config, "defaultColor", ar.color))
    }), this.config.colors && this.config.colors.length > 0 && (this.colorList = Ke(k(this.config.colors)));
  }

  _createClass(Y, [{
    key: "addSnapshot",
    value: function addSnapshot(e, t) {
      this.editor.addSnapshot(void 0, e, t);
    }
  }, {
    key: "clickableCanvas",
    value: function clickableCanvas(e) {
      this.editor.clickableCanvas(e);
    }
  }, {
    key: "beginStroke",
    value: function beginStroke() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!this.drawingContainer) {
        var t = this.editor.orderHelper.addSprite(g.BRUSH);
        this.drawingContainer = this.editor.engine.addDrawing({
          strokes: e
        }, this.editor.imageContainer, t);
      }

      this.id = this.drawingContainer.getID(), this.drawingContainer.beginStroke({
        id: "imgly_brush_radial",
        color: k(this.state.color),
        size: this.state.size,
        hardness: this.state.hardness
      });
    }
  }, {
    key: "strokePosition",
    value: function strokePosition(e) {
      if (this.drawingContainer) {
        var t = this.editor.previewToWorld(e, !1);
        this.drawingContainer.addPointToCurrentStroke(t), this.editor.render();
      }
    }
  }, {
    key: "endStroke",
    value: function endStroke() {
      this.drawingContainer && (this.drawingContainer.endStroke(), this.editor.render(), this.strokes = this.drawingContainer.getData(), this.addSnapshot(F.EDIT, this.locale.history.brushStroke), this.dirty.set(!0));
    }
  }, {
    key: "updateStateFromHistory",
    value: function updateStateFromHistory(e) {
      if (e = e || {
        strokes: []
      }, this.drawingContainer) {
        if (this.strokes && this.strokes.strokes.length === e.strokes.length) return;
        this.strokes = e, this.drawingContainer.setData(this.strokes), e.strokes.length !== 0 && this.dirty.set(!0);
      } else {
        var t = this.editor.orderHelper.addSprite(g.BRUSH);
        this.drawingContainer = this.editor.engine.addDrawing({
          strokes: e.strokes
        }, this.editor.imageContainer, t), this.strokes = this.drawingContainer.getData();
      }

      this.id = this.drawingContainer.getID();
    }
  }, {
    key: "pureReset",
    value: function pureReset() {
      this.dirty.set(!1), this.strokes = {
        strokes: []
      }, this.drawingContainer && (this.editor.engine.removeContainer(this.drawingContainer), this.drawingContainer = void 0);
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.BRUSH];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.BRUSH];
    }
  }, {
    key: "localeColor",
    get: function get() {
      return this.editor.configStore.locale.common.color;
    }
  }, {
    key: "color",
    get: function get() {
      return this.state.color;
    }
  }, {
    key: "size",
    get: function get() {
      return this.state.size;
    }
  }, {
    key: "relativeSize",
    get: function get() {
      var _this$state2 = this.state,
          e = _this$state2.size,
          t = _this$state2.maximumSize,
          r = _this$state2.minimumSize;
      return (e - r) * 100 / (t - r);
    }
  }, {
    key: "sizeOnScreenSpace",
    get: function get() {
      var e = this.editor.engineMediator.engine.getSmallerOutputSide();
      return this.editor.worldToPreview(this.state.size * e);
    }
  }, {
    key: "hardness",
    get: function get() {
      return this.state.hardness;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this.dirty.get();
    }
  }]);

  return Y;
}();

a([S], Y.prototype, "state", 2), a([S], Y.prototype, "dirty", 2), a([d], Y.prototype, "initSize", 2), a([d], Y.prototype, "changeColor", 2), a([d], Y.prototype, "changeSize", 2), a([d], Y.prototype, "changeRelativeSize", 2), a([d], Y.prototype, "changeHardness", 2), a([d], Y.prototype, "clickableCanvas", 1), a([d], Y.prototype, "beginStroke", 1), a([d], Y.prototype, "strokePosition", 1), a([d], Y.prototype, "endStroke", 1), a([d], Y.prototype, "updateStateFromHistory", 1), a([d], Y.prototype, "reset", 2), a([u], Y.prototype, "config", 1), a([u], Y.prototype, "locale", 1), a([u], Y.prototype, "localeColor", 1), a([u], Y.prototype, "color", 1), a([u], Y.prototype, "size", 1), a([u], Y.prototype, "relativeSize", 1), a([u], Y.prototype, "sizeOnScreenSpace", 1), a([u], Y.prototype, "hardness", 1), a([u], Y.prototype, "isDirty", 1);
var Xe;

(function (i) {
  i.LEADING = "leading", i.CENTER = "center", i.TRAILING = "trailing";
})(Xe || (Xe = {}));

var am = {
  horizontalGuides: [],
  verticalGuides: [],
  rotationGuides: []
},
    at =
/*#__PURE__*/
function () {
  function at(e) {
    var _this77 = this;

    _classCallCheck(this, at);

    this.previewTopLeftPosition = {
      x: 0,
      y: 0
    };

    this.getGuideValue = function (e, t) {
      var _this77$editor$getPre = _this77.editor.getPreviewSize(),
          r = _this77$editor$getPre.height,
          o = _this77$editor$getPre.width,
          _this77$configStore$c = _this77.configStore.config.snapping.position,
          n = _this77$configStore$c.snapToLeft,
          s = _this77$configStore$c.snapToRight,
          l = _this77$configStore$c.snapToTop,
          c = _this77$configStore$c.snapToBottom,
          p = Math.min(r, o),
          m = 0;

      return t === "bottom" ? m = Math.round(r - p * c) : t === "top" ? m = Math.round(p * l) : t === "right" ? m = Math.round(o - p * s) : t === "left" ? m = Math.round(p * n) : e === "vertical" && t === "center" ? m = Math.round(o / 2) : e === "horizontal" && t === "center" && (m = Math.round(r / 2)), m;
    };

    this.getVerticalGuidesFromConfig = function () {
      var _this77$configStore$c2 = _this77.configStore.config.snapping.position,
          e = _this77$configStore$c2.snapToVerticalCenter,
          t = _this77$configStore$c2.snapToLeft,
          r = _this77$configStore$c2.snapToRight,
          o = [];
      return e && o.push({
        value: _this77.getGuideValue("vertical", "center"),
        edge: Xe.CENTER,
        isVisible: !1,
        direction: "vertical"
      }), t && o.push({
        value: _this77.getGuideValue("vertical", "left"),
        edge: Xe.LEADING,
        isVisible: !1,
        direction: "vertical"
      }), r && o.push({
        value: _this77.getGuideValue("vertical", "right"),
        edge: Xe.TRAILING,
        isVisible: !1,
        direction: "vertical"
      }), o;
    };

    this.getHorizontalGuidesFromConfig = function () {
      var _this77$configStore$c3 = _this77.configStore.config.snapping.position,
          e = _this77$configStore$c3.snapToHorizontalCenter,
          t = _this77$configStore$c3.snapToTop,
          r = _this77$configStore$c3.snapToBottom,
          o = [];
      return e && o.push({
        value: _this77.getGuideValue("horizontal", "center"),
        edge: Xe.CENTER,
        isVisible: !1,
        direction: "horizontal"
      }), t && o.push({
        value: _this77.getGuideValue("horizontal", "top"),
        edge: Xe.LEADING,
        isVisible: !1,
        direction: "horizontal"
      }), r && o.push({
        value: _this77.getGuideValue("horizontal", "bottom"),
        edge: Xe.TRAILING,
        isVisible: !1,
        direction: "horizontal"
      }), o;
    };

    this.getRotationGuidesFromConfig = function () {
      var e = _this77.configStore.config.snapping.rotation.angles,
          t = [];
      return e.forEach(function (o) {
        t.push(o), t.push(o + 360), t.push(o - 360);
      }), t.filter(function (o, n) {
        return t.indexOf(o) === n;
      }).map(function (o) {
        return {
          value: o * Math.PI / 180,
          edge: Xe.CENTER,
          isVisible: !1,
          position: {
            x: 0,
            y: 0
          }
        };
      });
    };

    this.getSpriteDimensions = function (_ref26) {
      var e = _ref26.leftTop,
          t = _ref26.leftBottom,
          r = _ref26.rightTop,
          o = _ref26.rightBottom;
      var n = Math.min(e.y, r.y, t.y, o.y),
          s = Math.max(e.y, r.y, t.y, o.y),
          l = Math.min(e.x, r.x, t.x, o.x),
          c = Math.max(e.x, r.x, t.x, o.x);
      return {
        height: Math.round(s - n),
        width: Math.round(c - l)
      };
    };

    this.mapRange = function (_ref27) {
      var e = _ref27.value,
          t = _ref27.fromMin,
          r = _ref27.fromLength,
          o = _ref27.toMin,
          n = _ref27.toLength;
      return (e - t) * n / r + o;
    };

    this.updateGuides = function () {
      _this77.state.horizontalGuides = _this77.getHorizontalGuidesFromConfig(), _this77.state.verticalGuides = _this77.getVerticalGuidesFromConfig();
    };

    this.mapToSnapSystem = function (e, t, r, o) {
      if (t.length === 0) return e;
      if (t[0] > e) return e - r;

      for (var n = 0; n < t.length - 1; n += 1) {
        var s = t[n],
            l = t[n + 1],
            c = s + r,
            p = l - r,
            m = 0;
        o && (m = n * r * 2, c += m, p += m + r * 2);
        var h = 1e-5;
        if (s <= e && e <= l) return e <= s + h ? s + m : e >= l - h ? l + m + (o ? r * 2 : 0) : _this77.mapRange({
          value: e,
          fromMin: s,
          fromLength: l - s,
          toMin: c,
          toLength: p - c
        });
      }

      return o ? e + (t.length - 1) * r * 2 + r : e;
    };

    this.mapFromSnapSystem = function (e, t, r, o) {
      if (t.length === 0) return e;
      if (t[0] > e) return e >= t[0] - r ? t[0] : e + r;
      var n = e;

      for (var l = 0; l < t.length - 1; l += 1) {
        var c = t[l],
            p = t[l + 1],
            m = c + r,
            h = p - r,
            b = p;
        if (o && (h += r * 2, b += r * 2, n = e - l * r * 2), c <= n && n <= b) return m <= n && n <= h ? _this77.mapRange({
          value: n,
          fromMin: m,
          fromLength: h - m,
          toMin: c,
          toLength: p - c
        }) : n < m ? c : p;
      }

      n -= r * 3;
      var s = t[t.length - 1];
      return n <= s ? s : n;
    };

    this.centerSnapValue = function (e, t) {
      var r = t * .5,
          o = e.value,
          n = e.edge,
          s = o;
      return n === Xe.LEADING ? s += r : n === Xe.TRAILING && (s -= r), s;
    };

    this.mapSnappingGuidesToCenter = function (e, t) {
      var r = [];
      return e.forEach(function (o) {
        r.push(_this77.centerSnapValue(o, t));
      }), r;
    };

    this.calcSnapThresholdInRadians = function (e, t) {
      return e === 0 ? 0 : t / e;
    };

    this.calculatePreviewTopLeftPosition = function () {
      var e = _this77.editor.engineMediator.preview.container.getPosition(),
          t = _this77.editor.getPreviewSize(),
          r = ie.devicePixelRatio;

      _this77.previewTopLeftPosition = {
        x: e.x / r - t.width / 2,
        y: e.y / r - t.height / 2
      };
    };

    this.snapToRotation = function (e, t, r) {
      var o = _this77.state.rotationGuides,
          _this77$configStore$c4 = _this77.configStore.config.snapping.rotation,
          n = _this77$configStore$c4.enabled,
          s = _this77$configStore$c4.threshold,
          _this77$previewTopLef = _this77.previewTopLeftPosition,
          l = _this77$previewTopLef.x,
          c = _this77$previewTopLef.y,
          _this77$editor$getPre2 = _this77.editor.getPreviewSize(),
          p = _this77$editor$getPre2.width,
          m = (e + Math.PI * 2) % (Math.PI * 2);

      if (n) {
        var h = new _(t).magnitude,
            b = o.map(function (I) {
          return I.value;
        }).sort(function (I, R) {
          return I - R;
        }),
            v = _this77.calcSnapThresholdInRadians(h, s);

        if (!_this77.rotationOffset) {
          var I = _this77.mapToSnapSystem(e, b, v, !1);

          _this77.rotationOffset = I - m;
        }

        m = _this77.mapFromSnapSystem(m + _this77.rotationOffset, b, v, !1);
        var x = {
          x: r.position.x - l - p,
          y: r.position.y - c
        };
        return o.forEach(function (I) {
          I.isVisible = I.value === m, I.position = x;
        }), m;
      }

      return e;
    };

    this.snapToPosition = function (e, t) {
      var _this77$state = _this77.state,
          r = _this77$state.horizontalGuides,
          o = _this77$state.verticalGuides,
          _this77$configStore$c5 = _this77.configStore.config.snapping.position,
          n = _this77$configStore$c5.enabled,
          s = _this77$configStore$c5.threshold,
          l = new _(_this77.previewTopLeftPosition),
          _this77$getSpriteDime = _this77.getSpriteDimensions(t),
          c = _this77$getSpriteDime.height,
          p = _this77$getSpriteDime.width,
          _subtract = new _(e).subtract(l),
          m = _subtract.x,
          h = _subtract.y;

      if (n) {
        var b = _this77.mapSnappingGuidesToCenter(r, c).sort(function (R, M) {
          return R - M;
        }),
            v = _this77.mapSnappingGuidesToCenter(o, p).sort(function (R, M) {
          return R - M;
        });

        if (!_this77.positionOffset) {
          var R = _this77.mapToSnapSystem(m, v, s, !0),
              M = _this77.mapToSnapSystem(h, b, s, !0);

          _this77.positionOffset = new _(R, M).subtract(new _(m, h));
        }

        var x = _this77.mapFromSnapSystem(m + _this77.positionOffset.x, v, s, !0),
            I = _this77.mapFromSnapSystem(h + _this77.positionOffset.y, b, s, !0);

        return x = Math.round(x), I = Math.round(I), r.forEach(function (R) {
          var M = Math.round(_this77.centerSnapValue(R, c));
          R.isVisible = M === I;
        }), o.forEach(function (R) {
          var M = Math.round(_this77.centerSnapValue(R, p));
          R.isVisible = M === x;
        }), new _(x, I).add(l);
      }

      return {
        x: m,
        y: h
      };
    };

    this.editor = e, this.configStore = e.configStore, this.state = S(am), this.rotationOffset = null, this.positionOffset = null, this.state.horizontalGuides = this.getHorizontalGuidesFromConfig(), this.state.verticalGuides = this.getVerticalGuidesFromConfig(), this.state.rotationGuides = this.getRotationGuidesFromConfig();
  }

  _createClass(at, [{
    key: "hidePositionGuides",
    value: function hidePositionGuides() {
      this.positionOffset = null, this.state.verticalGuides = this.state.verticalGuides.map(function (e) {
        return f(f({}, e), {
          isVisible: !1
        });
      }), this.state.horizontalGuides = this.state.horizontalGuides.map(function (e) {
        return f(f({}, e), {
          isVisible: !1
        });
      });
    }
  }, {
    key: "hideRotationGuides",
    value: function hideRotationGuides() {
      this.rotationOffset = null, this.state.rotationGuides = this.state.rotationGuides.map(function (e) {
        return f(f({}, e), {
          isVisible: !1
        });
      });
    }
  }, {
    key: "positionGuides",
    get: function get() {
      var _this$state3 = this.state,
          e = _this$state3.verticalGuides,
          t = _this$state3.horizontalGuides;
      return [].concat(_toConsumableArray(e), _toConsumableArray(t));
    }
  }, {
    key: "rotationGuides",
    get: function get() {
      return this.state.rotationGuides;
    }
  }]);

  return at;
}();

a([S], at.prototype, "state", 2), a([d], at.prototype, "snapToRotation", 2), a([d], at.prototype, "snapToPosition", 2), a([d], at.prototype, "hidePositionGuides", 1), a([d], at.prototype, "hideRotationGuides", 1), a([u], at.prototype, "positionGuides", 1), a([u], at.prototype, "rotationGuides", 1);

function oo(i) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return new Promise(function (t, r) {
    var o = new Image();
    o.addEventListener("load", function () {
      var n = document.createElement("canvas"),
          s = n.getContext("2d");
      n.width = o.width, n.height = o.height, e && (n.width = e, n.height = e * o.height / o.width), s.drawImage(o, 0, 0, n.width, n.height), t(n.toDataURL(Gt.PNG));
    }), o.addEventListener("error", function () {
      r();
    }), o.src = i;
  });
}

var Xl = function Xl(i) {
  return new Promise(function (e, t) {
    var r = new FileReader();
    r.onload = function (o) {
      return C(void 0, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee35() {
        var n, s;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;
                n = o.target.result;
                _context35.next = 4;
                return oo(n, 150);

              case 4:
                s = _context35.sent;
                e({
                  stickerURI: n,
                  thumbnailURI: s,
                  name: i.name || "",
                  type: i.type,
                  identifier: xi()
                });
                _context35.next = 11;
                break;

              case 8:
                _context35.prev = 8;
                _context35.t0 = _context35["catch"](0);
                t(_context35.t0);

              case 11:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[0, 8]]);
      }));
    }, r.onerror = function (o) {
      t(o);
    }, r.readAsDataURL(i);
  });
};

var lm = "white",
    Ae = {
  identifier: "identity",
  opacity: 1,
  tintColor: xe[lm],
  tintMode: "none",
  resizeMode: "keepAspect"
},
    ys = {};

var Jl = "identity",
    vs = "imgly_sticker_custom",
    z =
/*#__PURE__*/
function () {
  function z(e) {
    var _this78 = this;

    _classCallCheck(this, z);

    this.state = S.map(ys);
    this.customStickers = [];
    this.colorList = ie.defaultColors;

    this.selectLast = function () {
      _this78.editor.spriteStore.selectHighestOrderSprite(Array.from(_this78.state.keys()));
    };

    this.doesStickerAssetExist = function (e) {
      return _this78.entityManager.items.findIndex(function (t) {
        return t.identifier === e;
      }) !== -1;
    };

    this.add = function (e) {
      var t = _this78.entityManager.items.find(function (n) {
        return n.identifier === e;
      }),
          r = t ? t.tintMode : Ae.tintMode,
          o = t ? t.resizeMode : Ae.resizeMode;

      _this78.editor.spriteStore.addSticker({
        state: {
          identifier: e,
          tintMode: r,
          tintColor: Ae.tintColor,
          opacity: Ae.opacity,
          resizeMode: o
        }
      });
    };

    this.duplicate = function () {
      if (_this78.id) {
        var _e8 = _this78.editor.spriteStore.getDuplicateContainerTransform(_this78.id),
            _t10 = _this78.editor.spriteStore.getDuplicateContainerFlip(_this78.id),
            _this78$editor$output = _this78.editor.outputContainer.getData(),
            _r7 = _this78$editor$output.flipHorizontally,
            o = _this78$editor$output.flipVertically;

        _this78.editor.spriteStore.addSticker({
          state: {
            identifier: _this78.identifier,
            tintColor: k(_this78.tintColor),
            tintMode: _this78.tintMode,
            resizeMode: _this78.resizeMode,
            opacity: _this78.opacity,
            flipHorizontally: _r7 !== _t10.flipHorizontally,
            flipVertically: o !== _t10.flipVertically
          },
          transform: _e8
        });
      }
    };

    this.bringToFront = function () {
      _this78.id && _this78.editor.spriteStore.bringToFront(_this78.id);
    };

    this.flipHorizontally = function () {
      _this78.id && _this78.editor.spriteStore.flipHorizontally(_this78.id);
    };

    this.delete = function () {
      if (_this78.id) {
        var _e9 = _this78.id;
        _this78.editor.spriteStore.removeSprite(_e9), _this78.state.delete(_e9), _this78.selectLast();
      }
    };

    this.updateStateFromHistory = function (e, t) {
      _this78.setState(e, t), _this78.editor.spriteStore.setContainerProperties(e, t);
    };

    this.setState = function (e, t) {
      var r = _this78.state.get(e);

      r ? ("opacity" in t && (r.opacity = t.opacity), t.tintColor && (r.tintColor = t.tintColor), t.tintMode && (r.tintMode = t.tintMode), t.resizeMode && (r.resizeMode = t.resizeMode), _this78.state.set(e, r)) : _this78.state.set(e, {
        identifier: t.identifier,
        opacity: t.opacity,
        tintMode: t.tintMode,
        resizeMode: t.resizeMode,
        tintColor: t.tintColor ? t.tintColor : Ae.tintColor
      });
    };

    this.changeOpacity = function (e) {
      if (_this78.id) {
        var _t11 = _this78.state.get(_this78.id);

        if (_t11) {
          _this78.editor.spriteStore.setContainerProperties(_this78.id, {
            opacity: e
          });

          var _r8 = _this78.editor.spriteStore.getContainerProperties(_this78.id);

          _t11.opacity = _r8.opacity, _this78.state.set(_this78.id, _t11);
        }
      }
    };

    this.changeTintColor = function (e) {
      if (_this78.id) {
        var _t12 = _this78.state.get(_this78.id);

        if (_t12) {
          var _this78$entityManager = _this78.entityManager.items.find(function (n) {
            return n.identifier === _this78.identifier;
          }),
              _r9 = _this78$entityManager.tintMode;

          _this78.editor.spriteStore.setContainerProperties(_this78.id, {
            tintColor: e,
            tintMode: _r9
          });

          var o = _this78.editor.spriteStore.getContainerProperties(_this78.id);

          _t12.tintColor = o.tintColor, _t12.tintMode = o.tintMode || Ae.tintMode, _this78.state.set(_this78.id, _t12);
        }
      }
    };

    this.tintColorSnapshot = function () {
      _this78.addSnapshot(F.EDIT, _this78.locale.history.color);
    };

    this.addFiles = function (e) {
      return C(_this78, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee36() {
        var _t13, _r10, o;

        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                if (!(this.editor.modalStore.showInfoModal("loading"), e.length)) {
                  _context36.next = 13;
                  break;
                }

                _t13 = 0, _r10 = [];

                for (_t13 = 0; _t13 < e.length; _t13 += 1) {
                  _r10.push(Xl(e[_t13]));
                }

                _context36.prev = 3;
                _context36.next = 6;
                return Promise.all(_r10);

              case 6:
                o = _context36.sent;
                this.addCustomStickerAsset(o), this.editor.configStore.events.onStickerUploadedAdd(o.map(function (_ref28, l) {
                  var n = _ref28.identifier,
                      s = _ref28.stickerURI;
                  return {
                    identifier: n,
                    stickerURI: s,
                    file: e[l]
                  };
                }));
                _context36.next = 13;
                break;

              case 10:
                _context36.prev = 10;
                _context36.t0 = _context36["catch"](3);
                this.editor.modalStore.hideModal(), this.editor.modalStore.showInfoModal("stickerLoading");

              case 13:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this, [[3, 10]]);
      }));
    };

    this.addCustomStickerAsset = function (e) {
      return C(_this78, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee37() {
        var _this79 = this;

        var t, r, o, n;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                t = [];
                e.forEach(function (_ref29) {
                  var s = _ref29.stickerURI,
                      l = _ref29.thumbnailURI,
                      c = _ref29.name,
                      p = _ref29.identifier,
                      m = _ref29.type;
                  t.push({
                    stickerURI: s,
                    thumbnailURI: l,
                    name: c,
                    tintMode: _this79.customStickerTintMode,
                    resizeMode: "keepAspect",
                    identifier: p
                  }), _this79.customStickers.push({
                    identifier: p,
                    type: m,
                    stickerURI: s,
                    name: c
                  });
                });
                r = this.locale.categories[vs];
                this.editor.assetProvider.addCustomStickerAsset(t, vs, r);
                o = this.editor.assetProvider.getAssets("sticker"), n = this.config;
                this.entityManager = new ee(o, f(f({}, n), {
                  categoryKey: "thumbnailURI",
                  itemKey: "stickerURI",
                  locale: this.locale.items,
                  getAssetPath: this.editor.getAssetPath("sticker")
                })), this.selectedCategory = vs, this.editor.modalStore.hideModal();

              case 6:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    };

    this.toolSnapshot = function () {
      _this78.addSnapshot(F.EDIT, _this78.locale.history.opacity);
    };

    this.addSnapshot = function (e, t) {
      _this78.currentSticker && _this78.editor.spriteStore.addSnapshot(e, t);
    };

    this.toggleCategorySelection = function (e) {
      _this78.selectedCategory = _this78.selectedCategory === e ? Jl : e;
    };

    this.pureReset = function () {
      _this78.state = S.map(ys);
    };

    this.editor = e, this.selectedCategory = Jl;
    var t = this.config,
        r = this.editor.assetProvider.getAssets("sticker");
    this.entityManager = new ee(r, f(f({}, t), {
      categoryKey: "thumbnailURI",
      itemKey: "stickerURI",
      locale: f(f({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("sticker")
    })), Ae.tintColor = k(Ge(this.config, "defaultTintColor", Ae.tintColor)), this.config.colors && this.config.colors.length > 0 && (this.colorList = Ke(k(this.config.colors)));
  }

  _createClass(z, [{
    key: "isStickerSelected",
    get: function get() {
      return this.editor.spriteStore.isSpriteSticker;
    }
  }, {
    key: "isCustomStickerEnabled",
    get: function get() {
      return this.config.enableCustomUpload;
    }
  }, {
    key: "customStickerTintMode",
    get: function get() {
      return this.config.customStickerTintMode;
    }
  }, {
    key: "currentSticker",
    get: function get() {
      if (this.isStickerSelected) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    }
  }, {
    key: "identifier",
    get: function get() {
      if (this.isStickerSelected) {
        var e = this.state.get(this.id);
        if (e) return e.identifier;
      }

      return "none";
    }
  }, {
    key: "id",
    get: function get() {
      if (this.isStickerSelected) return this.editor.spriteStore.id;
    }
  }, {
    key: "opacity",
    get: function get() {
      return this.currentSticker ? this.currentSticker.opacity : Ae.opacity;
    }
  }, {
    key: "tintMode",
    get: function get() {
      return this.currentSticker ? this.currentSticker.tintMode : Ae.tintMode;
    }
  }, {
    key: "resizeMode",
    get: function get() {
      return this.currentSticker ? this.currentSticker.resizeMode : Ae.resizeMode;
    }
  }, {
    key: "tintable",
    get: function get() {
      return this.currentSticker ? this.currentSticker.tintMode === "solid" || this.currentSticker.tintMode === "colorized" : !1;
    }
  }, {
    key: "tintColor",
    get: function get() {
      return this.currentSticker ? this.currentSticker.tintColor : Ae.tintColor;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.STICKER];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.STICKER];
    }
  }, {
    key: "localeColor",
    get: function get() {
      return this.editor.configStore.locale.common.color;
    }
  }, {
    key: "selectedCategoryIdentifier",
    get: function get() {
      return this.selectedCategory;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }, {
    key: "categories",
    get: function get() {
      return this.entityManager.categories;
    }
  }]);

  return z;
}();

a([S], z.prototype, "selectedCategory", 2), a([S], z.prototype, "entityManager", 2), a([d], z.prototype, "selectLast", 2), a([d], z.prototype, "add", 2), a([d], z.prototype, "duplicate", 2), a([d], z.prototype, "bringToFront", 2), a([d], z.prototype, "flipHorizontally", 2), a([d], z.prototype, "delete", 2), a([d], z.prototype, "updateStateFromHistory", 2), a([d], z.prototype, "setState", 2), a([d], z.prototype, "changeOpacity", 2), a([d], z.prototype, "changeTintColor", 2), a([d], z.prototype, "addFiles", 2), a([d], z.prototype, "addCustomStickerAsset", 2), a([d], z.prototype, "toggleCategorySelection", 2), a([d], z.prototype, "pureReset", 2), a([u], z.prototype, "isStickerSelected", 1), a([u], z.prototype, "isCustomStickerEnabled", 1), a([u], z.prototype, "customStickerTintMode", 1), a([u], z.prototype, "currentSticker", 1), a([u], z.prototype, "identifier", 1), a([u], z.prototype, "id", 1), a([u], z.prototype, "opacity", 1), a([u], z.prototype, "tintMode", 1), a([u], z.prototype, "resizeMode", 1), a([u], z.prototype, "tintable", 1), a([u], z.prototype, "tintColor", 1), a([u], z.prototype, "config", 1), a([u], z.prototype, "locale", 1), a([u], z.prototype, "localeColor", 1), a([u], z.prototype, "selectedCategoryIdentifier", 1), a([u], z.prototype, "items", 1), a([u], z.prototype, "categories", 1);
var cm = "imgly_font_open_sans_bold",
    G = {
  text: "Write Something",
  identifier: cm,
  fontSize: 73.3,
  defaultFontSize: 73.3,
  fontFamily: "Open Sans",
  fontStyle: "",
  fontWeight: "bold",
  lineHeight: 1,
  alignment: "center",
  textColor: xe.white,
  backgroundColor: xe.transparent || [0, 0, 0, 0],
  width: 0
},
    _s = {};

var Zl = {
  100: "Extra Light",
  200: "Light",
  300: "Book",
  400: "Regular",
  500: "Medium",
  600: "SemiBold",
  700: "Bold",
  800: "Black",
  900: "Extra Black",
  bold: "Bold",
  normal: "Regular",
  lighter: "Lighter"
},
    ki =
/*#__PURE__*/
function () {
  function ki(e) {
    var _this80 = this;

    _classCallCheck(this, ki);

    this.state = S.map(_s);
    this.colorList = ie.defaultColors;
    this.backgroundColorList = ie.defaultBackgroundColors;
    this.loadingObservable = S.box(!1);

    this.loadfonts = function (e) {
      if (_this80.fontsLoaded) e();else {
        var t = _this80.editor.assetProvider.getFontManager(),
            r = _this80.editor.assetProvider.getFontAssetsForText().map(function (o) {
          return o.identifier;
        });

        t.loadFontsWithIdentifiers(r).then(function () {
          _this80.loadingObservable.set(!0), e();
        }).catch(function (o) {
          console.error(o), _this80.editor.modalStore.showActionModal({
            type: oe.ERROR,
            identifier: "fontLoading",
            error: o
          });
        });
      }
    };

    this.doesTextAssetExist = function (e) {
      return _this80.editor.assetProvider.getFontAssets().findIndex(function (t) {
        return t.identifier === e;
      }) !== -1;
    };

    this.validFontWithConfig = function (e) {
      return _this80.fonts.find(function (t) {
        return t.identifier === e;
      }) || _this80.fonts[0];
    };

    this.addOrselect = function () {
      _this80.state.size ? _this80.selectLast() : _this80.add();
    };

    this.selectLast = function () {
      _this80.editor.spriteStore.selectHighestOrderSprite(Array.from(_this80.state.keys()));
    };

    this.add = function () {
      var e = function e() {
        _this80.editor.spriteStore.addText({
          state: {
            identifier: G.identifier,
            text: G.text,
            textColor: G.textColor,
            backgroundColor: G.backgroundColor,
            lineHeight: G.lineHeight,
            alignment: G.alignment,
            fontSize: 0
          }
        });
      };

      _this80.loadfonts(e);
    };

    this.duplicate = function () {
      if (_this80.id) {
        var _e10 = _this80.editor.spriteStore.getDuplicateContainerTransform(_this80.id);

        _this80.editor.spriteStore.addText({
          state: {
            identifier: _this80.identifier,
            text: _this80.text,
            textColor: k(_this80.textColor),
            lineHeight: _this80.lineHeight,
            alignment: _this80.alignment,
            fontSize: _this80.fontSize,
            backgroundColor: k(_this80.backgroundColor),
            width: _this80.width
          },
          transform: _e10
        });
      }
    };

    this.bringToFront = function () {
      _this80.id && _this80.editor.spriteStore.bringToFront(_this80.id);
    };

    this.delete = function () {
      if (_this80.id) {
        var _e11 = _this80.id;
        _this80.editor.spriteStore.removeSprite(_e11), _this80.state.delete(_e11), _this80.selectLast();
      }
    };

    this.setEditMode = function (e) {
      _this80.editor.spriteStore.setEditMode(e);
    };

    this.changeFont = function (e) {
      var t = _this80.fonts.find(function (r) {
        return r.identifier === e;
      });

      _this80.changeIdentifier(t, _this80.id), _this80.id && _this80.addSnapshot(F.EDIT, _this80.locale.history.fontFamily);
    };

    this.changeIdentifier = function (e, t) {
      re(function () {
        if (e && t) {
          var r = _this80.state.get(t);

          if (r) {
            _this80.editor.spriteStore.setContainerProperties(t, {
              fontIdentifier: e.identifier
            }, !0);

            var o = _this80.editor.spriteStore.getContainerProperties(t);

            r.identifier = o.fontIdentifier, r.fontFamily = e.fontFamily, r.fontStyle = e.fontStyle, r.fontWeight = e.fontWeight, r.fontSize = o.fontSize, r.width = o.width, r.defaultFontSize = r.fontSize, _this80.state.set(t, r);
          }
        }
      });
    };

    this.changeFontSize = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (_this80.id) {
        var r = _this80.state.get(_this80.id);

        r && (r.fontSize = e, t && (r.defaultFontSize = e), _this80.state.set(_this80.id, r));
      }
    };

    this.updateDefaultFontSize = function () {
      if (_this80.id) {
        var _e12 = _this80.state.get(_this80.id);

        _e12 && (_e12.defaultFontSize = _e12.fontSize, _this80.state.set(_this80.id, _e12));
      }
    };

    this.changeSize = function (e, t) {
      var r = _this80.state.get(e);

      r && (r.width = t.width, r.fontSize = t.fontSize, r.defaultFontSize = t.fontSize, _this80.state.set(e, r));
    };

    this.changeWidth = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        t && (t.width = e, _this80.state.set(_this80.id, t));
      }
    };

    this.changeText = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            text: e
          }, !0);

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id),
              o = _this80.editor.outputContainer.getSizeInOutputSpace(),
              n = _this80.editor.spriteStore.getSize(_this80.id);

          _this80.config.disableAutoScaling || n.height > o.height && _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            fontSize: _this80.calculateFitFontSize(_this80.id, o.height)
          }, !0), r = _this80.editor.spriteStore.getContainerProperties(_this80.id), t.text = r.text, t.fontSize = r.fontSize, t.defaultFontSize = r.fontSize, _this80.state.set(_this80.id, t), _this80.addSnapshot(F.EDIT, _this80.locale.history.edit);
        }
      }
    };

    this.calculateFitFontSize = function (e, t) {
      if (!ki.measureContext) {
        var v = document.createElement("canvas");
        ki.measureContext = v.getContext("2d");
      }

      var r = _this80.editor.spriteStore.getContainerProperties(e),
          o = _this80.editor.engine.assetProvider.getFontManager().getFontWithId(r.fontIdentifier),
          n = _this80.config.minFontSizeForAutoScaling,
          s = er(ki.measureContext, r.text, o, r.fontSize, r.lineHeight, r.width, o.textMetrics),
          l = Math.min(Math.floor(r.fontSize * (t / s.height)), 1),
          c = Math.round(r.fontSize),
          p = 0,
          m = c - l,
          h = Math.floor((c - l) * 2),
          b = m;

      for (; p <= h;) {
        m = p + Math.floor((h - p) / 2);

        var _v = er(ki.measureContext, r.text, o, m, r.lineHeight, r.width, o.textMetrics);

        if (t < _v.height) h = m - 1, b = m - 1;else if (t > _v.height) {
          if (p = m + 1, l + m >= c) return c;
        } else {
          b = m;
          break;
        }
      }

      return n && b < n ? n : b;
    };

    this.changeLineHeight = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t && e) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            lineHeight: e
          }, !0);

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id);

          t.lineHeight = r.lineHeight, _this80.state.set(_this80.id, t);
        }
      }
    };

    this.changeColor = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            textColor: e
          });

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id);

          t.textColor = r.textColor, _this80.state.set(_this80.id, t);
        }
      }
    };

    this.changeBackgroundColor = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            backgroundColor: e
          });

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id);

          t.backgroundColor = r.backgroundColor, _this80.state.set(_this80.id, t);
        }
      }
    };

    this.colorSnapshot = function () {
      _this80.addSnapshot(F.EDIT, _this80.locale.history.textColor);
    };

    this.backgroundColorSnapshot = function () {
      _this80.addSnapshot(F.EDIT, _this80.locale.history.backgroundColor);
    };

    this.changeAlignment = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            alignment: e
          });

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id);

          t.alignment = r.alignment, _this80.state.set(_this80.id, t), _this80.addSnapshot(F.EDIT, _this80.locale.history.alignment);
        }
      }
    };

    this.toolSnapshot = function () {
      _this80.addSnapshot(F.EDIT, _this80.locale.history.lineSpacing);
    };

    this.addSnapshot = function (e, t) {
      _this80.currentText && _this80.editor.spriteStore.addSnapshot(e, t);
    };

    this.updateStateFromHistory = function (e, t) {
      _this80.setState(e, t), _this80.editor.spriteStore.setContainerProperties(e, t);
    };

    this.setState = function (e, t) {
      var r = _this80.state.get(e);

      if (r) t.alignment && (r.alignment = t.alignment), t.text && (r.text = t.text), t.lineHeight && (r.lineHeight = t.lineHeight), t.textColor && (r.textColor = t.textColor), t.backgroundColor && (r.backgroundColor = t.backgroundColor), t.fontIdentifier && (r.identifier = t.fontIdentifier), t.fontSize && (r.fontSize = t.fontSize, r.defaultFontSize = t.fontSize), t.width && (r.width = t.width);else {
        var o = _this80.validFontWithConfig(t.fontIdentifier);

        o && _this80.state.set(e, {
          text: t.text,
          identifier: o.identifier,
          alignment: t.alignment,
          textColor: t.textColor ? t.textColor : G.textColor,
          backgroundColor: t.backgroundColor ? t.backgroundColor : G.backgroundColor,
          fontFamily: o.fontFamily,
          fontStyle: o.fontStyle,
          fontSize: t.fontSize,
          fontWeight: o.fontWeight,
          lineHeight: t.lineHeight,
          width: t.width,
          defaultFontSize: t.fontSize
        });
      }
    };

    this.setFontSize = function (e) {
      if (_this80.id) {
        var t = _this80.state.get(_this80.id);

        if (t) {
          _this80.editor.spriteStore.setContainerProperties(_this80.id, {
            fontSize: e
          }, !0);

          var r = _this80.editor.spriteStore.getContainerProperties(_this80.id);

          t.fontSize = r.fontSize, t.defaultFontSize = r.fontSize, _this80.state.set(_this80.id, t);
        }
      }
    };

    this.pureReset = function () {
      _this80.state = S.map(_s);
    };

    this.editor = e, this.fonts.find(function (t) {
      return t.identifier === G.identifier;
    }) || (G.identifier = this.fonts[0].identifier), G.textColor = k(Ge(this.config, "defaultColor", G.textColor)), G.backgroundColor = k(Ge(this.config, "defaultBackgroundColor", G.backgroundColor)), G.text = this.locale.canvasControls.placeholderText, this.config.colors && this.config.colors.length > 0 && (this.colorList = Ke(k(this.config.colors))), this.config.backgroundColors && this.config.backgroundColors.length > 0 && (this.backgroundColorList = Ke(k(this.config.backgroundColors)));
  }

  _createClass(ki, [{
    key: "isEditMode",
    get: function get() {
      return this.editor.spriteStore.isEditMode;
    }
  }, {
    key: "isTextSelected",
    get: function get() {
      return this.editor.spriteStore.isSpriteText;
    }
  }, {
    key: "fontsLoaded",
    get: function get() {
      return this.loadingObservable.get();
    }
  }, {
    key: "currentText",
    get: function get() {
      if (this.isTextSelected) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    }
  }, {
    key: "text",
    get: function get() {
      return this.currentText ? this.currentText.text : G.text;
    }
  }, {
    key: "fontSize",
    get: function get() {
      return this.currentText ? this.currentText.fontSize : G.fontSize;
    }
  }, {
    key: "defaultFontSize",
    get: function get() {
      return this.currentText ? this.currentText.defaultFontSize : G.defaultFontSize;
    }
  }, {
    key: "width",
    get: function get() {
      return this.currentText ? this.currentText.width : G.width;
    }
  }, {
    key: "fontFamily",
    get: function get() {
      return this.currentText ? this.currentText.fontFamily : G.fontFamily;
    }
  }, {
    key: "fontStyle",
    get: function get() {
      return this.currentText ? this.currentText.fontStyle : G.fontStyle;
    }
  }, {
    key: "fontWeight",
    get: function get() {
      return this.currentText ? this.currentText.fontWeight : G.fontWeight;
    }
  }, {
    key: "lineHeight",
    get: function get() {
      return this.currentText ? this.currentText.lineHeight : G.lineHeight;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.currentText ? this.currentText.identifier : G.identifier;
    }
  }, {
    key: "id",
    get: function get() {
      if (this.isTextSelected) return this.editor.spriteStore.id;
    }
  }, {
    key: "alignment",
    get: function get() {
      return this.currentText ? this.currentText.alignment : G.alignment;
    }
  }, {
    key: "textColor",
    get: function get() {
      return this.currentText ? this.currentText.textColor : G.textColor;
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this.currentText ? this.currentText.backgroundColor : G.backgroundColor;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.TEXT];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.TEXT];
    }
  }, {
    key: "localeColor",
    get: function get() {
      return this.editor.configStore.locale.common.color;
    }
  }, {
    key: "rawOptions",
    get: function get() {
      return this.editor.assetProvider.getFontAssetsForText();
    }
  }, {
    key: "fonts",
    get: function get() {
      var _this81 = this;

      return this.rawOptions.reduce(function (e, t) {
        return _this81.rawOptions.find(function (r) {
          return r.identifier === t.identifier;
        }) ? [].concat(_toConsumableArray(e), [{
          identifier: t.identifier,
          fontFamily: t.fontFamily,
          fontStyle: t.fontStyle || "",
          fontWeight: t.fontWeight || ""
        }]) : e;
      }, []);
    }
  }, {
    key: "fontFamilies",
    get: function get() {
      return _toConsumableArray(new Set(this.fonts));
    }
  }], [{
    key: "defaultText",
    value: function defaultText() {
      return G.text;
    }
  }, {
    key: "getDisplayFontStyle",
    value: function getDisplayFontStyle(e) {
      var t = e.fontWeight && Zl[e.fontWeight].toLowerCase() !== "regular" ? Zl[e.fontWeight] : "",
          r = e.fontStyle && e.fontStyle.toLowerCase() !== "normal" ? e.fontStyle : "";
      return "".concat(e.fontFamily.toLowerCase().includes(t.toLowerCase()) ? "" : t, " ").concat(r).trim();
    }
  }]);

  return ki;
}(),
    O = ki;

a([d], O.prototype, "addOrselect", 2), a([d], O.prototype, "selectLast", 2), a([d], O.prototype, "add", 2), a([d], O.prototype, "duplicate", 2), a([d], O.prototype, "bringToFront", 2), a([d], O.prototype, "delete", 2), a([d], O.prototype, "setEditMode", 2), a([d], O.prototype, "changeFont", 2), a([d], O.prototype, "changeIdentifier", 2), a([d], O.prototype, "changeFontSize", 2), a([d], O.prototype, "updateDefaultFontSize", 2), a([d], O.prototype, "changeSize", 2), a([d], O.prototype, "changeWidth", 2), a([d], O.prototype, "changeText", 2), a([d], O.prototype, "changeLineHeight", 2), a([d], O.prototype, "changeColor", 2), a([d], O.prototype, "changeBackgroundColor", 2), a([d], O.prototype, "changeAlignment", 2), a([d], O.prototype, "updateStateFromHistory", 2), a([d], O.prototype, "setState", 2), a([d], O.prototype, "setFontSize", 2), a([d], O.prototype, "pureReset", 2), a([u], O.prototype, "isEditMode", 1), a([u], O.prototype, "isTextSelected", 1), a([u], O.prototype, "fontsLoaded", 1), a([u], O.prototype, "currentText", 1), a([u], O.prototype, "text", 1), a([u], O.prototype, "fontSize", 1), a([u], O.prototype, "defaultFontSize", 1), a([u], O.prototype, "width", 1), a([u], O.prototype, "fontFamily", 1), a([u], O.prototype, "fontStyle", 1), a([u], O.prototype, "fontWeight", 1), a([u], O.prototype, "lineHeight", 1), a([u], O.prototype, "identifier", 1), a([u], O.prototype, "id", 1), a([u], O.prototype, "alignment", 1), a([u], O.prototype, "textColor", 1), a([u], O.prototype, "backgroundColor", 1), a([u], O.prototype, "config", 1), a([u], O.prototype, "locale", 1), a([u], O.prototype, "localeColor", 1), a([u], O.prototype, "rawOptions", 1), a([u], O.prototype, "fonts", 1), a([u], O.prototype, "fontFamilies", 1);
var um = "imgly_text_design_blocks",
    ue = {
  identifier: um,
  color: xe.white,
  isInverted: !1,
  text: "Write Something With Style",
  seed: 0,
  padding: 0,
  width: 0
},
    Ss = {
  imgly_text_design_blocks: 835,
  imgly_text_design_rotated: 6,
  imgly_text_design_blocks_light: 3,
  imgly_text_design_equal_width: 727,
  imgly_text_design_masked: 259,
  imgly_text_design_celebrate: 579,
  imgly_text_design_sunshine: 77,
  imgly_text_design_masked_badge: 683,
  imgly_text_design_blocks_condensed: 673,
  imgly_text_design_celebrate_simple: 425,
  imgly_text_design_equal_width_fat: 961,
  imgly_text_design_watercolor: 671,
  imgly_text_design_particles: 683,
  imgly_text_design_masked_speech_bubble: 317,
  imgly_text_design_masked_speech_bubble_comic: 229,
  imgly_text_design_multiline: 831
},
    Ds = {};

var U =
/*#__PURE__*/
function () {
  function U(e) {
    var _this82 = this;

    _classCallCheck(this, U);

    this.state = S.map(Ds);
    this.colorList = ie.defaultColors;
    this.fontsLoaded = !1;

    this.loadfonts = function (e) {
      if (_this82.fontsLoaded) e();else {
        var _t14 = _this82.editor.assetProvider.getFontManager(),
            r = _this82.editor.assetProvider.getFontAssetsForTextDesign().map(function (o) {
          return o.identifier;
        });

        _t14.loadFontsWithIdentifiers(r).then(function () {
          _this82.fontsLoaded = !0, e();
        }).catch(function (o) {
          console.error(o), _this82.editor.modalStore.showActionModal({
            type: oe.ERROR,
            identifier: "fontLoading",
            error: r[0]
          });
        });
      }
    };

    this.doesTextDesignAssetExist = function (e) {
      return _this82.entityManager.items.findIndex(function (t) {
        return t.identifier === e;
      }) !== -1;
    };

    this.addOrselect = function () {
      _this82.state.size ? _this82.selectLast() : _this82.add();
    };

    this.selectLast = function () {
      _this82.editor.spriteStore.selectHighestOrderSprite(Array.from(_this82.state.keys()));
    };

    this.add = function () {
      var e = function e() {
        _this82.editor.spriteStore.addTextDesign({
          state: {
            identifier: ue.identifier,
            text: ue.text,
            color: ue.color,
            isInverted: ue.isInverted,
            seed: Ss[ue.identifier] || ue.seed,
            padding: 0
          }
        });
      };

      _this82.loadfonts(e);
    };

    this.updateStateFromHistory = function (e, t) {
      var r = _this82.state.get(e);

      t.identifier === r.identifier ? (_this82.setState(e, t), _this82.editor.spriteStore.setContainerProperties(e, t)) : _this82.changeIdentifier(t.identifier, !1, t.seed, e);
    };

    this.setState = function (e, t) {
      var r = _this82.state.get(e);

      r ? (t.inverted && (r.isInverted = t.inverted), t.seed && (r.seed = t.seed), t.color && (r.color = t.color), t.padding && (r.padding = t.padding), t.width && (r.width = t.width)) : _this82.state.set(e, {
        width: t.width,
        text: t.text,
        isInverted: t.inverted,
        identifier: t.identifier,
        seed: t.seed,
        color: t.color ? t.color : ue.color,
        padding: t.padding
      });
    };

    this.changeText = function (e) {
      if (_this82.id) {
        var _t15 = _this82.state.get(_this82.id);

        if (_t15) {
          _this82.editor.spriteStore.setContainerProperties(_this82.id, {
            text: e
          }, !0);

          var r = _this82.editor.spriteStore.getContainerProperties(_this82.id);

          _t15.text = r.text, _this82.state.set(_this82.id, _t15), _this82.addSnapshot(F.EDIT, _this82.locale.history.edit);
        }
      }
    };

    this.setEditMode = function (e) {
      _this82.editor.spriteStore.setEditMode(e);
    };

    this.duplicate = function () {
      if (_this82.id) {
        var _e13 = _this82.editor.spriteStore.getDuplicateContainerTransform(_this82.id);

        _this82.editor.spriteStore.addTextDesign({
          state: {
            identifier: _this82.identifier,
            text: _this82.text,
            color: k(_this82.color),
            isInverted: _this82.isInverted,
            seed: _this82.seed,
            padding: _this82.padding,
            width: _this82.width
          },
          transform: _e13
        });
      }
    };

    this.bringToFront = function () {
      _this82.id && _this82.editor.spriteStore.bringToFront(_this82.id);
    };

    this.addSnapshot = function (e, t) {
      _this82.currentTextDesign && _this82.editor.spriteStore.addSnapshot(e, t);
    };

    this.delete = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this82.id;
      e && (_this82.editor.spriteStore.removeSprite(e), _this82.state.delete(e), _this82.selectLast());
    };

    this.changeSeed = function () {
      if (_this82.id) {
        var _e14 = _this82.state.get(_this82.id);

        if (_e14) {
          _this82.editor.spriteStore.setContainerProperties(_this82.id, {
            seed: -1
          }, !0);

          var _t16 = _this82.editor.spriteStore.getContainerProperties(_this82.id);

          _e14.seed = _t16.seed, _this82.state.set(_this82.id, _e14), _this82.addSnapshot(F.EDIT, _this82.locale.history.shuffle);
        }
      }
    };

    this.changeIdentifier = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _this82.id;

      if (o && e !== _this82.identifier) {
        var n = _this82.state.get(o),
            s = _this82.editor.spriteStore.getContainerTransform(o);

        _this82.editor.spriteStore.addTextDesign({
          spriteId: o,
          state: {
            identifier: e,
            text: n.text,
            color: k(n.color),
            isInverted: n.isInverted,
            seed: r || Ss[e] || n.seed,
            padding: n.padding,
            width: n.width
          },
          transform: s
        }, t, !0);
      }
    };

    this.changeColor = function (e) {
      if (_this82.id) {
        var _t17 = _this82.state.get(_this82.id);

        if (_t17) {
          _this82.editor.spriteStore.setContainerProperties(_this82.id, {
            color: e
          });

          var r = _this82.editor.spriteStore.getContainerProperties(_this82.id);

          _t17.color = r.color, _this82.state.set(_this82.id, _t17);
        }
      }
    };

    this.colorSnapshot = function () {
      _this82.addSnapshot(F.EDIT, _this82.locale.history.color);
    };

    this.invertBackground = function () {
      if (_this82.id) {
        var _e15 = _this82.state.get(_this82.id);

        if (_e15) {
          _this82.editor.spriteStore.setContainerProperties(_this82.id, {
            inverted: !_e15.isInverted
          }, !0);

          var _t18 = _this82.editor.spriteStore.getContainerProperties(_this82.id);

          _e15.isInverted = _t18.inverted, _this82.state.set(_this82.id, _e15), _this82.addSnapshot(F.EDIT, _this82.locale.history.invert);
        }
      }
    };

    this.changeWidth = function (e) {
      if (_this82.id) {
        var _t19 = _this82.state.get(_this82.id);

        _t19 && (_t19.width = e, _this82.state.set(_this82.id, _t19));
      }
    };

    this.changePadding = function (e) {
      if (_this82.id) {
        var _t20 = _this82.state.get(_this82.id);

        _t20 && (_t20.padding = e, _this82.state.set(_this82.id, _t20));
      }
    };

    this.pureReset = function () {
      _this82.state = S.map(Ds);
    };

    this.editor = e;
    var t = this.editor.assetProvider.getAssets("textdesign");
    this.entityManager = new ee(t, f(f({}, this.config), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: {},
      getAssetPath: this.editor.getAssetPath("textdesign")
    })), this.entityManager.items.find(function (r) {
      return r.identifier === ue.identifier;
    }) || (ue.identifier = this.entityManager.items[0].identifier), ue.text = this.locale.canvasControls.placeholderText, ue.color = k(Ge(this.config, "defaultColor", ue.color)), this.config.colors && this.config.colors.length > 0 && (this.colorList = Ke(k(this.config.colors)));
  }

  _createClass(U, [{
    key: "isTextDesignSelected",
    get: function get() {
      return this.editor.spriteStore.isSpriteTextDesign;
    }
  }, {
    key: "isEditMode",
    get: function get() {
      return this.editor.spriteStore.isEditMode;
    }
  }, {
    key: "currentTextDesign",
    get: function get() {
      if (this.isTextDesignSelected && this.id) {
        var e = this.state.get(this.id);
        if (e) return e;
      }
    }
  }, {
    key: "id",
    get: function get() {
      if (this.isTextDesignSelected) return this.editor.spriteStore.id;
    }
  }, {
    key: "text",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.text : ue.text;
    }
  }, {
    key: "seed",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.seed : ue.seed;
    }
  }, {
    key: "padding",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.padding : ue.padding;
    }
  }, {
    key: "width",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.width : ue.width;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.identifier : null;
    }
  }, {
    key: "isInverted",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.isInverted : ue.isInverted;
    }
  }, {
    key: "color",
    get: function get() {
      return this.currentTextDesign ? this.currentTextDesign.color : ue.color;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.TEXT_DESIGN];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.TEXT_DESIGN];
    }
  }, {
    key: "localeColor",
    get: function get() {
      return this.editor.configStore.locale.common.color;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }], [{
    key: "defaultText",
    value: function defaultText() {
      return ue.text;
    }
  }]);

  return U;
}();

a([d], U.prototype, "addOrselect", 2), a([d], U.prototype, "selectLast", 2), a([d], U.prototype, "add", 2), a([d], U.prototype, "updateStateFromHistory", 2), a([d], U.prototype, "setState", 2), a([d], U.prototype, "changeText", 2), a([d], U.prototype, "setEditMode", 2), a([d], U.prototype, "duplicate", 2), a([d], U.prototype, "bringToFront", 2), a([d], U.prototype, "delete", 2), a([d], U.prototype, "changeSeed", 2), a([d], U.prototype, "changeIdentifier", 2), a([d], U.prototype, "changeColor", 2), a([d], U.prototype, "invertBackground", 2), a([d], U.prototype, "changeWidth", 2), a([d], U.prototype, "changePadding", 2), a([d], U.prototype, "pureReset", 2), a([u], U.prototype, "isTextDesignSelected", 1), a([u], U.prototype, "isEditMode", 1), a([u], U.prototype, "currentTextDesign", 1), a([u], U.prototype, "id", 1), a([u], U.prototype, "text", 1), a([u], U.prototype, "seed", 1), a([u], U.prototype, "padding", 1), a([u], U.prototype, "width", 1), a([u], U.prototype, "identifier", 1), a([u], U.prototype, "isInverted", 1), a([u], U.prototype, "color", 1), a([u], U.prototype, "config", 1), a([u], U.prototype, "locale", 1), a([u], U.prototype, "localeColor", 1), a([u], U.prototype, "items", 1);

var dm = function dm(i) {
  return {
    height: i.y,
    width: i.x
  };
},
    pm = {},
    no = "none",
    mm = {
  position: {
    x: 0,
    y: 0
  },
  rotation: 0
},
    lr =
/*#__PURE__*/
function () {
  function lr(e) {
    var _this83 = this;

    _classCallCheck(this, lr);

    this.state = S.map(pm);
    this.selectedId = S.box(no);
    this.editMode = S.box(!1);
    this.dragMode = S.box(!1);
    this.minLength = 0;

    this.addSticker = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee38() {
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return this.addStickerAsync(e, t);

              case 2:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    };

    this.addStickerAsync = function (n) {
      for (var _len5 = arguments.length, s = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        s[_key5 - 1] = arguments[_key5];
      }

      return C(_this83, [n].concat(s),
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee40(_ref30) {
        var _this84 = this;

        var e,
            t,
            r,
            o,
            _args40 = arguments;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                e = _ref30.spriteId, t = _ref30.state, r = _ref30.transform;
                o = _args40.length > 1 && _args40[1] !== undefined ? _args40[1] : !0;
                return _context40.abrupt("return", new Promise(function (l, c) {
                  r = _this84.getInitialTransform(r);

                  var p = t.identifier,
                      m = _this84.editor.orderHelper.addSprite(p);

                  _this84.editor.engine.addStickerFromAssets(p, _this84.editor.engineMediator.image.container, m).then(function (h) {
                    return C(_this84, null,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee39() {
                      var b, v, x, Q, se, _this$editor$outputCo, I, R, M;

                      return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                        while (1) {
                          switch (_context39.prev = _context39.next) {
                            case 0:
                              e && h.setData({
                                id: e
                              });
                              b = h.getID();
                              this.container[b] = h, this.editor.orderHelper.renameSprite(p, b);
                              v = this.getSize(b);
                              v.width *= h.getScale().x, v.height *= h.getScale().y, h.setPivot(.5, .5);
                              if (r.scale) x = r.scale;else if (r.size) x = {
                                x: r.size.width / v.width,
                                y: r.size.height / v.height
                              };else {
                                Q = this.editor.shortestOutputSide * .4, se = lr.magnitude(Q) / lr.sizeMagnitude(h.getSizeInWorldSpace());
                                x = {
                                  x: se,
                                  y: se
                                };
                              }
                              _this$editor$outputCo = this.editor.outputContainer.getData(), I = _this$editor$outputCo.flipHorizontally, R = _this$editor$outputCo.flipVertically;
                              h.setFlipHorizontally(I), h.setFlipVertically(R), h.setTransform({
                                position: r.position,
                                scale: x,
                                rotation: r.rotation
                              }), t.flipHorizontally !== void 0 && h.setFlipHorizontally(t.flipHorizontally !== I), t.flipVertically !== void 0 && h.setFlipVertically(t.flipVertically !== R), this.setContainerProperties(b, f({}, t));
                              M = h.getData();
                              this.setInitialSpriteState(b, g.STICKER);
                              this.stickerToolStore.setState(b, f(f({}, M), {
                                identifier: p
                              }));
                              _context39.next = 13;
                              return this.editor.renderPromise();

                            case 13:
                              o && (this.selectedId.set(b), this.addSnapshot(F.ADD, this.stickerLocale.add));
                              l();

                            case 15:
                            case "end":
                              return _context39.stop();
                          }
                        }
                      }, _callee39, this);
                    }));
                  }).catch(function (h) {
                    console.error(h), c();
                  });
                }));

              case 3:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40);
      }));
    };

    this.addText = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _context41.next = 2;
                return this.addTextAsync(e, t);

              case 2:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    };

    this.addTextAsync = function (_ref31) {
      var e = _ref31.spriteId,
          t = _ref31.state,
          r = _ref31.transform;
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return new Promise(function (n, s) {
        r = _this83.getInitialTransform(r);

        var l = _this83.editor.orderHelper.addSprite(t.identifier),
            c = _this83.editor.shortestOutputSide,
            p = {
          fontIdentifier: t.identifier,
          text: t.text,
          width: t.width || c * .6,
          fontSize: t.fontSize || c * .1,
          lineHeight: t.lineHeight,
          alignment: t.alignment,
          textColor: t.textColor,
          backgroundColor: t.backgroundColor
        };

        _this83.editor.engine.addTextWithFontLoading(p, _this83.editor.engineMediator.image.container, l).then(function (m) {
          return C(_this83, null,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee42() {
            var h, _this$editor$outputCo2, b, v, x;

            return _regeneratorRuntime.wrap(function _callee42$(_context42) {
              while (1) {
                switch (_context42.prev = _context42.next) {
                  case 0:
                    e && m.setData({
                      id: e
                    });
                    h = m.getID();
                    this.container[h] = m, this.editor.orderHelper.renameSprite(t.identifier, this.id);
                    _this$editor$outputCo2 = this.editor.outputContainer.getData(), b = _this$editor$outputCo2.flipHorizontally, v = _this$editor$outputCo2.flipVertically;
                    m.setFlipHorizontally(b), m.setFlipVertically(v), m.setPivot(.5, .5), m.setPosition(r.position), m.setRotation(r.rotation), this.setInitialSpriteState(h, g.TEXT);
                    x = m.getData();
                    this.textToolStore.setState(h, f({}, x));
                    _context42.next = 9;
                    return this.editor.renderPromise();

                  case 9:
                    o && (this.selectedId.set(h), this.addSnapshot(F.ADD, this.textLocale.add));
                    n();

                  case 11:
                  case "end":
                    return _context42.stop();
                }
              }
            }, _callee42, this);
          }));
        }).catch(function (m) {
          console.error(m), s();
        });
      });
    };

    this.addTextDesign = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this.addTextDesignAsync(e, t, r);

              case 2:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    };

    this.addTextDesignAsync = function (_ref32) {
      var e = _ref32.spriteId,
          t = _ref32.state,
          r = _ref32.transform;
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return new Promise(function (s, l) {
        r = _this83.getInitialTransform(r);

        var c = _this83.editor.orderHelper.addSprite(t.identifier),
            p = _this83.editor.shortestOutputSide,
            m = {
          width: t.width || p * .6,
          text: t.text,
          color: t.color,
          inverted: t.isInverted,
          seed: t.seed,
          padding: t.padding
        };

        _this83.editor.engine.addTextDesignAsync(t.identifier, m, _this83.editor.engineMediator.image.container, c).then(function (h) {
          return C(_this83, null,
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee44() {
            var b, _this$editor$outputCo3, v, x, I;

            return _regeneratorRuntime.wrap(function _callee44$(_context44) {
              while (1) {
                switch (_context44.prev = _context44.next) {
                  case 0:
                    e && (n && (this.pureRemoveSprite(e), this.textDesignToolStore.state.delete(e)), h.setData({
                      id: e
                    }));
                    b = h.getID();
                    this.container[b] = h, this.editor.orderHelper.renameSprite(t.identifier, this.id);
                    _this$editor$outputCo3 = this.editor.outputContainer.getData(), v = _this$editor$outputCo3.flipHorizontally, x = _this$editor$outputCo3.flipVertically;
                    h.setFlipHorizontally(v), h.setFlipVertically(x), h.setPivot(.5, .5), h.setPosition(r.position), h.setRotation(r.rotation), this.setInitialSpriteState(b, g.TEXT_DESIGN);
                    I = h.getData();
                    this.textDesignToolStore.setState(b, f(f({}, I), {
                      identifier: t.identifier
                    }));
                    _context44.next = 9;
                    return this.editor.renderPromise();

                  case 9:
                    o && (this.selectedId.set(b), this.addSnapshot(F.ADD, this.textDesignLocale.add));
                    s();

                  case 11:
                  case "end":
                    return _context44.stop();
                }
              }
            }, _callee44, this);
          }));
        }).catch(function (h) {
          console.error(h), l();
        });
      });
    };

    this.spriteLocalTransform = function () {
      return {
        position: _this83.editor.previewToOutput(_this83.position),
        size: _this83.size,
        rotation: _this83.rotation
      };
    };

    this.clickableCanvas = function (e) {
      _this83.editor.clickableCanvas(e);
    };

    this.setContainerProperties = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      _this83.container[e].setData(t), r && _this83.updatePositionAndSize(), _this83.editor.render();
    };

    this.setContainerPosition = function (e, t) {
      _this83.container[e].setPosition(t);
    };

    this.pureRemoveSprite = function (e) {
      return _this83.editor.engine.removeContainer(_this83.container[e]), _this83.container[e].getIndexInParent() === -1 ? (delete _this83.container[e], _this83.state.delete(e), _this83.editor.orderHelper.removeSprite(e), !0) : !1;
    };

    this.deleteSprite = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this83.id;

      var t = _this83.state.get(e);

      t.tool === g.STICKER ? _this83.stickerToolStore.delete() : t.tool === g.TEXT ? _this83.textToolStore.delete() : t.tool === g.TEXT_DESIGN && _this83.textDesignToolStore.delete();
    };

    this.removeSprite = function (e) {
      _this83.pureRemoveSprite(e) && (_this83.selectLast(), _this83.spriteSnapshot("delete"), _this83.editor.render());
    };

    this.addSnapshot = function (e, t) {
      _this83.editor.addSnapshot(void 0, e, t);
    };

    this.spriteSnapshot = function (e) {
      _this83.addSnapshot(F.EDIT, _this83.historyLocale[e]);
    };

    this.updateStateFromHistory = function (e) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee45() {
        var _this85 = this;

        var t, r, o, n, s, l, c, p, m, h, b;
        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                t = Object.keys(this.container), r = e.spriteIdList;

                if (!(r.length !== t.length)) {
                  _context45.next = 28;
                  break;
                }

                o = t.filter(function (s) {
                  return r.indexOf(s) === -1;
                }), n = r.filter(function (s) {
                  return t.indexOf(s) === -1;
                });
                o.forEach(function (s) {
                  _this85.pureRemoveSprite(s);
                });
                s = 0;

              case 5:
                if (!(s < n.length)) {
                  _context45.next = 26;
                  break;
                }

                l = n[s], c = e.common ? e.common[l] : void 0, p = e.text ? e.text[l] : void 0, m = e.sticker ? e.sticker[l] : void 0, h = e.textdesign ? e.textdesign[l] : void 0;

                if (!c) {
                  _context45.next = 23;
                  break;
                }

                b = {
                  spriteId: l,
                  transform: {
                    size: c.size ? dm(_.fromSize(c.size)) : void 0,
                    position: new _(c.position),
                    rotation: c.rotation
                  }
                };

                if (!p) {
                  _context45.next = 14;
                  break;
                }

                _context45.next = 12;
                return this.addNewText(b, p);

              case 12:
                _context45.next = 23;
                break;

              case 14:
                if (!h) {
                  _context45.next = 19;
                  break;
                }

                _context45.next = 17;
                return this.addNewTextDesign(b, h);

              case 17:
                _context45.next = 23;
                break;

              case 19:
                _context45.t0 = m;

                if (!_context45.t0) {
                  _context45.next = 23;
                  break;
                }

                _context45.next = 23;
                return this.addNewSticker(b, f(f({}, m), {
                  flipHorizontally: c.flipHorizontally,
                  flipVertically: c.flipVertically
                }));

              case 23:
                s += 1;
                _context45.next = 5;
                break;

              case 26:
                _context45.next = 29;
                break;

              case 28:
                this.updateSpriteStateFromHistory(e);

              case 29:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));
    };

    this.addNewText = function (e, t) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if (!this.textToolStore.doesTextAssetExist(t.identifier)) {
                  _context46.next = 5;
                  break;
                }

                _context46.next = 3;
                return this.addTextAsync(f(f({}, e), {
                  state: t
                }), !1);

              case 3:
                _context46.next = 6;
                break;

              case 5:
                throw new Error("Text identifier ".concat(t.identifier, " doesn't exist"));

              case 6:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    };

    this.addNewTextDesign = function (e, t) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                if (!this.textDesignToolStore.doesTextDesignAssetExist(t.identifier)) {
                  _context47.next = 5;
                  break;
                }

                _context47.next = 3;
                return this.addTextDesignAsync(f(f({}, e), {
                  state: t
                }), !1);

              case 3:
                _context47.next = 6;
                break;

              case 5:
                throw new Error("TextDesign identifier ".concat(t.identifier, " doesn't exist"));

              case 6:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    };

    this.addNewSticker = function (e, t) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee48() {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (!this.stickerToolStore.doesStickerAssetExist(t.identifier)) {
                  _context48.next = 5;
                  break;
                }

                _context48.next = 3;
                return this.addStickerAsync(f(f({}, e), {
                  state: t
                }), !1);

              case 3:
                _context48.next = 6;
                break;

              case 5:
                throw new Error("Sticker identifier ".concat(t.identifier, " doesn't exist"));

              case 6:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    };

    this.updateSpriteStateFromHistory = function (e) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee49() {
        var _this86 = this;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                Object.keys(this.container).forEach(function (t) {
                  var r = e.common ? e.common[t] : void 0,
                      o = e.sticker ? e.sticker[t] : void 0,
                      n = e.text ? e.text[t] : void 0,
                      s = e.textdesign ? e.textdesign[t] : void 0,
                      l = _this86.state.get(t);

                  if (l && r) {
                    _this86.state.set(t, l);

                    var c = _this86.container[t];
                    c.setPosition(new _(r.position)), c.setRotation(r.rotation), l.rotation = c.getRotation(), r.flipHorizontally !== void 0 && c.setFlipHorizontally(r.flipHorizontally), r.flipVertically !== void 0 && c.setFlipVertically(r.flipVertically), o ? (c.setSizeInWorldSpace(r.size), _this86.stickerToolStore.updateStateFromHistory(t, o)) : n ? _this86.textToolStore.updateStateFromHistory(t, f(f({}, n), {
                      fontIdentifier: n.identifier
                    })) : s && _this86.textDesignToolStore.updateStateFromHistory(t, f(f({}, s), {
                      inverted: s.isInverted
                    })), _this86.updatePositionAndSize(t);
                  }
                });

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    };

    this.getSpriteHistoryState = function () {
      var _o5;

      var e = k(_this83.state),
          t = k(_this83.textToolStore.state),
          r = k(_this83.textDesignToolStore.state),
          o = (_o5 = {
        common: e
      }, _defineProperty(_o5, g.STICKER, k(_this83.stickerToolStore.state)), _defineProperty(_o5, g.TEXT, t), _defineProperty(_o5, g.TEXT_DESIGN, r), _defineProperty(_o5, "spriteIdList", Object.keys(_this83.container)), _o5);
      return Object.keys(o.common).forEach(function (n) {
        o.common[n].size = _this83.container[n].getSizeInWorldSpace(), o.common[n].position = _this83.container[n].getPosition(), o.common[n].order = _this83.container[n].getIndexInParent();
      }), o;
    };

    this.updateStateFromSerialization = function (e, t) {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee51() {
        var _this87 = this;

        var r, _r11, o, n, s, l, c, p, _this$editor$outputCo4, m, h, b, v, x, I, R;

        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                if (!(t && t.length)) {
                  _context51.next = 12;
                  break;
                }

                _context51.prev = 1;
                _context51.next = 4;
                return Promise.all(t.map(function (c) {
                  return C(_this87, [c],
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee50(_ref33) {
                    var o, n, s, l, p, m, h;
                    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
                      while (1) {
                        switch (_context50.prev = _context50.next) {
                          case 0:
                            o = _ref33.svg, n = _ref33.raster, s = _ref33.name, l = _ref33.identifier;
                            p = (o == null ? void 0 : o.data) ? Gt.SVG : n.type;
                            m = "data:".concat(p, ";base64,").concat((o == null ? void 0 : o.data) || n.data);
                            _context50.next = 5;
                            return oo(m, 150);

                          case 5:
                            h = _context50.sent;
                            return _context50.abrupt("return", {
                              stickerURI: m,
                              thumbnailURI: h,
                              name: s,
                              type: p,
                              identifier: l
                            });

                          case 7:
                          case "end":
                            return _context50.stop();
                        }
                      }
                    }, _callee50);
                  }));
                }));

              case 4:
                r = _context51.sent;
                _context51.next = 7;
                return this.stickerToolStore.addCustomStickerAsset(r);

              case 7:
                _context51.next = 12;
                break;

              case 9:
                _context51.prev = 9;
                _context51.t0 = _context51["catch"](1);
                this.editor.modalStore.hideModal(), this.editor.modalStore.showInfoModal("stickerLoading");

              case 12:
                _r11 = 0;

              case 13:
                if (!(_r11 < e.spriteIdList.length)) {
                  _context51.next = 38;
                  break;
                }

                o = e.spriteIdList[_r11], n = e.common ? e.common[o] : void 0, s = e.sticker ? e.sticker[o] : void 0, l = e.text ? e.text[o] : void 0, c = e.textdesign ? e.textdesign[o] : void 0;

                if (!n) {
                  _context51.next = 35;
                  break;
                }

                p = n.size;
                p && (p = {
                  width: this.editor.worldToPreview(n.size.width),
                  height: this.editor.worldToPreview(n.size.height)
                });
                _this$editor$outputCo4 = this.editor.outputContainer.getData(), m = _this$editor$outputCo4.flipHorizontally, h = _this$editor$outputCo4.flipVertically, b = this.editor.outputContainer.getRotation(), v = h !== m ? n.rotation - b : n.rotation + b, x = h !== m ? -v : v, I = {
                  spriteId: o,
                  transform: {
                    size: p,
                    position: n.position,
                    rotation: x
                  }
                };

                if (!l) {
                  _context51.next = 26;
                  break;
                }

                R = this.textToolStore.validFontWithConfig(l.identifier);
                l.identifier = R == null ? void 0 : R.identifier;
                _context51.next = 24;
                return this.addNewText(I, l);

              case 24:
                _context51.next = 35;
                break;

              case 26:
                if (!c) {
                  _context51.next = 31;
                  break;
                }

                _context51.next = 29;
                return this.addNewTextDesign(I, c);

              case 29:
                _context51.next = 35;
                break;

              case 31:
                _context51.t1 = s;

                if (!_context51.t1) {
                  _context51.next = 35;
                  break;
                }

                _context51.next = 35;
                return this.addNewSticker(I, f(f({}, s), {
                  flipHorizontally: n.flipHorizontally,
                  flipVertically: n.flipVertically
                }));

              case 35:
                _r11 += 1;
                _context51.next = 13;
                break;

              case 38:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this, [[1, 9]]);
      }));
    };

    this.serializableState = function () {
      return C(_this83, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee53() {
        var _this88 = this;

        var e, t;
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                e = this.editor.spriteStore.getSpriteHistoryState();
                Object.keys(e.common).forEach(function (r) {
                  var _this88$editor$output = _this88.editor.outputContainer.getData(),
                      o = _this88$editor$output.flipHorizontally,
                      n = _this88$editor$output.flipVertically,
                      s = _this88.editor.outputContainer.getRotation(),
                      l = n !== o ? -e.common[r].rotation : e.common[r].rotation;

                  e.common[r].rotation = n !== o ? l + s : l - s;
                });
                _context53.next = 4;
                return Promise.all(this.editor.spriteStore.stickerToolStore.customStickers.map(function (l) {
                  return C(_this88, [l],
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee52(_ref34) {
                    var _n$split, _n$split2;

                    var r, o, n, s, c, _p$split, _p$split2, p;

                    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
                      while (1) {
                        switch (_context52.prev = _context52.next) {
                          case 0:
                            r = _ref34.identifier, o = _ref34.type, n = _ref34.stickerURI, s = _ref34.name;
                            c = {
                              identifier: r,
                              name: s,
                              raster: {
                                data: "",
                                type: Gt.JPEG
                              }
                            };

                            if (!(o === Gt.SVG && (c.svg = {
                              data: n.split(",")[1]
                            }), o === Gt.JPEG || o === Gt.PNG)) {
                              _context52.next = 6;
                              break;
                            }

                            (_n$split = n.split(","), _n$split2 = _slicedToArray(_n$split, 2), c.raster.data = _n$split2[1], _n$split), c.raster.type = o;
                            _context52.next = 10;
                            break;

                          case 6:
                            _context52.next = 8;
                            return oo(n);

                          case 8:
                            p = _context52.sent;
                            (_p$split = p.split(","), _p$split2 = _slicedToArray(_p$split, 2), c.raster.data = _p$split2[1], _p$split), c.raster.type = Gt.PNG;

                          case 10:
                            return _context52.abrupt("return", c);

                          case 11:
                          case "end":
                            return _context52.stop();
                        }
                      }
                    }, _callee52);
                  }));
                }));

              case 4:
                t = _context53.sent;
                return _context53.abrupt("return", {
                  sprite: e,
                  customStickers: t
                });

              case 6:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    };

    this.updateCanvasControls = function () {
      Object.keys(_this83.container).forEach(function (e) {
        _this83.updatePositionAndSize(e, !0);

        var t = _this83.state.get(e);

        if (t) {
          if (t.tool === g.TEXT) {
            var r = _this83.getContainerProperties(e);

            _this83.textToolStore.changeSize(e, r);
          } else if (t.tool === g.TEXT_DESIGN) {
            var _r12 = _this83.getContainerProperties(e);

            _this83.textToolStore.changeWidth(_r12.width);
          }
        }
      });
    };

    this.setEditMode = function (e) {
      _this83.currentSprite && [g.TEXT, g.TEXT_DESIGN].indexOf(_this83.tool) !== -1 && (e ? _this83.editor.modalStore.showTextEditModal() : _this83.editor.modalStore.hideModal(), _this83.editMode.set(e));
    };

    this.setDragMode = function (e) {
      _this83.dragMode.set(e);
    };

    this.setPosition = function (e) {
      var t = _this83.currentSprite,
          r = _this83.container[_this83.id];

      if (t && r) {
        r.setPosition(_this83.editor.previewToWorld(e));

        var _this83$getSizePositi = _this83.getSizePositionFromContainer(),
            o = _this83$getSizePositi.position;

        t.position.x = o.x, t.position.y = o.y, _this83.state.set(_this83.id, t), _this83.editor.render();
      }
    };

    this.setSize = function (e) {
      var t = _this83.currentSprite;
      t && (t.size.width = e.width, t.size.height = e.height, _this83.state.set(_this83.id, t));
    };

    this.setRotation = function (e) {
      var t = _this83.currentSprite;

      if (t) {
        var _this83$editor$output = _this83.editor.outputContainer.getData(),
            r = _this83$editor$output.flipHorizontally,
            o = _this83$editor$output.flipVertically,
            n = _this83.editor.outputContainer.getRotation(),
            s = Qi({
          rotation: e + n,
          flipHorizontally: r,
          flipVertically: o
        });

        _this83.container[_this83.id].setRotation(s), t.rotation = _this83.container[_this83.id].getRotation(), _this83.state.set(_this83.id, t), _this83.editor.render();
      }
    };

    this.onCanvasClick = function (e) {
      _this83.isEditMode || _this83.selectHighestOrderSprite(e);
    };

    this.select = function (e) {
      var t = _this83.state.get(e);

      t && (_this83.editor.activeStore.tool !== t.tool && _this83.editor.activeStore.selectTool(t.tool), _this83.selectedId.set(e));
    };

    this.selectLast = function () {
      var e = _this83.editor.orderHelper.getLastSpriteId();

      e && _this83.select(e);
    };

    this.selectNext = function () {
      if (_this83.currentSprite) {
        var t = _this83.container[_this83.id].getIndexInParent();

        if (t) {
          var r = Object.keys(_this83.container).find(function (o) {
            return _this83.container[o].getIndexInParent() === t - 1;
          });
          r && _this83.select(r);
        }
      }
    };

    this.deselect = function () {
      _this83.selectedId.set(no);
    };

    this.bringToFront = function (e) {
      var t = _this83.editor.orderHelper.bringToFront(e);

      _this83.container[e].setIndexInParent(t), _this83.spriteSnapshot("order"), _this83.editor.render();
    };

    this.flipHorizontally = function (e) {
      var t = _this83.state.get(e),
          r = _this83.container[e];

      r.setFlipHorizontally(!r.getFlipHorizontally()), t.flipHorizontally = r.getFlipHorizontally(), _this83.spriteSnapshot("flip"), _this83.state.set(e, t), _this83.editor.render();
    };

    this.pureReset = function () {
      _this83.selectedId.set(no), Array.from(_this83.state.keys()).forEach(function (e) {
        _this83.pureRemoveSprite(e);
      }), _this83.stickerToolStore.pureReset(), _this83.textToolStore.pureReset(), _this83.textDesignToolStore.pureReset();
    };

    this.selectHighestOrderSprite = function (e) {
      var t = _this83.editor.brushToolStore.containerId();

      if (e = e.filter(function (n) {
        return n !== t;
      }), e.length < 1) {
        _this83.deselect();

        return;
      }

      var r = "",
          o = 0;
      e.forEach(function (n) {
        var s = _this83.container[n],
            l = s && s.getIndexInParent() || 0;
        l >= o && (o = l, r = n);
      }), _this83.select(r);
    };

    this.onCornerDrag = function (_ref35) {
      var e = _ref35.x,
          t = _ref35.y;

      if (_this83.currentSprite) {
        var r = new _(_this83.currentSprite.position),
            o = new _(e, t),
            n = o.subtract(r).magnitude,
            s = _this83.getSize(),
            l = n * 2 / lr.sizeMagnitude(s);

        if (n > _this83.minLength) if (_this83.isSpriteSticker) {
          if (_this83.stickerToolStore.resizeMode !== "unrestricted") _this83.setStickerSize({
            width: s.width * l,
            height: s.height * l
          });else {
            var c = _this83.rotationWRTOutputRotation,
                p = o.subtract(r),
                m = Math.cos(c),
                h = Math.sin(c),
                b = Math.max(Math.abs(p.x * m * 2 + p.y * h * 2), _this83.minLength),
                v = Math.max(Math.abs(p.x * -h * 2 + p.y * m * 2), _this83.minLength);

            _this83.setStickerSize({
              width: b,
              height: v
            });
          }
        } else _this83.isSpriteText ? _this83.setTextSize(s.width * l) : _this83.isSpriteTextDesign && _this83.setTextDesignScale(l);

        _this83.editor.render();
      }
    };

    this.onWidthDrag = function (_ref36) {
      var e = _ref36.x,
          t = _ref36.y;

      var r = new _(_this83.currentSprite.position),
          n = new _(e, t).subtract(r).magnitude,
          s = _this83.editor.previewToWorld(2 * n);

      if (s > _this83.minLength && (_this83.setContainerProperties(_this83.id, {
        width: s
      }, !0), _this83.isSpriteText)) {
        var l = _this83.getContainerProperties(_this83.id);

        _this83.textToolStore.changeWidth(l.width);
      }
    };

    this.onPaddingDrag = function (_ref37) {
      var e = _ref37.x,
          t = _ref37.y;

      if (_this83.isSpriteTextDesign) {
        var r = _this83.getContainerProperties(_this83.id),
            o = new _(_this83.currentSprite.position),
            s = new _(e, t).subtract(o).magnitude,
            l = Math.max(_this83.editor.previewToWorld(s) - r.width / 2, 0);

        _this83.setContainerProperties(_this83.id, {
          padding: l
        }, !0), _this83.isSpriteTextDesign && (r = _this83.getContainerProperties(_this83.id), _this83.textDesignToolStore.changePadding(r.padding));
      }
    };

    this.correctTextFlip = function () {
      var _this83$editor$output2 = _this83.editor.outputContainer.getData(),
          e = _this83$editor$output2.flipHorizontally,
          t = _this83$editor$output2.flipVertically;

      Object.values(_this83.container).forEach(function (r) {
        (r.type === "text" || r.type === "text-design") && (r.setFlipHorizontally(e), r.setFlipVertically(t));
      });
    };

    this.reverseTextHorizontally = function () {
      Object.values(_this83.container).forEach(function (e) {
        (e.type === "text" || e.type === "text-design") && e.setFlipHorizontally(!e.getFlipHorizontally());
      });
    };

    this.reverseTextVertically = function () {
      Object.values(_this83.container).forEach(function (e) {
        (e.type === "text" || e.type === "text-design") && e.setFlipVertically(!e.getFlipVertically());
      });
    };

    this.getOutputProperties = function () {
      return _this83.editor.outputContainer.getData();
    };

    this.getContainerProperties = function (e) {
      return _this83.container[e].getData();
    };

    this.getContainerTransform = function (e) {
      return _this83.container[e].getTransform();
    };

    this.getDuplicateContainerTransform = function (e) {
      var t = _this83.container[e].getTransform(),
          r = _this83.editor.shortestOutputSide * .1,
          o = new _(t.position).add(new _(r, r));

      return f(f({}, t), {
        position: o
      });
    };

    this.getDuplicateContainerFlip = function (e) {
      var t = _this83.container[e].getFlipHorizontally(),
          r = _this83.container[e].getFlipVertically();

      return {
        flipHorizontally: t,
        flipVertically: r
      };
    };

    this.updatePositionAndSize = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this83.id;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      var _this83$getSizePositi2 = _this83.getSizePositionFromContainer(e),
          r = _this83$getSizePositi2.position,
          o = _this83$getSizePositi2.size,
          n = _this83.state.get(e);

      if (n) {
        if (n.position.x = r.x, n.position.y = r.y, n.size.width = o.width, n.size.height = o.height, t) {
          var s = _this83.container[e].getRotation();

          _this83.container[e].setRotation(s), n.rotation = _this83.container[e].getRotation();
        }

        _this83.state.set(e, n);
      }
    };

    this.getInitialTransform = function (e) {
      var t = _this83.editor.outputToWorld(mm.position);

      return e ? f({
        position: t
      }, e) : {
        rotation: _this83.editor.outputContainer.getRotation(),
        position: t
      };
    };

    this.setInitialSpriteState = function (e, t) {
      var r = _this83.container[e],
          _this83$getSizePositi3 = _this83.getSizePositionFromContainer(e),
          o = _this83$getSizePositi3.position,
          n = _this83$getSizePositi3.size,
          s = r.getRotation(),
          l = t !== g.STICKER ? !1 : r.getFlipHorizontally(),
          c = t !== g.STICKER ? !1 : r.getFlipVertically();

      _this83.state.set(e, {
        tool: t,
        position: o,
        rotation: s,
        size: n,
        flipHorizontally: l,
        flipVertically: c
      });
    };

    this.setStickerSize = function (e) {
      var t = _this83.container[_this83.id];
      t.setSizeInWorldSpace(_this83.editor.previewSizeToWorld(e));
      var r = _this83.currentSprite;
      r && (r.size = _this83.editor.worldSizeToPreview(t.getSizeInWorldSpace()), _this83.state.set(_this83.id, r));
    };

    this.setTextSize = function (e) {
      var t = _this83.getContainerProperties(_this83.id),
          r = {
        width: _this83.editor.previewToWorld(e)
      },
          o = r.width / t.width,
          n = {
        fontSize: Math.round(t.fontSize * o)
      },
          s = _this83.isSpriteText ? f(f({}, r), n) : r;

      r.width > _this83.minLength && n.fontSize && (_this83.setContainerProperties(_this83.id, s, !0), t = _this83.getContainerProperties(_this83.id), _this83.textToolStore.changeFontSize(t.fontSize, !0), _this83.textToolStore.changeWidth(t.width));
    };

    this.setTextDesignScale = function (e) {
      var t = _this83.getContainerProperties(_this83.id),
          r = t.width * e;

      if (r > _this83.minLength) {
        _this83.setContainerProperties(_this83.id, {
          width: r
        }, !0);

        var _this83$getContainerP = _this83.getContainerProperties(_this83.id),
            o = _this83$getContainerP.width;

        _this83.textDesignToolStore.changeWidth(o), t = _this83.getContainerProperties(_this83.id), _this83.textDesignToolStore.changePadding(t.padding);
      }
    };

    this.getSizePositionFromContainer = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this83.id;
      var t = _this83.container[e];

      if (t) {
        var r = _this83.editor.worldToPreview(t.getPosition()),
            o = _this83.editor.worldSizeToPreview(t.getSizeInWorldSpace());

        return {
          position: r,
          size: o
        };
      }

      return {
        position: {
          x: 0,
          y: 0
        },
        size: {
          height: 1,
          width: 1
        }
      };
    };

    this.getSize = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this83.id;
      var t = _this83.container[e];
      return t ? _this83.editor.worldSizeToPreview(t.getSizeInWorldSpace()) : {
        width: 0,
        height: 0
      };
    };

    this.editor = e, this.container = {}, this.stickerToolStore = new z(e), this.textToolStore = new O(e), this.textDesignToolStore = new U(e), this.rect = new ne(this.editor, this), this.minLength = this.editor.configStore.measurements.canvasControls.sprite.minSize / Math.sqrt(2);
  }

  _createClass(lr, [{
    key: "currentSprite",
    get: function get() {
      if (this.isSpriteSelected) return this.state.get(this.id);
    }
  }, {
    key: "padding",
    get: function get() {
      return this.textDesignToolStore.padding;
    }
  }, {
    key: "isEditMode",
    get: function get() {
      return this.editMode.get();
    }
  }, {
    key: "isDragMode",
    get: function get() {
      return this.dragMode.get();
    }
  }, {
    key: "id",
    get: function get() {
      return this.selectedId.get();
    }
  }, {
    key: "isSpriteSelected",
    get: function get() {
      return this.id !== no;
    }
  }, {
    key: "position",
    get: function get() {
      if (this.currentSprite) return this.currentSprite.position;
    }
  }, {
    key: "tool",
    get: function get() {
      if (this.currentSprite) return this.currentSprite.tool;
    }
  }, {
    key: "size",
    get: function get() {
      if (this.currentSprite) return this.currentSprite.size;
    }
  }, {
    key: "rotation",
    get: function get() {
      if (this.currentSprite) return this.currentSprite.rotation;
    }
  }, {
    key: "rotationWRTOutputRotation",
    get: function get() {
      if (this.currentSprite) {
        var _this$editor$outputCo5 = this.editor.outputContainer.getData(),
            e = _this$editor$outputCo5.flipHorizontally,
            t = _this$editor$outputCo5.flipVertically,
            r = this.editor.outputContainer.getRotation();

        return Qi({
          rotation: this.currentSprite.rotation - r,
          flipHorizontally: e,
          flipVertically: t
        });
      }
    }
  }, {
    key: "flipHorizontal",
    get: function get() {
      if (this.currentSprite) return this.currentSprite.flipHorizontally;
    }
  }, {
    key: "isSpriteSticker",
    get: function get() {
      return this.tool === g.STICKER;
    }
  }, {
    key: "isSpriteText",
    get: function get() {
      return this.tool === g.TEXT;
    }
  }, {
    key: "isSpriteTextDesign",
    get: function get() {
      return this.tool === g.TEXT_DESIGN;
    }
  }, {
    key: "spritePosition",
    get: function get() {
      if (this.currentSprite) {
        var _this$currentSprite$p = this.currentSprite.position,
            e = _this$currentSprite$p.x,
            t = _this$currentSprite$p.y,
            _this$currentSprite$s = this.currentSprite.size,
            r = _this$currentSprite$s.height,
            o = _this$currentSprite$s.width;
        return {
          x: Math.round(e - o / 2),
          y: Math.round(t - r / 2)
        };
      }
    }
  }, {
    key: "currentRect",
    get: function get() {
      if (this.currentSprite) return this.rect;
    }
  }, {
    key: "leftTopPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.leftTop;
    }
  }, {
    key: "leftBottomPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.leftBottom;
    }
  }, {
    key: "leftMidPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.leftMid;
    }
  }, {
    key: "leftMidPadPosition",
    get: function get() {
      if (this.currentSprite) {
        var e = this.rect.leftMid;
        return {
          x: e.x - this.editor.worldToPreview(this.padding),
          y: e.y
        };
      }
    }
  }, {
    key: "rightTopPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.rightTop;
    }
  }, {
    key: "rightBottomPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.rightBottom;
    }
  }, {
    key: "rightMidPosition",
    get: function get() {
      if (this.currentSprite) return this.rect.rightMid;
    }
  }, {
    key: "rightMidPadPosition",
    get: function get() {
      if (this.currentSprite) {
        var e = this.rect.rightMid;
        return {
          x: e.x + this.editor.worldToPreview(this.padding),
          y: e.y
        };
      }
    }
  }, {
    key: "leftBottomHandlePosition",
    get: function get() {
      if (this.currentSprite) return this.rect.leftBottomHandle;
    }
  }, {
    key: "rightBottomHandlePosition",
    get: function get() {
      if (this.currentSprite) return this.rect.rightBottomHandle;
    }
  }, {
    key: "historyLocale",
    get: function get() {
      return this.isSpriteSticker ? this.stickerLocale : this.isSpriteText ? this.textDesignLocale : this.textLocale;
    }
  }, {
    key: "stickerLocale",
    get: function get() {
      return this.editor.configStore.locale[g.STICKER].history;
    }
  }, {
    key: "textLocale",
    get: function get() {
      return this.editor.configStore.locale[g.TEXT].history;
    }
  }, {
    key: "textDesignLocale",
    get: function get() {
      return this.editor.configStore.locale[g.TEXT_DESIGN].history;
    }
  }], [{
    key: "magnitude",
    value: function magnitude(e, t) {
      return new _(e, t || e).magnitude;
    }
  }, {
    key: "sizeMagnitude",
    value: function sizeMagnitude(e) {
      return Math.sqrt(e.width * e.width + e.height * e.height);
    }
  }]);

  return lr;
}(),
    w = lr;

a([d], w.prototype, "addSticker", 2), a([d], w.prototype, "addStickerAsync", 2), a([d], w.prototype, "addText", 2), a([d], w.prototype, "addTextAsync", 2), a([d], w.prototype, "addTextDesign", 2), a([d], w.prototype, "addTextDesignAsync", 2), a([d], w.prototype, "clickableCanvas", 2), a([d], w.prototype, "setContainerProperties", 2), a([d], w.prototype, "setContainerPosition", 2), a([d], w.prototype, "pureRemoveSprite", 2), a([d], w.prototype, "deleteSprite", 2), a([d], w.prototype, "removeSprite", 2), a([d], w.prototype, "addSnapshot", 2), a([d], w.prototype, "updateStateFromHistory", 2), a([d], w.prototype, "addNewText", 2), a([d], w.prototype, "addNewTextDesign", 2), a([d], w.prototype, "addNewSticker", 2), a([d], w.prototype, "updateSpriteStateFromHistory", 2), a([d], w.prototype, "updateStateFromSerialization", 2), a([d], w.prototype, "updateCanvasControls", 2), a([d], w.prototype, "setEditMode", 2), a([d], w.prototype, "setDragMode", 2), a([d], w.prototype, "setPosition", 2), a([d], w.prototype, "setSize", 2), a([d], w.prototype, "setRotation", 2), a([d], w.prototype, "onCanvasClick", 2), a([d], w.prototype, "select", 2), a([d], w.prototype, "selectLast", 2), a([d], w.prototype, "selectNext", 2), a([d], w.prototype, "deselect", 2), a([d], w.prototype, "bringToFront", 2), a([d], w.prototype, "flipHorizontally", 2), a([d], w.prototype, "pureReset", 2), a([d], w.prototype, "onCornerDrag", 2), a([d], w.prototype, "onWidthDrag", 2), a([d], w.prototype, "onPaddingDrag", 2), a([d], w.prototype, "correctTextFlip", 2), a([d], w.prototype, "reverseTextHorizontally", 2), a([d], w.prototype, "reverseTextVertically", 2), a([u], w.prototype, "currentSprite", 1), a([u], w.prototype, "padding", 1), a([u], w.prototype, "isEditMode", 1), a([u], w.prototype, "isDragMode", 1), a([u], w.prototype, "id", 1), a([u], w.prototype, "isSpriteSelected", 1), a([u], w.prototype, "position", 1), a([u], w.prototype, "tool", 1), a([u], w.prototype, "size", 1), a([u], w.prototype, "rotation", 1), a([u], w.prototype, "rotationWRTOutputRotation", 1), a([u], w.prototype, "flipHorizontal", 1), a([u], w.prototype, "isSpriteSticker", 1), a([u], w.prototype, "isSpriteText", 1), a([u], w.prototype, "isSpriteTextDesign", 1), a([u], w.prototype, "spritePosition", 1), a([u], w.prototype, "currentRect", 1), a([u], w.prototype, "leftTopPosition", 1), a([u], w.prototype, "leftBottomPosition", 1), a([u], w.prototype, "leftMidPosition", 1), a([u], w.prototype, "leftMidPadPosition", 1), a([u], w.prototype, "rightTopPosition", 1), a([u], w.prototype, "rightBottomPosition", 1), a([u], w.prototype, "rightMidPosition", 1), a([u], w.prototype, "rightMidPadPosition", 1), a([u], w.prototype, "leftBottomHandlePosition", 1), a([u], w.prototype, "rightBottomHandlePosition", 1), a([u], w.prototype, "historyLocale", 1), a([u], w.prototype, "stickerLocale", 1), a([u], w.prototype, "textLocale", 1), a([u], w.prototype, "textDesignLocale", 1);
var Je = {
  position: {
    x: 0,
    y: 0
  },
  size: {
    height: 0,
    width: 0
  },
  lockResolution: !1,
  forceDimensions: !1,
  ratio: "*"
},
    Ql = {
  identifier: "identity",
  outputRotation: 0,
  rotationInDegrees: 0,
  flipHorizontally: !1,
  flipVertically: !1,
  cropState: S.map({})
};

var B =
/*#__PURE__*/
function () {
  function B(e, t) {
    _classCallCheck(this, B);

    this.minCropSize = 0;
    this.state = Ql, this.configStore = e.configStore, this.minCropSize = this.configStore.measurements.crop.minSize, this.defaults = t;
  }

  _createClass(B, [{
    key: "changeIdentifier",
    value: function changeIdentifier(e) {
      this.state.identifier = e, this.state.cropState.get(e) || this.state.cropState.set(e, f({}, Je));
    }
  }, {
    key: "changeRatio",
    value: function changeRatio(e) {
      var t = this.state.cropState.get(this.identifier);
      t && this.state.cropState.set(this.identifier, f(f({}, t), {
        ratio: e
      }));
    }
  }, {
    key: "changeSize",
    value: function changeSize(e) {
      var t = this.state.cropState.get(this.identifier);
      t && (e.width && e.width > 0 && (t.size.width = Math.round(e.width)), e.height && e.height > 0 && (t.size.height = Math.round(e.height)), this.state.cropState.set(this.identifier, t));
    }
  }, {
    key: "changeHeight",
    value: function changeHeight(e) {
      var t = this.state.cropState.get(this.identifier);
      t && e && (t.size.height = Math.round(e), this.state.cropState.set(this.identifier, t));
    }
  }, {
    key: "changeWidth",
    value: function changeWidth(e) {
      var t = this.state.cropState.get(this.identifier);
      t && e && (t.size.width = Math.round(e), this.state.cropState.set(this.identifier, t));
    }
  }, {
    key: "changePositionX",
    value: function changePositionX(e, t) {
      var r = this.state.cropState.get(this.identifier);
      return r && e <= t - this.minCropSize && e >= 0 ? (r.position.x = Math.round(e), this.state.cropState.set(this.identifier, r), !0) : !1;
    }
  }, {
    key: "changePositionY",
    value: function changePositionY(e, t) {
      var r = this.state.cropState.get(this.identifier);
      return r && e <= t - this.minCropSize && e >= 0 ? (r.position.y = Math.round(e), this.state.cropState.set(this.identifier, r), !0) : !1;
    }
  }, {
    key: "changePosition",
    value: function changePosition(e, t) {
      var r = this.state.cropState.get(this.identifier);
      return r && e.x <= t.width - this.minCropSize && e.x >= 0 && e.y <= t.height - this.minCropSize && e.y >= 0 ? (r.position.x = Math.round(e.x), r.position.y = Math.round(e.y), this.state.cropState.set(this.identifier, r), !0) : !1;
    }
  }, {
    key: "changeLockResolution",
    value: function changeLockResolution(e) {
      var t = this.state.cropState.get(this.identifier);
      t && (t.lockResolution = e !== void 0 ? e : !t.lockResolution, this.state.cropState.set(this.identifier, t));
    }
  }, {
    key: "changeForceDimensions",
    value: function changeForceDimensions(e) {
      var t = this.state.cropState.get(this.identifier);
      t && (t.forceDimensions = e, this.state.cropState.set(this.identifier, t));
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      this.state.rotationInDegrees = e;
    }
  }, {
    key: "resetRotation",
    value: function resetRotation() {
      this.state.rotationInDegrees = 0;
    }
  }, {
    key: "resetOutputRotation",
    value: function resetOutputRotation() {
      this.state.outputRotation = 0;
    }
  }, {
    key: "resetFlip",
    value: function resetFlip() {
      this.state.flipHorizontally = !1, this.state.flipVertically = !1;
    }
  }, {
    key: "updateFlip",
    value: function updateFlip(_ref38) {
      var e = _ref38.flipHorizontally,
          t = _ref38.flipVertically;
      this.state.flipHorizontally = e, this.state.flipVertically = t;
    }
  }, {
    key: "setOutputRotation",
    value: function setOutputRotation(e) {
      this.state.outputRotation = e;
    }
  }, {
    key: "flipHorizontally",
    value: function flipHorizontally() {
      this.state.flipHorizontally = !this.state.flipHorizontally;
    }
  }, {
    key: "flipVertically",
    value: function flipVertically() {
      this.state.flipVertically = !this.state.flipVertically;
    }
  }, {
    key: "flipCenter",
    get: function get() {
      var _this$defaults$maxCro = this.defaults.maxCropMaskSize,
          e = _this$defaults$maxCro.width,
          t = _this$defaults$maxCro.height;
      return new _(e / 2, t / 2);
    }
  }, {
    key: "isFlippedHorizontal",
    get: function get() {
      return this.state.flipHorizontally;
    }
  }, {
    key: "isFlippedVertical",
    get: function get() {
      return this.state.flipVertically;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.state.identifier;
    }
  }, {
    key: "height",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size.height : Je.size.height;
    }
  }, {
    key: "width",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size.width : Je.size.width;
    }
  }, {
    key: "position",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position : Je.position;
    }
  }, {
    key: "ratio",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.ratio : Je.ratio;
    }
  }, {
    key: "size",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.size : Je.size;
    }
  }, {
    key: "x",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position.x : Je.position.x;
    }
  }, {
    key: "y",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.position.y : Je.position.y;
    }
  }, {
    key: "lockResolution",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.lockResolution : Je.lockResolution;
    }
  }, {
    key: "forceDimensions",
    get: function get() {
      return this.selectedCrop ? this.selectedCrop.forceDimensions : Je.forceDimensions;
    }
  }, {
    key: "selectedCrop",
    get: function get() {
      return this.state.cropState.get(this.identifier);
    }
  }, {
    key: "rotationInDegrees",
    get: function get() {
      return this.state.rotationInDegrees;
    }
  }, {
    key: "outputRotation",
    get: function get() {
      return this.state.outputRotation;
    }
  }]);

  return B;
}();

a([S], B.prototype, "state", 2), a([d], B.prototype, "changeIdentifier", 1), a([d], B.prototype, "changeRatio", 1), a([d], B.prototype, "changeSize", 1), a([d], B.prototype, "changeHeight", 1), a([d], B.prototype, "changeWidth", 1), a([d], B.prototype, "changePositionX", 1), a([d], B.prototype, "changePositionY", 1), a([d], B.prototype, "changePosition", 1), a([d], B.prototype, "changeLockResolution", 1), a([d], B.prototype, "changeForceDimensions", 1), a([d], B.prototype, "setRotation", 1), a([d], B.prototype, "resetRotation", 1), a([d], B.prototype, "resetOutputRotation", 1), a([d], B.prototype, "resetFlip", 1), a([d], B.prototype, "updateFlip", 1), a([d], B.prototype, "setOutputRotation", 1), a([d], B.prototype, "flipHorizontally", 1), a([d], B.prototype, "flipVertically", 1), a([u], B.prototype, "flipCenter", 1), a([u], B.prototype, "isFlippedHorizontal", 1), a([u], B.prototype, "isFlippedVertical", 1), a([u], B.prototype, "identifier", 1), a([u], B.prototype, "height", 1), a([u], B.prototype, "width", 1), a([u], B.prototype, "position", 1), a([u], B.prototype, "ratio", 1), a([u], B.prototype, "size", 1), a([u], B.prototype, "x", 1), a([u], B.prototype, "y", 1), a([u], B.prototype, "lockResolution", 1), a([u], B.prototype, "forceDimensions", 1), a([u], B.prototype, "selectedCrop", 1), a([u], B.prototype, "rotationInDegrees", 1), a([u], B.prototype, "outputRotation", 1);

var xs =
/*#__PURE__*/
function () {
  function xs(e) {
    _classCallCheck(this, xs);

    this.transforms = {
      output: JSON.stringify(X.IDENTITY),
      preview: JSON.stringify(X.IDENTITY)
    };
    this.editor = e, this.overlayOpacity = 0, this.frameOpacity = 0;
  }

  _createClass(xs, [{
    key: "onLeave",
    value: function onLeave() {
      var _this$transformToolSt = this.transformToolStore.rotateFlipState,
          e = _this$transformToolSt.flipHorizontally,
          t = _this$transformToolSt.flipVertically,
          r = _this$transformToolSt.rotation,
          o = _this$transformToolSt.outputRotation;
      this.editor.overlayToolStore.identifier !== "identity" && this.editor.overlayToolStore.changeOpacity(this.overlayOpacity), this.editor.frameToolStore.identifier !== "identity" && this.editor.frameToolStore.changeOpacity(this.frameOpacity);
      var n = this.editor.previewToWorld(new _(this.transformToolStore.leftTopRespectFlip).add(new _(this.transformToolStore.rightBottomRespectFlip)).divide(2).add(new _(this.transformToolStore.unRotatedDefaults.cropMaskPosition)), !0),
          s = this.engineMediator.preview.container,
          l = this.editor.outputContainer;
      l.setResolution(k(this.transformToolStore.localOutputImageSize)), l.setData({
        flipVertically: t,
        flipHorizontally: e
      });
      var c = s.getScale();
      this.editor.overlayToolStore.correctOverlayFlip(), this.saveTransforms();
      var p = 1;

      if (this.transformToolStore.lockResolution) {
        var _this$transformToolSt2 = this.transformToolStore,
            x = _this$transformToolSt2.cropMaskSize,
            I = _this$transformToolSt2.defaultImageSize,
            R = this.transformToolStore.maxCropMaskSize;
        p = {
          height: x.height * I.height / R.height,
          width: x.width * I.width / R.width
        }.width / this.transformToolStore.localOutputImageSize.width;
      }

      var m = Math.abs(c.x),
          h = p / (m / this.transformToolStore.defaultScale),
          b = {
        x: h,
        y: h
      },
          v = -(r - o);
      l.setTransform({
        scale: b,
        position: n,
        rotation: v
      }), this.editor.engineMediator.preview.updateTransform(0, !1), this.editor.scale.setInitialTransform(), this.editor.spriteStore.updateCanvasControls(), this.editor.focusToolStore.updateCanvasControls();
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      this.editor.overlayToolStore.identifier !== "identity" && (this.overlayOpacity = this.editor.overlayToolStore.opacity, this.editor.overlayToolStore.changeOpacity(0)), this.editor.frameToolStore.identifier !== "identity" && (this.frameOpacity = this.editor.frameToolStore.opacity, this.editor.frameToolStore.changeOpacity(0)), this.editor.scale.setScaleToDefault();
      var e = this.engineMediator.preview.container,
          t = this.editor.outputContainer,
          r = JSON.parse(this.transforms.preview);
      t.setResolution(k(this.transformToolStore.defaultImageSize)), e.setTransform(r), t.setTransform(JSON.parse(this.transforms.output));
      var o = r.scale;
      t.setData({
        flipVertically: !1,
        flipHorizontally: !1
      }), this.transformToolStore.transformStore.updateFlip({
        flipVertically: o.y < 0,
        flipHorizontally: o.x < 0
      }), this.engineMediator.preview.savePreviewTransform(r);

      var _this$engineMediator$ = this.engineMediator.preview.calculateTransform(),
          n = _this$engineMediator$.scale;

      this.editor.scale.setInitialTransform(n.x);
    }
  }, {
    key: "rotateOutputContainer",
    value: function rotateOutputContainer() {
      var _this89 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      this.editor.outputContainer.rotate90(e), this.transformToolStore.transformStore.setOutputRotation(this.editor.outputContainer.getRotation());
      var t = this.transformToolStore.rotateFlipState.rotation;
      this.engineMediator.preview.updateTransform(t), re(function () {
        _this89.editor.scale.setInitialTransform();

        var r = _this89.getScaleWithFlip(t);

        _this89.engineMediator.preview.container.setScale(r), _this89.transformToolStore.setCropDefaults(!0), _this89.transformToolStore.updateCropMask();
      }), this.editor.render();
    }
  }, {
    key: "applyPreviewTransform",
    value: function applyPreviewTransform() {
      var _this$transformToolSt3 = this.transformToolStore.rotateFlipState,
          e = _this$transformToolSt3.rotation,
          t = _this$transformToolSt3.flipHorizontally,
          r = _this$transformToolSt3.flipVertically,
          o = this.editor.scale.getPositionWithOffset(),
          n = this.getScaleWithFlip(),
          s = e;
      t && (s = Zi(s)), r && (s = Zi(s));
      var l = {
        position: o,
        rotation: s,
        scale: n
      };
      this.engineMediator.preview.savePreviewTransform(l), this.engineMediator.preview.container.setTransform(l);
    }
  }, {
    key: "getScaleWithFlip",
    value: function getScaleWithFlip() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.transformToolStore.rotateFlipState.rotation;
      var _this$transformToolSt4 = this.transformToolStore.rotateFlipState,
          t = _this$transformToolSt4.flipHorizontally,
          r = _this$transformToolSt4.flipVertically,
          o = t ? -1 : 1,
          n = r ? -1 : 1,
          s = this.editor.scale.calculateScale(e);
      return {
        x: s * o,
        y: s * n
      };
    }
  }, {
    key: "saveTransforms",
    value: function saveTransforms() {
      var e = JSON.stringify(this.engineMediator.preview.container.getTransform()),
          t = JSON.stringify(this.editor.outputContainer.getTransform());
      this.transforms = {
        preview: e,
        output: t
      };
    }
  }, {
    key: "saveTransformsBasedOnFlip",
    value: function saveTransformsBasedOnFlip() {
      var e = this.engineMediator.preview.container.getTransform(),
          t = e.scale,
          _this$editor$outputCo6 = this.editor.outputContainer.getData(),
          r = _this$editor$outputCo6.flipVertically,
          o = _this$editor$outputCo6.flipHorizontally,
          n = JSON.stringify(this.editor.outputContainer.getTransform());

      this.transforms = {
        preview: JSON.stringify(f(f({}, e), {
          scale: {
            x: o ? -t.x : t.x,
            y: r ? -t.y : t.y
          }
        })),
        output: n
      };
    }
  }, {
    key: "engineMediator",
    get: function get() {
      return this.editor.engineMediator;
    }
  }, {
    key: "transformToolStore",
    get: function get() {
      return this.editor.transformToolStore;
    }
  }], [{
    key: "rotateOutput",
    value: function rotateOutput(e, t) {
      switch (e %= 360, e) {
        case 90:
        case -270:
          return t.swapped.multiply(-1, 1);

        case 180:
        case -180:
          return t.multiply(-1);

        case 270:
        case -90:
          return t.swapped.multiply(1, -1);

        default:
          return t;
      }
    }
  }]);

  return xs;
}();

var ec = "identity",
    si =
/*#__PURE__*/
function () {
  function si(e) {
    var _this90 = this;

    _classCallCheck(this, si);

    this.unRotatedDefaults = {
      cropMaskPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    };
    this.defaultAngle = 0;
    this.dragMode = S.box(!1);
    this.minCropSize = 0;
    this.localSnapshotEnabled = !0;
    this.defaults = {
      cropMaskPosition: {
        x: 0,
        y: 0
      },
      maxCropMaskSize: {
        width: 0,
        height: 0
      },
      imageSize: {
        width: 0,
        height: 0
      },
      scale: 1
    };
    this.localOutputSize = {
      width: 0,
      height: 0
    };

    this.checkIfTransformThumbnailExits = function (e) {
      var t = _this90.editor.configStore.config.assetBaseUrl,
          _t21 = t,
          r = _t21.length;
      if (t[r - 1] !== "/" && (t += "/"), "".concat(t, "transform/") === e) return !1;
      var o = new Image();

      try {
        return o.src = e, !0;
      } catch (n) {
        return !1;
      }
    };

    this.reset = function () {
      _this90.transformStore.resetRotation(), _this90.transformStore.resetOutputRotation(), _this90.transformStore.resetFlip(), _this90.editor.spriteStore.correctTextFlip(), _this90.editor.overlayToolStore.correctOverlayFlip(), _this90.setDefaultAngle(0), _this90.editor.outputContainer.getRotation() !== 0 && _this90.engineMediator.output.applyNewImageTransform(), _this90.engineMediator.output.container.setData({
        flipHorizontally: !1,
        flipVertically: !1
      }), _this90.engineMediator.preview.updateTransform(), _this90.editor.scale.setInitialTransform(), _this90.setCropDefaults(), _this90.applyInitialCrop(), _this90.editor.render();
    };

    this.changeLocalOutputSize = function (e) {
      _this90.localOutputSize.height = Math.round(e.height), _this90.localOutputSize.width = Math.round(e.width);
    };

    this.changeDefaultScale = function (e) {
      _this90.defaults.scale = e;
    };

    this.changeLocalOutputHeight = function (e) {
      _this90.localOutputSize.height = Math.round(e);
    };

    this.changeLocalOutputWidth = function (e) {
      _this90.localOutputSize.width = Math.round(e);
    };

    this.changeLockResolution = function () {
      _this90.transformStore.changeLockResolution(), _this90.addLocalSnapshot();
    };

    this.rotateClockwise = function () {
      _this90.rotateOutputContainer(_this90.isFlippedVertical !== _this90.isFlippedHorizontal);
    };

    this.rotateAntiClockwise = function () {
      _this90.rotateOutputContainer(_this90.isFlippedVertical === _this90.isFlippedHorizontal);
    };

    this.flipHorizontally = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      _this90.transformStore.flipHorizontally(), _this90.editor.spriteStore.reverseTextHorizontally(), _this90.transformRender(e), e && _this90.addLocalSnapshot();
    };

    this.flipVertically = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      _this90.transformStore.flipVertically(), _this90.editor.spriteStore.reverseTextVertically(), _this90.transformRender(e), e && _this90.addLocalSnapshot();
    };

    this.applyDefaultCrop = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      if (_this90.identifier === "identity") {
        var _this90$getMatchingIt = _this90.getMatchingItem(),
            _t22 = _this90$getMatchingIt.identifier;

        _this90.changeIdentifier(_t22, e);
      }
    };

    this.updateCropMask = function () {
      _this90.changeIdentifier(_this90.identifier, !0);
    };

    this.onLeftTop = function (_ref39) {
      var e = _ref39.x,
          t = _ref39.y;

      var r = _this90.getRatio(),
          o = _this90.rightBottom,
          n = _this90.minCropMaskSize,
          s = _this90.maxCropMaskSize,
          l = Math.min(Math.max(0, e), o.x - n.width),
          c = Math.min(Math.max(0, t), o.y - n.height),
          p = o.x - l,
          m = o.y - c,
          h = {
        width: Math.max(_this90.minCropSize, Math.min(p, s.width - l)),
        height: Math.max(_this90.minCropSize, Math.min(m, s.height - c))
      };

      if (r === "*") _this90.changePosition({
        x: l,
        y: c
      }) && _this90.changeCropAndOutputSize(h);else {
        var b = _this90.proportionalSize(r, h),
            v = new _(o).rounded.subtract({
          x: b.width,
          y: b.height
        });

        _this90.changePosition(v) && _this90.changeCropAndOutputSize(b);
      }
    };

    this.onLeftBottom = function (_ref40) {
      var e = _ref40.x,
          t = _ref40.y;

      var r = _this90.getRatio(),
          o = _this90.rightTop,
          n = _this90.minCropMaskSize,
          s = _this90.maxCropMaskSize,
          l = Math.min(Math.max(0, e), o.x - n.width),
          c = Math.max(0, t, o.y + n.height),
          p = o.x - l,
          m = c - o.y,
          h = {
        width: Math.max(1, Math.min(p, s.width - l)),
        height: Math.max(1, Math.min(m, s.height - o.y))
      };

      if (r === "*") _this90.changeCropAndOutputSize(h) && _this90.changePositionX(l);else {
        var b = _this90.proportionalSize(r, h);

        _this90.changePositionX(Math.round(o.x) - b.width) && _this90.changeCropAndOutputSize(b);
      }
    };

    this.onRightTop = function (_ref41) {
      var e = _ref41.x,
          t = _ref41.y;

      var r = _this90.getRatio(),
          o = _this90.leftBottom,
          n = _this90.minCropMaskSize,
          s = _this90.maxCropMaskSize,
          l = Math.max(0, e, o.x + n.width),
          c = Math.min(Math.max(0, t), o.y - n.height),
          p = l - o.x,
          m = o.y - c,
          h = {
        width: Math.max(1, Math.min(p, s.width - o.x)),
        height: Math.max(1, Math.min(m, s.height - c))
      };

      if (r === "*") _this90.changePositionY(c) && _this90.changeCropAndOutputSize(h);else {
        var b = _this90.proportionalSize(r, h);

        _this90.changePositionY(Math.round(o.y) - b.height) && _this90.changeCropAndOutputSize(b);
      }
    };

    this.onRightBottom = function (_ref42) {
      var e = _ref42.x,
          t = _ref42.y;

      var r = _this90.getRatio(),
          o = _this90.leftTop,
          n = _this90.minCropMaskSize,
          s = _this90.maxCropMaskSize,
          l = Math.max(0, e, o.x + n.width),
          c = Math.max(0, t, o.y + n.height),
          p = l - o.x,
          m = c - o.y,
          h = {
        width: Math.max(1, Math.min(p, s.width - o.x)),
        height: Math.max(1, Math.min(m, s.height - o.y))
      };

      if (r === "*") _this90.changeCropAndOutputSize(h);else {
        var b = _this90.proportionalSize(r, h);

        _this90.changeCropAndOutputSize(b);
      }
    };

    this.onPixelWidth = function (e) {
      var t = JSON.stringify(k(_this90.localOutputSize)),
          r = _this90.entityManager.items.find(function (n) {
        return n.identifier === _this90.identifier;
      }),
          o = _this90.defaults.imageSize;

      if (r && r.ratio) {
        var _n3 = e,
            _s3 = _this90.localOutputSize.height,
            l = r.ratio;
        if (l === "*" && _this90.lockResolution && (l = _this90.localOutputSize.width / _this90.localOutputSize.height), l === "*" && !_this90.lockResolution) _n3 = Math.max(Math.min(e, o.width), _this90.minCropSize), _this90.changeLocalOutputWidth(_n3);else {
          var c = si.placeCropMask(l, o);
          _n3 = Math.max(Math.min(_n3, c.width), _this90.minCropSize), _s3 = _n3 / l, _this90.changeLocalOutputSize({
            height: _s3,
            width: _n3
          });
        }
        return _this90.lockResolution || _this90.updatePreviewSizeWRTImageSize(), _this90.checkAndAddSnapshot(JSON.parse(t)), Math.round(_n3);
      }

      return e;
    };

    this.onPixelHeight = function (e) {
      var t = JSON.stringify(k(_this90.localOutputSize)),
          r = _this90.entityManager.items.find(function (n) {
        return n.identifier === _this90.identifier;
      }),
          o = _this90.defaults.imageSize;

      if (r && r.ratio) {
        var _n4 = e,
            _s4 = _this90.localOutputSize.width,
            l = r.ratio;
        if (l === "*" && _this90.lockResolution && (l = _this90.localOutputSize.width / _this90.localOutputSize.height), l === "*" && !_this90.lockResolution) _n4 = Math.max(Math.min(e, o.height), _this90.minCropSize), _this90.changeLocalOutputHeight(_n4);else {
          var c = si.placeCropMask(l, o);
          _n4 = Math.max(Math.min(_n4, c.height), _this90.minCropSize), _s4 = _n4 * l, _this90.changeLocalOutputSize({
            height: _n4,
            width: _s4
          });
        }
        return _this90.lockResolution || _this90.updatePreviewSizeWRTImageSize(), _this90.checkAndAddSnapshot(JSON.parse(t)), Math.round(_n4);
      }

      return e;
    };

    this.closestRatioReducer = function (e) {
      return function (t, r) {
        return r === null || Math.abs(e - t.ratio) < Math.abs(e - r.ratio) ? -1 : 1;
      };
    };

    this.closestDimensionsReducer = function (e) {
      return function (t, r) {
        if (r === null) return -1;
        var o = Math.abs(t.dimensions.x / t.dimensions.y),
            n = Math.abs(r.dimensions.x / r.dimensions.y);
        return o === n ? t.dimensions.x * t.dimensions.y > r.dimensions.x * r.dimensions.y ? -1 : 1 : Math.abs(e - o) < Math.abs(e - n) ? -1 : 1;
      };
    };

    this.getMatchingItem = function () {
      var e = _this90.entityManager.items.findIndex(function (c) {
        return c.identifier === "imgly_transform_common_custom";
      });

      if (e !== -1) return _this90.entityManager.items[e];

      var t = _this90.entityManager.items.findIndex(function (c) {
        return c.ratio === "*";
      });

      if (t !== -1) return _this90.entityManager.items[t];

      var r = k(_this90.editor.outputContainer.getResolution()),
          o = Math.abs(r.width / r.height),
          _this90$entityManager = _this90.entityManager.items.filter(function (c) {
        return c.ratio && typeof c.ratio == "number";
      }).sort(_this90.closestRatioReducer(o)),
          _this90$entityManager2 = _slicedToArray(_this90$entityManager, 1),
          n = _this90$entityManager2[0],
          _this90$entityManager3 = _this90.entityManager.items.filter(function (c) {
        return c.dimensions && !c.ratio;
      }).sort(_this90.closestDimensionsReducer(o)),
          _this90$entityManager4 = _slicedToArray(_this90$entityManager3, 1),
          s = _this90$entityManager4[0];

      if (!n || !s || !n.ratio && !s.dimensions) return _this90.entityManager.items[0];
      if (!s || !s.dimensions) return n;
      if (!n || !n.ratio) return s;
      var l = Math.abs(s.dimensions.x / s.dimensions.y);
      return l === n.ratio || Math.abs(o - n.ratio) < Math.abs(o - l) ? n : s;
    };

    this.getTransform = function (e) {
      var t = _this90.entityManager.items.find(function (r) {
        return r.identifier === e;
      });

      return t || (t = _this90.getMatchingItem()), t;
    };

    this.editor = e, this.selectedCategory = ec, this.transformStore = new B(e, this.defaults), this.transformations = new xs(e);
    var s = this.config,
        t = s.enableRotation,
        r = s.enableFlip,
        o = Pe(s, ["enableRotation", "enableFlip"]),
        n = this.editor.assetProvider.getAssets("transform");
    this.entityManager = new ee(n, f(f({}, o), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      locale: f(f({}, this.locale.items), this.locale.categories),
      getAssetPath: this.editor.getAssetPath("transform")
    })), this.rect = new ne(this.editor, this.transformStore, "topLeft", !1, !1), this.rectForUi = new ne(this.editor, this.transformStore, "topLeft", !1, !0), this.minCropSize = this.editor.configStore.measurements.crop.minSize;
  }

  _createClass(si, [{
    key: "changeIdentifier",
    value: function changeIdentifier(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this.transformStore.changeIdentifier(e);
      var r = this.getCropMask(e, this.defaults.imageSize);
      r && (this.transformStore.changeRatio(r.ratio), this.changeLocalOutputSize(r), this.updatePreviewSizeWRTImageSize(), r.yChanged !== void 0 && this.updateInitialCropMaskPosition(r.yChanged), r.dimensions && this.changeLocalOutputSize({
        width: r.dimensions.x,
        height: r.dimensions.y
      }), t && this.addLocalSnapshot());
    }
  }, {
    key: "setDragMode",
    value: function setDragMode(e) {
      this.dragMode.set(e);
    }
  }, {
    key: "getCropMask",
    value: function getCropMask(e, t) {
      var r = this.getTransform(e);

      if (r) {
        var o = r.ratio,
            n = r.forceDimensions,
            s = r.lockDimensions,
            _r$dimensions = r.dimensions,
            l = _r$dimensions === void 0 ? null : _r$dimensions;
        if (n && this.transformStore.changeForceDimensions(n), s && this.transformStore.changeLockResolution(s), o) switch (o) {
          case "*":
            return this.changePosition({
              x: 0,
              y: 0
            }), f(f({}, t), {
              yChanged: void 0,
              ratio: "*",
              dimensions: l
            });

          default:
            return f(f({}, si.placeCropMask(r.ratio, t)), {
              ratio: r.ratio,
              dimensions: l
            });
        } else {
          var _r$dimensions2 = r.dimensions,
              c = _r$dimensions2.x,
              p = _r$dimensions2.y;
          return f(f({}, si.placeCropMask(c / p, t)), {
            ratio: null,
            dimensions: l
          });
        }
      }

      return null;
    }
  }, {
    key: "setCropDefaults",
    value: function setCropDefaults() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var t = this.editor.outputContainer.getResolution();
      this.setDefaultImageSize(t);
      var r = this.editor.getPreviewSize(),
          o = this.editor.engineMediator.preview.previewTransformWithoutDpr.position;
      this.setMaxCropSize(r), this.setDefaultCropPosition({
        x: o.x - r.width / 2,
        y: o.y - r.height / 2
      }), this.changeDefaultScale(this.editor.scale.defaultScale), e || (this.unRotatedDefaults.cropMaskPosition = this.defaultCropMaskPosition, this.unRotatedDefaults.scale = this.defaultScale);
    }
  }, {
    key: "setDefaultImageSize",
    value: function setDefaultImageSize(e) {
      this.defaults.imageSize = f({}, k(e)), this.lockResolution || (this.localOutputSize = f({}, k(e)));
    }
  }, {
    key: "setMaxCropSize",
    value: function setMaxCropSize(e) {
      this.defaults.maxCropMaskSize.height = e.height, this.defaults.maxCropMaskSize.width = e.width;
    }
  }, {
    key: "setDefaultCropPosition",
    value: function setDefaultCropPosition(e) {
      this.defaults.cropMaskPosition.x = e.x, this.defaults.cropMaskPosition.y = e.y;
    }
  }, {
    key: "resetCrop",
    value: function resetCrop() {
      this.state.cropState = S.map({}), this.state.identifier = "identity";
    }
  }, {
    key: "toggleCategorySelection",
    value: function toggleCategorySelection(e) {
      this.selectedCategory = this.selectedCategory === e ? ec : e;
    }
  }, {
    key: "pureReset",
    value: function pureReset() {
      this.transformStore.resetRotation(), this.transformStore.resetOutputRotation(), this.transformStore.resetFlip(), this.editor.spriteStore.correctTextFlip(), this.editor.overlayToolStore.correctOverlayFlip(), this.resetCrop();
    }
  }, {
    key: "changePosition",
    value: function changePosition(e) {
      return this.transformStore.changePosition(e, this.defaults.maxCropMaskSize);
    }
  }, {
    key: "changePositionX",
    value: function changePositionX(e) {
      return this.transformStore.changePositionX(e, this.defaults.maxCropMaskSize.width);
    }
  }, {
    key: "changePositionY",
    value: function changePositionY(e) {
      return this.transformStore.changePositionY(e, this.defaults.maxCropMaskSize.height);
    }
  }, {
    key: "changeCropAndOutputHeight",
    value: function changeCropAndOutputHeight(e) {
      return e && e >= this.minCropSize ? (this.transformStore.changeHeight(e), this.lockResolution || this.changeLocalOutputHeight(e * this.defaults.imageSize.height / this.defaults.maxCropMaskSize.height), !0) : !1;
    }
  }, {
    key: "changeCropAndOutputWidth",
    value: function changeCropAndOutputWidth(e) {
      return e && e >= this.minCropSize ? (this.transformStore.changeWidth(e), this.lockResolution || this.changeLocalOutputWidth(e * this.defaults.imageSize.width / this.defaults.maxCropMaskSize.width), !0) : !1;
    }
  }, {
    key: "changeCropAndOutputSize",
    value: function changeCropAndOutputSize(e) {
      var t = this.changeCropAndOutputHeight(e.height),
          r = this.changeCropAndOutputWidth(e.width);
      return {
        widthChanged: t,
        heightChanged: r
      };
    }
  }, {
    key: "transformRender",
    value: function transformRender() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      this.transformations.applyPreviewTransform(), e && this.editor.render();
    }
  }, {
    key: "addLocalSnapshot",
    value: function addLocalSnapshot() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Local ".concat(this.locale.title);

      if (this.localSnapshotEnabled) {
        var t = this.state,
            r = t.cropState,
            o = Pe(t, ["cropState"]);
        this.editor.addLocalTransformSnapshot(f(f(f({}, o), this.cropState), {
          localOutputSize: k(this.localOutputSize),
          outputSize: this.engineMediator.output.container.getResolution(),
          defaults: k(this.defaults),
          previewTransform: this.engineMediator.preview.container.getTransform(),
          outputTransform: this.engineMediator.output.container.getTransform()
        }), e);
      }
    }
  }, {
    key: "updateLocalStateFromHistory",
    value: function updateLocalStateFromHistory(e) {
      var t = this.editor.activeStore.tool;
      t === g.TRANSFORM && (this.transformStore.changeLockResolution(e.lockResolution), this.transformStore.changeForceDimensions(e.forceDimensions), this.transformStore.changeIdentifier(e.identifier), this.transformStore.setRotation(e.rotationInDegrees), this.setDefaultAngle(e.rotationInDegrees), this.transformStore.setOutputRotation(e.outputRotation), this.transformStore.updateFlip(e), this.engineMediator.output.container.setRotation(e.outputRotation), this.setDefaultImageSize(e.defaults.imageSize), this.localOutputSize = e.defaults.imageSize, this.changeLocalOutputSize(e.localOutputSize), this.transformStore.changeSize(e.size), this.changePosition(e.position), this.setMaxCropSize(e.defaults.maxCropMaskSize), this.setDefaultCropPosition(e.defaults.cropMaskPosition), this.changeDefaultScale(e.defaults.scale), this.engineMediator.output.container.setResolution(e.outputSize), this.engineMediator.preview.container.setTransform(e.previewTransform), this.engineMediator.output.container.setTransform(e.outputTransform));
    }
  }, {
    key: "updateStateFromHistory",
    value: function updateStateFromHistory(e) {
      var t = this.editor.activeStore.tool;
      t !== g.TRANSFORM && (this.engineMediator.output.container.setTransform(e.outputTransform), this.engineMediator.preview.container.setTransform(e.previewTransform), this.engineMediator.output.container.setResolution(e.outputSize), this.changeLocalOutputSize(e.outputSize));
    }
  }, {
    key: "getStartEndForOperation",
    value: function getStartEndForOperation(e) {
      var t = this.leftTop,
          r = this.rightBottom,
          o = this.maxCropMaskSize,
          n = t.y,
          s = t.x,
          l = r.x,
          c = r.y;

      switch (e) {
        case 270:
          return {
            leftTop: {
              x: o.height - c,
              y: s
            },
            rightBottom: {
              x: o.height - n,
              y: l
            }
          };

        case 180:
          return {
            leftTop: {
              x: o.width - l,
              y: o.height - c
            },
            rightBottom: {
              x: o.width - s,
              y: o.height - n
            }
          };

        case 90:
          return {
            leftTop: {
              x: n,
              y: o.width - l
            },
            rightBottom: {
              x: c,
              y: o.width - s
            }
          };

        default:
          return {
            leftTop: {
              x: s,
              y: n
            },
            rightBottom: {
              x: l,
              y: c
            }
          };
      }
    }
  }, {
    key: "getStartEndForUI",
    value: function getStartEndForUI(e, t, r) {
      var o = this.maxCropMaskSize,
          n = t.y,
          s = t.x,
          l = r.x,
          c = r.y;

      switch (e) {
        case 90:
          return {
            leftTop: {
              x: n,
              y: o.height - l
            },
            rightBottom: {
              x: c,
              y: o.height - s
            }
          };

        case 180:
          return {
            leftTop: {
              x: o.width - l,
              y: o.height - c
            },
            rightBottom: {
              x: o.width - s,
              y: o.height - n
            }
          };

        case 270:
          return {
            leftTop: {
              x: o.width - c,
              y: s
            },
            rightBottom: {
              x: o.width - n,
              y: l
            }
          };

        default:
          return {
            leftTop: {
              x: s,
              y: n
            },
            rightBottom: {
              x: l,
              y: c
            }
          };
      }
    }
  }, {
    key: "convertOperationOptionsToUI",
    value: function convertOperationOptionsToUI(_ref43) {
      var e = _ref43.start,
          t = _ref43.end,
          r = _ref43.rotation,
          o = _ref43.outputRotation;

      var n = o === 90 || o === 270,
          s = n ? _.fromSize(this.defaultImageSize).swapped : _.fromSize(this.defaultImageSize),
          l = Math.cos(r),
          c = Math.sin(r),
          p = this.calculateScale(r),
          m = new _(Math.min(e.x, t.x), Math.min(e.y, t.y)),
          b = new _(Math.max(e.x, t.x), Math.max(e.y, t.y)).subtract(m).divide(2),
          x = m.add(b).multiply(s).subtract(s.multiply(.5)),
          I = new _(x.x * l - x.y * c, x.x * c + x.y * l).multiply(p),
          M = s.multiply(.5).add(I).divide(s),
          Q = M.subtract(b.multiply(p)),
          se = M.add(b.multiply(p)),
          ve = n ? _.fromSize(this.maxCropMaskSize).swapped : _.fromSize(this.maxCropMaskSize),
          _e = Q.multiply(ve),
          T = se.multiply(ve),
          _this$getStartEndForU = this.getStartEndForUI(o, _e, T),
          Z = _this$getStartEndForU.leftTop,
          ae = _this$getStartEndForU.rightBottom;

      return {
        start: new _(Z),
        end: new _(ae)
      };
    }
  }, {
    key: "convertUIToOperationOptions",
    value: function convertUIToOperationOptions(e, t) {
      var r = t === 90 || t === 270,
          o = r ? _.fromSize(this.defaultImageSize).swapped : _.fromSize(this.defaultImageSize),
          n = r ? _.fromSize(this.maxCropMaskSize).swapped : _.fromSize(this.maxCropMaskSize),
          s = Math.cos(-e),
          l = Math.sin(-e),
          c = this.calculateScale(e, r),
          _this$getStartEndForO = this.getStartEndForOperation(t),
          p = _this$getStartEndForO.leftTop,
          m = _this$getStartEndForO.rightBottom,
          h = new _(p).divide(n),
          v = new _(m).divide(n).subtract(h).divide(2),
          I = h.add(v).multiply(o).subtract(o.multiply(.5)),
          R = new _(I.x * s - I.y * l, I.x * l + I.y * s).divide(c),
          Q = o.multiply(.5).add(R).divide(o),
          se = Q.subtract(v.divide(c)),
          ve = Q.add(v.divide(c));

      return {
        start: se,
        end: ve
      };
    }
  }, {
    key: "calculateScale",
    value: function calculateScale(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r = t ? _.fromSize(this.defaultImageSize).swapped : _.fromSize(this.defaultImageSize),
          o = new _(Math.abs(r.x * Math.cos(e)) + Math.abs(r.y * Math.sin(e)), Math.abs(r.x * Math.sin(e)) + Math.abs(r.y * Math.cos(e))),
          n = r.subtract(o.clone()).divide(2).abs;
      return n.y > n.x ? n.y * 2 / r.y + 1 : n.x * 2 / r.x + 1;
    }
  }, {
    key: "updateStateFromSerialization",
    value: function updateStateFromSerialization(e, t) {
      this.localSnapshotEnabled = t, this.transformStore.resetRotation(), this.transformStore.resetOutputRotation(), this.transformStore.resetFlip(), this.setDefaultAngle(0), this.editor.outputContainer.getRotation() !== 0 && this.engineMediator.output.applyNewImageTransform(), this.engineMediator.output.container.setData({
        flipHorizontally: !1,
        flipVertically: !1
      }), this.engineMediator.preview.updateTransform(), this.editor.scale.setInitialTransform(), this.setCropDefaults(), this.applyInitialCrop();
      var r = Math.round(e.rotation * 180 / Math.PI);
      this.transformStore.setRotation(r > 180 ? r - 360 : r), this.applyOutputRotationFromSerialization(e), e.identifier && this.transformStore.changeIdentifier(e.identifier);
      var o = e.outputRotation < 0 ? e.outputRotation + 360 : e.outputRotation;

      if (o = (360 - o) % 360, e.start && e.end) {
        (e.end.x === 0 || e.end.y === 0) && (e.end.x = 1, e.end.y = 1);

        var _this$convertOperatio = this.convertOperationOptionsToUI({
          start: new _(e.start),
          end: new _(e.end),
          rotation: e.rotation,
          outputRotation: o
        }),
            n = _this$convertOperatio.start,
            s = _this$convertOperatio.end;

        this.changePositionX(n.x), this.changePositionY(n.y);
        var l = s.x - n.x,
            c = s.y - n.y;
        this.transformStore.changeSize({
          width: l,
          height: c
        });
        var _this$defaults = this.defaults,
            p = _this$defaults.maxCropMaskSize,
            m = _this$defaults.imageSize,
            h = {
          height: c * m.height / p.height,
          width: l * m.width / p.width
        };
        this.changeLocalOutputSize(h);
      }

      this.editor.outputContainer.setData({
        flipHorizontally: e.flipHorizontally,
        flipVertically: e.flipVertically
      }), e.flipHorizontally && this.flipHorizontally(!1), e.flipVertically && this.flipVertically(!1), this.editor.overlayToolStore.correctOverlayFlip(), this.localSnapshotEnabled = !0;
    }
  }, {
    key: "applyOutputRotationFromSerialization",
    value: function applyOutputRotationFromSerialization(e) {
      if (e.outputRotation !== void 0) switch (e.outputRotation) {
        case 90:
          this.transformations.rotateOutputContainer();
          break;

        case 180:
          this.transformations.rotateOutputContainer(), this.transformations.rotateOutputContainer();
          break;

        case 270:
          this.transformations.rotateOutputContainer(!0);
          break;

        default:
          break;
      }
      this.transformations.rotateOutputContainer(!0), this.transformations.rotateOutputContainer();
    }
  }, {
    key: "setDefaultAngle",
    value: function setDefaultAngle(e) {
      this.defaultAngle = e;
    }
  }, {
    key: "updateCanvasControls",
    value: function updateCanvasControls(e) {
      var t = k(this.cropMaskPosition),
          r = k(this.cropMaskSize),
          o = k(this.defaults.maxCropMaskSize);
      this.changeCropAndOutputSize({
        height: o.height * r.height / e.height,
        width: o.width * r.width / e.width
      }), this.changePosition({
        y: o.height * t.y / e.height,
        x: o.width * t.x / e.width
      });
    }
  }, {
    key: "onLeave",
    value: function onLeave() {
      this.transformations.onLeave();
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      this.transformations.onEnter();
    }
  }, {
    key: "saveTransforms",
    value: function saveTransforms() {
      this.transformations.saveTransforms();
    }
  }, {
    key: "saveTransformsBasedOnFlip",
    value: function saveTransformsBasedOnFlip() {
      this.transformations.saveTransformsBasedOnFlip();
    }
  }, {
    key: "setRotation",
    value: function setRotation(e) {
      this.transformStore.setRotation(e), this.transformRender();
    }
  }, {
    key: "rotateOutputContainer",
    value: function rotateOutputContainer() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return C(this, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                this.setDragMode(!0);
                this.transformations.rotateOutputContainer(e);
                _context54.next = 4;
                return this.editor.wait();

              case 4:
                this.setDragMode(!1);

              case 5:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "applyInitialCrop",
    value: function applyInitialCrop() {
      var _this$getMatchingItem = this.getMatchingItem(),
          e = _this$getMatchingItem.identifier;

      this.changeIdentifier(e, !1);
    }
  }, {
    key: "clickableCanvas",
    value: function clickableCanvas(e) {
      this.editor.clickableCanvas(e);
    }
  }, {
    key: "proportionalSize",
    value: function proportionalSize(e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.defaults.maxCropMaskSize;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.minCropSize;
      var n = {
        width: t.height * e,
        height: t.height
      };
      return (n.width > r.width || n.width < o || n.height < o) && (n.width = t.width, n.height = t.width / e), n.width = Math.round(n.width), n.height = Math.round(n.height), n;
    }
  }, {
    key: "checkAndAddSnapshot",
    value: function checkAndAddSnapshot(e) {
      var t = k(this.localOutputSize);
      (e.width !== t.width || e.height !== t.height) && this.addLocalSnapshot();
    }
  }, {
    key: "updateInitialCropMaskPosition",
    value: function updateInitialCropMaskPosition(e) {
      var t = this.cropMaskSize,
          r = this.defaults.maxCropMaskSize;
      e ? this.changePosition({
        x: 0,
        y: Math.abs(r.height - t.height) / 2
      }) : this.changePosition({
        x: Math.abs(r.width - t.width) / 2,
        y: 0
      });
    }
  }, {
    key: "updatePreviewSizeWRTImageSize",
    value: function updatePreviewSizeWRTImageSize() {
      var e = k(this.localOutputSize),
          t = k(this.defaults.imageSize),
          r = k(this.defaults.maxCropMaskSize),
          o = {
        height: r.height * e.height / t.height,
        width: r.width * e.width / t.width
      };
      this.transformStore.changeSize(o);
    }
  }, {
    key: "getScaleWithFlip",
    value: function getScaleWithFlip() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rotateFlipState.rotation;
      return this.transformations.getScaleWithFlip(e);
    }
  }, {
    key: "getRatio",
    value: function getRatio() {
      var e = this.getTransform(this.identifier);

      if (e) {
        if (Object.prototype.hasOwnProperty.call(e, "ratio")) return this.lockResolution ? this.localOutputWidth / this.localOutputHeight : e.ratio;
        var _e$dimensions = e.dimensions,
            t = _e$dimensions.x,
            r = _e$dimensions.y;
        return t / r;
      }

      return "*";
    }
  }, {
    key: "serializableState",
    get: function get() {
      var _this$rotateFlipState = this.rotateFlipState,
          e = _this$rotateFlipState.flipHorizontally,
          t = _this$rotateFlipState.flipVertically,
          r = this.editor.engineMediator.output.container.getRotation() * 180 / Math.PI % 360,
          o = this.identifier,
          n = this.rotationInDegrees,
          s = n * Math.PI / 180,
          l = r + n;
      l = Math.round(l / 90) * 90, l = l < 0 ? l + 360 : l, l = (360 - l) % 360;

      var _this$convertUIToOper = this.convertUIToOperationOptions(s, l),
          c = _this$convertUIToOper.start,
          p = _this$convertUIToOper.end;

      return {
        flipHorizontally: e,
        flipVertically: t,
        rotation: s,
        start: c,
        end: p,
        identifier: o,
        outputRotation: l
      };
    }
  }, {
    key: "cropState",
    get: function get() {
      return this.transformStore.selectedCrop;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.transformStore.identifier;
    }
  }, {
    key: "ratio",
    get: function get() {
      return this.transformStore.ratio;
    }
  }, {
    key: "height",
    get: function get() {
      return this.transformStore.height;
    }
  }, {
    key: "width",
    get: function get() {
      return this.transformStore.width;
    }
  }, {
    key: "localOutputImageSize",
    get: function get() {
      return this.localOutputSize;
    }
  }, {
    key: "localOutputHeight",
    get: function get() {
      return this.localOutputSize.height;
    }
  }, {
    key: "localOutputWidth",
    get: function get() {
      return this.localOutputSize.width;
    }
  }, {
    key: "lockResolution",
    get: function get() {
      return this.transformStore.lockResolution;
    }
  }, {
    key: "forceDimensions",
    get: function get() {
      return this.transformStore.forceDimensions;
    }
  }, {
    key: "rotationInDegrees",
    get: function get() {
      return this.transformStore.rotationInDegrees;
    }
  }, {
    key: "outputRotation",
    get: function get() {
      return this.transformStore.outputRotation;
    }
  }, {
    key: "isDragMode",
    get: function get() {
      return this.dragMode.get();
    }
  }, {
    key: "rotateFlipState",
    get: function get() {
      var _this$transformStore$ = this.transformStore.state,
          e = _this$transformStore$.flipHorizontally,
          t = _this$transformStore$.flipVertically,
          r = _this$transformStore$.rotationInDegrees,
          o = _this$transformStore$.outputRotation;
      return {
        flipHorizontally: e,
        flipVertically: t,
        rotation: si.inRadians(r),
        outputRotation: o
      };
    }
  }, {
    key: "selectedCategoryIdentifier",
    get: function get() {
      return this.selectedCategory;
    }
  }, {
    key: "categories",
    get: function get() {
      return this.entityManager.categories;
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.TRANSFORM];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.TRANSFORM];
    }
  }, {
    key: "isOptionSelected",
    get: function get() {
      return this.identifier !== "identity";
    }
  }, {
    key: "leftTop",
    get: function get() {
      return this.rect.leftTop;
    }
  }, {
    key: "leftBottom",
    get: function get() {
      return this.rect.leftBottom;
    }
  }, {
    key: "rightTop",
    get: function get() {
      return this.rect.rightTop;
    }
  }, {
    key: "rightBottom",
    get: function get() {
      return this.rect.rightBottom;
    }
  }, {
    key: "isFlippedHorizontal",
    get: function get() {
      return this.transformStore.isFlippedHorizontal;
    }
  }, {
    key: "isFlippedVertical",
    get: function get() {
      return this.transformStore.isFlippedVertical;
    }
  }, {
    key: "leftTopRespectFlip",
    get: function get() {
      return this.rectForUi.leftTop;
    }
  }, {
    key: "leftBottomRespectFlip",
    get: function get() {
      return this.rectForUi.leftBottom;
    }
  }, {
    key: "rightTopRespectFlip",
    get: function get() {
      return this.rectForUi.rightTop;
    }
  }, {
    key: "rightBottomRespectFlip",
    get: function get() {
      return this.rectForUi.rightBottom;
    }
  }, {
    key: "cropMaskPosition",
    get: function get() {
      return this.transformStore.position;
    }
  }, {
    key: "cropMaskSize",
    get: function get() {
      return this.transformStore.size;
    }
  }, {
    key: "state",
    get: function get() {
      return this.transformStore.state;
    }
  }, {
    key: "defaultImageSize",
    get: function get() {
      return this.defaults.imageSize;
    }
  }, {
    key: "maxCropMaskSize",
    get: function get() {
      return this.defaults.maxCropMaskSize;
    }
  }, {
    key: "minCropMaskSize",
    get: function get() {
      var e = this.getRatio();
      return e === "*" || e === 1 ? {
        width: this.minCropSize,
        height: this.minCropSize
      } : e > 1 ? {
        width: this.minCropSize * e,
        height: this.minCropSize
      } : {
        width: this.minCropSize,
        height: this.minCropSize * e
      };
    }
  }, {
    key: "defaultCropMaskPosition",
    get: function get() {
      return this.defaults.cropMaskPosition;
    }
  }, {
    key: "defaultScale",
    get: function get() {
      return this.defaults.scale;
    }
  }, {
    key: "engineMediator",
    get: function get() {
      return this.editor.engineMediator;
    }
  }], [{
    key: "inRadians",
    value: function inRadians(e) {
      return e * Math.PI / 180;
    }
  }, {
    key: "placeCropMask",
    value: function placeCropMask(e, t) {
      if (t.height * e > t.width) return {
        height: t.width / e,
        width: t.width,
        yChanged: !0
      };
      var r = t.height * e;
      return {
        height: t.height,
        width: r,
        yChanged: !1
      };
    }
  }]);

  return si;
}(),
    D = si;

a([S], D.prototype, "selectedCategory", 2), a([S], D.prototype, "defaults", 2), a([S], D.prototype, "localOutputSize", 2), a([d], D.prototype, "changeIdentifier", 1), a([d], D.prototype, "setDragMode", 1), a([d], D.prototype, "setCropDefaults", 1), a([d], D.prototype, "setDefaultImageSize", 1), a([d], D.prototype, "setMaxCropSize", 1), a([d], D.prototype, "setDefaultCropPosition", 1), a([d], D.prototype, "resetCrop", 1), a([d], D.prototype, "toggleCategorySelection", 1), a([d], D.prototype, "pureReset", 1), a([d], D.prototype, "reset", 2), a([d], D.prototype, "changePosition", 1), a([d], D.prototype, "changePositionX", 1), a([d], D.prototype, "changePositionY", 1), a([d], D.prototype, "changeCropAndOutputHeight", 1), a([d], D.prototype, "changeCropAndOutputWidth", 1), a([d], D.prototype, "changeCropAndOutputSize", 1), a([d], D.prototype, "onLeave", 1), a([d], D.prototype, "onEnter", 1), a([d], D.prototype, "changeLocalOutputSize", 2), a([d], D.prototype, "changeDefaultScale", 2), a([d], D.prototype, "changeLocalOutputHeight", 2), a([d], D.prototype, "changeLocalOutputWidth", 2), a([d], D.prototype, "changeLockResolution", 2), a([d], D.prototype, "setRotation", 1), a([d], D.prototype, "rotateClockwise", 2), a([d], D.prototype, "rotateAntiClockwise", 2), a([d], D.prototype, "rotateOutputContainer", 1), a([d], D.prototype, "flipHorizontally", 2), a([d], D.prototype, "flipVertically", 2), a([d], D.prototype, "applyDefaultCrop", 2), a([d], D.prototype, "applyInitialCrop", 1), a([d], D.prototype, "updateCropMask", 2), a([d], D.prototype, "clickableCanvas", 1), a([d], D.prototype, "onLeftTop", 2), a([d], D.prototype, "onLeftBottom", 2), a([d], D.prototype, "onRightTop", 2), a([d], D.prototype, "onRightBottom", 2), a([d], D.prototype, "proportionalSize", 1), a([d], D.prototype, "onPixelWidth", 2), a([d], D.prototype, "onPixelHeight", 2), a([d], D.prototype, "updateInitialCropMaskPosition", 1), a([d], D.prototype, "updatePreviewSizeWRTImageSize", 1), a([u], D.prototype, "cropState", 1), a([u], D.prototype, "identifier", 1), a([u], D.prototype, "ratio", 1), a([u], D.prototype, "height", 1), a([u], D.prototype, "width", 1), a([u], D.prototype, "localOutputImageSize", 1), a([u], D.prototype, "localOutputHeight", 1), a([u], D.prototype, "localOutputWidth", 1), a([u], D.prototype, "lockResolution", 1), a([u], D.prototype, "forceDimensions", 1), a([u], D.prototype, "rotationInDegrees", 1), a([u], D.prototype, "outputRotation", 1), a([u], D.prototype, "isDragMode", 1), a([u], D.prototype, "rotateFlipState", 1), a([u], D.prototype, "selectedCategoryIdentifier", 1), a([u], D.prototype, "categories", 1), a([u], D.prototype, "items", 1), a([u], D.prototype, "config", 1), a([u], D.prototype, "locale", 1), a([u], D.prototype, "isOptionSelected", 1), a([u], D.prototype, "leftTop", 1), a([u], D.prototype, "leftBottom", 1), a([u], D.prototype, "rightTop", 1), a([u], D.prototype, "rightBottom", 1), a([u], D.prototype, "isFlippedHorizontal", 1), a([u], D.prototype, "isFlippedVertical", 1), a([u], D.prototype, "leftTopRespectFlip", 1), a([u], D.prototype, "leftBottomRespectFlip", 1), a([u], D.prototype, "rightTopRespectFlip", 1), a([u], D.prototype, "rightBottomRespectFlip", 1), a([u], D.prototype, "cropMaskPosition", 1), a([u], D.prototype, "cropMaskSize", 1), a([u], D.prototype, "state", 1), a([u], D.prototype, "defaultImageSize", 1), a([u], D.prototype, "maxCropMaskSize", 1), a([u], D.prototype, "minCropMaskSize", 1), a([u], D.prototype, "defaultCropMaskPosition", 1), a([u], D.prototype, "defaultScale", 1);

var ie =
/*#__PURE__*/
function () {
  function ie(e) {
    var _this91 = this;

    _classCallCheck(this, ie);

    this.checkImageResize = function () {
      _this91.engine.on(Yr.BEGAN_IMAGE_DOWNSCALING, function () {
        _this91.modalStore.showInfoModal("resizing");
      }), _this91.engine.on(Yr.IMAGE_DOWNSCALED, function (_ref44) {
        var e = _ref44.width,
            t = _ref44.height;
        var r = _this91.configStore.config.engine.downscaleOptions.maxMegaPixels,
            o = jn.isMobile() ? r.mobile : r.desktop;
        _this91.modalStore.hideModal(), _this91.modalStore.showActionModal({
          type: oe.WARNING,
          identifier: "imageResized",
          handleConfirm: function handleConfirm() {
            _this91.modalStore.hideModal();
          },
          error: {
            megapixels: "".concat(o),
            width: "".concat(e),
            height: "".concat(t)
          }
        });
      });
    };

    this.init = function (e) {
      _this91.historyStore.isDirty() ? _this91.modalStore.showActionModal({
        type: oe.WARNING,
        identifier: "discardChanges",
        handleConfirm: function handleConfirm() {
          _this91.setImage(e), _this91.resetToolStates();
        },
        handleDismiss: function handleDismiss() {
          _this91.setImage(e, !0);
        }
      }) : _this91.setImage(e, !0).then(function () {
        var _this91$configStore$c = _this91.configStore.config,
            r = _this91$configStore$c.engine,
            o = _this91$configStore$c.displayCanvasRendererWarning;
        r.preferredRenderer === "canvas" && o && _this91.modalStore.showActionModal({
          type: oe.WARNING,
          identifier: "unsupportedWebGLRenderer",
          handleConfirm: function handleConfirm() {
            _this91.modalStore.hideModal();
          }
        });
      }), _this91.historyStore.reset(), _this91.libraryStore.fetchImages();
    };

    this.setImage = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return C(_this91, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee55() {
        var _this$transformToolSt5, r, o;

        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _context55.prev = 0;
                this.modalStore.showInfoModal(this.configStore.config.displayResizeWarning ? "resizing" : "loading");
                this.scale.defaultScale = 1;
                this.scale.resetOffset();
                _context55.next = 6;
                return this.activeStore.setImage(e);

              case 6:
                _context55.next = 8;
                return this.engineMediator.image.addImageToContainer();

              case 8:
                this.engineMediator.output.applyNewImageTransform();
                this.engineMediator.preview.updateTransform();
                this.scale.setInitialTransform();
                this.transformToolStore.setCropDefaults();
                this.historyStore.addInitialSnapshot();
                _this$transformToolSt5 = this.transformToolStore.rotateFlipState, r = _this$transformToolSt5.flipHorizontally, o = _this$transformToolSt5.flipVertically;
                this.outputContainer.setData({
                  flipVertically: o,
                  flipHorizontally: r
                });
                t ? (this.focusToolStore.updateCanvasControls(), this.spriteStore.updateCanvasControls(), this.transformToolStore.resetCrop(), this.transformToolStore.applyDefaultCrop(), this.transformToolStore.saveTransformsBasedOnFlip(), this.transformToolStore.onEnter(), this.transformToolStore.setRotation(this.transformToolStore.rotationInDegrees), this.transformToolStore.onLeave(), this.transformToolStore.onEnter(), this.transformToolStore.onLeave()) : this.transformToolStore.saveTransforms();
                this.snappingStore.calculatePreviewTopLeftPosition();
                _context55.next = 19;
                return this.renderPromise();

              case 19:
                this.configStore.config.filter.enablePreviewThumbnails && this.configStore.config.engine.preferredRenderer === "webgl" && this.filterToolStore.setImageAndGetPreviews();
                this.activeStore.tool ? this.configStore.events.onImageLoaded() : this.onReady();
                this.modalStore.identifier !== "imageResized" && this.modalStore.hideModal();
                _context55.next = 27;
                break;

              case 24:
                _context55.prev = 24;
                _context55.t0 = _context55["catch"](0);
                this.configStore.events.onErrorImageLoading(_context55.t0), this.modalStore.hideModal(), this.modalStore.showActionModal({
                  type: oe.ERROR,
                  identifier: _context55.t0.identifier ? _context55.t0.identifier : "rendering",
                  error: _context55.t0,
                  handleConfirm: function handleConfirm() {
                    window.location.reload();
                  }
                });

              case 27:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this, [[0, 24]]);
      }));
    };

    this.onToolChange = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

      if (e !== t && _this91.engineMediator.preview.container) {
        if ([e, t].indexOf(g.TRANSFORM) !== -1) {
          var o = _this91.canvasStore.canvasSize,
              n = _this91.configStore.measurements.basicToolControlBar.controlsBarHeight;

          if (e === g.TRANSFORM) {
            _this91.transformToolStore.onLeave(), _this91.historyStore.removeTransformLocalSnapshots();

            var s = _this91.engineMediator.preview.container.getScale().x,
                l = _this91.engineMediator.output.container.getResolution(),
                c = _this91.transformToolStore.defaultImageSize;

            (s !== 1 || c.width !== l.width || c.height !== l.height) && _this91.addSnapshot(void 0, F.EDIT, _this91.configStore.locale.transform.title), _this91.snappingStore.calculatePreviewTopLeftPosition(), _this91.configStore.isLayoutAdvanced || (_this91.canvasStore.state.canvasSize.height = o.height + n, _this91.resize(!0));
          } else t === g.TRANSFORM && (_this91.configStore.isLayoutAdvanced || (_this91.canvasStore.state.canvasSize.height = o.height - n, _this91.resize(), _this91.render()), _this91.transformToolStore.onEnter(), _this91.transformToolStore.addLocalSnapshot(), _this91.historyStore.saveTransformLocalSnapshotIndex());
        } else _this91.scale.resetOffset(), _this91.scale.resetPosition(), _this91.scale.setScaleToDefault(), _this91.scale.scaleRender(!0);

        r && _this91.render();
      }
    };

    this.resize = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;

      try {
        _this91.transformToolStore.applyDefaultCrop(), _this91.canvasStore.updateCanvasDimensions();

        var _t23 = k(_this91.transformToolStore.maxCropMaskSize),
            r = _this91.activeStore.tool === g.TRANSFORM;

        (!r || e) && _this91.transformToolStore.onEnter();

        var o = _this91.engineMediator.preview.container.getRotation();

        if (_this91.engineMediator.preview.updateTransform(o)) {
          _this91.scale.setInitialTransform(), _this91.transformToolStore.setCropDefaults(), _this91.transformToolStore.updateCanvasControls(_t23), _this91.focusToolStore.updateCanvasControls(), _this91.spriteStore.updateCanvasControls();

          var s = _this91.transformToolStore.getScaleWithFlip(o);

          _this91.engineMediator.preview.container.setScale(s), (!r || e) && (_this91.transformToolStore.onLeave(), _this91.transformToolStore.onEnter(), _this91.transformToolStore.onLeave()), _this91.snappingStore.calculatePreviewTopLeftPosition(), _this91.render();
        }
      } catch (t) {
        _this91.modalStore.showActionModal({
          type: oe.ERROR,
          identifier: "rendering",
          handleConfirm: function handleConfirm() {
            window.location.reload();
          }
        });
      }
    };

    this.export = function () {
      var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = r.preventExportEvent,
          t = Pe(r, ["preventExportEvent"]);
      return new Promise(function (o, n) {
        _this91.modalStore.showInfoModal("exporting");

        var s = _this91.activeStore.tool === g.TRANSFORM;
        s && _this91.transformToolStore.onLeave();
        var l = _this91.configStore.config,
            c = f(f({}, l.export.image), t),
            p = c.exportType,
            m = c.format,
            h = c.quality,
            b = c.enableDownload;

        _this91.engineMediator.engine.export(p, m, h).then(function (v) {
          b && _this91.triggerFileDownload(l.export.filename, m, p, v), e || _this91.configStore.events.onExport(v), o(v), s && _this91.transformToolStore.onEnter(), _this91.modalStore.hideModal(), _this91.historyStore.isDirtySinceSave = !1;
        }).catch(function (v) {
          n(v), s && _this91.transformToolStore.onEnter(), _this91.modalStore.hideModal();
        });
      });
    };

    this.serialize = function () {
      var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        image: !0
      },
          e = _ref45.image;

      return _this91.serializationMediator.serialize({
        image: e
      });
    };

    this.deserialize = function (e) {
      return _this91.serializationMediator.deserialize(e);
    };

    this.close = function () {
      _this91.historyStore.isDirtySinceSave && _this91.configStore.config.displayCloseWarning ? _this91.modalStore.showActionModal({
        type: oe.WARNING,
        identifier: "unsavedChanges",
        handleConfirm: function handleConfirm() {
          _this91.configStore.events.onClose();
        }
      }) : _this91.configStore.events.onClose();
    };

    this.hasChanges = function () {
      return _this91.historyStore.isDirty();
    };

    this.wait = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new Promise(function (t) {
        return setTimeout(t, e);
      });
    };

    this.clickableCanvas = function (e) {
      return C(_this91, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee56() {
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                if (!e) {
                  _context56.next = 6;
                  break;
                }

                _context56.next = 3;
                return new Promise(function (t) {
                  return setTimeout(t, 0);
                });

              case 3:
                this.canvasStore.enableCanvasClick();
                _context56.next = 7;
                break;

              case 6:
                this.canvasStore.disableCanvasClick();

              case 7:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));
    };

    this.onReady = function () {
      return C(_this91, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee57() {
        var _this$configStore$con, e, t, r, o, n;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _this$configStore$con = this.configStore.config, e = _this$configStore$con.layout, t = _this$configStore$con.forceCrop;

                if (e === "advanced" && this.activeStore.selectTool(this.configStore.defaultTool), t) {
                  r = this.transformToolStore.localOutputImageSize, o = r.width / r.height, n = this.transformToolStore.entityManager.items.map(function (s) {
                    return s.ratio ? s.ratio : s.dimensions.x / s.dimensions.y;
                  });
                  n.indexOf("*") !== -1 ? console.error('ForceCrop will not work if "*" is one of the ratios') : n.indexOf(parseFloat(o.toFixed(2))) === -1 && this.activeStore.selectTool(g.TRANSFORM);
                }

                this.configStore.events.onEditorReady();

              case 3:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    };

    this.addSnapshot = function (e, t, r) {
      _this91.historyStore.addSnapshot(e, t, r);
    };

    this.addLocalTransformSnapshot = function (e, t) {
      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : F.EDIT;

      _this91.historyStore.addSnapshot({
        localTransform: e
      }, r, t);
    };

    this.resetToolStates = function () {
      _this91.filterToolStore.pureReset(), _this91.focusToolStore.pureReset(), _this91.adjustmentsToolStore.pureReset(), _this91.overlayToolStore.pureReset(), _this91.frameToolStore.pureReset(), _this91.brushToolStore.pureReset(), _this91.spriteStore.pureReset(), _this91.transformToolStore.pureReset(), _this91.historyStore.reset(), _this91.render();
    };

    this.getAssetPath = function (e) {
      return _this91.assetProvider.getPathForCategory(e);
    };

    this.render = function () {
      return C(_this91, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee58() {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return this.renderPromise();

              case 2:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    };

    this.applyFlipToPreview = function (e) {
      return _this91.engineMediator.previewSpaceToFlippedPreviewSpace(e);
    };

    this.getPreviewSize = function () {
      var _this91$engine$getOut = _this91.engine.getOutputDimensions(),
          e = _this91$engine$getOut.width,
          t = _this91$engine$getOut.height;

      return e && t ? {
        width: Math.round(_this91.worldToPreview(_this91.outputToWorld(e))),
        height: Math.round(_this91.worldToPreview(_this91.outputToWorld(t)))
      } : {
        height: t,
        width: e
      };
    };

    this.triggerFileDownload = function (e, t, r, o) {
      var n = t === Be.JPEG && r !== $e.MSBLOB ? ".jpeg" : ".png",
          s = e + n,
          l = _this91.blobFromExportData(o);

      _this91.triggerBlobDownload(s, l);
    };

    this.triggerBlobDownload = function (e, t) {
      if (navigator.msSaveBlob) navigator.msSaveBlob(t, e);else {
        var r = document.createElement("a"),
            o = URL.createObjectURL(t);
        r.href = o, r.download = e, document.body.appendChild(r), r.click(), document.body.removeChild(r), yl() || URL.revokeObjectURL(o);
      }
    };

    this.blobFromExportData = function (e) {
      return typeof e == "string" ? gs(e) : e instanceof HTMLImageElement ? gs(e.src) : e;
    };

    this.configStore = new ke();
    var t = this.configStore.saveConfig(e);

    if (this.engineMediator = new Cs(this), this.serializationMediator = new or(this), this.spriteStore = new w(this), this.scale = new le(this), this.filterToolStore = new te(this), this.adjustmentsToolStore = new H(this), this.focusToolStore = new P(this), this.overlayToolStore = new ce(this), this.frameToolStore = new J(this), this.brushToolStore = new Y(this), this.transformToolStore = new D(this), this.libraryStore = new Fe(this), this.modalStore = new Le(this), this.snappingStore = new at(this), this.activeStore = new qe(this), this.canvasStore = new Ie(this), this.historyStore = new oi(this), this.modalStore.showInfoModal("loading"), this.libraryStore.initProvider(t), this.configStore.config.displayResizeWarning && this.checkImageResize(), this.configStore.config.filter.enablePreviewThumbnails && this.configStore.config.engine.preferredRenderer === "webgl") {
      var r = this.configStore.config.engine;
      this.previewThumbnails = new sr(f(f({}, r), {
        license: this.configStore.config.license,
        assetProvider: this.configStore.assetProvider
      }));
    }
  }

  _createClass(ie, [{
    key: "renderPromise",
    value: function renderPromise() {
      return this.engineMediator.render(this.engineMediator.preview.container);
    }
  }, {
    key: "previewToWorld",
    value: function previewToWorld(e, t) {
      return Ve(e) ? this.engineMediator.previewSpaceToWorldSpace(e, t) : this.engineMediator.previewSpaceToWorldSpace(e, t);
    }
  }, {
    key: "worldToPreview",
    value: function worldToPreview(e) {
      return Ve(e) ? this.engineMediator.worldSpaceToPreviewSpace(e) : this.engineMediator.worldSpaceToPreviewSpace(e);
    }
  }, {
    key: "worldSizeToPreview",
    value: function worldSizeToPreview(e) {
      return {
        width: this.engineMediator.worldSpaceToPreviewSpace(e.width),
        height: this.engineMediator.worldSpaceToPreviewSpace(e.height)
      };
    }
  }, {
    key: "previewSizeToWorld",
    value: function previewSizeToWorld(e, t) {
      return {
        width: this.engineMediator.previewSpaceToWorldSpace(e.width, t),
        height: this.engineMediator.previewSpaceToWorldSpace(e.height, t)
      };
    }
  }, {
    key: "outputToWorld",
    value: function outputToWorld(e) {
      return Ve(e) ? this.engineMediator.outputSpaceToWorldSpace(e) : this.engineMediator.outputSpaceToWorldSpace(e);
    }
  }, {
    key: "previewToOutput",
    value: function previewToOutput(e) {
      return Ve(e) ? this.engineMediator.previewSpaceToOutputSpace(e) : this.engineMediator.previewSpaceToOutputSpace(e);
    }
  }, {
    key: "shortestOutputSide",
    get: function get() {
      var e = this.outputContainer.getBounds();
      return Math.min(e.width, e.height);
    }
  }, {
    key: "assetProvider",
    get: function get() {
      return this.configStore.assetProvider;
    }
  }, {
    key: "engine",
    get: function get() {
      return this.engineMediator.engine;
    }
  }, {
    key: "imageContainer",
    get: function get() {
      return this.engineMediator.image.container;
    }
  }, {
    key: "orderHelper",
    get: function get() {
      return this.engineMediator.orderHelper;
    }
  }, {
    key: "outputContainer",
    get: function get() {
      return this.engineMediator.output.container;
    }
  }], [{
    key: "defaultColors",
    get: function get() {
      return Object.keys(xe).map(function (e) {
        var t = xe[e];
        return {
          identifier: e,
          color: t,
          colorString: ir(t)
        };
      });
    }
  }, {
    key: "defaultBackgroundColors",
    get: function get() {
      return Object.keys(ts).map(function (e) {
        var t = ts[e];
        return {
          identifier: e,
          color: t,
          colorString: ir(t)
        };
      });
    }
  }, {
    key: "devicePixelRatio",
    get: function get() {
      return window.devicePixelRatio || 1;
    }
  }]);

  return ie;
}();

a([d], ie.prototype, "resize", 2), a([d], ie.prototype, "export", 2), a([d], ie.prototype, "clickableCanvas", 2);

function ws(i, e) {
  var t = i.width / i.height,
      r = e.width / e.height;
  return t > r ? i.height / e.height : i.width / e.width;
}

var hm = {
  transform: X.IDENTITY
},
    wt =
/*#__PURE__*/
function () {
  function wt(e) {
    _classCallCheck(this, wt);

    this.initialTransform = X.IDENTITY;
    this.editor = e, this.state = S(hm);
  }

  _createClass(wt, [{
    key: "createPreview",
    value: function createPreview(e) {
      this.container = this.editor.engine.createPreview(e);
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var r = this.calculateTransform(e);
      return r.scale.x ? (t ? this.saveInitialTransform(r) : this.savePreviewTransform(r), this.container.setTransform(this.state.transform), !0) : !1;
    }
  }, {
    key: "saveInitialTransform",
    value: function saveInitialTransform(e) {
      this.initialTransform = e, this.savePreviewTransform(e);
    }
  }, {
    key: "savePreviewTransform",
    value: function savePreviewTransform(e) {
      var _this92 = this;

      re(function () {
        _this92.state.transform.position = e.position, _this92.state.transform.scale = e.scale, _this92.state.transform.rotation = e.rotation;
        var t = ie.devicePixelRatio;
        _this92.previewTransformWithoutDpr = {
          position: new _(e.position).divide(t),
          scale: new _(e.scale).divide(t),
          rotation: e.rotation
        };
      });
    }
  }, {
    key: "calculateTransform",
    value: function calculateTransform() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var t = ie.devicePixelRatio,
          _this$editor$canvasSt2 = this.editor.canvasStore.canvasSize,
          r = _this$editor$canvasSt2.width,
          o = _this$editor$canvasSt2.height,
          n = this.editor.engine.getOutputDimensions(),
          s = ws({
        width: r,
        height: o
      }, n),
          l = .95;
      window.innerWidth < 600 && (l = .98), s *= l;
      var c = o - n.height * s,
          p = this.editor.configStore.measurements.mainCanvasActionBar.height * 2;
      c < p && (s = ws({
        width: r,
        height: o - p
      }, n), s *= l), s *= t;
      var m = {
        x: r * t / 2,
        y: o * t / 2
      },
          h = {
        x: s,
        y: s
      };
      return new X(m, h, e);
    }
  }, {
    key: "transform",
    get: function get() {
      return this.state.transform;
    }
  }, {
    key: "position",
    get: function get() {
      return this.state.transform.position;
    }
  }, {
    key: "scale",
    get: function get() {
      return this.state.transform.scale;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.state.transform.rotation;
    }
  }]);

  return wt;
}();

a([d], wt.prototype, "updateTransform", 1), a([d], wt.prototype, "savePreviewTransform", 1), a([u], wt.prototype, "transform", 1), a([u], wt.prototype, "position", 1), a([u], wt.prototype, "scale", 1), a([u], wt.prototype, "rotation", 1);

var Vt =
/*#__PURE__*/
function () {
  function Vt() {
    _classCallCheck(this, Vt);

    this.imageContainerOrder = [];
    this.spriteContainerOrder = [];
  }

  _createClass(Vt, [{
    key: "addIndex",
    value: function addIndex(e) {
      Vt.checkTool(e);

      var _Vt$indexForOrder = Vt.indexForOrder(Vt.IMAGE_CONTAINER_INDEX, this.imageContainerOrder, e),
          t = _Vt$indexForOrder.index,
          r = _Vt$indexForOrder.order;

      return this.imageContainerOrder = r, t;
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(e) {
      Vt.checkTool(e), Vt.remove(e, this.imageContainerOrder);
    }
  }, {
    key: "addSprite",
    value: function addSprite(e) {
      return this.spriteContainerOrder.push(e), this.imageContainerOrder.length + this.spriteContainerOrder.length - 1;
    }
  }, {
    key: "removeSprite",
    value: function removeSprite(e) {
      Vt.remove(e, this.spriteContainerOrder);
    }
  }, {
    key: "renameSprite",
    value: function renameSprite(e, t) {
      var r = this.spriteContainerOrder.findIndex(function (o) {
        return o === e;
      });
      r !== -1 && (this.spriteContainerOrder[r] = t);
    }
  }, {
    key: "bringToFront",
    value: function bringToFront(e) {
      var t = this.spriteContainerOrder.findIndex(function (r) {
        return r === e;
      });
      return t !== -1 && (this.spriteContainerOrder.splice(t, 1), this.spriteContainerOrder.push(e)), this.getLastSpriteIndex();
    }
  }, {
    key: "getLastSpriteId",
    value: function getLastSpriteId() {
      var e = this.spriteContainerOrder.length;
      return this.spriteContainerOrder[e - 1];
    }
  }, {
    key: "getSpriteIndex",
    value: function getSpriteIndex(e) {
      return this.spriteContainerOrder.findIndex(function (r) {
        return r === e;
      }) + this.imageContainerOrder.length - 1;
    }
  }, {
    key: "getLastSpriteIndex",
    value: function getLastSpriteIndex() {
      return this.imageContainerOrder.length + this.spriteContainerOrder.length - 1;
    }
  }], [{
    key: "checkTool",
    value: function checkTool(e) {
      if ([g.STICKER, g.TEXT, g.TEXT_DESIGN, g.BRUSH, g.FRAME].indexOf(e) !== -1) throw new Error("addIndex is used for non sprites, for sprites use addSprite");
    }
  }, {
    key: "remove",
    value: function remove(e, t) {
      var r = t.findIndex(function (o) {
        return o === e;
      });
      r !== -1 && t.splice(r, 1);
    }
  }, {
    key: "indexForOrder",
    value: function indexForOrder(e, t, r) {
      var o = e[r],
          n = t.findIndex(function (l) {
        return l === r;
      });
      if (n !== -1) return {
        index: n,
        order: t
      };
      var _t24 = t,
          s = _t24.length;

      if (s) {
        var l;

        for (l = 0; l < s; l += 1) {
          var c = t[l],
              p = e[c];
          if (o < p) return t = [].concat(_toConsumableArray(t.slice(0, l)), [r], _toConsumableArray(t.slice(l))), {
            index: l,
            order: t
          };
        }
      }

      return t.push(r), {
        index: t.length - 1,
        order: t
      };
    }
  }]);

  return Vt;
}(),
    so = Vt;

so.IMAGE_CONTAINER_INDEX = (_so$IMAGE_CONTAINER_I = {}, _defineProperty(_so$IMAGE_CONTAINER_I, g.ART_FILTER, 0), _defineProperty(_so$IMAGE_CONTAINER_I, g.FILTER, 1), _defineProperty(_so$IMAGE_CONTAINER_I, g.ADJUSTMENT, 2), _defineProperty(_so$IMAGE_CONTAINER_I, g.FOCUS, 3), _defineProperty(_so$IMAGE_CONTAINER_I, g.OVERLAY, 4), _so$IMAGE_CONTAINER_I);

var Cs =
/*#__PURE__*/
function () {
  function Cs(e) {
    _classCallCheck(this, Cs);

    this.orderHelper = new so();
    var t = e.configStore.config.engine;
    this.engine = new tr(f(f({}, t), {
      license: e.configStore.config.license,
      assetProvider: e.configStore.assetProvider
    })), this.image = new ds(e), this.output = new ps(e), this.preview = new wt(e), this.editor = e;
  }

  _createClass(Cs, [{
    key: "render",
    value: function render(e) {
      return this.engine.render(e);
    }
  }, {
    key: "previewSpaceToWorldSpace",
    value: function previewSpaceToWorldSpace(e, t) {
      var r = this.preview.previewTransformWithoutDpr;

      if (Ve(e)) {
        var o = this.editor.engine.convertPointFromPreviewIntoWorldSpace(_.ZERO, r, t),
            n = this.editor.engine.convertPointFromPreviewIntoWorldSpace({
          x: e,
          y: 0
        }, r, t);
        return _.distance(new _(o), new _(n));
      }

      return this.editor.engine.convertPointFromPreviewIntoWorldSpace(e, r, t);
    }
  }, {
    key: "worldSpaceToPreviewSpace",
    value: function worldSpaceToPreviewSpace(e) {
      var t = this.preview.previewTransformWithoutDpr;

      if (Ve(e)) {
        var r = this.editor.engine.convertPointFromWorldIntoPreviewSpace(_.ZERO, t),
            o = this.editor.engine.convertPointFromWorldIntoPreviewSpace({
          x: e,
          y: 0
        }, t);
        return _.distance(new _(r), new _(o));
      }

      return this.editor.engine.convertPointFromWorldIntoPreviewSpace(e, t);
    }
  }, {
    key: "outputSpaceToWorldSpace",
    value: function outputSpaceToWorldSpace(e) {
      return Ve(e) ? A.getScalarInWorldSpace(e, this.editor.engine.getOutputContainer()) : A.getPointInWorldSpace(e, this.editor.engine.getOutputContainer());
    }
  }, {
    key: "previewSpaceToOutputSpace",
    value: function previewSpaceToOutputSpace(e) {
      var t = this.preview.previewTransformWithoutDpr;

      if (Ve(e)) {
        var r = this.editor.engine.convertPointFromPreviewIntoOutputSpace(_.ZERO, t),
            o = this.editor.engine.convertPointFromPreviewIntoOutputSpace({
          x: e,
          y: 0
        }, t);
        return _.distance(new _(r), new _(o));
      }

      return this.editor.engine.convertPointFromPreviewIntoOutputSpace(e, t);
    }
  }, {
    key: "previewSpaceToFlippedPreviewSpace",
    value: function previewSpaceToFlippedPreviewSpace(e) {
      return this.editor.engine.convertPointFromPreviewIntoFlippedPreviewSpace(e);
    }
  }]);

  return Cs;
}();

var tc = [[0, 0], [0, 1], [1, 0], [1, 1]],
    fm = [[0, 1, 2, 3], [2, 3, 0, 1], [1, 0, 3, 2], [3, 2, 1, 0]],
    lt =
/*#__PURE__*/
function () {
  function lt(e, t) {
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "center";
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

    _classCallCheck(this, lt);

    this.considerRotation = !0;
    this.considerFlip = !0;
    this.store = t, this.m = r === "center" ? lt.movePivotTo([.5, .5]) : tc, this.considerRotation = o, this.considerFlip = n, this.configStore = e.configStore;
  }

  _createClass(lt, [{
    key: "handleOrigin",
    value: function handleOrigin(e, t, r) {
      var o = lt.getFlippedEdgeIndex(e, t, r),
          n = this.m[o][0] * this.size.width,
          s = this.m[o][1] * this.size.height;
      return {
        width: n,
        height: s
      };
    }
  }, {
    key: "position",
    get: function get() {
      return this.store.position;
    }
  }, {
    key: "size",
    get: function get() {
      return this.store.size;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.considerRotation ? this.store.rotationWRTOutputRotation : 0;
    }
  }, {
    key: "flipHorizontally",
    get: function get() {
      return this.considerFlip ? this.store.isFlippedHorizontal : !1;
    }
  }, {
    key: "flipVertically",
    get: function get() {
      return this.considerFlip ? this.store.isFlippedVertical : !1;
    }
  }, {
    key: "flipCenter",
    get: function get() {
      return this.considerFlip ? this.store.flipCenter : null;
    }
  }, {
    key: "leftTop",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(0, t, r);
      return lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "leftBottom",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(1, t, r);
      return lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "rightTop",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(2, t, r);
      return lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "rightBottom",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(3, t, r);
      return lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "leftBottomHandle",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(1, t, r);
      return o.height += this.configStore.measurements.canvasControls.sprite.rotateHandle.height, lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "rightBottomHandle",
    get: function get() {
      var e = this.position,
          t = this.flipHorizontally,
          r = this.flipVertically,
          o = this.handleOrigin(3, t, r);
      return o.height += this.configStore.measurements.canvasControls.sprite.rotateHandle.height, lt.coordinatesWithRotation(o, this.rotation, this.flipHorizontally, this.flipVertically, this.flipCenter, e);
    }
  }, {
    key: "leftMid",
    get: function get() {
      var e = new _(this.leftTop),
          t = new _(this.leftBottom);
      return e.add(t).divide(2);
    }
  }, {
    key: "rightMid",
    get: function get() {
      var e = new _(this.rightTop),
          t = new _(this.rightBottom);
      return e.add(t).divide(2);
    }
  }], [{
    key: "getFlippedEdgeIndex",
    value: function getFlippedEdgeIndex(e, t, r) {
      return fm[(t ? 1 : 0) + (r ? 2 : 0)][e];
    }
  }, {
    key: "movePivotTo",
    value: function movePivotTo(e) {
      return tc.map(function (t) {
        return [t[0] - e[0], t[1] - e[1]];
      });
    }
  }]);

  return lt;
}(),
    ne = lt;

ne.coordinatesWithRotation = function (_ref46, r, o, n, s, l) {
  var e = _ref46.width,
      t = _ref46.height;
  var c = e * Math.cos(r) - t * Math.sin(r) + l.x,
      p = e * Math.sin(r) + t * Math.cos(r) + l.y;
  return o && (c = s.x * 2 - c), n && (p = s.y * 2 - p), new _({
    x: c,
    y: p
  }).rounded;
}, a([u], ne.prototype, "position", 1), a([u], ne.prototype, "size", 1), a([u], ne.prototype, "rotation", 1), a([u], ne.prototype, "flipHorizontally", 1), a([u], ne.prototype, "flipVertically", 1), a([u], ne.prototype, "flipCenter", 1), a([u], ne.prototype, "leftTop", 1), a([u], ne.prototype, "leftBottom", 1), a([u], ne.prototype, "rightTop", 1), a([u], ne.prototype, "rightBottom", 1), a([u], ne.prototype, "leftBottomHandle", 1), a([u], ne.prototype, "rightBottomHandle", 1), a([u], ne.prototype, "leftMid", 1), a([u], ne.prototype, "rightMid", 1);

var Ii = function Ii(i) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var r = Math.tan(e),
      o = Math.sqrt(Math.pow(r, 2) + 1);
  return {
    x: i.x + t / o,
    y: i.y + t * r / o
  };
};

var ao = {
  blurRadius: 40,
  gradientSize: .2
},
    gm = f({
  start: {
    x: 0,
    y: 0
  },
  end: {
    x: 0,
    y: 0
  }
}, ao),
    bm = f({
  center: {
    x: 0,
    y: 0
  },
  radius: 0
}, ao),
    ym = f({
  origin: {
    x: 0,
    y: 0
  },
  rotation: 0,
  size: 0
}, ao),
    vm = ao,
    ai = {
  identifier: "identity",
  linear: gm,
  radial: bm,
  mirrored: ym,
  gaussian: vm
};

var Se =
/*#__PURE__*/
function () {
  function Se(e) {
    var _this93 = this;

    _classCallCheck(this, Se);

    this.selectFocus = function (e, t) {
      re(function () {
        _this93.state.identifier = e, t && (_this93.state[e].blurRadius = t);
      });
    };

    this.changeBlurRadius = function (e, t) {
      e !== "identity" && (_this93.state[e].blurRadius = t);
    };

    this.reset = function () {
      _this93.indexInContainer === -1 && (_this93.state.identifier = ai.identifier, _this93.state.identifier !== "identity" && (_this93.state[_this93.state.identifier].blurRadius = ai[_this93.state.identifier].blurRadius));
    };

    this.setLinear = function (_ref47) {
      var e = _ref47.start,
          t = _ref47.end;
      _this93.state.linear.start.x = e.x, _this93.state.linear.start.y = e.y, _this93.state.linear.end.x = t.x, _this93.state.linear.end.y = t.y;
    };

    this.setLinearStart = function (e) {
      _this93.state.linear.start.x = e.x, _this93.state.linear.start.y = e.y;
    };

    this.setLinearEnd = function (e) {
      _this93.state.linear.end.x = e.x, _this93.state.linear.end.y = e.y;
    };

    this.setRadialCenter = function (e) {
      _this93.state.radial.center.x = e.x, _this93.state.radial.center.y = e.y;
    };

    this.setRadialRadius = function (e) {
      _this93.state.radial.radius = e;
    };

    this.setMirroredOrigin = function (e) {
      _this93.state.mirrored.origin.x = e.x, _this93.state.mirrored.origin.y = e.y;
    };

    this.setMirroredRotation = function (e) {
      _this93.state.mirrored.rotation = e;
    };

    this.setMirroredSize = function (e) {
      _this93.state.mirrored.size = e;
    };

    this.getEffectProperties = function () {
      return _this93.effect ? _this93.effect.getProperties() : null;
    };

    this.setLinearFocus = function (e) {
      _this93.effect = _this93.engineMediator.engine.addLinearBlur(e, _this93.imageContainer, _this93.order), _this93.updateLinearState(_this93.effect.getProperties());
    };

    this.setGaussianFocus = function (e) {
      _this93.effect = _this93.engineMediator.engine.addGaussianBlur(e, _this93.imageContainer, _this93.order), _this93.updateGaussianState(_this93.effect.getProperties());
    };

    this.setRadialFocus = function (e) {
      _this93.effect = _this93.engineMediator.engine.addRadialBlur(e, _this93.imageContainer, _this93.order), _this93.updateRadialState(_this93.effect.getProperties());
    };

    this.setMirroredFocus = function (e) {
      _this93.effect = _this93.engineMediator.engine.addMirroredBlur(e, _this93.imageContainer, _this93.order), _this93.updateMirroredState(_this93.effect.getProperties());
    };

    this.updateFromEngineState = function (e) {
      var t = _this93.getEffectProperties();

      if (t && e !== "identity") switch (e) {
        case W.LINEAR:
          _this93.updateLinearState(t);

          break;

        case W.RADIAL:
          _this93.updateRadialState(t);

          break;

        case W.MIRRORED:
          _this93.updateMirroredState(t);

          break;

        default:
          break;
      }
    };

    this.updateGaussianState = function (e) {
      _this93.changeBlurRadius(W.GAUSSIAN, e.blurRadius);
    };

    this.updateMirroredState = function (e) {
      var t = _this93.editor.worldToPreview(e.mirrorAxisOrigin),
          o = new _(_this93.editor.worldToPreview(e.mirrorAxisDirection)).subtract(t),
          n = Math.atan2(o.y, o.x);

      _this93.setMirroredOrigin(_this93.editor.worldToPreview(e.mirrorAxisOrigin)), _this93.setMirroredRotation(n), _this93.setMirroredSize(_this93.editor.worldToPreview(e.clearAreaWidth)), _this93.changeBlurRadius(W.MIRRORED, e.blurRadius);
    };

    this.updateRadialState = function (e) {
      _this93.setRadialCenter(_this93.editor.worldToPreview(e.center)), _this93.setRadialRadius(_this93.editor.worldToPreview(e.radius)), _this93.changeBlurRadius(W.RADIAL, e.blurRadius);
    };

    this.updateLinearState = function (e) {
      _this93.setLinearStart(_this93.editor.worldToPreview(e.start)), _this93.setLinearEnd(_this93.editor.worldToPreview(e.end)), _this93.changeBlurRadius(W.LINEAR, e.blurRadius);
    };

    this.setEffectProperties = function (e) {
      return _this93.effect ? (_this93.effect.setProperties(e), _this93.effect.getProperties()) : null;
    };

    this.removeFocus = function () {
      _this93.effect && (_this93.engineMediator.engine.removeEffect(_this93.effect), _this93.engineMediator.orderHelper.removeIndex(g.FOCUS));
    };

    this.editor = e, this.engineMediator = this.editor.engineMediator, this.state = ai;
  }

  _createClass(Se, [{
    key: "indexInContainer",
    get: function get() {
      return this.effect ? this.effect.getIndexInParent() : -1;
    }
  }, {
    key: "order",
    get: function get() {
      return this.engineMediator.orderHelper.addIndex(g.FOCUS);
    }
  }, {
    key: "imageContainer",
    get: function get() {
      return this.engineMediator.image.container;
    }
  }]);

  return Se;
}();

a([S], Se.prototype, "state", 2), a([d], Se.prototype, "selectFocus", 2), a([d], Se.prototype, "changeBlurRadius", 2), a([d], Se.prototype, "reset", 2), a([d], Se.prototype, "setLinear", 2), a([d], Se.prototype, "setLinearStart", 2), a([d], Se.prototype, "setLinearEnd", 2), a([d], Se.prototype, "setRadialCenter", 2), a([d], Se.prototype, "setRadialRadius", 2), a([d], Se.prototype, "setMirroredOrigin", 2), a([d], Se.prototype, "setMirroredRotation", 2), a([d], Se.prototype, "setMirroredSize", 2), a([d], Se.prototype, "updateFromEngineState", 2);

var li =
/*#__PURE__*/
function () {
  function li(e) {
    var _this94 = this;

    _classCallCheck(this, li);

    this.selectFocus = function (e) {
      if (e !== _this94.identifier) {
        _this94.focusStore.removeFocus();

        var _t25 = _this94.maxIntensity * .2,
            _this94$editor$engine = _this94.editor.engine.getOutputContainer().getBounds(),
            r = _this94$editor$engine.width,
            o = _this94.editor.shortestOutputSide * .2;

        switch (e) {
          case W.LINEAR:
            var n = _this94.editor.outputToWorld({
              x: -r / 2,
              y: 0
            }),
                s = _this94.editor.outputToWorld({
              x: r / 2,
              y: 0
            });

            _this94.setLinearFocus({
              start: n,
              end: s,
              blurRadius: _t25
            });

            break;

          case W.RADIAL:
            var l = _this94.editor.outputToWorld({
              x: 0,
              y: 0
            });

            _this94.setRadialFocus({
              center: l,
              radius: o,
              blurRadius: _t25
            });

            break;

          case W.MIRRORED:
            var c = _this94.editor.outputToWorld({
              x: 0,
              y: 0
            }),
                p = o,
                m = _this94.editor.outputToWorld(Ii({
              x: 0,
              y: 0
            }, 0));

            _this94.setMirroredFocus({
              mirrorAxisOrigin: c,
              clearAreaWidth: p,
              blurRadius: _t25,
              mirrorAxisDirection: m
            });

            break;

          case W.GAUSSIAN:
            _this94.setGaussianFocus({
              blurRadius: _t25
            });

            break;

          default:
            break;
        }

        _this94.focusStore.selectFocus(e, _t25), _this94.editor.render(), _this94.addSnapshot(F.ADD, g.FOCUS);
      }
    };

    this.changeIntensity = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        blurRadius: e
      });

      t && (_this94.focusStore.changeBlurRadius(_this94.identifier, t.blurRadius), _this94.editor.render());
    };

    this.changeRelativeIntensity = function (e) {
      var t = (_this94.maxIntensity - li.minIntensity) * e / 100 + li.minIntensity,
          r = _this94.focusStore.setEffectProperties({
        blurRadius: t
      });

      r && (_this94.focusStore.changeBlurRadius(_this94.identifier, r.blurRadius), _this94.editor.render());
    };

    this.toolSnapshot = function (e) {
      _this94.addSnapshot(F.EDIT, e);
    };

    this.addSnapshot = function (e, t) {
      _this94.editor.addSnapshot(void 0, e, t);
    };

    this.clickableCanvas = function (e) {
      _this94.editor.clickableCanvas(e);
    };

    this.pureReset = function () {
      _this94.focusStore.removeFocus(), _this94.focusStore.reset();
    };

    this.reset = function () {
      _this94.pureReset(), _this94.editor.render(), _this94.addSnapshot(F.DELETE, _this94.locale.controls.buttonReset);
    };

    this.setStart = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        start: _this94.editor.previewToWorld(e)
      });

      t && (_this94.focusStore.setLinearStart(_this94.editor.worldToPreview(t.start)), _this94.editor.render());
    };

    this.setEnd = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        end: _this94.editor.previewToWorld(e)
      });

      t && (_this94.focusStore.setLinearEnd(_this94.editor.worldToPreview(t.end)), _this94.editor.render());
    };

    this.setCenter = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        center: _this94.editor.previewToWorld(e)
      });

      t && (_this94.focusStore.setRadialCenter(_this94.editor.worldToPreview(t.center)), _this94.editor.render());
    };

    this.setRadius = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        radius: _this94.editor.previewToWorld(e)
      });

      t && (_this94.focusStore.setRadialRadius(_this94.editor.worldToPreview(t.radius)), _this94.editor.render());
    };

    this.setOrigin = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        mirrorAxisOrigin: _this94.editor.previewToWorld(e),
        mirrorAxisDirection: _this94.editor.previewToWorld(Ii(e, _this94.rotation))
      });

      t && (_this94.focusStore.setMirroredOrigin(_this94.editor.worldToPreview(t.mirrorAxisOrigin)), _this94.editor.render());
    };

    this.setSize = function (e) {
      var t = _this94.focusStore.setEffectProperties({
        clearAreaWidth: _this94.editor.previewToWorld(e)
      });

      t && (_this94.focusStore.setMirroredSize(_this94.editor.worldToPreview(t.clearAreaWidth)), _this94.editor.render());
    };

    this.setRotation = function (e) {
      _this94.focusStore.setEffectProperties({
        mirrorAxisDirection: _this94.editor.previewToWorld(Ii(_this94.origin, e))
      }), _this94.focusStore.setMirroredRotation(e), _this94.editor.render();
    };

    this.updateStateFromHistory = function (e, t) {
      _this94.focusStore.removeFocus();

      var r = t.magnitude;
      re(function () {
        switch (e.identifier) {
          case W.LINEAR:
            _this94.focusStore.selectFocus(W.LINEAR), _this94.setLinearFocus({
              start: _this94.editor.previewToWorld(new _(e.linear.start).multiply(t)),
              end: _this94.editor.previewToWorld(new _(e.linear.end).multiply(t)),
              blurRadius: e.linear.blurRadius
            });
            break;

          case W.GAUSSIAN:
            _this94.focusStore.selectFocus(W.GAUSSIAN), _this94.setGaussianFocus({
              blurRadius: e.gaussian.blurRadius
            });
            break;

          case W.RADIAL:
            _this94.focusStore.selectFocus(W.RADIAL), _this94.setRadialFocus({
              center: _this94.editor.previewToWorld(new _(e.radial.center).multiply(t)),
              radius: _this94.editor.previewToWorld(e.radial.radius * r),
              blurRadius: e.radial.blurRadius
            });
            break;

          case W.MIRRORED:
            _this94.focusStore.selectFocus(W.MIRRORED), _this94.setMirroredFocus({
              mirrorAxisOrigin: _this94.editor.previewToWorld(new _(e.mirrored.origin).multiply(t)),
              clearAreaWidth: _this94.editor.previewToWorld(e.mirrored.size * r),
              blurRadius: e.mirrored.blurRadius,
              mirrorAxisDirection: _this94.editor.previewToWorld(Ii(e.mirrored.origin, e.mirrored.rotation))
            });
            break;

          case "identity":
            _this94.pureReset();

            break;

          default:
            break;
        }
      });
    };

    this.updateStateFromSerialization = function (e) {
      return C(_this94, null,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee59() {
        var _this95 = this;

        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                if (!li.doesFocusIdentifierExist(e.identifier)) {
                  _context59.next = 4;
                  break;
                }

                this.focusStore.removeFocus(), re(function () {
                  switch (_this95.focusStore.selectFocus(e.identifier), e.identifier) {
                    case W.LINEAR:
                      _this95.setLinearFocus(e.linear);

                      break;

                    case W.GAUSSIAN:
                      _this95.setGaussianFocus(e.gaussian);

                      break;

                    case W.RADIAL:
                      _this95.setRadialFocus(e.radial);

                      break;

                    case W.MIRRORED:
                      _this95.setMirroredFocus({
                        mirrorAxisOrigin: e.mirrored.origin,
                        clearAreaWidth: e.mirrored.size,
                        blurRadius: e.mirrored.blurRadius,
                        mirrorAxisDirection: Ii(e.mirrored.origin, e.mirrored.rotation)
                      });

                      break;

                    default:
                      break;
                  }
                });
                _context59.next = 5;
                break;

              case 4:
                throw new Error("Focus identifier ".concat(e.identifier, " doesn't exist"));

              case 5:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    };

    this.updateCanvasControls = function () {
      _this94.focusStore.updateFromEngineState(_this94.identifier);
    };

    this.getFocusStateForHistory = function () {
      var e = _this94.editor.canvasStore.sizeVector,
          t = _this94.focusStore.state.linear,
          r = _this94.focusStore.state.radial,
          o = _this94.focusStore.state.mirrored,
          n = e,
          s = n.magnitude;
      return f(f({}, _this94.focusStore.state), {
        linear: f(f({}, t), {
          start: new _(t.start).divide(n),
          end: new _(t.end).divide(n)
        }),
        radial: f(f({}, r), {
          center: new _(r.center).divide(n),
          radius: r.radius / s
        }),
        mirrored: f(f({}, o), {
          origin: new _(o.origin).divide(n),
          size: o.size / s
        }),
        gaussian: f({}, _this94.focusStore.state.gaussian)
      });
    };

    this.editor = e, this.focusStore = new Se(this.editor);
    var t = this.editor.assetProvider.getAssets("focus");
    this.entityManager = new ee(t, f(f({}, this.config), {
      categoryKey: "",
      itemKey: "thumbnailURI",
      flattenCategories: !0,
      locale: this.locale.items,
      getAssetPath: this.editor.getAssetPath("focus")
    }));
  }

  _createClass(li, [{
    key: "setGaussianFocus",
    value: function setGaussianFocus(_ref48) {
      var e = _ref48.blurRadius;
      this.focusStore.setGaussianFocus({
        blurRadius: e
      });
    }
  }, {
    key: "setLinearFocus",
    value: function setLinearFocus(_ref49) {
      var e = _ref49.start,
          t = _ref49.end,
          r = _ref49.blurRadius;
      this.focusStore.setLinearFocus({
        start: e,
        end: t,
        blurRadius: r
      });
    }
  }, {
    key: "setRadialFocus",
    value: function setRadialFocus(_ref50) {
      var e = _ref50.center,
          t = _ref50.radius,
          r = _ref50.blurRadius;
      this.focusStore.setRadialFocus({
        center: e,
        radius: t,
        blurRadius: r
      });
    }
  }, {
    key: "setMirroredFocus",
    value: function setMirroredFocus(_ref51) {
      var e = _ref51.mirrorAxisOrigin,
          t = _ref51.clearAreaWidth,
          r = _ref51.blurRadius,
          o = _ref51.mirrorAxisDirection;
      this.focusStore.setMirroredFocus({
        mirrorAxisOrigin: e,
        clearAreaWidth: t,
        blurRadius: r,
        mirrorAxisDirection: o
      });
    }
  }, {
    key: "state",
    get: function get() {
      return this.focusStore.state;
    }
  }, {
    key: "serializableState",
    get: function get() {
      switch (this.identifier) {
        case W.LINEAR:
          return {
            identifier: this.identifier,
            linear: this.focusStore.getEffectProperties()
          };

        case W.RADIAL:
          return {
            identifier: this.identifier,
            radial: this.focusStore.getEffectProperties()
          };

        case W.MIRRORED:
          var e = this.focusStore.getEffectProperties();
          return {
            identifier: this.identifier,
            mirrored: {
              blurRadius: e.blurRadius,
              origin: e.mirrorAxisOrigin,
              rotation: k(this.state.mirrored.rotation),
              size: e.clearAreaWidth
            }
          };

        case W.GAUSSIAN:
          return {
            identifier: this.identifier,
            gaussian: this.focusStore.getEffectProperties()
          };

        default:
          return ai;
      }
    }
  }, {
    key: "start",
    get: function get() {
      return this.focusStore.state.linear.start;
    }
  }, {
    key: "startOnPreview",
    get: function get() {
      var e = this.editor.applyFlipToPreview(this.focusStore.state.linear.start);
      return {
        x: Math.abs(e.x),
        y: Math.abs(e.y)
      };
    }
  }, {
    key: "end",
    get: function get() {
      return this.focusStore.state.linear.end;
    }
  }, {
    key: "endOnPreview",
    get: function get() {
      var e = this.editor.applyFlipToPreview(this.focusStore.state.linear.end);
      return {
        x: Math.abs(e.x),
        y: Math.abs(e.y)
      };
    }
  }, {
    key: "center",
    get: function get() {
      return this.focusStore.state.radial.center;
    }
  }, {
    key: "radius",
    get: function get() {
      return this.focusStore.state.radial.radius;
    }
  }, {
    key: "origin",
    get: function get() {
      return this.focusStore.state.mirrored.origin;
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.focusStore.state.mirrored.rotation;
    }
  }, {
    key: "rotationOnPreview",
    get: function get() {
      var _this$editor$outputCo7 = this.editor.outputContainer.getData(),
          e = _this$editor$outputCo7.flipHorizontally,
          t = _this$editor$outputCo7.flipVertically;

      return Qi({
        rotation: this.focusStore.state.mirrored.rotation,
        flipHorizontally: e,
        flipVertically: t
      });
    }
  }, {
    key: "size",
    get: function get() {
      return this.focusStore.state.mirrored.size;
    }
  }, {
    key: "mirroredAreaWidth",
    get: function get() {
      var _this$editor$canvasSt3 = this.editor.canvasStore.canvasSize,
          e = _this$editor$canvasSt3.width,
          t = _this$editor$canvasSt3.height;
      return Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) * 2;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.state.identifier;
    }
  }, {
    key: "intensity",
    get: function get() {
      return this.identifier === "identity" ? ai.gaussian.blurRadius : this.state[this.identifier].blurRadius;
    }
  }, {
    key: "relativeIntensity",
    get: function get() {
      var _ref52 = this.identifier === "identity" ? this.state.gaussian : this.state[this.identifier],
          e = _ref52.blurRadius;

      return (e - li.minIntensity) * 100 / (this.maxIntensity - li.minIntensity);
    }
  }, {
    key: "maxIntensity",
    get: function get() {
      return this.editor.shortestOutputSide / 10;
    }
  }, {
    key: "isOptionSelected",
    get: function get() {
      return this.identifier !== "identity";
    }
  }, {
    key: "config",
    get: function get() {
      return this.editor.configStore.config[g.FOCUS];
    }
  }, {
    key: "locale",
    get: function get() {
      return this.editor.configStore.locale[g.FOCUS];
    }
  }, {
    key: "items",
    get: function get() {
      return this.entityManager.items;
    }
  }], [{
    key: "doesFocusIdentifierExist",
    value: function doesFocusIdentifierExist(e) {
      return Object.keys(W).map(function (t) {
        return W[t];
      }).findIndex(function (t) {
        return t === e;
      }) !== -1;
    }
  }, {
    key: "minIntensity",
    get: function get() {
      return 0;
    }
  }]);

  return li;
}(),
    P = li;

a([d], P.prototype, "selectFocus", 2), a([d], P.prototype, "changeIntensity", 2), a([d], P.prototype, "changeRelativeIntensity", 2), a([d], P.prototype, "clickableCanvas", 2), a([d], P.prototype, "pureReset", 2), a([d], P.prototype, "reset", 2), a([d], P.prototype, "setStart", 2), a([d], P.prototype, "setEnd", 2), a([d], P.prototype, "setCenter", 2), a([d], P.prototype, "setRadius", 2), a([d], P.prototype, "setOrigin", 2), a([d], P.prototype, "setSize", 2), a([d], P.prototype, "setRotation", 2), a([d], P.prototype, "updateStateFromHistory", 2), a([d], P.prototype, "updateStateFromSerialization", 2), a([d], P.prototype, "updateCanvasControls", 2), a([u], P.prototype, "state", 1), a([u], P.prototype, "start", 1), a([u], P.prototype, "startOnPreview", 1), a([u], P.prototype, "end", 1), a([u], P.prototype, "endOnPreview", 1), a([u], P.prototype, "center", 1), a([u], P.prototype, "radius", 1), a([u], P.prototype, "origin", 1), a([u], P.prototype, "rotation", 1), a([u], P.prototype, "rotationOnPreview", 1), a([u], P.prototype, "size", 1), a([u], P.prototype, "mirroredAreaWidth", 1), a([u], P.prototype, "identifier", 1), a([u], P.prototype, "intensity", 1), a([u], P.prototype, "relativeIntensity", 1), a([u], P.prototype, "maxIntensity", 1), a([u], P.prototype, "isOptionSelected", 1), a([u], P.prototype, "config", 1), a([u], P.prototype, "locale", 1), a([u], P.prototype, "items", 1);
import { keyframes as _m } from "styled-components";

var Es = _m(_templateObject());

import { keyframes as Sm } from "styled-components";
var Dm = Sm(_templateObject2());
import { keyframes as xm } from "styled-components";
var ks = xm(_templateObject3());
import di from "react";
var Ue = [];

var ic = function ic() {
  return Ue.some(function (i) {
    return i.activeTargets.length > 0;
  });
};

var rc = function rc() {
  return Ue.some(function (i) {
    return i.skippedTargets.length > 0;
  });
};

var oc = "ResizeObserver loop completed with undelivered notifications.",
    nc = function nc() {
  var i;
  typeof ErrorEvent == "function" ? i = new ErrorEvent("error", {
    message: oc
  }) : (i = document.createEvent("Event"), i.initEvent("error", !1, !1), i.message = oc), window.dispatchEvent(i);
};

var ci;

(function (i) {
  i.BORDER_BOX = "border-box", i.CONTENT_BOX = "content-box", i.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(ci || (ci = {}));

var Is = function () {
  function i(e, t, r, o) {
    return this.x = e, this.y = t, this.width = r, this.height = o, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Object.freeze(this);
  }

  return i.prototype.toJSON = function () {
    var e = this,
        t = e.x,
        r = e.y,
        o = e.top,
        n = e.right,
        s = e.bottom,
        l = e.left,
        c = e.width,
        p = e.height;
    return {
      x: t,
      y: r,
      top: o,
      right: n,
      bottom: s,
      left: l,
      width: c,
      height: p
    };
  }, i.fromRect = function (e) {
    return new i(e.x, e.y, e.width, e.height);
  }, i;
}();

var cr = function cr(i) {
  return i instanceof SVGElement && "getBBox" in i;
},
    lo = function lo(i) {
  if (cr(i)) {
    var e = i.getBBox(),
        t = e.width,
        r = e.height;
    return !t && !r;
  }

  var o = i,
      n = o.offsetWidth,
      s = o.offsetHeight;
  return !(n || s || i.getClientRects().length);
},
    Fs = function Fs(i) {
  var e,
      t,
      r = (t = (e = i) === null || e === void 0 ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(r && i instanceof r.Element);
},
    sc = function sc(i) {
  switch (i.tagName) {
    case "INPUT":
      if (i.type !== "image") break;

    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }

  return !1;
};

var ui = typeof window != "undefined" ? window : {};

var co = new WeakMap(),
    ac = /auto|scroll/,
    Cm = /^tb|vertical/,
    wm = /msie|trident/i.test(ui.navigator && ui.navigator.userAgent),
    ct = function ct(i) {
  return parseFloat(i || "0");
},
    Fi = function Fi(i, e, t) {
  return i === void 0 && (i = 0), e === void 0 && (e = 0), t === void 0 && (t = !1), Object.freeze({
    inlineSize: (t ? e : i) || 0,
    blockSize: (t ? i : e) || 0
  });
},
    lc = Object.freeze({
  devicePixelContentBoxSize: Fi(),
  borderBoxSize: Fi(),
  contentBoxSize: Fi(),
  contentRect: new Is(0, 0, 0, 0)
}),
    As = function As(i, e) {
  if (e === void 0 && (e = !1), co.has(i) && !e) return co.get(i);
  if (lo(i)) return co.set(i, lc), lc;

  var t = getComputedStyle(i),
      r = cr(i) && i.ownerSVGElement && i.getBBox(),
      o = !wm && t.boxSizing === "border-box",
      n = Cm.test(t.writingMode || ""),
      s = !r && ac.test(t.overflowY || ""),
      l = !r && ac.test(t.overflowX || ""),
      c = r ? 0 : ct(t.paddingTop),
      p = r ? 0 : ct(t.paddingRight),
      m = r ? 0 : ct(t.paddingBottom),
      h = r ? 0 : ct(t.paddingLeft),
      b = r ? 0 : ct(t.borderTopWidth),
      v = r ? 0 : ct(t.borderRightWidth),
      x = r ? 0 : ct(t.borderBottomWidth),
      I = r ? 0 : ct(t.borderLeftWidth),
      R = h + p,
      M = c + m,
      Q = I + v,
      se = b + x,
      ve = l ? i.offsetHeight - se - i.clientHeight : 0,
      _e = s ? i.offsetWidth - Q - i.clientWidth : 0,
      T = o ? R + Q : 0,
      Z = o ? M + se : 0,
      ae = r ? r.width : ct(t.width) - T - _e,
      Qe = r ? r.height : ct(t.height) - Z - ve,
      ed = ae + R + _e + Q,
      td = Qe + M + ve + se,
      Aa = Object.freeze({
    devicePixelContentBoxSize: Fi(Math.round(ae * devicePixelRatio), Math.round(Qe * devicePixelRatio), n),
    borderBoxSize: Fi(ed, td, n),
    contentBoxSize: Fi(ae, Qe, n),
    contentRect: new Is(h, c, ae, Qe)
  });

  return co.set(i, Aa), Aa;
},
    uo = function uo(i, e, t) {
  var r = As(i, t),
      o = r.borderBoxSize,
      n = r.contentBoxSize,
      s = r.devicePixelContentBoxSize;

  switch (e) {
    case ci.DEVICE_PIXEL_CONTENT_BOX:
      return s;

    case ci.BORDER_BOX:
      return o;

    default:
      return n;
  }
};

var Rs = function () {
  function i(e) {
    var t = As(e);
    this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = [t.borderBoxSize], this.contentBoxSize = [t.contentBoxSize], this.devicePixelContentBoxSize = [t.devicePixelContentBoxSize];
  }

  return i;
}();

var po = function po(i) {
  if (lo(i)) return Infinity;

  for (var e = 0, t = i.parentNode; t;) {
    e += 1, t = t.parentNode;
  }

  return e;
};

var cc = function cc() {
  var i = Infinity,
      e = [];
  Ue.forEach(function (s) {
    if (s.activeTargets.length !== 0) {
      var l = [];
      s.activeTargets.forEach(function (p) {
        var m = new Rs(p.target),
            h = po(p.target);
        l.push(m), p.lastReportedSize = uo(p.target, p.observedBox), h < i && (i = h);
      }), e.push(function () {
        s.callback.call(s.observer, l, s.observer);
      }), s.activeTargets.splice(0, s.activeTargets.length);
    }
  });

  for (var t = 0, r = e; t < r.length; t++) {
    var o = r[t];
    o();
  }

  return i;
};

var Os = function Os(i) {
  Ue.forEach(function (t) {
    t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (o) {
      o.isActive() && (po(o.target) > i ? t.activeTargets.push(o) : t.skippedTargets.push(o));
    });
  });
};

var uc = function uc() {
  var i = 0;

  for (Os(i); ic();) {
    i = cc(), Os(i);
  }

  return rc() && nc(), i > 0;
};

var Ts,
    dc = [],
    Em = function Em() {
  return dc.splice(0).forEach(function (i) {
    return i();
  });
},
    pc = function pc(i) {
  if (!Ts) {
    var e = 0,
        t = document.createTextNode(""),
        r = {
      characterData: !0
    };
    new MutationObserver(function () {
      return Em();
    }).observe(t, r), Ts = function Ts() {
      t.textContent = "" + (e ? e-- : e++);
    };
  }

  dc.push(i), Ts();
};

var mc = function mc(i) {
  pc(function () {
    requestAnimationFrame(i);
  });
};

var mo = 0,
    km = function km() {
  return !!mo;
},
    Im = 250,
    Fm = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
},
    hc = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
    fc = function fc(i) {
  return i === void 0 && (i = 0), Date.now() + i;
},
    Ps = !1,
    Am = function () {
  function i() {
    var e = this;
    this.stopped = !0, this.listener = function () {
      return e.schedule();
    };
  }

  return i.prototype.run = function (e) {
    var t = this;

    if (e === void 0 && (e = Im), !Ps) {
      Ps = !0;
      var r = fc(e);
      mc(function () {
        var o = !1;

        try {
          o = uc();
        } finally {
          if (Ps = !1, e = r - fc(), !km()) return;
          o ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
        }
      });
    }
  }, i.prototype.schedule = function () {
    this.stop(), this.run();
  }, i.prototype.observe = function () {
    var e = this,
        t = function t() {
      return e.observer && e.observer.observe(document.body, Fm);
    };

    document.body ? t() : ui.addEventListener("DOMContentLoaded", t);
  }, i.prototype.start = function () {
    var e = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), hc.forEach(function (t) {
      return ui.addEventListener(t, e.listener, !0);
    }));
  }, i.prototype.stop = function () {
    var e = this;
    this.stopped || (this.observer && this.observer.disconnect(), hc.forEach(function (t) {
      return ui.removeEventListener(t, e.listener, !0);
    }), this.stopped = !0);
  }, i;
}(),
    ho = new Am(),
    Ms = function Ms(i) {
  !mo && i > 0 && ho.start(), mo += i, !mo && ho.stop();
};

var Rm = function Rm(i) {
  return !cr(i) && !sc(i) && getComputedStyle(i).display === "inline";
},
    gc = function () {
  function i(e, t) {
    this.target = e, this.observedBox = t || ci.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }

  return i.prototype.isActive = function () {
    var e = uo(this.target, this.observedBox, !0);
    return Rm(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
  }, i;
}();

var bc = function () {
  function i(e, t) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
  }

  return i;
}();

var fo = new WeakMap(),
    yc = function yc(i, e) {
  for (var t = 0; t < i.length; t += 1) {
    if (i[t].target === e) return t;
  }

  return -1;
},
    ur = function () {
  function i() {}

  return i.connect = function (e, t) {
    var r = new bc(e, t);
    fo.set(e, r);
  }, i.observe = function (e, t, r) {
    var o = fo.get(e),
        n = o.observationTargets.length === 0;
    yc(o.observationTargets, t) < 0 && (n && Ue.push(o), o.observationTargets.push(new gc(t, r && r.box)), Ms(1), ho.schedule());
  }, i.unobserve = function (e, t) {
    var r = fo.get(e),
        o = yc(r.observationTargets, t),
        n = r.observationTargets.length === 1;
    o >= 0 && (n && Ue.splice(Ue.indexOf(r), 1), r.observationTargets.splice(o, 1), Ms(-1));
  }, i.disconnect = function (e) {
    var t = this,
        r = fo.get(e);
    r.observationTargets.slice().forEach(function (o) {
      return t.unobserve(e, o.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, i;
}();

var Bs = function () {
  function i(e) {
    if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof e != "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    ur.connect(this, e);
  }

  return i.prototype.observe = function (e, t) {
    if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Fs(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ur.observe(this, e, t);
  }, i.prototype.unobserve = function (e) {
    if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Fs(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    ur.unobserve(this, e);
  }, i.prototype.disconnect = function () {
    ur.disconnect(this);
  }, i.toString = function () {
    return "function ResizeObserver () { [polyfill code] }";
  }, i;
}();

var xc = Ye(dr());
import Jm from "styled-components";
import Xm from "react";
var Dc = Xm.createContext({});

var Zm = Jm.div(_templateObject4(), function (i) {
  return i.theme.background;
}, function (i) {
  return i.theme.foreground;
}, function (i) {
  return i.theme.typography.fontFamily;
}),
    Us =
/*#__PURE__*/
function (_di$Component) {
  _inherits(Us, _di$Component);

  function Us(e) {
    var _this96;

    _classCallCheck(this, Us);

    _this96 = _possibleConstructorReturn(this, _getPrototypeOf(Us).call(this, e));
    _this96.node = di.createRef();

    _this96.saveEditorDimensions = function (e) {
      _this96.setState({
        contextValue: {
          element: e,
          rect: e.getBoundingClientRect()
        }
      });
    };

    var t;

    if ((t = di) == null ? void 0 : t.version) {
      var r = Number.parseInt(di.version.split(".")[0], 10),
          o = Number.parseInt(di.version.split(".")[1], 10);
      (r < 16 || r === 16 && o < 8) && console.error("Please be aware that the PhotoEditorSDK will require React 16.8.6 or above.");
    }

    _this96.saveEditorDimensions = xc.default(_this96.saveEditorDimensions, 100), _this96.resizeObserver = new Bs(function (_ref53) {
      var _ref54 = _slicedToArray(_ref53, 1),
          r = _ref54[0];

      _this96.saveEditorDimensions(r.target);
    }), _this96.state = {
      contextValue: {
        element: null,
        rect: null
      }
    };
    return _this96;
  }

  _createClass(Us, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e;
      ((e = this.node) == null ? void 0 : e.current) && this.resizeObserver.observe(this.node.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var e;
      ((e = this.node) == null ? void 0 : e.current) && this.resizeObserver.unobserve(this.node.current);
    }
  }, {
    key: "render",
    value: function render() {
      var e = this.props.children,
          t = this.state.contextValue;
      return di.createElement(Zm, {
        ref: this.node
      }, di.createElement(Dc.Provider, {
        value: t
      }, e));
    }
  }]);

  return Us;
}(di.Component);

import Eo from "react";
import pi, { PureComponent as yh, Component as Ks, forwardRef as qs, memo as Mc, createElement as vh } from "react";
import { useState as Qm } from "react";
if (!Qm) throw new Error("mobx-react-lite requires React with Hooks support");
if (!mn) throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
import { unstable_batchedUpdates as Cc } from "react-dom";
import { useCallback as eh, useEffect as C0, useState as th } from "react";

var ih = function ih(i, e) {
  var t = typeof Symbol == "function" && i[Symbol.iterator];
  if (!t) return i;
  var r = t.call(i),
      o,
      n = [],
      s;

  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done;) {
      n.push(o.value);
    }
  } catch (l) {
    s = {
      error: l
    };
  } finally {
    try {
      o && !o.done && (t = r.return) && t.call(r);
    } finally {
      if (s) throw s.error;
    }
  }

  return n;
};

function Ns() {
  var i = ih(th(0), 2),
      e = i[1],
      t = eh(function () {
    e(function (r) {
      return r + 1;
    });
  }, []);
  return t;
}

function wc(i) {
  return typeof Symbol == "function" ? Symbol.for(i) : "__$mobx-react " + i + "__";
}

var rh = {};

function Ec() {
  return typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : rh;
}

var oh = wc("observerBatching");

function nh(i) {
  i();
}

function go(i) {
  i || (i = nh), al({
    reactionScheduler: i
  }), Ec()[oh] = !0;
}

var sh = !1;

function ut() {
  return sh;
}

import { forwardRef as ph, memo as Tc } from "react";
import Gs from "react";

function kc(i) {
  return dn(i);
}

function Ic(i) {
  var e = {
    cleanAt: Date.now() + ah,
    reaction: i
  };
  return e;
}

var ah = 1e4,
    lh = 1e4,
    pr = new Set(),
    Hs;

function Fc() {
  Hs === void 0 && (Hs = setTimeout(ch, lh));
}

function Ac(i) {
  pr.add(i), Fc();
}

function Rc(i) {
  pr.delete(i);
}

function ch() {
  Hs = void 0;
  var i = Date.now();
  pr.forEach(function (e) {
    var t = e.current;
    t && i >= t.cleanAt && (t.reaction.dispose(), e.current = null, pr.delete(e));
  }), pr.size > 0 && Fc();
}

import uh from "react";
var bo = !1,
    yo = [];

function Ws(i) {
  return function () {
    bo ? yo.push(i) : i();
  };
}

function js(i) {
  bo = !0, yo = [];

  try {
    var e = i();
    bo = !1;
    var t = yo.length > 0 ? yo : void 0;
    return uh.useLayoutEffect(function () {
      t && t.forEach(function (r) {
        return r();
      });
    }, [t]), e;
  } finally {
    bo = !1;
  }
}

var dh = {};

function Oc(i) {
  return "observer" + i;
}

function Ai(i, e, t) {
  if (e === void 0 && (e = "observed"), t === void 0 && (t = dh), ut()) return i();
  var r = t.useForceUpdate || Ns,
      o = r(),
      n = Ws(o),
      s = Gs.useRef(null);

  if (!s.current) {
    var l = new zt(Oc(e), function () {
      c.mounted ? n() : (l.dispose(), s.current = null);
    }),
        c = Ic(l);
    s.current = c, Ac(s);
  }

  var p = s.current.reaction;
  return Gs.useDebugValue(p, kc), Gs.useEffect(function () {
    return Rc(s), s.current ? s.current.mounted = !0 : (s.current = {
      reaction: new zt(Oc(e), function () {
        n();
      }),
      cleanAt: Infinity
    }, n()), function () {
      s.current.reaction.dispose(), s.current = null;
    };
  }, []), js(function () {
    var m, h;
    if (p.track(function () {
      try {
        m = i();
      } catch (b) {
        h = b;
      }
    }), h) throw h;
    return m;
  });
}

var _Vs = function Vs() {
  return _Vs = Object.assign || function (i) {
    for (var e, t = 1, r = arguments.length; t < r; t++) {
      e = arguments[t];

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && (i[o] = e[o]);
      }
    }

    return i;
  }, _Vs.apply(this, arguments);
};

function $s(i, e) {
  if (ut()) return i;

  var t = _Vs({
    forwardRef: !1
  }, e),
      r = i.displayName || i.name,
      o = function o(s, l) {
    return Ai(function () {
      return i(s, l);
    }, r);
  };

  o.displayName = r;
  var n;
  return t.forwardRef ? n = Tc(ph(o)) : n = Tc(o), mh(i, n), n.displayName = r, n;
}

var hh = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0
};

function mh(i, e) {
  Object.keys(i).forEach(function (t) {
    hh[t] || Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
  });
}

function Ri(i) {
  var e = i.children,
      t = i.render,
      r = e || t;
  return typeof r != "function" ? null : Ai(r);
}

Ri.propTypes = {
  children: Pc,
  render: Pc
};
Ri.displayName = "Observer";

function Pc(i, e, t, r, o) {
  var n = e === "children" ? "render" : "children",
      s = typeof i[e] == "function",
      l = typeof i[n] == "function";
  return s && l ? new Error("MobX Observer: Do not use children and render in the same time in`" + t) : s || l ? null : new Error("Invalid prop `" + o + "` of type `" + typeof i[e] + "` supplied to `" + t + "`, expected `function`.");
}

import J0 from "react";
import rF from "react";
go(Cc);
var Bc = 0;

function _h(i) {
  if (typeof Symbol == "function") return Symbol(i);
  var e = "__$mobx-react " + i + " (" + Bc + ")";
  return Bc++, e;
}

var Ys = {};

function $t(i) {
  return Ys[i] || (Ys[i] = _h(i)), Ys[i];
}

function Lc(i, e) {
  if (zc(i, e)) return !0;
  if (typeof i != "object" || i === null || typeof e != "object" || e === null) return !1;
  var t = Object.keys(i),
      r = Object.keys(e);
  if (t.length !== r.length) return !1;

  for (var o = 0; o < t.length; o++) {
    if (!Object.hasOwnProperty.call(e, t[o]) || !zc(i[t[o]], e[t[o]])) return !1;
  }

  return !0;
}

function zc(i, e) {
  return i === e ? i !== 0 || 1 / i == 1 / e : i !== i && e !== e;
}

var Sh = {
  $$typeof: 1,
  render: 1,
  compare: 1,
  type: 1,
  childContextTypes: 1,
  contextType: 1,
  contextTypes: 1,
  defaultProps: 1,
  getDefaultProps: 1,
  getDerivedStateFromError: 1,
  getDerivedStateFromProps: 1,
  mixins: 1,
  propTypes: 1
};

function Dh(i, e) {
  var t = Object.getOwnPropertyNames(Object.getPrototypeOf(i));
  Object.getOwnPropertyNames(i).forEach(function (r) {
    !Sh[r] && t.indexOf(r) === -1 && Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(i, r));
  });
}

function Et(i, e, t) {
  Object.hasOwnProperty.call(i, e) ? i[e] = t : Object.defineProperty(i, e, {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: t
  });
}

var Uc = $t("patchMixins"),
    Nc = $t("patchedDefinition");

function xh(i, e) {
  var t = i[Uc] = i[Uc] || {},
      r = t[e] = t[e] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}

function Hc(i, e) {
  for (var t = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), n = 2; n < r; n++) {
    o[n - 2] = arguments[n];
  }

  e.locks++;

  try {
    var s;
    return i != null && (s = i.apply(this, o)), s;
  } finally {
    e.locks--, e.locks === 0 && e.methods.forEach(function (l) {
      l.apply(t, o);
    });
  }
}

function Wc(i, e) {
  var t = function t() {
    for (var o = arguments.length, n = new Array(o), s = 0; s < o; s++) {
      n[s] = arguments[s];
    }

    Hc.call.apply(Hc, [this, i, e].concat(n));
  };

  return t;
}

function Ch(i, e, t) {
  var r = xh(i, e);
  r.methods.indexOf(t) < 0 && r.methods.push(t);
  var o = Object.getOwnPropertyDescriptor(i, e);

  if (!(o && o[Nc])) {
    var n = i[e],
        s = jc(i, e, o ? o.enumerable : void 0, r, n);
    Object.defineProperty(i, e, s);
  }
}

function jc(i, e, t, r, o) {
  var n,
      s = Wc(o, r);
  return n = {}, n[Nc] = !0, n.get = function () {
    return s;
  }, n.set = function (c) {
    if (this === i) s = Wc(c, r);else {
      var p = jc(this, e, t, r, c);
      Object.defineProperty(this, e, p);
    }
  }, n.configurable = !0, n.enumerable = t, n;
}

var Xs = Sn || "$mobx",
    Gc = $t("isMobXReactObserver"),
    Vc = $t("isUnmounted"),
    vo = $t("skipRender"),
    _o = $t("isForcingUpdate");

function Eh(i) {
  var e = i.prototype;

  if (i[Gc]) {
    var t = Js(e);
    console.warn("The provided component class (" + t + ") \n                has already been declared as an observer component.");
  } else i[Gc] = !0;

  if (e.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");

  if (i.__proto__ !== yh) {
    if (!e.shouldComponentUpdate) e.shouldComponentUpdate = $c;else if (e.shouldComponentUpdate !== $c) throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }

  Kc(e, "props"), Kc(e, "state");
  var r = e.render;
  return e.render = function () {
    return wh.call(this, r);
  }, Ch(e, "componentWillUnmount", function () {
    var o;

    if (ut() !== !0 && ((o = this.render[Xs]) === null || o === void 0 || o.dispose(), this[Vc] = !0, !this.render[Xs])) {
      var n = Js(this);
      console.warn("The reactive render of an observer class component (" + n + ") \n                was overriden after MobX attached. This may result in a memory leak if the \n                overriden reactive render was not properly disposed.");
    }
  }), i;
}

function Js(i) {
  return i.displayName || i.name || i.constructor && (i.constructor.displayName || i.constructor.name) || "<component>";
}

function wh(i) {
  var e = this;
  if (ut() === !0) return i.call(this);
  Et(this, vo, !1), Et(this, _o, !1);
  var t = Js(this),
      r = i.bind(this),
      o = !1,
      n = new zt(t + ".render()", function () {
    if (!o && (o = !0, e[Vc] !== !0)) {
      var l = !0;

      try {
        Et(e, _o, !0), e[vo] || Ks.prototype.forceUpdate.call(e), l = !1;
      } finally {
        Et(e, _o, !1), l && n.dispose();
      }
    }
  });
  n.reactComponent = this, s[Xs] = n, this.render = s;

  function s() {
    o = !1;
    var l = void 0,
        c = void 0;
    if (n.track(function () {
      try {
        c = Za(!1, r);
      } catch (p) {
        l = p;
      }
    }), l) throw l;
    return c;
  }

  return s.call(this);
}

function $c(i, e) {
  return ut() && console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side."), this.state !== e ? !0 : !Lc(this.props, i);
}

function Kc(i, e) {
  var t = $t("reactProp_" + e + "_valueHolder"),
      r = $t("reactProp_" + e + "_atomHolder");

  function o() {
    return this[r] || Et(this, r, Ar("reactive " + e)), this[r];
  }

  Object.defineProperty(i, e, {
    configurable: !0,
    enumerable: !0,
    get: function get() {
      var s = !1;
      return Zt && vt && (s = Zt(!0)), o.call(this).reportObserved(), Zt && vt && vt(s), this[t];
    },
    set: function set(s) {
      !this[_o] && !Lc(this[t], s) ? (Et(this, t, s), Et(this, vo, !0), o.call(this).reportChanged(), Et(this, vo, !1)) : Et(this, t, s);
    }
  });
}

var qc = typeof Symbol == "function" && Symbol.for,
    Yc = qc ? Symbol.for("react.forward_ref") : typeof qs == "function" && qs(function (i) {
  return null;
}).$$typeof,
    Xc = qc ? Symbol.for("react.memo") : typeof Mc == "function" && Mc(function (i) {
  return null;
}).$$typeof;

function Zs(i) {
  if (i.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'"), Xc && i.$$typeof === Xc) throw new Error("Mobx observer: You are trying to use 'observer' on a function component wrapped in either another observer or 'React.memo'. The observer already applies 'React.memo' for you.");

  if (Yc && i.$$typeof === Yc) {
    var e = i.render;
    if (typeof e != "function") throw new Error("render property of ForwardRef was not a function");
    return qs(function () {
      var r = arguments;
      return vh(Ri, null, function () {
        return e.apply(void 0, r);
      });
    });
  }

  return typeof i == "function" && (!i.prototype || !i.prototype.render) && !i.isReactClass && !Object.prototype.isPrototypeOf.call(Ks, i) ? $s(i) : Eh(i);
}

function So() {
  return So = Object.assign || function (i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (i[r] = t[r]);
      }
    }

    return i;
  }, So.apply(this, arguments);
}

function kh(i, e) {
  if (i == null) return {};
  var t = {},
      r = Object.keys(i),
      o,
      n;

  for (n = 0; n < r.length; n++) {
    o = r[n], !(e.indexOf(o) >= 0) && (t[o] = i[o]);
  }

  return t;
}

var Qs = pi.createContext({});

function Ih(i) {
  var e = i.children,
      t = kh(i, ["children"]),
      r = pi.useContext(Qs),
      o = pi.useRef(So({}, r, t)),
      n = o.current;
  if (!1) var s;
  return pi.createElement(Qs.Provider, {
    value: n
  }, e);
}

Ih.displayName = "MobXProvider";

function Jc(i, e, t, r) {
  var o = pi.forwardRef(function (n, s) {
    var l = So({}, n),
        c = pi.useContext(Qs);
    return Object.assign(l, i(c || {}, l) || {}), s && (l.ref = s), pi.createElement(e, l);
  });
  return r && (o = Zs(o)), o.isMobxInjector = !0, Dh(e, o), o.wrappedComponent = e, o.displayName = Fh(e, t), o;
}

function Fh(i, e) {
  var t,
      r = i.displayName || i.name || i.constructor && i.constructor.name || "Component";
  return e ? t = "inject-with-" + e + "(" + r + ")" : t = "inject(" + r + ")", t;
}

function Ah(i) {
  return function (e, t) {
    return i.forEach(function (r) {
      if (!(r in t)) {
        if (!(r in e)) throw new Error("MobX injector: Store '" + r + "' is not available! Make sure it is provided by some Provider");
        t[r] = e[r];
      }
    }), t;
  };
}

function Zc() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++) {
    e[t] = arguments[t];
  }

  if (typeof arguments[0] == "function") {
    var r = arguments[0];
    return function (o) {
      return Jc(r, o, r.name, !0);
    };
  } else return function (o) {
    return Jc(Ah(e), o, e.join("-"), !1);
  };
}

if (!Ks) throw new Error("mobx-react requires React to be available");
if (!S) throw new Error("mobx-react requires mobx to be available");
import Oi from "react";
import Qc, { css as Ph } from "styled-components";
import Rh, { css as Oh } from "styled-components";
var mr = Oh(_templateObject5(), function (i) {
  return i.theme.measurements.colorItem.size;
}, function (i) {
  return i.theme.measurements.colorItem.size;
}, function (i) {
  return i.theme.colorItem.borderRadius || "".concat(i.theme.shape.radiusSmall, "px");
}),
    Th = Rh.div.attrs(function (i) {
  return {
    style: {
      background: i.color
    }
  };
})(_templateObject6(), mr, function (i) {
  return i.theme.measurements.zIndex.colorItem.background;
}),
    Do = Th;

var Mh = Qc.div(_templateObject7(), mr, function (i) {
  return i.theme.measurements.zIndex.colorItem.overlay;
}, function (i) {
  return i.theme.colorItem.borderRadius || "".concat(i.theme.shape.radiusSmall, "px");
}, function (i) {
  return i.isActive && Ph(_templateObject8(), i.theme.selectColor.activeBorderColor);
}),
    ea = Qc.span(_templateObject9()),
    Bh = function Bh(_ref55) {
  var i = _ref55.isActive,
      e = _ref55.className,
      t = _ref55.style;
  return Oi.createElement(Mh, {
    isActive: i,
    className: e,
    style: t
  }, i && Oi.createElement(Oi.Fragment, null, Oi.createElement(ea, null), Oi.createElement(ea, null), Oi.createElement(ea, null)));
},
    xo = Bh;

import Uh from "styled-components";
import { css as zh } from "styled-components";
var be = zh(_templateObject10(), function (i) {
  return i.theme.focusOutlineColor;
}, function (i) {
  return i.theme.focusOutlineColor;
});
import { css as Lh } from "styled-components";
var hr = Lh(_templateObject11());
var Nh = Uh.button.attrs({
  type: "button"
})(_templateObject12(), function (i) {
  return i.theme.measurements.colorItem.size;
}, function (i) {
  return i.theme.measurements.colorItem.size;
}, function (i) {
  return i.theme.colorItem.margin;
}, function (i) {
  return i.theme.colorItem.borderRadius || "".concat(i.theme.shape.radiusSmall, "px");
}, be, function (i) {
  return i.theme.selectColor.inactiveOpacity;
}),
    Co = Nh;
import Hh from "styled-components";
var Wh = Hh.div.attrs(function (i) {
  return {
    style: i.url ? {
      backgroundImage: "url(".concat(i.url, ")")
    } : {}
  };
})(_templateObject13(), mr, function (i) {
  return i.theme.measurements.zIndex.colorItem.tiledBackground;
}),
    wo = Wh;

var jh = function jh(_ref56) {
  var i = _ref56.isActive,
      e = _ref56.onClick,
      t = _ref56.color,
      r = _ref56.label,
      o = _ref56.isDisabled,
      n = _ref56.tiledBackgroundUrl,
      s = _ref56.className,
      l = _ref56.style,
      c = _ref56.children;
  return Eo.createElement(Co, {
    disabled: o,
    onClick: e,
    "aria-label": r,
    className: s,
    style: l
  }, Eo.createElement(wo, {
    url: n
  }), Eo.createElement(Do, {
    color: t
  }), Eo.createElement(xo, {
    isActive: i
  }), c);
},
    eu = Zc("config")(Zs(jh));

import ta from "react";
import Gh from "styled-components";
var Vh = Gh.div(_templateObject14(), function (i) {
  return i.theme.measurements.zIndex.dialog.backdrop;
}, function (i) {
  return i.theme.modal.backdrop;
}),
    ko = Vh;
import $h from "react";
import Kh, { css as qh } from "styled-components";

var Yh = Kh.div(_templateObject15(), function (i) {
  return i.theme.measurements.zIndex.dialog.base;
}, function (i) {
  return i.isVisible && qh(_templateObject16());
}),
    Io = function Io(_ref57) {
  var i = _ref57.isVisible,
      e = _ref57.className,
      t = _ref57.children;
  return $h.createElement(Yh, {
    isVisible: i,
    className: e
  }, t);
};

import Xh from "styled-components";
var Jh = Xh.div.attrs(function (_ref58) {
  var i = _ref58.style;
  return {
    role: "dialog",
    "aria-hidden": !1,
    style: i
  };
})(_templateObject17(), function (i) {
  return i.top;
}, function (i) {
  return i.left;
}, function (i) {
  return i.width;
}, function (i) {
  return i.height;
}, function (i) {
  return i.theme.shape.radiusLarge;
}, function (i) {
  return i.theme.modal.background;
}, function (i) {
  return i.theme.modal.bodyForeground;
}, function (i) {
  return i.theme.measurements.zIndex.dialog.container;
}),
    Fo = Jh;

var Zh = function Zh(_ref59) {
  var _ref59$isVisible = _ref59.isVisible,
      i = _ref59$isVisible === void 0 ? !1 : _ref59$isVisible,
      _ref59$width = _ref59.width,
      e = _ref59$width === void 0 ? "350px" : _ref59$width,
      _ref59$height = _ref59.height,
      t = _ref59$height === void 0 ? "fit-content" : _ref59$height,
      r = _ref59.position,
      o = _ref59.header,
      n = _ref59.body,
      s = _ref59.footer,
      l = _ref59.className,
      c = _ref59.style,
      p = _ref59.children;
  return ta.createElement(Io, {
    isVisible: i
  }, ta.createElement(ko, null), ta.createElement(Fo, {
    height: t,
    width: e,
    left: r.x,
    top: r.y,
    className: l,
    style: c,
    "data-test": me.Dialog
  }, o, n, p, s));
},
    tu = Zh;

import Qh from "styled-components";
var ef = Qh.div(_templateObject18(), function (i) {
  return i.theme.measurements.fontSystem.body.size;
}, function (i) {
  return i.theme.measurements.fontSystem.body.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.body.case;
}, function (i) {
  return i.theme.modal.bodyForeground;
}),
    kt = ef;
import tf from "styled-components";
var rf = tf.div(_templateObject19(), function (i) {
  return i.type === "error" ? i.theme.error : i.theme.warning;
}),
    Ti = rf;
import of from "styled-components";
var nf = of.h3(_templateObject20(), function (i) {
  return i.theme.measurements.fontSystem.headline2.size;
}, function (i) {
  return i.theme.measurements.fontSystem.headline2.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.headline2.case;
}, function (i) {
  return i.theme.modal.headerForeground;
}),
    Pi = nf;
import sf, { css as iu, keyframes as af } from "styled-components";
var ru = af(_templateObject21()),
    lf = iu(_templateObject22(), ru),
    cf = iu(_templateObject23(), ru),
    uf = sf.div(_templateObject24(), function (i) {
  return i.theme.primary;
}, function (i) {
  return i.theme.modal.background;
}, lf, function (i) {
  return i.theme.modal.background;
}, cf),
    Ao = uf;
import zo from "react";
import aa from "react";
import la from "react-dom";
var ia = ["Moz", "Webkit", "O", "ms"];

function df(i) {
  var e = "",
      t = !0,
      r;

  for (r = 0; r < i.length; r += 1) {
    t ? (e += i[r].toUpperCase(), t = !1) : i[r] === "-" ? t = !0 : e += i[r];
  }

  return e;
}

function ra(i, e) {
  return e ? "".concat(e).concat(df(i)) : i;
}

function pf() {
  var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
  if (typeof window == "undefined" || typeof window.document == "undefined") return "";
  var e = window.document.documentElement.style;
  if (i in e) return "";
  var t;

  for (t = 0; t < ia.length; t += 1) {
    if (ra(i, ia[t]) in e) return ia[t];
  }

  return "";
}

var ou = pf();

function Ro(i, e) {
  for (var t = 0, r = i.length; t < r; t += 1) {
    if (e.apply(e, [i[t], t, i])) return i[t];
  }

  return null;
}

function oa(i) {
  return typeof i == "function" || Object.prototype.toString.call(i) === "[object Function]";
}

function Mi(i) {
  return typeof i == "number" && !Number.isNaN(i);
}

function fe(i) {
  return parseInt(i, 10);
}

var Oo = "";

function mf(i, e) {
  return Oo || (Oo = Ro(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function (t) {
    return oa(i[t]);
  })), oa(i[Oo]) ? i[Oo](e) : !1;
}

function na(i, e, t) {
  var r = i;

  do {
    if (mf(r, e)) return !0;
    if (r === t) return !1;
    r = r.parentNode;
  } while (r);

  return !1;
}

function To(i, e, t) {
  !i || (i.attachEvent ? i.attachEvent("on".concat(e), t) : i.addEventListener ? i.addEventListener(e, t, !0) : i["on".concat(e)] = t);
}

function Kt(i, e, t) {
  !i || (i.detachEvent ? i.detachEvent("on".concat(e), t) : i.removeEventListener ? i.removeEventListener(e, t, !0) : i["on".concat(e)] = null);
}

function nu(i) {
  var e = i.clientHeight,
      t = i.ownerDocument.defaultView.getComputedStyle(i);
  return e += fe(t.borderTopWidth), e += fe(t.borderBottomWidth), e;
}

function su(i) {
  var e = i.clientWidth,
      t = i.ownerDocument.defaultView.getComputedStyle(i);
  return e += fe(t.borderLeftWidth), e += fe(t.borderRightWidth), e;
}

function au(i) {
  var e = i.clientHeight,
      t = i.ownerDocument.defaultView.getComputedStyle(i);
  return e -= fe(t.paddingTop), e -= fe(t.paddingBottom), e;
}

function lu(i) {
  var e = i.clientWidth,
      t = i.ownerDocument.defaultView.getComputedStyle(i);
  return e -= fe(t.paddingLeft), e -= fe(t.paddingRight), e;
}

function cu(i, e) {
  var r = e === e.ownerDocument.body ? {
    left: 0,
    top: 0
  } : e.getBoundingClientRect(),
      o = i.clientX + e.scrollLeft - r.left,
      n = i.clientY + e.scrollTop - r.top;
  return {
    x: o,
    y: n
  };
}

function uu(_ref60) {
  var i = _ref60.x,
      e = _ref60.y,
      t = _ref60.rotation;
  var r = "translate(".concat(i, "px,").concat(e, "px) rotate(").concat(t, "rad)");
  return _defineProperty({}, ra("transform", ou), r);
}

function du(i, e) {
  var t = null;
  return i.targetTouches && (t = Ro(i.targetTouches, function (r) {
    return e === r.identifier;
  })), i.changedTouches && !t && (t = Ro(i.changedTouches, function (r) {
    return e === r.identifier;
  })), t;
}

function pu(i) {
  return i.targetTouches && i.targetTouches[0] ? i.targetTouches[0].identifier : i.changedTouches && i.changedTouches[0] ? i.changedTouches[0].identifier : null;
}

import hf from "react-dom";

function sa(i) {
  var e = hf.findDOMNode(i);
  if (!e) throw new Error("<DraggableCore>: Unmounted during event!");
  return e;
}

function mu(i, e, t) {
  if (!i.props.bounds) return [e, t];
  var r = i.props.bounds;
  r = typeof r == "string" ? r : f({}, r);
  var o = sa(i);

  if (typeof r == "string") {
    var n = o.ownerDocument,
        s = n.defaultView,
        l = r === "parent" ? o.parentNode : n.querySelector(r);
    if (!(l instanceof HTMLElement)) throw new Error("Bounds selector \"".concat(r, "\" could not find an element."));

    if (o instanceof HTMLElement) {
      var c = s.getComputedStyle(o),
          p = s.getComputedStyle(l);
      r = {
        left: -o.offsetLeft + fe(p.paddingLeft) + fe(c.marginLeft),
        top: -o.offsetTop + fe(p.paddingTop) + fe(c.marginTop),
        right: lu(l) - su(o) - o.offsetLeft + fe(p.paddingRight) - fe(c.marginRight),
        bottom: au(l) - nu(o) - o.offsetTop + fe(p.paddingBottom) - fe(c.marginBottom)
      };
    }
  }

  return r = r, Mi(r.right) && (e = Math.min(e, r.right)), Mi(r.bottom) && (t = Math.min(t, r.bottom)), Mi(r.left) && (e = Math.max(e, r.left)), Mi(r.top) && (t = Math.max(t, r.top)), [e, t];
}

function Po(i, e, t) {
  var r = i.state,
      o = !Mi(r.lastX),
      n = sa(i);
  return o ? {
    node: n,
    deltaX: 0,
    deltaY: 0,
    lastX: e,
    lastY: t,
    x: e,
    y: t
  } : {
    node: n,
    deltaX: e - r.lastX,
    deltaY: t - r.lastY,
    lastX: r.lastX,
    lastY: r.lastY,
    x: e,
    y: t
  };
}

function Mo(i, e) {
  return {
    node: e.node,
    x: i.state.x + e.deltaX,
    y: i.state.y + e.deltaY,
    deltaX: e.deltaX,
    deltaY: e.deltaY,
    lastX: i.state.x,
    lastY: i.state.y
  };
}

function hu(i) {
  return i.props.axis === "both" || i.props.axis === "x";
}

function fu(i) {
  return i.props.axis === "both" || i.props.axis === "y";
}

function Bo(i, e) {
  var t = sa(e),
      r = e.props.offsetParent;
  return !r && t instanceof HTMLElement && (r = t.offsetParent || t.ownerDocument.body), cu(i, r);
}

var dt = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
},
    Re = dt.mouse,
    ca = {
  cancel: null,
  disabled: !1,
  offsetParent: null,
  handle: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
},
    mi =
/*#__PURE__*/
function (_aa$Component) {
  _inherits(mi, _aa$Component);

  function mi() {
    var _this97;

    _classCallCheck(this, mi);

    _this97 = _possibleConstructorReturn(this, _getPrototypeOf(mi).apply(this, arguments));
    _this97.state = {
      dragging: !1,
      lastX: NaN,
      lastY: NaN,
      touchIdentifier: void 0
    };

    _this97.getTouchFromEvent = function (e) {
      var t = pu(e);
      return _this97.setState({
        touchIdentifier: t
      }), du(e, t);
    };

    _this97.preventDefault = function (e) {
      e.stopPropagation && e.stopPropagation();
    };

    _this97.handleDragStart = function (e) {
      var t = la.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this97)));
      if (!t || !t.ownerDocument || !t.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
      var r = t.ownerDocument;
      if (_this97.props.disabled || !(e.target instanceof Node) || _this97.props.handle && !na(e.target, _this97.props.handle, t) || _this97.props.cancel && na(e.target, _this97.props.cancel, t)) return !1;
      var o = Bo(e, _assertThisInitialized(_assertThisInitialized(_this97)));
      if (o == null) return !1;
      var n = o.x,
          s = o.y,
          l = Po(_assertThisInitialized(_assertThisInitialized(_this97)), n, s);
      if (_this97.props.onStart(e, l) === !1) return !1;
      _this97.setState({
        dragging: !0,
        lastX: n,
        lastY: s
      }), Re.move === "touchmove" ? To(r, Re.move, _this97.onTouchDrag) : To(r, Re.move, _this97.onMouseDrag), To(r, Re.stop, _this97.handleDragStop);
    };

    _this97.handleDrag = function (e) {
      var t = Bo(e, _assertThisInitialized(_assertThisInitialized(_this97)));
      if (t == null) return;
      var r = t.x,
          o = t.y,
          n = Po(_assertThisInitialized(_assertThisInitialized(_this97)), r, o);

      if (_this97.props.onDrag(e, n) === !1) {
        try {
          _this97.handleDragStop(new MouseEvent("mouseup"));
        } catch (l) {
          var c = document.createEvent("MouseEvents");
          c.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), _this97.handleDragStop(c);
        }

        return;
      }

      _this97.setState({
        lastX: r,
        lastY: o
      });
    };

    _this97.handleDragStop = function (e) {
      if (!_this97.state.dragging) return;
      var t = Bo(e, _assertThisInitialized(_assertThisInitialized(_this97)));
      if (t == null) return;
      var r = t.x,
          o = t.y,
          n = Po(_assertThisInitialized(_assertThisInitialized(_this97)), r, o),
          s = la.findDOMNode(_assertThisInitialized(_assertThisInitialized(_this97)));
      _this97.setState({
        dragging: !1,
        lastX: NaN,
        lastY: NaN
      }), _this97.props.onStop(e, n), s && (Re.move === "touchmove" ? Kt(s.ownerDocument, Re.move, _this97.onTouchDrag) : Kt(s.ownerDocument, Re.move, _this97.onMouseDrag), Kt(s.ownerDocument, Re.stop, _this97.handleDragStop));
    };

    _this97.onMouseDown = function (e) {
      return _this97.preventDefault(e), Re = dt.mouse, _this97.props.onMouseDown(e), e.button && typeof e.button == "number" && e.button !== 0 ? !1 : _this97.handleDragStart(e);
    };

    _this97.onMouseDrag = function (e) {
      return _this97.preventDefault(e), _this97.handleDrag(e);
    };

    _this97.onMouseUp = function (e) {
      return _this97.preventDefault(e), Re = dt.mouse, _this97.handleDragStop(e);
    };

    _this97.onTouchStart = function (e) {
      _this97.preventDefault(e), Re = dt.touch;

      var t = _this97.getTouchFromEvent(e);

      return _this97.handleDragStart(t);
    };

    _this97.onTouchDrag = function (e) {
      _this97.preventDefault(e), Re = dt.touch;

      var t = _this97.getTouchFromEvent(e);

      return _this97.handleDrag(t);
    };

    _this97.onTouchEnd = function (e) {
      _this97.preventDefault(e), Re = dt.touch;

      var t = _this97.getTouchFromEvent(e);

      return _this97.handleDragStop(t);
    };

    return _this97;
  }

  _createClass(mi, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var e = la.findDOMNode(this);

      if (e) {
        var t = e.ownerDocument;
        Kt(t, dt.mouse.move, this.onMouseDrag), Kt(t, dt.touch.move, this.onTouchDrag), Kt(t, dt.mouse.stop, this.handleDragStop), Kt(t, dt.touch.stop, this.handleDragStop);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return aa.cloneElement(aa.Children.only(this.props.children), {
        style: f({
          touchAction: "none"
        }, this.props.children.props.style),
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return mi;
}(aa.Component);

mi.defaultProps = ca, mi.displayName = "DraggableCore";

var ff = f(f({}, ca), {
  axis: "both",
  bounds: !1,
  defaultClassName: "draggable",
  defaultClassNameDragging: "draggable-dragging",
  defaultClassNameDragged: "draggable-dragged",
  defaultPosition: {
    x: 0,
    y: 0
  },
  position: null,
  rotation: 0,
  updateOnPosition: !1
}),
    Lo =
/*#__PURE__*/
function (_zo$Component) {
  _inherits(Lo, _zo$Component);

  function Lo(e) {
    var _this98;

    _classCallCheck(this, Lo);

    _this98 = _possibleConstructorReturn(this, _getPrototypeOf(Lo).call(this, e));

    _this98.onDragStart = function (e, t) {
      if (_this98.props.onStart(e, Mo(_assertThisInitialized(_assertThisInitialized(_this98)), t)) === !1) return !1;

      _this98.setState({
        dragging: !0,
        dragged: !0
      });
    };

    _this98.onDrag = function (e, t) {
      var _this98$props = _this98.props,
          r = _this98$props.position,
          o = _this98$props.defaultPosition,
          n = _this98$props.onDrag,
          s = _this98$props.bounds;
      if (!_this98.state.dragging) return !1;
      var l = Mo(_assertThisInitialized(_assertThisInitialized(_this98)), t),
          c = Boolean(r),
          p = {
        x: c ? l.x : o.x,
        y: c ? l.y : o.y,
        slackX: 0,
        slackY: 0
      };

      if (s) {
        var h = p.x,
            b = p.y;
        p.x += _this98.state.slackX, p.y += _this98.state.slackY;

        var _mu = mu(_assertThisInitialized(_assertThisInitialized(_this98)), p.x, p.y),
            _mu2 = _slicedToArray(_mu, 2),
            v = _mu2[0],
            x = _mu2[1];

        p.x = v, p.y = x, p.slackX = _this98.state.slackX + (h - p.x), p.slackY = _this98.state.slackY + (b - p.y), l.x = p.x, l.y = p.y, l.deltaX = p.x - _this98.state.x, l.deltaY = p.y - _this98.state.y;
      }

      if (n(e, l) === !1) return !1;

      _this98.setState(p);
    };

    _this98.onDragStop = function (e, t) {
      if (!_this98.state.dragging || _this98.props.onStop(e, Mo(_assertThisInitialized(_assertThisInitialized(_this98)), t)) === !1) return !1;
      var o = {
        dragging: !1,
        slackX: 0,
        slackY: 0,
        x: 0,
        y: 0
      };

      if (Boolean(_this98.props.position)) {
        var _this98$props$positio = _this98.props.position,
            s = _this98$props$positio.x,
            l = _this98$props$positio.y;
        o.x = s, o.y = l;
      }

      _this98.setState(o);
    };

    _this98.state = {
      dragging: !1,
      dragged: !1,
      x: e.position ? e.position.x : e.defaultPosition.x,
      y: e.position ? e.position.y : e.defaultPosition.y,
      slackX: 0,
      slackY: 0
    };
    return _this98;
  }

  _createClass(Lo, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      Boolean(this.props.position) && (this.props.updateOnPosition ? (e.position && e.position.x !== this.props.position.x || e.position.y !== this.props.position.y) && this.setState({
        x: this.props.position.x,
        y: this.props.position.y
      }) : (e.position && this.props.position.x !== this.state.x || this.props.position.y !== this.state.y) && this.setState({
        x: this.props.position.x,
        y: this.props.position.y
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var ve = this.props,
          e = ve.position,
          t = ve.defaultPosition,
          r = ve.rotation,
          o = ve.defaultClassName,
          n = ve.defaultClassNameDragging,
          s = ve.defaultClassNameDragged,
          l = Pe(ve, ["position", "defaultPosition", "rotation", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged"]),
          _this$state4 = this.state,
          c = _this$state4.x,
          p = _this$state4.y,
          m = _this$state4.dragging,
          h = _this$state4.dragged,
          b = {},
          x = !Boolean(e) || m,
          I = e || t,
          R = {
        x: hu(this) && x ? c : I.x,
        y: fu(this) && x ? p : I.y,
        rotation: r
      };
      b = uu(R);
      var M = zo.Children.only(this.props.children),
          Q = [M.props.className || "", o, m ? n : "", h ? s : ""].join(" ").trim(),
          se = zo.cloneElement(M, {
        className: Q,
        style: f(f({}, M.props.style), b)
      });
      return zo.createElement(mi, f(f({}, l), {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), se);
    }
  }]);

  return Lo;
}(zo.Component);

Lo.defaultProps = ff, Lo.displayName = "Draggable";
var gu = Lo;
var Du = Ye(fr());
import Ze from "react";
import qt, { css as xu } from "styled-components";
import br from "react";
import Tf, { css as Pf } from "styled-components";
import gr from "styled-components";
var No = gr.span(_templateObject25()),
    da = gr(No)(_templateObject26()),
    Oe = gr(No)(_templateObject27()),
    Bi = gr(No)(_templateObject28()),
    Ho = {
  display: "none",
  left: 0,
  top: 0
},
    Wo = gr(No)(_templateObject29(), function (_ref62) {
  var i = _ref62.display;
  return i;
}, function (_ref63) {
  var i = _ref63.left;
  return i;
}, function (_ref64) {
  var i = _ref64.top;
  return i;
}, Es);

var It = Pf(_templateObject30(), function (i) {
  return i.theme.button.activeForeground;
}),
    Mf = Tf.button(_templateObject31(), function (i) {
  return i.theme.shape.radiusMedium;
}, function (i) {
  return i.theme.measurements.fontSystem.button1.size;
}, function (i) {
  return i.theme.measurements.fontSystem.button1.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.button1.case;
}, function (i) {
  return i.theme.typography.fontFamily;
}, be, It, function (_ref65) {
  var i = _ref65.isActive;
  return i && It;
}, Oe, function (i) {
  return i.theme.button.outlinedInactiveOverlayColor;
}, Bi, function (i) {
  return i.theme.button.hoverOverlayColor;
}),
    Te =
/*#__PURE__*/
function (_br$Component) {
  _inherits(Te, _br$Component);

  function Te() {
    var _this99;

    _classCallCheck(this, Te);

    _this99 = _possibleConstructorReturn(this, _getPrototypeOf(Te).apply(this, arguments));
    _this99.state = Ho;
    _this99.timeout = null;

    _this99.onClick = function (e) {
      var t = e.currentTarget.getBoundingClientRect(),
          r = e.pageX - t.left,
          o = e.pageY - t.top;
      _this99.state.display === "block" ? _this99.setState({
        display: "none"
      }, function () {
        _this99.setRippleState(r, o);
      }) : _this99.setRippleState(r, o), _this99.props.onClick(e);
    };

    _this99.setRippleState = function (e, t) {
      _this99.setState({
        left: e,
        top: t,
        display: "block"
      }), _this99.timeout = setTimeout(function () {
        _this99.setState({
          display: "none"
        });
      }, 1200);
    };

    return _this99;
  }

  _createClass(Te, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var h = this.props,
          e = h.isActive,
          t = h.isDisabled,
          r = h.label,
          o = h.ariaLabel,
          n = h.children,
          s = h.className,
          l = Pe(h, ["isActive", "isDisabled", "label", "ariaLabel", "children", "className"]),
          _this$state5 = this.state,
          c = _this$state5.left,
          p = _this$state5.top,
          m = _this$state5.display;
      return br.createElement(Mf, f(f({
        "data-test": o,
        className: s,
        isActive: e,
        disabled: t,
        "aria-label": o
      }, l), {
        onClick: this.onClick
      }), r, n, br.createElement(Wo, {
        display: m,
        left: c,
        top: p
      }), br.createElement(Oe, null), br.createElement(Bi, null));
    }
  }]);

  return Te;
}(br.Component);

Te.defaultProps = {
  type: "button",
  isDisabled: !1,
  isActive: !1
};
import Bf from "react";
import Su, { css as zf } from "styled-components";

var Lf = Su.label(_templateObject32(), hr),
    Uf = Su.label(_templateObject33(), function (i) {
  return i.theme.measurements.fontSystem.label.size;
}, function (i) {
  return i.theme.measurements.fontSystem.label.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.label.case;
}, function (i) {
  return i.theme.toolControlBar.inputLabelForeground;
}, function (_ref66) {
  var i = _ref66.isDisabled;
  return i && zf(_templateObject34(), function (e) {
    return e.theme.toolControlBar.inputLabelInactiveOpacity;
  });
}),
    ye = function ye(_ref67) {
  var i = _ref67.label,
      e = _ref67.htmlFor,
      t = _ref67.show,
      r = _ref67.style,
      o = _ref67.isDisabled,
      n = _ref67.className;
  var s = t ? Uf : Lf,
      l = e || (i ? i.replace(" ", "-") : void 0);
  return Bf.createElement(s, {
    style: r,
    isDisabled: o,
    htmlFor: l,
    className: n
  }, i);
};

ye.defaultProps = {
  show: !0
};

var Nf = qt.div(_templateObject35()),
    Hf = qt(ye)(_templateObject36()),
    Cu = qt(Te)(_templateObject37(), function (i) {
  return i.theme.button.textSecondaryForeground;
}),
    Wf = qt.div(_templateObject38(), function (i) {
  return i.theme.measurements.advancedUIToolControlBar.width - 48;
}),
    jf = qt.article(_templateObject39(), function (i) {
  return .6 * i.theme.measurements.advancedUIToolControlBar.width;
}, function (i) {
  return i.theme.measurements.fontSystem.body.size;
}, function (i) {
  return i.theme.measurements.fontSystem.body.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.body.case;
}, function (i) {
  return i.theme.toolControlBar.inputLabelForeground;
}),
    Gf = qt.div(_templateObject40(), function (i) {
  return .6 * i.theme.measurements.advancedUIToolControlBar.width;
}),
    Vf = qt.span(_templateObject41(), function (i) {
  return Math.round(i.length * .6 * i.theme.measurements.advancedUIToolControlBar.width);
}, function (i) {
  return i.activeIndex * .6 * i.theme.measurements.advancedUIToolControlBar.width;
}, function (i) {
  return i.theme.typography.fontFamily;
}),
    wu = qt.div(_templateObject42(), function (i) {
  return i.theme.card.foreground;
}, function (_ref68) {
  var i = _ref68.direction;
  return i === "left" ? xu(_templateObject43()) : xu(_templateObject44());
}),
    pa =
/*#__PURE__*/
function (_Ze$PureComponent) {
  _inherits(pa, _Ze$PureComponent);

  function pa(e) {
    var _this100;

    _classCallCheck(this, pa);

    _this100 = _possibleConstructorReturn(this, _getPrototypeOf(pa).call(this, e));

    _this100.updateIndex = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var r = e + (t ? -1 : 1),
          o = _this100.props.list.length - 1;
      r > o && (r = 0), r < 0 && (r = o), _this100.props.onSelect(_this100.props.list[r].identifier);
    };

    _this100.getActiveIndex = function (e) {
      var t = _this100.props.list,
          r = t.findIndex(function (o) {
        return o.identifier === e;
      });
      return r !== -1 ? r : 0;
    };

    _this100.throttledUpdateIndex = Du.default(_this100.updateIndex, 600);
    return _this100;
  }

  _createClass(pa, [{
    key: "render",
    value: function render() {
      var _this101 = this;

      var _this$props = this.props,
          e = _this$props.list,
          t = _this$props.label,
          _this$props$showLabel = _this$props.showLabel,
          r = _this$props$showLabel === void 0 ? !0 : _this$props$showLabel,
          o = this.getActiveIndex(this.props.defaultIdentifier),
          n = e.length <= 1;
      return Ze.createElement(Nf, {
        "data-test": me.CarouselSlider
      }, Ze.createElement(Hf, {
        show: r,
        label: t
      }), Ze.createElement(Wf, {
        id: "photoeditorsdk-".concat(t.replace(" ", "-"))
      }, Ze.createElement(Cu, {
        ariaLabel: "Select Previous",
        isDisabled: n,
        onClick: function onClick() {
          return _this101.throttledUpdateIndex(o, !0);
        }
      }, Ze.createElement(wu, {
        direction: "left"
      })), Ze.createElement(Gf, null, Ze.createElement(Vf, {
        activeIndex: o,
        length: e.length
      }, e.map(function (s) {
        return Ze.createElement(jf, {
          key: s.identifier
        }, s.value);
      }))), Ze.createElement(Cu, {
        ariaLabel: "Select Next",
        isDisabled: n,
        onClick: function onClick() {
          return _this101.throttledUpdateIndex(o);
        }
      }, Ze.createElement(wu, {
        direction: "right"
      }))));
    }
  }]);

  return pa;
}(Ze.PureComponent);

pa.defaultProps = {
  showLabel: !0
};
var Eu = pa;
import vr from "react";
import $f from "styled-components";
var Kf = $f.div(_templateObject45(), function (i) {
  return i.theme.measurements.basicToolControlBar.maxWidth;
}),
    jo = Kf;
import qf, { css as ku } from "styled-components";
var Yf = qf.div.attrs({
  tabIndex: 0
})(_templateObject46(), function (i) {
  return i.theme.checkbox.background;
}, function (i) {
  return i.theme.shape.radiusSmall;
}, be, function (i) {
  return i.theme.checkbox.hoverOpacity;
}, function (i) {
  return i.isChecked && ku(_templateObject47(), i.theme.checkbox.activeBackground, i.theme.checkbox.activeForeground, i.theme.checkbox.foreground, i.theme.checkbox.activeBackground);
}, function (i) {
  return i.isDisabled && ku(_templateObject48());
}),
    yr = Yf;
import Xf from "styled-components";
var Jf = Xf.input.attrs({
  type: "checkbox",
  tabIndex: 0
})(_templateObject49(), be),
    Go = Jf;

var Iu = function Iu(_ref69) {
  var i = _ref69.label,
      e = _ref69.value,
      t = _ref69.checkMarkPosition,
      r = _ref69.onClick,
      o = _ref69.isDisabled,
      n = _ref69.className,
      s = _ref69.style;
  var l = "photoeditorsdk-".concat(i.replace(" ", "-"));
  return vr.createElement(jo, {
    "data-test": me.Checkbox,
    className: n,
    style: s
  }, t === "left" && vr.createElement(yr, {
    onClick: r,
    isDisabled: o,
    isChecked: e
  }), vr.createElement(ye, {
    isDisabled: o,
    label: i,
    htmlFor: l
  }), vr.createElement(Go, {
    id: l,
    disabled: o,
    checked: e,
    onChange: r
  }), t === "right" && vr.createElement(yr, {
    onClick: r,
    isDisabled: o,
    isChecked: e
  }));
},
    Fu = Iu;

Iu.defaultProps = {
  value: !1,
  checkMarkPosition: "left"
};
import { css as Zf } from "styled-components";
var hi = Zf(_templateObject50(), function (i) {
  return i.theme.measurements.fontSystem.body.size;
}, function (i) {
  return i.theme.measurements.fontSystem.body.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.body.case;
}, function (i) {
  return i.theme.textInput.foreground;
}, function (i) {
  return i.theme.textInput.borderColor;
}, function (i) {
  return i.theme.textInput.background;
}, function (i) {
  return i.theme.typography.fontFamily;
}, function (i) {
  return i.theme.textInput.hoverBorderColor;
}, function (i) {
  return i.theme.textInput.hoverBorderColor;
}, function (i) {
  return i.theme.textInput.inactiveOpacity;
}, function (i) {
  return i.theme.textInput.hoverBorderColor;
});
import Ft from "react";
import zu from "styled-components";
import Qf, { css as eg } from "styled-components";
var Au = eg(_templateObject51(), function (i) {
  return i.theme.dropdown.inactiveOpacity;
}),
    Ru = Qf.div(_templateObject52(), Au, function (_ref70) {
  var i = _ref70.isDisabled;
  return i && Au;
});
import tg, { css as ig } from "styled-components";
var Ou = tg.li(_templateObject53(), function (i) {
  return i.theme.measurements.fontSystem.button2.size;
}, function (i) {
  return i.theme.measurements.fontSystem.button2.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.button2.case;
}, function (i) {
  return i.theme.dropdown.foreground;
}, function (i) {
  return i.theme.dropdown.listItemHoverBackground;
}, function (_ref71) {
  var i = _ref71.isActive;
  return i && ig(_templateObject54(), function (e) {
    return e.theme.primary;
  });
}, be);
import ng, { css as Mu } from "styled-components";
import Tu from "react";
import Pu, { css as zi } from "styled-components";

var rg = Pu.div(_templateObject55(), function (i) {
  return Me() || ti() ? zi(_templateObject56()) : i.direction === "vertical" ? zi(_templateObject57()) : zi(_templateObject58());
}),
    og = Pu.ul.attrs(function () {
  return {
    role: "menubar",
    "aria-label": "Tool Navigation"
  };
})(_templateObject59(), function (i) {
  return i.direction === "vertical" ? "column" : "row";
}, function (i) {
  return Me() || ti() ? zi(_templateObject60(), function () {
    return i.direction === "vertical" ? zi(_templateObject61()) : zi(_templateObject62());
  }, i.theme.toolbar.background, i.theme.toolbar.background, i.theme.toolbar.background) : "";
}),
    ma = function ma(_ref72) {
  var _ref72$direction = _ref72.direction,
      i = _ref72$direction === void 0 ? "horizontal" : _ref72$direction,
      e = _ref72["data-test"],
      t = _ref72.className,
      r = _ref72.children;
  return Tu.createElement(rg, {
    direction: i,
    className: t
  }, Tu.createElement(og, {
    direction: i,
    "data-test": e
  }, r));
};

var ha = ng(ma)(_templateObject63(), function (i) {
  return i.theme.dropdown.listBackground;
}, function (i) {
  return i.theme.dropdown.listForeground;
}, function (i) {
  return i.theme.dropdown.listBorderColor;
}, function (i) {
  return i.theme.dropdown.listShadow;
}, function (i) {
  return i.isOpen ? Mu(_templateObject64()) : "";
}, function () {
  return Me() ? Mu(_templateObject65()) : "";
}, function (i) {
  return i.theme.shape.radiusMedium;
}, function (i) {
  return i.theme.shape.radiusMedium;
}, function (i) {
  return i.theme.measurements.zIndex.input.list;
});
ha.defaultProps = {
  direction: "vertical"
};
import sg from "styled-components";
var Bu = sg.div(_templateObject66(), function (i) {
  return i.theme.measurements.fontSystem.body.size;
}, function (i) {
  return i.theme.measurements.fontSystem.body.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.body.case;
}, function (i) {
  return i.theme.dropdown.foreground;
}, function (i) {
  return i.theme.dropdown.background;
}, function (i) {
  return i.theme.dropdown.borderColor;
}, function (i) {
  return i.showList ? "pointer" : "default";
}, function (i) {
  return i.theme.dropdown.hoverBorderColor;
}, be);

var ag = zu.div(_templateObject67(), function (i) {
  return i.theme.dropdown.caretColor;
}, function (i) {
  return i.rotation || 0;
}),
    lg = zu.div(_templateObject68()),
    fa =
/*#__PURE__*/
function (_Ft$PureComponent) {
  _inherits(fa, _Ft$PureComponent);

  function fa(e) {
    var _this102;

    _classCallCheck(this, fa);

    _this102 = _possibleConstructorReturn(this, _getPrototypeOf(fa).call(this, e));
    _this102.state = {
      isOpen: !1
    };

    _this102.handleOutsideClick = function (e) {
      _this102.node && _this102.node.contains(e.target) || _this102.setState({
        isOpen: !1
      });
    };

    _this102.onSelect = function (e) {
      var t = _this102.props.onSelect;
      t(e), _this102.setState({
        isOpen: !1
      });
    };

    _this102.onClick = function () {
      _this102.setState(function (e) {
        return {
          isOpen: !e.isOpen
        };
      });
    };

    _this102.listItem = function (e) {
      var _this102$props = _this102.props,
          t = _this102$props.itemStyle,
          r = _this102$props.selectedItem,
          o = _this102.state.isOpen,
          n = e.value,
          s = e.label,
          l = {};
      return typeof t == "function" ? l = t(e) : t !== null && typeof t == "object" && (l = t), Ft.createElement(Ou, {
        "aria-hidden": !o,
        tabIndex: 0,
        style: l,
        onClick: function onClick() {
          return _this102.onSelect(n);
        },
        key: n,
        isActive: r === n
      }, s);
    };

    _this102.onKeyDown = function (e) {
      (e.code === "Space" || e.code === "Enter") && _this102.onClick();
    };

    _this102.nodeRef = function (t) {
      _this102.node = t;
    };

    return _this102;
  }

  _createClass(fa, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousedown", this.handleOutsideClick, !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleOutsideClick, !1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          e = _this$props2.selectedItem,
          t = _this$props2.list,
          r = _this$props2.label,
          o = _this$props2.style,
          n = _this$props2.isDisabled,
          s = this.state.isOpen,
          l = t.length > 1,
          c = n ? {} : {
        tabIndex: 0
      };
      return Ft.createElement(lg, null, Ft.createElement(ye, {
        isDisabled: n,
        style: {
          paddingLeft: "0px"
        },
        label: r
      }), Ft.createElement("div", {
        ref: this.nodeRef
      }, Ft.createElement(Ru, {
        isOpen: s,
        isDisabled: n
      }, Ft.createElement(Bu, f(f({
        "data-test": me.Dropdown,
        "aria-hidden": n
      }, c), {
        showList: l,
        style: o,
        onClick: l ? this.onClick : void 0,
        onKeyDown: this.onKeyDown
      }), e, l && Ft.createElement(ag, {
        rotation: s ? 180 : 0
      })), Ft.createElement(ha, {
        "data-test": me.DropdownList,
        isOpen: s
      }, l && t.map(this.listItem)))));
    }
  }]);

  return fa;
}(Ft.PureComponent);

import cg from "styled-components";
var Lu = cg.input.attrs({
  type: "file",
  id: "fileUpload",
  accept: "image/*"
})(_templateObject69());
import ug from "react";

var dg = function dg(_ref73) {
  var i = _ref73.children;
  return ug.createElement("form", {
    onSubmit: function onSubmit(t) {
      t.preventDefault();
    }
  }, i);
},
    Uu = dg;

import _r from "react";
import hg, { css as Hu } from "styled-components";
import ga from "react";
import Nu from "styled-components";

var pg = Nu.input(_templateObject70(), hi, function (i) {
  return i.theme.textInput.inactiveOpacity;
}),
    mg = Nu.div(_templateObject71()),
    ba =
/*#__PURE__*/
function (_ga$Component) {
  _inherits(ba, _ga$Component);

  function ba() {
    var _this103;

    _classCallCheck(this, ba);

    _this103 = _possibleConstructorReturn(this, _getPrototypeOf(ba).apply(this, arguments));

    _this103.onChange = function (e) {
      var t = _this103.props.onChange;
      t && t(e.target.value);
    };

    return _this103;
  }

  _createClass(ba, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          e = _this$props3.id,
          t = _this$props3.testId,
          r = _this$props3.value,
          o = _this$props3.type,
          n = _this$props3.min,
          s = _this$props3.max,
          l = _this$props3.onBlur,
          c = _this$props3.onFocus,
          p = _this$props3.onKeyUp,
          m = _this$props3.onKeyDown,
          h = _this$props3.onMouseUp,
          b = _this$props3.onTouchEnd,
          v = _this$props3.isDisabled,
          x = _this$props3.className,
          I = _this$props3.children;
      return ga.createElement(mg, {
        className: x
      }, ga.createElement(pg, {
        id: e,
        "data-test": t,
        "aria-hidden": v,
        disabled: v,
        value: r,
        type: o,
        min: n,
        max: s,
        onChange: this.onChange,
        onBlur: l,
        onFocus: c,
        onKeyUp: p,
        onKeyDown: m,
        onMouseUp: h,
        onTouchEnd: b
      }), I);
    }
  }]);

  return ba;
}(ga.Component);

ba.defaultProps = {
  type: "text"
};
var Vo = ba;

var fg = hg.div(_templateObject72(), Me() ? Hu(_templateObject73()) : Hu(_templateObject74())),
    Sr =
/*#__PURE__*/
function (_r$Component) {
  _inherits(Sr, _r$Component);

  function Sr(e) {
    var _this104;

    _classCallCheck(this, Sr);

    _this104 = _possibleConstructorReturn(this, _getPrototypeOf(Sr).call(this, e));
    _this104.node = null;

    _this104.handleOutsideClick = function (e) {
      _this104.node && _this104.node.current && _this104.node.current.contains(e.target) || _this104.onSubmit();
    };

    _this104.onSubmit = function () {
      var e = _this104.props.onSubmit,
          _this104$state = _this104.state,
          t = _this104$state.value,
          r = _this104$state.isActive;

      if (e) {
        var o = parseFloat(Sr.cleanValue(t));
        !Number.isNaN(o) && r && e("".concat(o));
      }

      _this104.setState({
        isActive: !1
      });
    };

    _this104.onBlur = function () {
      _this104.onSubmit();
    };

    _this104.onFocus = function () {
      _this104.setState({
        isActive: !0
      });
    };

    _this104.onKeyDown = function (e) {
      var t = _this104.state.value;
      if (e.key === "Enter") _this104.onSubmit();else if (e.key === "ArrowUp") {
        var r = parseFloat(Sr.cleanValue(t));
        typeof r == "number" && _this104.setState({
          value: (r + 1).toString(),
          isActive: !0
        });
      } else if (e.key === "ArrowDown") {
        var _r13 = parseFloat(Sr.cleanValue(t));

        typeof _r13 == "number" && _this104.setState({
          value: (_r13 - 1).toString(),
          isActive: !0
        });
      }
    };

    _this104.onChange = function (e) {
      _this104.setState({
        value: e.replace(/[^\d.,-]/g, ""),
        isActive: !0
      });
    };

    _this104.state = {
      value: _this104.props.value || "",
      isActive: !1
    }, _this104.node = _r.createRef(), document.addEventListener("mousedown", _this104.handleOutsideClick, !1), document.addEventListener("touchstart", _this104.handleOutsideClick, !1);
    return _this104;
  }

  _createClass(Sr, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleOutsideClick, !1), document.removeEventListener("touchstart", this.handleOutsideClick, !1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          e = _this$props4.id,
          t = _this$props4.label,
          r = _this$props4.isDisabled,
          o = _this$props4.ariaHidden,
          n = _this$props4.onMouseUp,
          s = _this$props4.onTouchEnd,
          l = _this$props4.className,
          c = this.state.value;
      return _r.createElement(fg, {
        ref: this.node,
        "data-test": me.NummericInput,
        className: l
      }, _r.createElement(ye, {
        htmlFor: e,
        label: t,
        show: !!t,
        isDisabled: r
      }), _r.createElement(Vo, {
        id: e,
        value: c,
        isDisabled: r,
        "aria-hidden": o,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onMouseUp: n,
        onTouchEnd: s
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref74, _ref75) {
      var e = _ref74.value;
      var t = _ref75.value,
          r = _ref75.isActive;
      return e !== t && !r ? {
        value: e
      } : null;
    }
  }, {
    key: "cleanValue",
    value: function cleanValue(e) {
      return e ? e.replace(",", ".").replace(/[a-zA-Z]/g, "").trim() : "";
    }
  }]);

  return Sr;
}(_r.Component),
    ya = Sr;

ya.defaultProps = {
  showLabel: !0
};
var $o = ya;
import va from "react";
import gg from "styled-components";

var bg = gg.input.attrs({
  type: "search"
})(_templateObject75(), hi),
    yg = function yg(i) {
  return va.createElement("div", null, va.createElement(ye, {
    show: !1,
    label: "photoeditorsdk-Search"
  }), va.createElement(bg, {
    id: "photoeditorsdk-Search",
    onChange: function onChange(t) {
      i.onChange(t.target.value);
    },
    placeholder: i.placeholder
  }));
},
    Wu = yg;

import _a from "react";
import ju, { css as vg } from "styled-components";

var _g = ju.div(_templateObject76()),
    Gu = function Gu(_ref76) {
  var i = _ref76.label,
      e = _ref76.children,
      t = _ref76.inline,
      r = _ref76.showLabel,
      o = _ref76.isDisabled,
      n = _ref76["data-test"];
  return _a.createElement(_g, {
    "data-test": n
  }, _a.createElement(ye, {
    isDisabled: o,
    label: i,
    show: r
  }), _a.createElement(Sg, {
    id: "photoeditorsdk-".concat(i.replace(" ", "-")),
    inline: !!t
  }, e));
},
    Sg = ju.div(_templateObject77(), function (i) {
  return !i.inline && vg(_templateObject78()) || "";
});

Gu.defaultProps = {
  showLabel: !0
};
var Vu = Gu;
import Li from "react";
import Dr, { css as xr } from "styled-components";

var Dg = Dr.div(_templateObject79()),
    xg = Dr(ye)(_templateObject80()),
    Sa = xr(_templateObject81(), ti() || Me() ? xr(_templateObject82()) : xr(_templateObject83()), function (i) {
  return i.theme.slider.thumbBackground;
}, function (i) {
  return i.theme.slider.thumbBorderColor;
}),
    Cg = function Cg(i) {
  var e = (i.value - i.min) * 100 / (i.max - i.min);
  return i.adjust ? i.value > 0 ? (e = i.value * (i.max / 2) * 100, "".concat(i.theme.slider.trackColor, " 0%,\n      ").concat(i.theme.slider.trackColor, " 50%,\n      ").concat(i.theme.slider.activeTrackColor, " 50%,\n      ").concat(i.theme.slider.activeTrackColor, " ").concat(50 + e, "%,\n      ").concat(i.theme.slider.trackColor, " ").concat(50 + e, "%,\n      ").concat(i.theme.slider.trackColor, " 100%\n      ")) : i.value < 0 ? (e = i.value * (i.min / 2) * 100, "".concat(i.theme.slider.trackColor, " 0%,\n      ").concat(i.theme.slider.trackColor, " ").concat(50 - e, "%,\n      ").concat(i.theme.slider.activeTrackColor, " ").concat(50 - e, "%,\n      ").concat(i.theme.slider.activeTrackColor, " 50%,\n      ").concat(i.theme.slider.trackColor, " 50%,\n      ").concat(i.theme.slider.trackColor, " 100%\n      ")) : "".concat(i.theme.slider.trackColor, " 0%,\n    ").concat(i.theme.slider.trackColor, " 100%") : "".concat(i.theme.slider.activeTrackColor, " 0%,\n    ").concat(i.theme.slider.activeTrackColor, " ").concat(e, "%,\n    ").concat(i.theme.slider.trackColor, " ").concat(e, "%,\n    ").concat(i.theme.slider.trackColor, " 100%");
},
    wg = Dr.input(_templateObject84(), be, ti() || Me() ? xr(_templateObject85()) : xr(_templateObject86(), function (i) {
  return "linear-gradient(to right, ".concat(Cg(i), ")");
}), function (i) {
  return i.theme.slider.inactiveOpacity;
}, function (i) {
  return i.theme.slider.hoverOpacity;
}, Sa, Sa, Sa, function (i) {
  return "".concat(i.theme.slider.activeTrackColor);
}, function (i) {
  return "".concat(i.theme.slider.trackColor);
}),
    Eg = Dr.div(_templateObject87(), function (i) {
  return i.centerSlider ? -56 : 0;
}),
    kg = Dr($o)(_templateObject88()),
    Da =
/*#__PURE__*/
function (_Li$Component) {
  _inherits(Da, _Li$Component);

  function Da(e) {
    var _this105;

    _classCallCheck(this, Da);

    _this105 = _possibleConstructorReturn(this, _getPrototypeOf(Da).call(this, e));

    _this105.onSubmit = function (e) {
      var _this105$props = _this105.props,
          t = _this105$props.onChange,
          r = _this105$props.suffix,
          o = _this105$props.divider,
          n = _this105$props.min,
          s = _this105$props.max,
          l = _this105$props.value,
          c = e.replace(r, ""),
          p = c ? parseFloat(c) / o : l,
          m = Math.max(n, Math.min(s, p));
      Number.isNaN(m) || (t(m), _this105.props.onMouseUp ? _this105.props.onMouseUp() : _this105.props.onTouchEnd && _this105.props.onTouchEnd());
    };

    _this105.onSliderChange = function (e) {
      var t = _this105.props.onChange,
          r = parseFloat(e.target.value);
      t(r);
    };

    _this105.randomId = xi();
    return _this105;
  }

  _createClass(Da, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          e = _this$props5["data-test"],
          t = _this$props5.identifier,
          r = _this$props5.value,
          o = _this$props5.min,
          n = _this$props5.max,
          s = _this$props5.divider,
          l = _this$props5.suffix,
          c = _this$props5.decimal,
          p = _this$props5.showLabel,
          m = _this$props5.showInput,
          h = _this$props5.style,
          b = _this$props5.centerSlider,
          v = _this$props5.adjust,
          x = _this$props5.label,
          I = _this$props5.isDisabled,
          R = _this$props5.step,
          M = _this$props5["aria-hidden"],
          Q = _this$props5.onMouseUp,
          se = _this$props5.onTouchEnd,
          ve = _this$props5.className,
          _e = "photoeditorsdk-slider-".concat(this.randomId),
          T = "".concat(_e, "-input"),
          Z = "".concat((r * s).toFixed(c)).concat(l),
          ae = m && Li.createElement(kg, {
        id: T,
        value: Z,
        isDisabled: I,
        "aria-hidden": M,
        onSubmit: this.onSubmit
      });

      return Li.createElement(Dg, {
        className: ve,
        "data-test": e || t || _e
      }, Li.createElement(xg, {
        isDisabled: I,
        label: x,
        show: p
      }), Li.createElement(Eg, {
        centerSlider: m && b
      }, Li.createElement(wg, {
        type: "range",
        role: "slider",
        "aria-hidden": M,
        tabIndex: 0,
        value: r,
        min: o,
        max: n,
        step: R,
        style: h,
        disabled: I,
        id: _e,
        onChange: this.onSliderChange,
        adjust: v,
        name: x,
        onKeyUp: this.onSliderChange,
        onKeyDown: this.onSliderChange,
        onMouseUp: Q,
        onTouchEnd: se
      }), ae));
    }
  }]);

  return Da;
}(Li.Component);

Da.defaultProps = {
  showLabel: !0,
  showInput: !0,
  adjust: !1,
  centerSlider: !1,
  min: -1,
  max: 1,
  value: 0,
  step: .01,
  decimal: 0,
  divider: 100,
  suffix: ""
};
var $u = Da;
import At from "react";
import Ig from "styled-components";
var Cr = Ig(Te)(_templateObject89(), function (i) {
  return i.theme.button.textPrimaryForeground;
}, function (_ref77) {
  var i = _ref77.isActive;
  return i && It;
}, Oe, function (i) {
  return i.theme.button.textInactiveOpacity;
});
import Fg from "styled-components";
var wr = Fg(Te)(_templateObject90(), function (i) {
  return i.theme.button.textSecondaryForeground;
}, function (_ref78) {
  var i = _ref78.isActive;
  return i && It;
}, Oe, function (i) {
  return i.theme.button.textInactiveOpacity;
});

var xa =
/*#__PURE__*/
function (_At$Component) {
  _inherits(xa, _At$Component);

  function xa() {
    var _this106;

    _classCallCheck(this, xa);

    _this106 = _possibleConstructorReturn(this, _getPrototypeOf(xa).apply(this, arguments));

    _this106.onDismiss = function () {
      var _this106$props = _this106.props,
          e = _this106$props.handleClose,
          t = _this106$props.handleDismiss;
      e && e(), t && t();
    };

    _this106.onConfirm = function () {
      var _this106$props2 = _this106.props,
          e = _this106$props2.handleClose,
          t = _this106$props2.handleConfirm;
      e && e(), t && t();
    };

    return _this106;
  }

  _createClass(xa, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          e = _this$props6.headerLabel,
          t = _this$props6.bodyLabel,
          r = _this$props6.confirmLabel,
          o = _this$props6.dismissLabel,
          n = _this$props6.type,
          s = _this$props6.children,
          l = At.Children.toArray(s)[0];
      if (!At.isValidElement(l)) throw new Error("Child is not a valid react element");
      return At.cloneElement(l, {
        handleConfirm: this.onConfirm,
        handleDismiss: this.onDismiss,
        header: At.createElement(Pi, null, e),
        body: At.createElement(kt, {
          "data-test": me.DialogBody
        }, t),
        footer: At.createElement(Ti, {
          type: n
        }, o && At.createElement(wr, {
          label: o,
          ariaLabel: o,
          onClick: this.onDismiss
        }), r && At.createElement(Cr, {
          label: r,
          ariaLabel: r,
          onClick: this.onConfirm
        }))
      });
    }
  }]);

  return xa;
}(At.Component);

import pt from "react";
import Ko from "styled-components";

var Ag = Ko.div(_templateObject91()),
    Rg = Ko(Pi)(_templateObject92()),
    Og = Ko.div(_templateObject93()),
    Tg = Ko(kt)(_templateObject94()),
    Ca =
/*#__PURE__*/
function (_pt$PureComponent) {
  _inherits(Ca, _pt$PureComponent);

  function Ca() {
    _classCallCheck(this, Ca);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ca).apply(this, arguments));
  }

  _createClass(Ca, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          e = _this$props7.headerLabel,
          t = _this$props7.bodyLabel,
          r = _this$props7.children,
          o = pt.Children.toArray(r)[0];
      if (!pt.isValidElement(o)) throw new Error("Child is not a valid react element");
      return pt.cloneElement(o, {
        height: "90px",
        body: pt.createElement(kt, {
          "data-test": me.DialogBody
        }, pt.createElement(Ag, null, pt.createElement(Ao, null), pt.createElement(Og, null, pt.createElement(Rg, null, e), pt.createElement(Tg, null, t))))
      });
    }
  }]);

  return Ca;
}(pt.PureComponent);

import Ne from "react";
import Er from "styled-components";

var Pg = Er.form(_templateObject95()),
    Mg = Er.textarea(_templateObject96(), function (i) {
  return i.theme.primary;
}, hi, function (i) {
  return i.theme.modal.bodyForeground;
}, function (i) {
  return i.theme.typography.fontFamily;
}, function (i) {
  return i.theme.primary;
}, function (i) {
  return i.theme.foreground;
}),
    Bg = Er.label(_templateObject97(), function (i) {
  return i.theme.measurements.fontSystem.label.size;
}, function (i) {
  return i.theme.measurements.fontSystem.label.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.label.case;
}, function (i) {
  return i.theme.modal.headerForeground;
}),
    zg = Er(kt)(_templateObject98()),
    Lg = Er(Ti)(_templateObject99()),
    wa =
/*#__PURE__*/
function (_Ne$Component) {
  _inherits(wa, _Ne$Component);

  function wa() {
    var _this107;

    _classCallCheck(this, wa);

    _this107 = _possibleConstructorReturn(this, _getPrototypeOf(wa).apply(this, arguments));
    _this107.state = {
      value: ""
    };
    _this107.input = Ne.createRef();

    _this107.handleKeydown = function (e) {
      El(_this107.handleDismiss)(e);
    };

    _this107.handleDismiss = function () {
      var e = _this107.props.handleDismiss;
      e && e(!1);
    };

    _this107.handleConfirm = function () {
      var e = _this107.props.handleConfirm,
          t = _this107.input.current.value;
      t && (e && e(t), _this107.handleDismiss());
    };

    _this107.onChange = function (e) {
      var t = _l(e.target.value);

      _this107.input.current.value = t, _this107.setState({
        value: t
      });
    };

    _this107.onSubmit = function (e) {
      e.preventDefault();
    };

    return _this107;
  }

  _createClass(wa, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          e = _this$props8.text,
          t = _this$props8.defaultText;
      this.input.current.focus(), this.input.current.value = e || t || "", this.setState({
        value: this.input.current.value
      }), document.addEventListener("keydown", this.handleKeydown, !1), e === t && this.input.current.select();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      var t = this.props.isVisible;
      e.isVisible !== t && t && this.input.current.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeydown, !1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          e = _this$props9.headerLabel,
          t = _this$props9.dismissLabel,
          r = _this$props9.confirmLabel,
          o = _this$props9.maxLength,
          n = _this$props9.type,
          s = _this$props9.children,
          l = this.state.value,
          c = Ne.Children.toArray(s)[0];
      if (!Ne.isValidElement(c)) throw new Error("Child is not a valid react element");
      return Ne.cloneElement(c, {
        handleConfirm: this.handleConfirm,
        handleDismiss: this.handleDismiss,
        isConfirmDisabled: !l,
        height: "150px",
        header: Ne.createElement(Bg, {
          htmlFor: "photoeditorsdk-TextInput"
        }, e),
        body: Ne.createElement(zg, null, Ne.createElement(Pg, {
          onSubmit: this.onSubmit
        }, Ne.createElement(Mg, {
          ref: this.input,
          id: "photoeditorsdk-TextInput",
          placeholder: "Write Something",
          autoFocus: !0,
          onChange: this.onChange,
          maxLength: o
        }))),
        footer: Ne.createElement(Lg, {
          type: n
        }, Ne.createElement(wr, {
          label: t,
          ariaLabel: t,
          onClick: this.handleDismiss
        }), Ne.createElement(Cr, {
          label: r,
          ariaLabel: r,
          isDisabled: !l,
          onClick: this.handleConfirm
        }))
      });
    }
  }]);

  return wa;
}(Ne.Component);

wa.defaultProps = {
  defaultText: "Write Something"
};
var Ku = wa;
import Ug from "styled-components";
var qu = Ug.div(_templateObject100(), function (i) {
  return (i.count || 1) * 8;
}),
    Yu = qu;
qu.defaultProps = {
  count: 1
};
import Ui from "react";

var Ea =
/*#__PURE__*/
function (_Ui$Component) {
  _inherits(Ea, _Ui$Component);

  function Ea() {
    _classCallCheck(this, Ea);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ea).apply(this, arguments));
  }

  _createClass(Ea, [{
    key: "getChildren",
    value: function getChildren() {
      var _this108 = this;

      var e = [],
          t = [];
      return Ui.Children.forEach(this.props.children, function (r) {
        switch (r.type.componentName) {
          case "case":
            _this108.props.type === r.props.value && e.push(r);
            break;

          case "default":
            t.push(r);
            break;
        }
      }), e.length > 0 ? e : t;
    }
  }, {
    key: "render",
    value: function render() {
      var e = this.getChildren();
      return e.length === 0 ? null : Ui.createElement(Ui.Fragment, null, e);
    }
  }]);

  return Ea;
}(Ui.Component),
    qo =
/*#__PURE__*/
function (_Ui$Component2) {
  _inherits(qo, _Ui$Component2);

  function qo() {
    _classCallCheck(this, qo);

    return _possibleConstructorReturn(this, _getPrototypeOf(qo).apply(this, arguments));
  }

  _createClass(qo, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return qo;
}(Ui.Component);

qo.componentName = "case";

var Yo =
/*#__PURE__*/
function (_Ui$Component3) {
  _inherits(Yo, _Ui$Component3);

  function Yo() {
    _classCallCheck(this, Yo);

    return _possibleConstructorReturn(this, _getPrototypeOf(Yo).apply(this, arguments));
  }

  _createClass(Yo, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return Yo;
}(Ui.Component);

Yo.componentName = "default";
import Ng, { keyframes as Hg, css as Wg } from "styled-components";
var jg = Hg(_templateObject101()),
    Gg = Ng.div(_templateObject102(), function (i) {
  return i.position.y;
}, function (i) {
  return i.position.x;
}, function (i) {
  return i.theme.shape.radiusMedium;
}, function (i) {
  return i.theme.measurements.zIndex.toast;
}, function (_ref79) {
  var i = _ref79.show;
  return i && Wg(_templateObject103(), jg);
}),
    Xu = Gg;
import ka from "react";
import Ia, { css as Ju } from "styled-components";

var Vg = Ia(Te)(_templateObject104(), function (_ref80) {
  var i = _ref80.fullWidth;
  return i && Ju(_templateObject105());
}),
    $g = Ia.div(_templateObject106()),
    Kg = Ia.div(_templateObject107(), function (_ref81) {
  var i = _ref81.hasIcon;
  return i && Ju(_templateObject108());
}),
    fi = function fi(n) {
  var i = n.label,
      e = n.children,
      t = n.icon,
      r = n.fullWidth,
      o = Pe(n, ["label", "children", "icon", "fullWidth"]);
  var s = ka.createElement(Kg, {
    hasIcon: !!t
  }, i, e);
  return ka.createElement(Vg, f({
    fullWidth: r
  }, o), t && ka.createElement($g, null, t), (e || i) && s);
};

import qg from "styled-components";
var Yg = qg(fi)(_templateObject109(), function (i) {
  return i.theme.button.outlinedPrimaryBackground;
}, function (i) {
  return i.theme.button.outlinedPrimaryForeground;
}, function (i) {
  return i.theme.button.outlinedBorderColor;
});
import Xg from "styled-components";
var Jg = Xg(fi)(_templateObject110(), function (i) {
  return i.theme.button.outlinedSecondaryBackground;
}, function (i) {
  return i.theme.button.outlinedSecondaryForeground;
}, function (i) {
  return i.theme.button.outlinedBorderColor;
});
import CT from "react";
import Zu from "styled-components";
var FT = Zu(Te)(_templateObject111(), function (i) {
  return i.theme.foreground;
}, function (_ref82) {
  var i = _ref82.isActive;
  return i && It;
}, Oe, function (i) {
  return i.theme.button.textInactiveOpacity;
}),
    AT = Zu.div(_templateObject112());
import Zg from "styled-components";
var Qg = Zg(fi)(_templateObject113(), function (i) {
  return i.theme.button.containedPrimaryBackground;
}, function (i) {
  return i.theme.button.containedPrimaryForeground;
}, function (i) {
  return i.theme.button.containedPrimaryBackground;
}, function (i) {
  return i.theme.button.containedPrimaryForeground;
});
import Ni from "react";
import eb, { css as Qu } from "styled-components";

var tb = function tb() {
  return Qu(_templateObject114(), ks);
},
    ib = Qu(_templateObject115(), function (i) {
  return i.theme.card.activeBorderColor;
}, da, function (i) {
  return i.theme.card.activeOverlayColor;
}),
    rb = eb.button.attrs(function (i) {
  var e = {};
  return i.image && (e.backgroundImage = "url(".concat(i.image, ")")), {
    style: e
  };
})(_templateObject116(), function (i) {
  return i.theme.card.background;
}, function (i) {
  return i.theme.card.foreground;
}, function (i) {
  return i.theme.shape.radiusMedium;
}, tb, be, function (_ref83) {
  var i = _ref83.isActive;
  return i && ib;
}, Oe, function (i) {
  return i.theme.card.inactiveOverlayColor;
}, Bi, function (i) {
  return i.theme.card.hoverOverlayColor;
}),
    Fa =
/*#__PURE__*/
function (_Ni$Component) {
  _inherits(Fa, _Ni$Component);

  function Fa() {
    var _this109;

    _classCallCheck(this, Fa);

    _this109 = _possibleConstructorReturn(this, _getPrototypeOf(Fa).apply(this, arguments));
    _this109.state = Ho;
    _this109.timeout = null;

    _this109.onKeyDown = function (e) {
      (e.key === "Space" || e.key === "Enter") && _this109.props.onClick && _this109.props.onClick();
    };

    _this109.onClick = function (e) {
      var t = e.currentTarget.getBoundingClientRect(),
          r = e.pageX - t.left,
          o = e.pageY - t.top;
      _this109.state.display === "block" ? _this109.setState({
        display: "none"
      }, function () {
        _this109.setRippleState(r, o);
      }) : _this109.setRippleState(r, o), _this109.props.onClick(e);
    };

    _this109.setRippleState = function (e, t) {
      _this109.setState({
        left: e,
        top: t,
        display: "block"
      }), _this109.timeout = setTimeout(function () {
        _this109.setState({
          display: "none"
        });
      }, 1200);
    };

    return _this109;
  }

  _createClass(Fa, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          e = _this$props10.children,
          t = _this$props10.label,
          r = _this$props10.isActive,
          o = _this$props10.isDisabled,
          n = _this$props10.image,
          s = _this$props10.style,
          l = _this$props10.className,
          _this$state6 = this.state,
          c = _this$state6.left,
          p = _this$state6.top,
          m = _this$state6.display;
      return Ni.createElement(rb, {
        isActive: r,
        "aria-label": t,
        "data-test": t,
        disabled: o,
        image: n,
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        style: s,
        className: l
      }, e, Ni.createElement(Wo, {
        display: m,
        left: c,
        top: p
      }), Ni.createElement(da, null), Ni.createElement(Oe, null), Ni.createElement(Bi, null));
    }
  }]);

  return Fa;
}(Ni.Component);

Fa.defaultProps = {
  isActive: !1
};
import jT from "react";
import kr, { css as Xo } from "styled-components";
var KT = kr.div(_templateObject117(), function (i) {
  return i.theme.measurements.fontSystem.label.size;
}, function (i) {
  return i.theme.measurements.fontSystem.label.letterSpacing;
}, function (i) {
  return i.theme.measurements.fontSystem.label.case;
}),
    qT = kr.div(_templateObject118(), function (i) {
  return i.theme.shape.radiusMedium;
}, function (i) {
  return i.withBackground ? Xo(_templateObject119(), i.theme.card.labelForeground, i.theme.card.labelBackground) : Xo(_templateObject120(), i.theme.card.foreground);
}),
    YT = kr.div(_templateObject121(), function (i) {
  return i.theme.card.labelForeground;
}, function (i) {
  return i.withBackground ? Xo(_templateObject122(), i.theme.card.labelForeground) : Xo(_templateObject123(), i.theme.card.foreground);
}, function (i) {
  return i.rotation || 0;
}),
    XT = kr.span(_templateObject124()),
    JT = kr.div(_templateObject125(), hr);
import ob from "styled-components";
var nb = ob.div.attrs(function (i) {
  return {
    "data-test": me.CardAvatar,
    style: {
      backgroundImage: "url(".concat(i.url, ")")
    }
  };
})(_templateObject126());
var aM = {
  Container: Us,
  ColorItem: eu,
  ColorItemBase: Co,
  ColorItemBackground: Do,
  ColorItemTiledBackground: wo,
  ColorItemActiveOverlay: xo,
  Dialog: tu,
  DialogBase: Io,
  DialogContainer: Fo,
  DialogBackdrop: ko,
  DialogHeader: Pi,
  DialogBody: kt,
  DialogFooter: Ti,
  DialogSpinner: Ao,
  TextEditModal: Ku,
  ActionModal: xa,
  InfoModal: Ca,
  Spacer: Yu,
  Draggable: gu,
  DraggableCore: mi,
  Toast: Xu,
  Input: {
    Label: ye,
    File: Lu,
    Search: Wu,
    Slider: $u,
    CarouselSlider: Eu,
    Selection: Vu,
    Checkbox: Fu,
    CheckboxBase: jo,
    CheckboxInput: Go,
    CheckboxCheckMark: yr,
    Dropdown: fa,
    Text: Vo,
    NumericInput: $o,
    Form: Uu
  },
  Switch: {
    Index: Ea,
    Case: qo,
    Default: Yo
  }
};
export { Xi as a, Dn as b, ti as c, CT as d, jT as e, kn as f, bp as g, Dc as h, Es as i, Dm as j, ks as k, be as l, hr as m, Cn as n, Tn as o, Me as p, Bs as q, xn as r, $r as s, Fn as t, An as u, Qg as v, Yg as w, Jg as x, En as y, yp as z, Mn as A, Oe as B, nb as C, gp as D, In as E, Pn as F, Cr as G, wr as H, I_ as I, On as J, FT as K, Rn as L, KT as M, F as N, fi as O, ma as P, AT as Q, qT as R, Pe as S, ne as T, YT as U, XT as V, is as W, JT as X, Te as Y, U as Z, Fa as _, Wt as $, O as aa, ir as ba, a as ca, me as da, ie as ea, aM as fa, dr as ga, Zs as ha, Qs as ia, Ih as ja, Zc as ka, al as la, k as ma };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */